/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import type * as Types from './schema-types';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
export * from './schema-types';
const defaultOptions = {} as const;
export type ChangeCounsellorDataQueryVariables = Exact<{
  input: Types.FetchAppointmentsInput;
}>;

export type ChangeCounsellorDataQuery = {
  __typename: 'Query';
  fetchAppointments: {
    __typename: 'FetchAppointmentsResponse';
    appointments: {
      __typename: 'PaginatedAppointments';
      data: Array<{
        __typename: 'Appointment';
        status: Types.AppointmentStatus;
        allowsCancellation: boolean;
      }>;
    };
  } | null;
  fetchCounsellor: {
    __typename: 'FetchCounsellorResponse';
    counsellor: {
      __typename: 'Counsellor';
      id: string;
      appointmentTypes: Array<Types.AppointmentType>;
    };
  } | null;
  assessedAsSuicideRisk: {
    __typename: 'AssessedAsSuicideRiskResponse';
    ccsTeamTelephoneNumber: string;
  } | null;
};

export type BookedCounsellorFragment = {
  __typename: 'Counsellor';
  id: string;
  appointmentTypes: Array<Types.AppointmentType>;
  firstName: string | null;
  lastName: string | null;
  jobTitles: Array<string | null> | null;
  avatarImage: { __typename: 'Image'; url: string } | null;
};

export type BookedAppointmentFragment = {
  __typename: 'Appointment';
  id: string;
  status: Types.AppointmentStatus;
  startDateTime: string;
  endDateTime: string;
  typeDescription: Types.AppointmentType;
  allowsCancellation: boolean;
  counsellor: {
    __typename: 'Counsellor';
    id: string;
    appointmentTypes: Array<Types.AppointmentType>;
    firstName: string | null;
    lastName: string | null;
    jobTitles: Array<string | null> | null;
    avatarImage: { __typename: 'Image'; url: string } | null;
  };
};

export type BookAppointmentMutationVariables = Exact<{
  input: Types.BookAppointmentInput;
}>;

export type BookAppointmentMutation = {
  __typename: 'Mutation';
  bookAppointment: {
    __typename: 'BookAppointmentResponse';
    appointment: {
      __typename: 'Appointment';
      id: string;
      status: Types.AppointmentStatus;
      startDateTime: string;
      endDateTime: string;
      typeDescription: Types.AppointmentType;
      allowsCancellation: boolean;
      counsellor: {
        __typename: 'Counsellor';
        id: string;
        appointmentTypes: Array<Types.AppointmentType>;
        firstName: string | null;
        lastName: string | null;
        jobTitles: Array<string | null> | null;
        avatarImage: { __typename: 'Image'; url: string } | null;
      };
    };
  } | null;
};

export type AppointmentDetailsCounsellorFragment = {
  __typename: 'Counsellor';
  id: string;
  appointmentTypes: Array<Types.AppointmentType>;
  firstName: string | null;
  lastName: string | null;
  jobTitles: Array<string | null> | null;
  avatarImage: { __typename: 'Image'; url: string } | null;
};

export type FetchAppointmentByIdQueryVariables = Exact<{
  appointmentId: string | number;
}>;

export type FetchAppointmentByIdQuery = {
  __typename: 'Query';
  fetchAppointmentById: {
    __typename: 'FetchAppointmentResponse';
    appointment: {
      __typename: 'Appointment';
      id: string;
      status: Types.AppointmentStatus;
      startDateTime: string;
      endDateTime: string;
      typeDescription: Types.AppointmentType;
      allowsCancellation: boolean;
      isVisibleToUser: boolean;
      counsellor: {
        __typename: 'Counsellor';
        id: string;
        appointmentTypes: Array<Types.AppointmentType>;
        firstName: string | null;
        lastName: string | null;
        jobTitles: Array<string | null> | null;
        avatarImage: { __typename: 'Image'; url: string } | null;
      };
    };
  } | null;
};

export type CancelledAppointmentFragment = {
  __typename: 'Appointment';
  id: string;
  startDateTime: string;
  endDateTime: string;
  typeDescription: Types.AppointmentType;
  counsellor: {
    __typename: 'Counsellor';
    id: string;
    appointmentTypes: Array<Types.AppointmentType>;
    firstName: string | null;
    lastName: string | null;
    jobTitles: Array<string | null> | null;
    avatarImage: { __typename: 'Image'; url: string } | null;
  };
};

export type CancelAppointmentMutationVariables = Exact<{
  id: string | number;
}>;

export type CancelAppointmentMutation = {
  __typename: 'Mutation';
  cancelAppointment: {
    __typename: 'CancelAppointmentResponse';
    appointment: {
      __typename: 'Appointment';
      id: string;
      startDateTime: string;
      endDateTime: string;
      typeDescription: Types.AppointmentType;
      counsellor: {
        __typename: 'Counsellor';
        id: string;
        appointmentTypes: Array<Types.AppointmentType>;
        firstName: string | null;
        lastName: string | null;
        jobTitles: Array<string | null> | null;
        avatarImage: { __typename: 'Image'; url: string } | null;
      };
    };
  } | null;
};

export type CounsellorLanguagesFragment = {
  __typename: 'Language';
  code: string | null;
  name: string | null;
};

export type CounsellorEducationsFragment = {
  __typename: 'CounsellorEducation';
  institution: string | null;
  name: string | null;
};

export type CounsellorInfoFragment = {
  __typename: 'CounsellorInfo';
  disability: string | null;
  licenses: Array<string | null> | null;
  ethnicBackground: string | null;
  gender: string | null;
  religion: string | null;
  sexualOrientation: string | null;
  specializations: Array<string | null> | null;
  bio: string | null;
};

export type CounsellorProfileFragment = {
  __typename: 'Counsellor';
  firstName: string | null;
  id: string;
  jobTitles: Array<string | null> | null;
  lastName: string | null;
  appointmentTypes: Array<Types.AppointmentType>;
  availableInNearFuture: boolean;
  allowsBooking: boolean;
  avatarImage: { __typename: 'Image'; url: string } | null;
  spokenLanguages: Array<{
    __typename: 'Language';
    code: string | null;
    name: string | null;
  } | null> | null;
  info: {
    __typename: 'CounsellorInfo';
    disability: string | null;
    licenses: Array<string | null> | null;
    ethnicBackground: string | null;
    gender: string | null;
    religion: string | null;
    sexualOrientation: string | null;
    specializations: Array<string | null> | null;
    bio: string | null;
  } | null;
};

export type FetchCounsellorByIdQueryVariables = Exact<{
  counsellorId: string | number;
}>;

export type FetchCounsellorByIdQuery = {
  __typename: 'Query';
  fetchCounsellorById: {
    __typename: 'FetchCounsellorResponse';
    counsellor: {
      __typename: 'Counsellor';
      firstName: string | null;
      id: string;
      jobTitles: Array<string | null> | null;
      lastName: string | null;
      appointmentTypes: Array<Types.AppointmentType>;
      availableInNearFuture: boolean;
      allowsBooking: boolean;
      avatarImage: { __typename: 'Image'; url: string } | null;
      spokenLanguages: Array<{
        __typename: 'Language';
        code: string | null;
        name: string | null;
      } | null> | null;
      info: {
        __typename: 'CounsellorInfo';
        disability: string | null;
        licenses: Array<string | null> | null;
        ethnicBackground: string | null;
        gender: string | null;
        religion: string | null;
        sexualOrientation: string | null;
        specializations: Array<string | null> | null;
        bio: string | null;
      } | null;
    };
  } | null;
};

export type FetchCounsellorForChatQueryVariables = Exact<{
  counsellorId: string | number;
}>;

export type FetchCounsellorForChatQuery = {
  __typename: 'Query';
  fetchCounsellorById: {
    __typename: 'FetchCounsellorResponse';
    counsellor: {
      __typename: 'Counsellor';
      firstName: string | null;
      lastName: string | null;
    };
  } | null;
};

export type CounsellorSelectionLanguagesFragment = {
  __typename: 'Language';
  code: string | null;
  name: string | null;
};

export type CounsellorSelectionFragment = {
  __typename: 'Counsellor';
  firstName: string | null;
  id: string;
  jobTitles: Array<string | null> | null;
  lastName: string | null;
  appointmentTypes: Array<Types.AppointmentType>;
  availableInNearFuture: boolean;
  avatarImage: { __typename: 'Image'; url: string } | null;
  spokenLanguages: Array<{
    __typename: 'Language';
    code: string | null;
    name: string | null;
  } | null> | null;
  info: { __typename: 'CounsellorInfo'; bio: string | null } | null;
};

export type FirstOfferedCounsellorFragment = {
  __typename: 'Counsellor';
  allowsBooking: boolean;
  firstName: string | null;
  lastName: string | null;
  id: string;
};

export type FirstOfferedTimeslotFragment = {
  __typename: 'AvailableTimeSlot';
  id: string;
  startDateTime: string;
  endDateTime: string;
  types: Array<Types.AppointmentType>;
  counsellor: {
    __typename: 'Counsellor';
    allowsBooking: boolean;
    firstName: string | null;
    lastName: string | null;
    id: string;
  };
};

export type CounsellorSelectionPaginationFragment = {
  __typename: 'Pagination';
  isLastPage: boolean;
  cursors: { __typename: 'PaginationCursors'; after: string | null };
};

export type AvailableFilterOptionsFragment = {
  __typename: 'CounsellorFilterOption';
  id: string;
  title: string;
};

export type FetchCounsellorsQueryVariables = Exact<{
  input: Types.FetchCounsellorsInput;
}>;

export type FetchCounsellorsQuery = {
  __typename: 'Query';
  fetchCounsellors: {
    __typename: 'FetchCounsellorsResponse';
    counsellors: {
      __typename: 'PaginatedCounsellors';
      data: Array<{
        __typename: 'Counsellor';
        firstName: string | null;
        id: string;
        jobTitles: Array<string | null> | null;
        lastName: string | null;
        appointmentTypes: Array<Types.AppointmentType>;
        availableInNearFuture: boolean;
        avatarImage: { __typename: 'Image'; url: string } | null;
        spokenLanguages: Array<{
          __typename: 'Language';
          code: string | null;
          name: string | null;
        } | null> | null;
        info: { __typename: 'CounsellorInfo'; bio: string | null } | null;
      }> | null;
      paging: {
        __typename: 'Pagination';
        isLastPage: boolean;
        cursors: { __typename: 'PaginationCursors'; after: string | null };
      } | null;
    };
  } | null;
};

export type FetchCounsellorFiltersQueryVariables = Exact<{
  locationId: string | number;
}>;

export type FetchCounsellorFiltersQuery = {
  __typename: 'Query';
  fetchCounsellorFilters: {
    __typename: 'FetchCounsellorFiltersResponse';
    filters: Array<{
      __typename: 'CounsellorFilter';
      id: string;
      title: string;
      description: string;
      options: Array<{
        __typename: 'CounsellorFilterOption';
        id: string;
        title: string;
      }>;
    }>;
  } | null;
};

export type FetchFirstOfferedAppointmentQueryVariables = Exact<{
  locationId: string | number;
}>;

export type FetchFirstOfferedAppointmentQuery = {
  __typename: 'Query';
  fetchFirstOfferedAvailableTimeSlot: {
    __typename: 'FetchFirstOfferedAvailableTimeSlotResponse';
    availableTimeSlot: {
      __typename: 'AvailableTimeSlot';
      id: string;
      startDateTime: string;
      endDateTime: string;
      types: Array<Types.AppointmentType>;
      counsellor: {
        __typename: 'Counsellor';
        allowsBooking: boolean;
        firstName: string | null;
        lastName: string | null;
        id: string;
      };
    };
  } | null;
};

export type StripeInitializationQueryVariables = Exact<{
  [key: string]: never;
}>;

export type StripeInitializationQuery = {
  __typename: 'Query';
  stripeInitialization: {
    __typename: 'StripeInitializationResponse';
    stripeInitialization: {
      __typename: 'StripeInitialization';
      publishableKey: string;
    };
  } | null;
  appointmentPaymentSetupIntent: {
    __typename: 'AppointmentPaymentSetupIntentResponse';
    stripeIntent: {
      __typename: 'StripeSetupIntent';
      customerId: string;
      intentClientSecret: string;
      customerSessionClientSecret: string;
    };
  } | null;
};

export type SelectedCardQueryVariables = Exact<{ [key: string]: never }>;

export type SelectedCardQuery = {
  __typename: 'Query';
  selectedCard: {
    __typename: 'SelectedCardResponse';
    selectedCard: {
      __typename: 'SelectedCard';
      last4Digits: string;
      cardBrand: Types.CardBrand;
      expirationMonth: number;
      expirationYear: number;
      isExpired: boolean;
    } | null;
  } | null;
};

export type TimeslotCounsellorFragment = {
  __typename: 'Counsellor';
  firstName: string | null;
  id: string;
  jobTitles: Array<string | null> | null;
  lastName: string | null;
  avatarImage: { __typename: 'Image'; url: string } | null;
};

export type TimeSlotFragment = {
  __typename: 'AvailableTimeSlot';
  endDateTime: string;
  id: string;
  startDateTime: string;
  types: Array<Types.AppointmentType>;
};

export type CounsellorWithTimeslotsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CounsellorWithTimeslotsQuery = {
  __typename: 'Query';
  fetchCounsellor: {
    __typename: 'FetchCounsellorResponse';
    counsellor: {
      __typename: 'Counsellor';
      firstName: string | null;
      id: string;
      jobTitles: Array<string | null> | null;
      lastName: string | null;
      timeSlots: Array<{
        __typename: 'AvailableTimeSlot';
        endDateTime: string;
        id: string;
        startDateTime: string;
        types: Array<Types.AppointmentType>;
      }> | null;
      avatarImage: { __typename: 'Image'; url: string } | null;
    };
  } | null;
};

export type CounsellorByIdWithTimeslotsQueryVariables = Exact<{
  counsellorId: string | number;
}>;

export type CounsellorByIdWithTimeslotsQuery = {
  __typename: 'Query';
  fetchCounsellorById: {
    __typename: 'FetchCounsellorResponse';
    counsellor: {
      __typename: 'Counsellor';
      firstName: string | null;
      id: string;
      jobTitles: Array<string | null> | null;
      lastName: string | null;
      timeSlots: Array<{
        __typename: 'AvailableTimeSlot';
        endDateTime: string;
        id: string;
        startDateTime: string;
        types: Array<Types.AppointmentType>;
      }> | null;
      avatarImage: { __typename: 'Image'; url: string } | null;
    };
  } | null;
};

export type SubdivisionQueryVariables = Exact<{ [key: string]: never }>;

export type SubdivisionQuery = {
  __typename: 'Query';
  fetchUserSubdivisions: {
    __typename: 'FetchUserSubdivisionsResponse';
    subdivisions: Array<{
      __typename: 'Subdivision';
      id: string;
      name: string;
    }>;
  } | null;
};

export type AppointmentsFragment = {
  __typename: 'Appointment';
  id: string;
  status: Types.AppointmentStatus;
  startDateTime: string;
  endDateTime: string;
  typeDescription: Types.AppointmentType;
  counsellor: {
    __typename: 'Counsellor';
    id: string;
    firstName: string | null;
    lastName: string | null;
    jobTitles: Array<string | null> | null;
    allowsBooking: boolean;
    avatarImage: { __typename: 'Image'; url: string } | null;
  };
};

export type AppointmentsPaginationFragment = {
  __typename: 'Pagination';
  isLastPage: boolean;
  cursors: { __typename: 'PaginationCursors'; after: string | null };
};

export type FetchUpcomingAppointmentsQueryVariables = Exact<{
  input: Types.FetchAppointmentsInput;
}>;

export type FetchUpcomingAppointmentsQuery = {
  __typename: 'Query';
  fetchAppointments: {
    __typename: 'FetchAppointmentsResponse';
    appointments: {
      __typename: 'PaginatedAppointments';
      data: Array<{
        __typename: 'Appointment';
        id: string;
        status: Types.AppointmentStatus;
        startDateTime: string;
        endDateTime: string;
        typeDescription: Types.AppointmentType;
        counsellor: {
          __typename: 'Counsellor';
          id: string;
          firstName: string | null;
          lastName: string | null;
          jobTitles: Array<string | null> | null;
          allowsBooking: boolean;
          avatarImage: { __typename: 'Image'; url: string } | null;
        };
      }>;
    };
  } | null;
};

export type FetchPastAppointmentsQueryVariables = Exact<{
  input: Types.FetchAppointmentsInput;
}>;

export type FetchPastAppointmentsQuery = {
  __typename: 'Query';
  fetchAppointments: {
    __typename: 'FetchAppointmentsResponse';
    appointments: {
      __typename: 'PaginatedAppointments';
      data: Array<{
        __typename: 'Appointment';
        id: string;
        status: Types.AppointmentStatus;
        startDateTime: string;
        endDateTime: string;
        typeDescription: Types.AppointmentType;
        counsellor: {
          __typename: 'Counsellor';
          id: string;
          firstName: string | null;
          lastName: string | null;
          jobTitles: Array<string | null> | null;
          allowsBooking: boolean;
          avatarImage: { __typename: 'Image'; url: string } | null;
        };
      }>;
      paging: {
        __typename: 'Pagination';
        isLastPage: boolean;
        cursors: { __typename: 'PaginationCursors'; after: string | null };
      };
    };
  } | null;
};

export type YourCounsellorFragment = {
  __typename: 'Counsellor';
  appointmentTypes: Array<Types.AppointmentType>;
  firstName: string | null;
  id: string;
  jobTitles: Array<string | null> | null;
  lastName: string | null;
  allowsBooking: boolean;
  displayHistory: boolean;
  avatarImage: { __typename: 'Image'; url: string } | null;
};

export type FetchYourCounsellorQueryVariables = Exact<{ [key: string]: never }>;

export type FetchYourCounsellorQuery = {
  __typename: 'Query';
  fetchCounsellor: {
    __typename: 'FetchCounsellorResponse';
    counsellor: {
      __typename: 'Counsellor';
      appointmentTypes: Array<Types.AppointmentType>;
      firstName: string | null;
      id: string;
      jobTitles: Array<string | null> | null;
      lastName: string | null;
      allowsBooking: boolean;
      displayHistory: boolean;
      avatarImage: { __typename: 'Image'; url: string } | null;
    };
  } | null;
};

export type WellbeingHubAssessmentListItemFragment = {
  __typename: 'AssessmentListItem';
  uuid: string;
  status: Types.AssessmentStatus;
  title: string;
  numberOfQuestions: number;
  percentageComplete: number;
  tierPoints: number | null;
  icon: { __typename: 'Image'; url: string } | null;
};

export type WellbeingHubAssessmentPromotionFragment = {
  __typename: 'AssessmentPromotion';
  title: string;
  assessment: {
    __typename: 'AssessmentListItem';
    uuid: string;
    status: Types.AssessmentStatus;
    title: string;
    numberOfQuestions: number;
    percentageComplete: number;
    tierPoints: number | null;
    icon: { __typename: 'Image'; url: string } | null;
  } | null;
};

export type WellbeingHubHraPromotionFragment = {
  __typename: 'HraPromotion';
  title: string;
  image: { __typename: 'Image'; url: string } | null;
  icon: { __typename: 'Image'; url: string } | null;
  assessment: {
    __typename: 'FeaturedAssessment';
    completedAt: string | null;
    status: Types.AssessmentStatus;
    title: string;
    tierPoints: number | null;
    numberOfAssessments: number | null;
    assessmentsRemaining: number | null;
    icon: { __typename: 'Image'; url: string } | null;
    assessment: {
      __typename: 'AssessmentListItem';
      title: string;
      status: Types.AssessmentStatus;
      numberOfQuestions: number;
      percentageComplete: number;
      uuid: string;
      result: {
        __typename: 'AssessmentListItemResult';
        percentageScore: number;
      } | null;
    };
  } | null;
};

export type PreAssessmentResultHistoryFragment = {
  __typename: 'PreAssessmentResult';
  completedAt: string | null;
  description: string;
  displayMaxScore: number;
  id: string;
  maxScore: number;
  score: number;
  sessionId: string;
  severities: Array<string>;
  title: string;
};

export type PreAssessmentResultsHistoryQueryVariables = Exact<{
  where?: Types.FilterPreAssessmentHistoryInput | null | undefined;
}>;

export type PreAssessmentResultsHistoryQuery = {
  __typename: 'Query';
  preAssessmentResultsHistory: {
    __typename: 'PreAssessmentResultsHistoryResponse';
    history: Array<{
      __typename: 'PreAssessmentResult';
      completedAt: string | null;
      description: string;
      displayMaxScore: number;
      id: string;
      maxScore: number;
      score: number;
      sessionId: string;
      severities: Array<string>;
      title: string;
    } | null> | null;
    pagination: {
      __typename: 'Pagination';
      isLastPage: boolean;
      cursors: { __typename: 'PaginationCursors'; after: string | null };
    };
  } | null;
};

export type CareAssessmentChoiceQuestionOptionFragment = {
  __typename: 'CareAssessmentChoiceQuestionOption';
  id: string;
  title: string;
  nextQuestionId: string | null;
};

export type CareAssessmentsChoiceQuestionFragment = {
  __typename: 'CareAssessmentChoiceQuestion';
  id: string;
  title: string;
  subtitle: string | null;
  description: string | null;
  options: Array<{
    __typename: 'CareAssessmentChoiceQuestionOption';
    id: string;
    title: string;
    nextQuestionId: string | null;
  }>;
};

export type CareAssessmentsTextQuestionFragment = {
  __typename: 'CareAssessmentTextQuestion';
  id: string;
  title: string;
  subtitle: string | null;
  description: string | null;
  placeholder: string | null;
  maxLength: number;
  nextQuestionId: string | null;
};

export type CareAssessmentFragment = {
  __typename: 'CareAssessment';
  id: string;
  title: string;
  subtitle: string | null;
  sessionId: string | null;
  questions: Array<
    | {
        __typename: 'CareAssessmentChoiceQuestion';
        id: string;
        title: string;
        subtitle: string | null;
        description: string | null;
        options: Array<{
          __typename: 'CareAssessmentChoiceQuestionOption';
          id: string;
          title: string;
          nextQuestionId: string | null;
        }>;
      }
    | {
        __typename: 'CareAssessmentTextQuestion';
        id: string;
        title: string;
        subtitle: string | null;
        description: string | null;
        placeholder: string | null;
        maxLength: number;
        nextQuestionId: string | null;
      }
  >;
};

export type PreAssessmentResultFragment = {
  __typename: 'PreAssessmentResult';
  title: string;
  severities: Array<string>;
  score: number;
  maxScore: number;
  displayMaxScore: number;
  description: string;
  completedAt: string | null;
  sessionId: string;
  id: string;
  retakeData: {
    __typename: 'RetakeData';
    earlyRetakeWarningMessage: string | null;
  };
};

export type PreAssessmentNotTakenFragment = {
  __typename: 'PreAssessmentNotTaken';
  id: string;
  sessionId: string;
  title: string;
};

export type PreAssessmentResultsFragment = {
  __typename: 'PreAssessmentResults';
  shouldSpeakToCounsellor: boolean;
  assessments: Array<
    | {
        __typename: 'PreAssessmentNotTaken';
        id: string;
        sessionId: string;
        title: string;
      }
    | {
        __typename: 'PreAssessmentResult';
        title: string;
        severities: Array<string>;
        score: number;
        maxScore: number;
        displayMaxScore: number;
        description: string;
        completedAt: string | null;
        sessionId: string;
        id: string;
        retakeData: {
          __typename: 'RetakeData';
          earlyRetakeWarningMessage: string | null;
        };
      }
  >;
};

export type RecommendationFragment = {
  __typename: 'PreAssessmentRecommendationSuicideRiskCallNow';
  id: string;
  ccsTeamTelephoneNumber: string;
};

export type PreAssessmentQueryVariables = Exact<{
  where?: Types.FilterPreAssessmentInput | null | undefined;
}>;

export type PreAssessmentQuery = {
  __typename: 'Query';
  preAssessment: {
    __typename: 'PreAssessmentResponse';
    nextAssessment: {
      __typename: 'CareAssessment';
      id: string;
      title: string;
      subtitle: string | null;
      sessionId: string | null;
      questions: Array<
        | {
            __typename: 'CareAssessmentChoiceQuestion';
            id: string;
            title: string;
            subtitle: string | null;
            description: string | null;
            options: Array<{
              __typename: 'CareAssessmentChoiceQuestionOption';
              id: string;
              title: string;
              nextQuestionId: string | null;
            }>;
          }
        | {
            __typename: 'CareAssessmentTextQuestion';
            id: string;
            title: string;
            subtitle: string | null;
            description: string | null;
            placeholder: string | null;
            maxLength: number;
            nextQuestionId: string | null;
          }
      >;
    } | null;
  } | null;
};

export type AnswerPreAssessmentMutationVariables = Exact<{
  request: Types.AnswerPreAssessmentInput;
}>;

export type AnswerPreAssessmentMutation = {
  __typename: 'Mutation';
  answerPreAssessment: {
    __typename: 'AnswerPreAssessmentResponse';
    nextAssessment: {
      __typename: 'CareAssessment';
      id: string;
      title: string;
      subtitle: string | null;
      sessionId: string | null;
      questions: Array<
        | {
            __typename: 'CareAssessmentChoiceQuestion';
            id: string;
            title: string;
            subtitle: string | null;
            description: string | null;
            options: Array<{
              __typename: 'CareAssessmentChoiceQuestionOption';
              id: string;
              title: string;
              nextQuestionId: string | null;
            }>;
          }
        | {
            __typename: 'CareAssessmentTextQuestion';
            id: string;
            title: string;
            subtitle: string | null;
            description: string | null;
            placeholder: string | null;
            maxLength: number;
            nextQuestionId: string | null;
          }
      >;
    } | null;
    recommendation:
      | { __typename: 'PreAssessmentRecommendationBookAppointment' }
      | {
          __typename: 'PreAssessmentRecommendationSuicideRiskCallNow';
          id: string;
          ccsTeamTelephoneNumber: string;
        }
      | null;
    results: {
      __typename: 'PreAssessmentResults';
      shouldSpeakToCounsellor: boolean;
      assessments: Array<
        | {
            __typename: 'PreAssessmentNotTaken';
            id: string;
            sessionId: string;
            title: string;
          }
        | {
            __typename: 'PreAssessmentResult';
            title: string;
            severities: Array<string>;
            score: number;
            maxScore: number;
            displayMaxScore: number;
            description: string;
            completedAt: string | null;
            sessionId: string;
            id: string;
            retakeData: {
              __typename: 'RetakeData';
              earlyRetakeWarningMessage: string | null;
            };
          }
      >;
    } | null;
  } | null;
};

export type RequestCallbackForAtRiskMemberMutationVariables = Exact<{
  input: Types.RequestCallbackForAtRiskMemberInput;
}>;

export type RequestCallbackForAtRiskMemberMutation = {
  __typename: 'Mutation';
  requestCallbackForAtRiskMember: {
    __typename: 'RequestCallbackForAtRiskMemberResponse';
    telephoneNumber: string | null;
  } | null;
};

export type SelectedCareServiceOptionQueryVariables = Exact<{
  [key: string]: never;
}>;

export type SelectedCareServiceOptionQuery = {
  __typename: 'Query';
  selectedCareServiceOption: {
    __typename: 'SelectedCareServiceOptionResponse';
    option: Types.CareServiceOption;
  } | null;
};

export type CareIssueFragment = {
  __typename: 'CareIssue';
  id: string;
  title: string;
  subtitle: string | null;
  analyticsId: string;
  default: boolean | null;
};

export type CareIssuesQueryVariables = Exact<{ [key: string]: never }>;

export type CareIssuesQuery = {
  __typename: 'Query';
  getCareIssues: {
    __typename: 'CareIssuesResponse';
    careIssues: Array<{
      __typename: 'CareIssue';
      id: string;
      title: string;
      subtitle: string | null;
      analyticsId: string;
      default: boolean | null;
    }>;
  } | null;
};

export type SetCareIssueMutationVariables = Exact<{
  request: Types.SetCareIssueInput;
}>;

export type SetCareIssueMutation = {
  __typename: 'Mutation';
  setCareIssue: {
    __typename: 'SetCareIssueResponse';
    careIssue: {
      __typename: 'CareIssue';
      id: string;
      title: string;
      subtitle: string | null;
      analyticsId: string;
      default: boolean | null;
    };
  } | null;
};

export type AskForImmediateHelpMutationVariables = Exact<{
  [key: string]: never;
}>;

export type AskForImmediateHelpMutation = {
  __typename: 'Mutation';
  askForImmediateHelp: {
    __typename: 'AskForImmediateHelpResponse';
    ccsTeamTelephoneNumber: string;
  } | null;
};

export type SelectCareServiceOptionMutationVariables = Exact<{
  request: Types.SelectCareServiceOptionInput;
}>;

export type SelectCareServiceOptionMutation = {
  __typename: 'Mutation';
  selectCareServiceOption: {
    __typename: 'SelectCareServiceOptionResponse';
    option: Types.CareServiceOption;
  } | null;
};

export type CarePlanActivityWithHippoFragment = {
  __typename: 'CarePlanActivityArticle';
  type: Types.ArticleType | null;
  body: string;
  copyright: string;
  audios: Array<{
    __typename: 'ArticleAudio';
    title: string | null;
    url: string;
  }>;
  heroImage: { __typename: 'Image'; url: string } | null;
  videos: Array<{
    __typename: 'ArticleVideo';
    hlsUrl: string | null;
    url: string;
  }>;
  documents: Array<{
    __typename: 'ArticleDocument';
    format: string;
    size: string;
    title: string;
    url: string;
    path: string;
  }>;
};

export type ModuleWithoutActivitiesFragment = {
  __typename: 'CarePlanModule';
  id: string;
  name: string;
};

export type ActivityFragment = {
  __typename: 'CarePlanActivityArticle';
  type: Types.ArticleType | null;
  id: string;
  title: string;
  completed: boolean;
  module: { __typename: 'CarePlanModule'; id: string; name: string };
};

export type CarePlanActivityFragment = {
  __typename: 'CarePlanActivityArticle';
  type: Types.ArticleType | null;
  id: string;
  title: string;
  completed: boolean;
  body: string;
  copyright: string;
  nextActivity: {
    __typename: 'CarePlanActivityArticle';
    type: Types.ArticleType | null;
    id: string;
    title: string;
    completed: boolean;
    module: { __typename: 'CarePlanModule'; id: string; name: string };
  } | null;
  previousActivity: {
    __typename: 'CarePlanActivityArticle';
    type: Types.ArticleType | null;
    id: string;
    title: string;
    completed: boolean;
    module: { __typename: 'CarePlanModule'; id: string; name: string };
  } | null;
  module: { __typename: 'CarePlanModule'; id: string; name: string };
  audios: Array<{
    __typename: 'ArticleAudio';
    title: string | null;
    url: string;
  }>;
  heroImage: { __typename: 'Image'; url: string } | null;
  videos: Array<{
    __typename: 'ArticleVideo';
    hlsUrl: string | null;
    url: string;
  }>;
  documents: Array<{
    __typename: 'ArticleDocument';
    format: string;
    size: string;
    title: string;
    url: string;
    path: string;
  }>;
};

export type CarePlanActivityQueryVariables = Exact<{
  where?: Types.CarePlanActivityInput | null | undefined;
}>;

export type CarePlanActivityQuery = {
  __typename: 'Query';
  carePlanActivity: {
    __typename: 'CarePlanActivityResponse';
    carePlanActivity: {
      __typename: 'CarePlanActivityArticle';
      type: Types.ArticleType | null;
      id: string;
      title: string;
      completed: boolean;
      body: string;
      copyright: string;
      nextActivity: {
        __typename: 'CarePlanActivityArticle';
        type: Types.ArticleType | null;
        id: string;
        title: string;
        completed: boolean;
        module: { __typename: 'CarePlanModule'; id: string; name: string };
      } | null;
      previousActivity: {
        __typename: 'CarePlanActivityArticle';
        type: Types.ArticleType | null;
        id: string;
        title: string;
        completed: boolean;
        module: { __typename: 'CarePlanModule'; id: string; name: string };
      } | null;
      module: { __typename: 'CarePlanModule'; id: string; name: string };
      audios: Array<{
        __typename: 'ArticleAudio';
        title: string | null;
        url: string;
      }>;
      heroImage: { __typename: 'Image'; url: string } | null;
      videos: Array<{
        __typename: 'ArticleVideo';
        hlsUrl: string | null;
        url: string;
      }>;
      documents: Array<{
        __typename: 'ArticleDocument';
        format: string;
        size: string;
        title: string;
        url: string;
        path: string;
      }>;
    } | null;
  } | null;
};

export type CompleteCarePlanActivityMutationVariables = Exact<{
  input?: Types.CompleteCarePlanActivityInput | null | undefined;
}>;

export type CompleteCarePlanActivityMutation = {
  __typename: 'Mutation';
  completeCarePlanActivity: {
    __typename: 'CompleteCarePlanActivityResponse';
    carePlanActivity: {
      __typename: 'CarePlanActivityArticle';
      id: string;
      completed: boolean;
    } | null;
  } | null;
};

export type CarePlanModulesFragment = {
  __typename: 'CarePlanModule';
  id: string;
  name: string;
  activities: Array<{
    __typename: 'CarePlanActivityArticle';
    type: Types.ArticleType | null;
    id: string;
    title: string;
    completed: boolean;
    module: { __typename: 'CarePlanModule'; id: string; name: string };
  }>;
};

export type CarePlanSectionsFragment = {
  __typename: 'CarePlanSection';
  id: string;
  modules: Array<{
    __typename: 'CarePlanModule';
    id: string;
    name: string;
    activities: Array<{
      __typename: 'CarePlanActivityArticle';
      type: Types.ArticleType | null;
      id: string;
      title: string;
      completed: boolean;
      module: { __typename: 'CarePlanModule'; id: string; name: string };
    }>;
  }>;
};

export type CarePlanFragment = {
  __typename: 'CarePlan';
  id: string;
  name: string;
  description: string;
  sections: Array<{
    __typename: 'CarePlanSection';
    id: string;
    modules: Array<{
      __typename: 'CarePlanModule';
      id: string;
      name: string;
      activities: Array<{
        __typename: 'CarePlanActivityArticle';
        type: Types.ArticleType | null;
        id: string;
        title: string;
        completed: boolean;
        module: { __typename: 'CarePlanModule'; id: string; name: string };
      }>;
    }>;
  }>;
  currentActivity: {
    __typename: 'CarePlanActivityArticle';
    type: Types.ArticleType | null;
    id: string;
    title: string;
    completed: boolean;
    module: { __typename: 'CarePlanModule'; id: string; name: string };
  } | null;
};

export type CarePlanQueryVariables = Exact<{ [key: string]: never }>;

export type CarePlanQuery = {
  __typename: 'Query';
  carePlan: {
    __typename: 'CarePlanResponse';
    carePlan: {
      __typename: 'CarePlan';
      id: string;
      name: string;
      description: string;
      sections: Array<{
        __typename: 'CarePlanSection';
        id: string;
        modules: Array<{
          __typename: 'CarePlanModule';
          id: string;
          name: string;
          activities: Array<{
            __typename: 'CarePlanActivityArticle';
            type: Types.ArticleType | null;
            id: string;
            title: string;
            completed: boolean;
            module: { __typename: 'CarePlanModule'; id: string; name: string };
          }>;
        }>;
      }>;
      currentActivity: {
        __typename: 'CarePlanActivityArticle';
        type: Types.ArticleType | null;
        id: string;
        title: string;
        completed: boolean;
        module: { __typename: 'CarePlanModule'; id: string; name: string };
      } | null;
    } | null;
  } | null;
};

export type AssignCarePlanMutationVariables = Exact<{
  input: Types.AssignCarePlanInput;
}>;

export type AssignCarePlanMutation = {
  __typename: 'Mutation';
  assignCarePlan: {
    __typename: 'AssignCarePlanResponse';
    received: boolean;
  } | null;
};

export type ActivityQueryVariables = Exact<{
  challengeId: string | number;
  from?: string | null | undefined;
  after?: string | null | undefined;
}>;

export type ActivityQuery = {
  __typename: 'Query';
  fetchChallenge: {
    __typename: 'fetchChallengeResponse';
    challenge:
      | {
          __typename: 'HabitChallenge';
          challengeId: string;
          subtitle: string | null;
          status: Types.ChallengeStatus;
          goal: number;
          activity: {
            __typename: 'HabitActivityResponse';
            activity: Array<{
              __typename: 'HabitDailyActivity';
              id: string;
              date: string;
              tracked: number;
              subtitle: string;
              tradeLimit: number;
              activity: Array<{
                __typename: 'HabitActivity';
                habit: {
                  __typename: 'Habit';
                  habitId: string;
                  tracked: number | null;
                  title: string;
                  thumbnailImage: {
                    __typename: 'Image';
                    url: string;
                    font: {
                      __typename: 'Font';
                      color: {
                        __typename: 'Color';
                        name: string | null;
                        hexCode: string;
                      } | null;
                    } | null;
                  } | null;
                } | null;
                optionActivity: Array<{
                  __typename: 'HabitOptionActivity';
                  tracked: number;
                  option: {
                    __typename: 'HabitOption';
                    optionId: string;
                    title: string;
                  } | null;
                } | null>;
              }> | null;
            }> | null;
            pagination: {
              __typename: 'Pagination';
              isLastPage: boolean;
              limit: number | null;
              cursors: {
                __typename: 'PaginationCursors';
                after: string | null;
                before: string | null;
              };
            } | null;
          };
          challengeHabits: {
            __typename: 'ChallengeHabits';
            habits: Array<{
              __typename: 'Habit';
              habitId: string;
              title: string;
              subtitle: string;
              description: string | null;
              selected: boolean | null;
              thumbnailImage: { __typename: 'Image'; url: string } | null;
              options: Array<{
                __typename: 'HabitOption';
                optionId: string;
                title: string;
              }> | null;
            }>;
          } | null;
        }
      | {
          __typename: 'StepChallenge';
          challengeId: string;
          status: Types.ChallengeStatus;
          goal: number;
          activity: {
            __typename: 'StepActivityResponse';
            activity: Array<{
              __typename: 'StepDailyActivity';
              date: string;
              tracked: number;
              type: Types.StepActivityType;
              subtitle: string;
            }> | null;
            pagination: {
              __typename: 'Pagination';
              isLastPage: boolean;
              limit: number | null;
              cursors: {
                __typename: 'PaginationCursors';
                after: string | null;
                before: string | null;
              };
            } | null;
          };
        }
      | null;
  };
};

export type HabitDailyActivityInputFragment = {
  __typename: 'HabitDailyActivity';
  id: string;
  tracked: number;
  activity: Array<{
    __typename: 'HabitActivity';
    habit: {
      __typename: 'Habit';
      habitId: string;
      tracked: number | null;
      title: string;
      subtitle: string;
      description: string | null;
      selected: boolean | null;
      tradeCaptions: {
        __typename: 'HabitTradeCaption';
        title: string;
        subtitle: string;
      };
      thumbnailImage: {
        __typename: 'Image';
        url: string;
        font: {
          __typename: 'Font';
          color: {
            __typename: 'Color';
            name: string | null;
            hexCode: string;
          } | null;
        } | null;
      } | null;
    } | null;
    optionActivity: Array<{
      __typename: 'HabitOptionActivity';
      tracked: number;
      option: {
        __typename: 'HabitOption';
        optionId: string;
        title: string;
      } | null;
    } | null>;
  }> | null;
};

export type FetchActivityHabitInputQueryVariables = Exact<{
  id: string | number;
  date: string;
}>;

export type FetchActivityHabitInputQuery = {
  __typename: 'Query';
  fetchChallenge: {
    __typename: 'fetchChallengeResponse';
    challenge:
      | {
          __typename: 'HabitChallenge';
          challengeId: string;
          activity: {
            __typename: 'HabitActivityResponse';
            activity: Array<{
              __typename: 'HabitDailyActivity';
              id: string;
              tracked: number;
              activity: Array<{
                __typename: 'HabitActivity';
                habit: {
                  __typename: 'Habit';
                  habitId: string;
                  tracked: number | null;
                  title: string;
                  subtitle: string;
                  description: string | null;
                  selected: boolean | null;
                  tradeCaptions: {
                    __typename: 'HabitTradeCaption';
                    title: string;
                    subtitle: string;
                  };
                  thumbnailImage: {
                    __typename: 'Image';
                    url: string;
                    font: {
                      __typename: 'Font';
                      color: {
                        __typename: 'Color';
                        name: string | null;
                        hexCode: string;
                      } | null;
                    } | null;
                  } | null;
                } | null;
                optionActivity: Array<{
                  __typename: 'HabitOptionActivity';
                  tracked: number;
                  option: {
                    __typename: 'HabitOption';
                    optionId: string;
                    title: string;
                  } | null;
                } | null>;
              }> | null;
            }> | null;
          };
          challengeHabits: {
            __typename: 'ChallengeHabits';
            habits: Array<{
              __typename: 'Habit';
              habitId: string;
              title: string;
              subtitle: string;
              description: string | null;
              selected: boolean | null;
              thumbnailImage: { __typename: 'Image'; url: string } | null;
              options: Array<{
                __typename: 'HabitOption';
                optionId: string;
                title: string;
              }> | null;
            }>;
          } | null;
        }
      | { __typename: 'StepChallenge' }
      | null;
  };
};

export type UpdateActivityHabitInputMutationVariables = Exact<{
  id: string;
  habitId: string;
  date: string;
  options:
    | Array<Types.UpdateHabitOptionActivityInput>
    | Types.UpdateHabitOptionActivityInput;
}>;

export type UpdateActivityHabitInputMutation = {
  __typename: 'Mutation';
  updateHabitActivity: {
    __typename: 'UpdateHabitActivityResponse';
    updatedHabitActivityTotals: {
      __typename: 'UpdatedHabitActivityTotals';
      challengeTrackedActivityTotal: number;
      habitTrackedActivityTotal: number;
    } | null;
  } | null;
};

export type RetakeIndividualChallengeMutationVariables = Exact<{
  id: string | number;
}>;

export type RetakeIndividualChallengeMutation = {
  __typename: 'Mutation';
  retakeIndividualChallenge: {
    __typename: 'RetakeIndividualChallengeResponse';
    challenge:
      | { __typename: 'HabitChallenge'; challengeId: string }
      | { __typename: 'StepChallenge' }
      | null;
  };
};

export type StepActivityFragment = {
  __typename: 'StepActivity';
  startedAt: string | null;
  emoji: string | null;
  type: Types.ExerciseActivityType | null;
  durationInMs: number | null;
};

export type StepDailyActivityInputFragment = {
  __typename: 'StepDailyActivity';
  id: string;
  tracked: number;
  activity: Array<{
    __typename: 'StepActivity';
    startedAt: string | null;
    emoji: string | null;
    type: Types.ExerciseActivityType | null;
    durationInMs: number | null;
  }> | null;
};

export type ActivityStepsQueryVariables = Exact<{
  id: string | number;
  date: string;
}>;

export type ActivityStepsQuery = {
  __typename: 'Query';
  fetchChallenge: {
    __typename: 'fetchChallengeResponse';
    challenge:
      | { __typename: 'HabitChallenge' }
      | {
          __typename: 'StepChallenge';
          challengeId: string;
          stepActivity: {
            __typename: 'StepActivityResponse';
            activity: Array<{
              __typename: 'StepDailyActivity';
              id: string;
              tracked: number;
              activity: Array<{
                __typename: 'StepActivity';
                startedAt: string | null;
                emoji: string | null;
                type: Types.ExerciseActivityType | null;
                durationInMs: number | null;
              }> | null;
            }> | null;
          };
        }
      | null;
  };
};

type ActivitySummaryData_AverageSteps_Fragment = {
  __typename: 'AverageSteps';
  total: number;
};

type ActivitySummaryData_ClimbedEiffelTower_Fragment = {
  __typename: 'ClimbedEiffelTower';
  total: number;
};

type ActivitySummaryData_CompletedMarathonPercentage_Fragment = {
  __typename: 'CompletedMarathonPercentage';
  total: number;
};

type ActivitySummaryData_HitGoal_Fragment = {
  __typename: 'HitGoal';
  total: number;
};

export type ActivitySummaryDataFragment =
  | ActivitySummaryData_AverageSteps_Fragment
  | ActivitySummaryData_ClimbedEiffelTower_Fragment
  | ActivitySummaryData_CompletedMarathonPercentage_Fragment
  | ActivitySummaryData_HitGoal_Fragment;

export type ChallengeResultFragment = {
  __typename: 'ChallengeResult';
  pointsAwarded: number | null;
  tieringStatus: Types.ChallengeResultTieringStatus;
  newTier: { __typename: 'Tier'; name: string; rank: number } | null;
};

export type ActivityStepsResultQueryVariables = Exact<{
  id: string | number;
  date: string;
}>;

export type ActivityStepsResultQuery = {
  __typename: 'Query';
  fetchChallenge: {
    __typename: 'fetchChallengeResponse';
    challenge:
      | { __typename: 'HabitChallenge' }
      | {
          __typename: 'StepChallenge';
          challengeId: string;
          result: {
            __typename: 'ChallengeResult';
            pointsAwarded: number | null;
            tieringStatus: Types.ChallengeResultTieringStatus;
            newTier: { __typename: 'Tier'; name: string; rank: number } | null;
          } | null;
          stepActivity: {
            __typename: 'StepActivityResponse';
            summary: Array<
              | { __typename: 'AverageSteps'; total: number }
              | { __typename: 'ClimbedEiffelTower'; total: number }
              | { __typename: 'CompletedMarathonPercentage'; total: number }
              | { __typename: 'HitGoal'; total: number }
            > | null;
          };
        }
      | null;
  };
};

export type TeamUserPermissionsFragment = {
  __typename: 'TeamPermissions';
  canCreateATeam: boolean | null;
  canChangeTeamName: boolean | null;
  canChangeTeamImage: boolean | null;
  canRemoveTeamImage: boolean | null;
  isTeamAdmin: boolean | null;
  membershipPrompt: Types.TeamMembershipPrompt;
};

export type ChallengeTeamFragment = {
  __typename: 'Team';
  id: string;
  name: string;
  image: { __typename: 'Image'; url: string } | null;
  userPermissions: {
    __typename: 'TeamPermissions';
    canCreateATeam: boolean | null;
    canChangeTeamName: boolean | null;
    canChangeTeamImage: boolean | null;
    canRemoveTeamImage: boolean | null;
    isTeamAdmin: boolean | null;
    membershipPrompt: Types.TeamMembershipPrompt;
  } | null;
};

export type PaginationFragment = {
  __typename: 'Pagination';
  isLastPage: boolean;
  limit: number | null;
  cursors: {
    __typename: 'PaginationCursors';
    after: string | null;
    before: string | null;
  };
};

export type HabitSelectionStateFragment = {
  __typename: 'Habit';
  habitId: string;
  selected: boolean | null;
};

export type ChallengeIntroductionFragment = {
  __typename: 'ChallengeIntroduction';
  id: string;
  info: string;
  title: string;
};

export type StepChallengeDateInfoFragment = {
  __typename: 'StepChallenge';
  startDateTimeISO: string | null;
  endDateTimeISO: string | null;
  lastUploaded: string | null;
};

export type FeaturedStepChallengeFieldFragment = {
  __typename: 'StepChallenge';
  participationType: Types.ChallengeParticipationType;
  challengeId: string;
  category: Types.ChallengeCategory;
  title: string;
  status: Types.ChallengeStatus;
  goal: number;
  wasJoined: boolean;
  endDateTimeISO: string | null;
  startDateTimeISO: string | null;
  image: { __typename: 'Image'; url: string } | null;
  completionReward: { __typename: 'TierReward'; points: string } | null;
  stepActivity: {
    __typename: 'StepActivityResponse';
    activity: Array<{
      __typename: 'StepDailyActivity';
      tracked: number;
    }> | null;
  };
};

export type FeaturedHabitChallengeFieldFragment = {
  __typename: 'HabitChallenge';
  participationType: Types.ChallengeParticipationType;
  challengeId: string;
  category: Types.ChallengeCategory;
  title: string;
  status: Types.ChallengeStatus;
  goal: number;
  wasJoined: boolean;
  endDateTimeISO: string | null;
  startDateTimeISO: string | null;
  image: { __typename: 'Image'; url: string } | null;
  completionReward: { __typename: 'TierReward'; points: string } | null;
  activity: {
    __typename: 'HabitActivityResponse';
    activity: Array<{
      __typename: 'HabitDailyActivity';
      tracked: number;
    }> | null;
  };
};

export type FeaturedChallengeFieldsFragment = {
  __typename: 'fetchFeaturedChallengesResponse';
  challenges: Array<
    | {
        __typename: 'HabitChallenge';
        participationType: Types.ChallengeParticipationType;
        challengeId: string;
        category: Types.ChallengeCategory;
        title: string;
        status: Types.ChallengeStatus;
        goal: number;
        wasJoined: boolean;
        endDateTimeISO: string | null;
        startDateTimeISO: string | null;
        image: { __typename: 'Image'; url: string } | null;
        completionReward: { __typename: 'TierReward'; points: string } | null;
        activity: {
          __typename: 'HabitActivityResponse';
          activity: Array<{
            __typename: 'HabitDailyActivity';
            tracked: number;
          }> | null;
        };
      }
    | {
        __typename: 'StepChallenge';
        participationType: Types.ChallengeParticipationType;
        challengeId: string;
        category: Types.ChallengeCategory;
        title: string;
        status: Types.ChallengeStatus;
        goal: number;
        wasJoined: boolean;
        endDateTimeISO: string | null;
        startDateTimeISO: string | null;
        image: { __typename: 'Image'; url: string } | null;
        completionReward: { __typename: 'TierReward'; points: string } | null;
        stepActivity: {
          __typename: 'StepActivityResponse';
          activity: Array<{
            __typename: 'StepDailyActivity';
            tracked: number;
          }> | null;
        };
      }
  > | null;
};

export type StepChallengeListItemFragment = {
  __typename: 'StepChallenge';
  challengeId: string;
  status: Types.ChallengeStatus;
  title: string;
  category: Types.ChallengeCategory;
  categoryDisplayText: string;
  participationType: Types.ChallengeParticipationType;
  wasJoined: boolean;
  goal: number;
  endDateTimeISO: string | null;
  startDateTimeISO: string | null;
  completionReward: { __typename: 'TierReward'; points: string } | null;
  image: { __typename: 'Image'; url: string } | null;
  stepActivity: {
    __typename: 'StepActivityResponse';
    activity: Array<{
      __typename: 'StepDailyActivity';
      tracked: number;
    }> | null;
  };
  leaderboardIndividuals: {
    __typename: 'LeaderboardIndividualResponse';
    leaderboard: Array<{
      __typename: 'IndividualsLeaderboardEntry';
      position: number | null;
    }> | null;
  };
};

export type StepChallengeBasicInfoFragment = {
  __typename: 'StepChallenge';
  challengeId: string;
  subtitle: string | null;
  status: Types.ChallengeStatus;
  title: string;
  category: Types.ChallengeCategory;
  categoryDisplayText: string;
  participationType: Types.ChallengeParticipationType;
  wasJoined: boolean;
  goal: number;
  endDateTimeISO: string | null;
  startDateTimeISO: string | null;
  lastUploaded: string | null;
  introduction: Array<{
    __typename: 'ChallengeIntroduction';
    id: string;
    info: string;
    title: string;
  } | null> | null;
  completionReward: { __typename: 'TierReward'; points: string } | null;
  image: { __typename: 'Image'; url: string } | null;
  stepActivity: {
    __typename: 'StepActivityResponse';
    activity: Array<{
      __typename: 'StepDailyActivity';
      tracked: number;
    }> | null;
  };
  leaderboardIndividuals: {
    __typename: 'LeaderboardIndividualResponse';
    leaderboard: Array<{
      __typename: 'IndividualsLeaderboardEntry';
      position: number | null;
    }> | null;
  };
};

export type HabitBasicInfoFragment = {
  __typename: 'Habit';
  habitId: string;
  title: string;
  subtitle: string;
  description: string | null;
  selected: boolean | null;
};

export type HabitChallengeDateInfoFragment = {
  __typename: 'HabitChallenge';
  startDateTimeISO: string | null;
  endDateTimeISO: string | null;
};

type ChallengePage_HabitChallenge_Fragment = {
  __typename: 'HabitChallenge';
  title: string;
  subtitle: string | null;
  challengeId: string;
  status: Types.ChallengeStatus;
  goal: number;
  participationType: Types.ChallengeParticipationType;
  category: Types.ChallengeCategory;
  wasJoined: boolean;
  startDateTimeISO: string | null;
  endDateTimeISO: string | null;
  image: { __typename: 'Image'; url: string } | null;
  introduction: Array<{
    __typename: 'ChallengeIntroduction';
    id: string;
    info: string;
    title: string;
  } | null> | null;
};

type ChallengePage_StepChallenge_Fragment = {
  __typename: 'StepChallenge';
  title: string;
  subtitle: string | null;
  challengeId: string;
  status: Types.ChallengeStatus;
  goal: number;
  participationType: Types.ChallengeParticipationType;
  lastUploaded: string | null;
  category: Types.ChallengeCategory;
  wasJoined: boolean;
  startDateTimeISO: string | null;
  endDateTimeISO: string | null;
  image: { __typename: 'Image'; url: string } | null;
  introduction: Array<{
    __typename: 'ChallengeIntroduction';
    id: string;
    info: string;
    title: string;
  } | null> | null;
};

export type ChallengePageFragment =
  ChallengePage_HabitChallenge_Fragment | ChallengePage_StepChallenge_Fragment;

export type ChallengePromotionFragment = {
  __typename: 'ChallengePromotion';
  challengeUnion:
    | {
        __typename: 'HabitChallenge';
        participationType: Types.ChallengeParticipationType;
        challengeId: string;
        category: Types.ChallengeCategory;
        title: string;
        status: Types.ChallengeStatus;
        goal: number;
        wasJoined: boolean;
        endDateTimeISO: string | null;
        startDateTimeISO: string | null;
        image: { __typename: 'Image'; url: string } | null;
        completionReward: { __typename: 'TierReward'; points: string } | null;
        activity: {
          __typename: 'HabitActivityResponse';
          activity: Array<{
            __typename: 'HabitDailyActivity';
            tracked: number;
          }> | null;
        };
      }
    | {
        __typename: 'StepChallenge';
        participationType: Types.ChallengeParticipationType;
        challengeId: string;
        category: Types.ChallengeCategory;
        title: string;
        status: Types.ChallengeStatus;
        goal: number;
        wasJoined: boolean;
        endDateTimeISO: string | null;
        startDateTimeISO: string | null;
        image: { __typename: 'Image'; url: string } | null;
        completionReward: { __typename: 'TierReward'; points: string } | null;
        stepActivity: {
          __typename: 'StepActivityResponse';
          activity: Array<{
            __typename: 'StepDailyActivity';
            tracked: number;
          }> | null;
        };
      }
    | null;
};

export type FetchChallengesHabitChallengeFragment = {
  __typename: 'HabitChallenge';
  categoryDisplayText: string;
  participationType: Types.ChallengeParticipationType;
  challengeId: string;
  category: Types.ChallengeCategory;
  title: string;
  status: Types.ChallengeStatus;
  goal: number;
  wasJoined: boolean;
  endDateTimeISO: string | null;
  startDateTimeISO: string | null;
  image: { __typename: 'Image'; url: string } | null;
  completionReward: { __typename: 'TierReward'; points: string } | null;
  activity: {
    __typename: 'HabitActivityResponse';
    activity: Array<{
      __typename: 'HabitDailyActivity';
      tracked: number;
    }> | null;
  };
};

export type FetchChallengesStepChallengeFragment = {
  __typename: 'StepChallenge';
  categoryDisplayText: string;
  participationType: Types.ChallengeParticipationType;
  challengeId: string;
  category: Types.ChallengeCategory;
  title: string;
  status: Types.ChallengeStatus;
  goal: number;
  wasJoined: boolean;
  endDateTimeISO: string | null;
  startDateTimeISO: string | null;
  image: { __typename: 'Image'; url: string } | null;
  completionReward: { __typename: 'TierReward'; points: string } | null;
  stepActivity: {
    __typename: 'StepActivityResponse';
    activity: Array<{
      __typename: 'StepDailyActivity';
      tracked: number;
    }> | null;
  };
};

export type FetchChallengesFragment = {
  __typename: 'fetchChallengesResponse';
  challenges: Array<
    | {
        __typename: 'HabitChallenge';
        categoryDisplayText: string;
        participationType: Types.ChallengeParticipationType;
        challengeId: string;
        category: Types.ChallengeCategory;
        title: string;
        status: Types.ChallengeStatus;
        goal: number;
        wasJoined: boolean;
        endDateTimeISO: string | null;
        startDateTimeISO: string | null;
        image: { __typename: 'Image'; url: string } | null;
        completionReward: { __typename: 'TierReward'; points: string } | null;
        activity: {
          __typename: 'HabitActivityResponse';
          activity: Array<{
            __typename: 'HabitDailyActivity';
            tracked: number;
          }> | null;
        };
      }
    | {
        __typename: 'StepChallenge';
        categoryDisplayText: string;
        participationType: Types.ChallengeParticipationType;
        challengeId: string;
        category: Types.ChallengeCategory;
        title: string;
        status: Types.ChallengeStatus;
        goal: number;
        wasJoined: boolean;
        endDateTimeISO: string | null;
        startDateTimeISO: string | null;
        image: { __typename: 'Image'; url: string } | null;
        completionReward: { __typename: 'TierReward'; points: string } | null;
        stepActivity: {
          __typename: 'StepActivityResponse';
          activity: Array<{
            __typename: 'StepDailyActivity';
            tracked: number;
          }> | null;
        };
      }
  > | null;
};

type ChallengeStatus_HabitChallenge_Fragment = {
  __typename: 'HabitChallenge';
  challengeId: string;
  status: Types.ChallengeStatus;
  wasJoined: boolean;
};

type ChallengeStatus_StepChallenge_Fragment = {
  __typename: 'StepChallenge';
  challengeId: string;
  status: Types.ChallengeStatus;
  wasJoined: boolean;
};

export type ChallengeStatusFragment =
  | ChallengeStatus_HabitChallenge_Fragment
  | ChallengeStatus_StepChallenge_Fragment;

export type HabitChallengeListItemFragment = {
  __typename: 'HabitChallenge';
  challengeId: string;
  status: Types.ChallengeStatus;
  title: string;
  category: Types.ChallengeCategory;
  categoryDisplayText: string;
  participationType: Types.ChallengeParticipationType;
  wasJoined: boolean;
  goal: number;
  endDateTimeISO: string | null;
  startDateTimeISO: string | null;
  completionReward: { __typename: 'TierReward'; points: string } | null;
  image: { __typename: 'Image'; url: string } | null;
  activity: {
    __typename: 'HabitActivityResponse';
    activity: Array<{
      __typename: 'HabitDailyActivity';
      tracked: number;
    }> | null;
  };
  leaderboardIndividuals: {
    __typename: 'LeaderboardIndividualResponse';
    leaderboard: Array<{
      __typename: 'IndividualsLeaderboardEntry';
      position: number | null;
    }> | null;
  };
};

export type HabitChallengeBasicInfoFragment = {
  __typename: 'HabitChallenge';
  challengeId: string;
  templateId: string;
  subtitle: string | null;
  status: Types.ChallengeStatus;
  title: string;
  category: Types.ChallengeCategory;
  categoryDisplayText: string;
  participationType: Types.ChallengeParticipationType;
  wasJoined: boolean;
  goal: number;
  endDateTimeISO: string | null;
  startDateTimeISO: string | null;
  introduction: Array<{
    __typename: 'ChallengeIntroduction';
    id: string;
    info: string;
    title: string;
  } | null> | null;
  challengeHabits: {
    __typename: 'ChallengeHabits';
    editSelectedHabits: {
      __typename: 'EditSelectedHabitsCaption';
      subtitle: string;
      title: string;
    };
    selectHabit: {
      __typename: 'SelectHabitCaption';
      description: string;
      title: string;
    };
    habits: Array<{
      __typename: 'Habit';
      habitId: string;
      title: string;
      subtitle: string;
      description: string | null;
      selected: boolean | null;
    }>;
  } | null;
  completionReward: { __typename: 'TierReward'; points: string } | null;
  image: { __typename: 'Image'; url: string } | null;
  activity: {
    __typename: 'HabitActivityResponse';
    activity: Array<{
      __typename: 'HabitDailyActivity';
      tracked: number;
    }> | null;
  };
  leaderboardIndividuals: {
    __typename: 'LeaderboardIndividualResponse';
    leaderboard: Array<{
      __typename: 'IndividualsLeaderboardEntry';
      position: number | null;
    }> | null;
  };
};

export type HabitFragment = {
  __typename: 'Habit';
  habitId: string;
  tracked: number | null;
  title: string;
  subtitle: string;
  description: string | null;
  selected: boolean | null;
  tradeCaptions: {
    __typename: 'HabitTradeCaption';
    title: string;
    subtitle: string;
  };
  thumbnailImage: {
    __typename: 'Image';
    url: string;
    font: {
      __typename: 'Font';
      color: {
        __typename: 'Color';
        name: string | null;
        hexCode: string;
      } | null;
    } | null;
  } | null;
};

export type OptionActivityFragment = {
  __typename: 'HabitOptionActivity';
  tracked: number;
  option: { __typename: 'HabitOption'; optionId: string; title: string } | null;
};

export type HabitActivityFragment = {
  __typename: 'HabitActivity';
  habit: {
    __typename: 'Habit';
    habitId: string;
    tracked: number | null;
    title: string;
    subtitle: string;
    description: string | null;
    selected: boolean | null;
    tradeCaptions: {
      __typename: 'HabitTradeCaption';
      title: string;
      subtitle: string;
    };
    thumbnailImage: {
      __typename: 'Image';
      url: string;
      font: {
        __typename: 'Font';
        color: {
          __typename: 'Color';
          name: string | null;
          hexCode: string;
        } | null;
      } | null;
    } | null;
  } | null;
  optionActivity: Array<{
    __typename: 'HabitOptionActivity';
    tracked: number;
    option: {
      __typename: 'HabitOption';
      optionId: string;
      title: string;
    } | null;
  } | null>;
};

export type FetchChallengePageQueryVariables = Exact<{
  id: string | number;
}>;

export type FetchChallengePageQuery = {
  __typename: 'Query';
  fetchChallenge: {
    __typename: 'fetchChallengeResponse';
    challenge:
      | {
          __typename: 'HabitChallenge';
          title: string;
          subtitle: string | null;
          challengeId: string;
          status: Types.ChallengeStatus;
          goal: number;
          participationType: Types.ChallengeParticipationType;
          category: Types.ChallengeCategory;
          wasJoined: boolean;
          startDateTimeISO: string | null;
          endDateTimeISO: string | null;
          image: { __typename: 'Image'; url: string } | null;
          introduction: Array<{
            __typename: 'ChallengeIntroduction';
            id: string;
            info: string;
            title: string;
          } | null> | null;
        }
      | {
          __typename: 'StepChallenge';
          title: string;
          subtitle: string | null;
          challengeId: string;
          status: Types.ChallengeStatus;
          goal: number;
          participationType: Types.ChallengeParticipationType;
          lastUploaded: string | null;
          category: Types.ChallengeCategory;
          wasJoined: boolean;
          startDateTimeISO: string | null;
          endDateTimeISO: string | null;
          image: { __typename: 'Image'; url: string } | null;
          introduction: Array<{
            __typename: 'ChallengeIntroduction';
            id: string;
            info: string;
            title: string;
          } | null> | null;
        }
      | null;
  };
};

export type FetchChallengeQueryVariables = Exact<{
  from?: string | null | undefined;
  id: string | number;
}>;

export type FetchChallengeQuery = {
  __typename: 'Query';
  fetchChallenge: {
    __typename: 'fetchChallengeResponse';
    challenge:
      | {
          __typename: 'HabitChallenge';
          title: string;
          subtitle: string | null;
          challengeId: string;
          status: Types.ChallengeStatus;
          goal: number;
          participationType: Types.ChallengeParticipationType;
          category: Types.ChallengeCategory;
          wasJoined: boolean;
          templateId: string;
          startDateTimeISO: string | null;
          endDateTimeISO: string | null;
          categoryDisplayText: string;
          image: { __typename: 'Image'; url: string } | null;
          introduction: Array<{
            __typename: 'ChallengeIntroduction';
            id: string;
            info: string;
            title: string;
          } | null> | null;
          challengeHabits: {
            __typename: 'ChallengeHabits';
            editSelectedHabits: {
              __typename: 'EditSelectedHabitsCaption';
              subtitle: string;
              title: string;
            };
            selectHabit: {
              __typename: 'SelectHabitCaption';
              description: string;
              title: string;
            };
            habits: Array<{
              __typename: 'Habit';
              habitId: string;
              title: string;
              subtitle: string;
              description: string | null;
              selected: boolean | null;
            }>;
          } | null;
          completionReward: { __typename: 'TierReward'; points: string } | null;
          activity: {
            __typename: 'HabitActivityResponse';
            activity: Array<{
              __typename: 'HabitDailyActivity';
              tracked: number;
            }> | null;
          };
          leaderboardIndividuals: {
            __typename: 'LeaderboardIndividualResponse';
            leaderboard: Array<{
              __typename: 'IndividualsLeaderboardEntry';
              position: number | null;
            }> | null;
          };
        }
      | {
          __typename: 'StepChallenge';
          title: string;
          subtitle: string | null;
          challengeId: string;
          status: Types.ChallengeStatus;
          goal: number;
          participationType: Types.ChallengeParticipationType;
          lastUploaded: string | null;
          category: Types.ChallengeCategory;
          wasJoined: boolean;
          startDateTimeISO: string | null;
          endDateTimeISO: string | null;
          categoryDisplayText: string;
          image: { __typename: 'Image'; url: string } | null;
          introduction: Array<{
            __typename: 'ChallengeIntroduction';
            id: string;
            info: string;
            title: string;
          } | null> | null;
          completionReward: { __typename: 'TierReward'; points: string } | null;
          stepActivity: {
            __typename: 'StepActivityResponse';
            activity: Array<{
              __typename: 'StepDailyActivity';
              tracked: number;
            }> | null;
          };
          leaderboardIndividuals: {
            __typename: 'LeaderboardIndividualResponse';
            leaderboard: Array<{
              __typename: 'IndividualsLeaderboardEntry';
              position: number | null;
            }> | null;
          };
        }
      | null;
  };
};

export type StepDailyActivityFragment = {
  __typename: 'StepDailyActivity';
  date: string;
  tracked: number;
  type: Types.StepActivityType;
  subtitle: string;
};

export type HabitDailyActivityFragment = {
  __typename: 'HabitDailyActivity';
  id: string;
  date: string;
  tracked: number;
  subtitle: string;
  tradeLimit: number;
  activity: Array<{
    __typename: 'HabitActivity';
    habit: {
      __typename: 'Habit';
      habitId: string;
      tracked: number | null;
      title: string;
      thumbnailImage: {
        __typename: 'Image';
        url: string;
        font: {
          __typename: 'Font';
          color: {
            __typename: 'Color';
            name: string | null;
            hexCode: string;
          } | null;
        } | null;
      } | null;
    } | null;
    optionActivity: Array<{
      __typename: 'HabitOptionActivity';
      tracked: number;
      option: {
        __typename: 'HabitOption';
        optionId: string;
        title: string;
      } | null;
    } | null>;
  }> | null;
};

export type JoinTeamMutationVariables = Exact<{
  challengeId: string | number;
  teamId: string | number;
}>;

export type JoinTeamMutation = {
  __typename: 'Mutation';
  joinChallengeTeam: {
    __typename: 'JoinChallengeTeamResponse';
    joinedTeam: boolean;
    reasonNotJoined: string | null;
    team: {
      __typename: 'Team';
      id: string;
      name: string;
      image: { __typename: 'Image'; url: string } | null;
      userPermissions: {
        __typename: 'TeamPermissions';
        canCreateATeam: boolean | null;
        canChangeTeamName: boolean | null;
        canChangeTeamImage: boolean | null;
        canRemoveTeamImage: boolean | null;
        isTeamAdmin: boolean | null;
        membershipPrompt: Types.TeamMembershipPrompt;
      } | null;
    } | null;
  } | null;
};

export type LeaveTeamMutationVariables = Exact<{
  challengeId: string | number;
  teamId: string | number;
}>;

export type LeaveTeamMutation = {
  __typename: 'Mutation';
  leaveChallengeTeam: {
    __typename: 'LeaveChallengeTeamResponse';
    departedTeam: boolean;
    reasonNotDeparted: string | null;
    team: {
      __typename: 'Team';
      id: string;
      name: string;
      image: { __typename: 'Image'; url: string } | null;
      userPermissions: {
        __typename: 'TeamPermissions';
        canCreateATeam: boolean | null;
        canChangeTeamName: boolean | null;
        canChangeTeamImage: boolean | null;
        canRemoveTeamImage: boolean | null;
        isTeamAdmin: boolean | null;
        membershipPrompt: Types.TeamMembershipPrompt;
      } | null;
    } | null;
  } | null;
};

export type UpdateChallengeTeamNameMutationVariables = Exact<{
  challengeId: string | number;
  teamId: string | number;
  teamName: string;
}>;

export type UpdateChallengeTeamNameMutation = {
  __typename: 'Mutation';
  updateChallengeTeamName: {
    __typename: 'UpdateChallengeTeamResponse';
    team: {
      __typename: 'Team';
      id: string;
      name: string;
      image: { __typename: 'Image'; url: string } | null;
      userPermissions: {
        __typename: 'TeamPermissions';
        canCreateATeam: boolean | null;
        canChangeTeamName: boolean | null;
        canChangeTeamImage: boolean | null;
        canRemoveTeamImage: boolean | null;
        isTeamAdmin: boolean | null;
        membershipPrompt: Types.TeamMembershipPrompt;
      } | null;
    };
  } | null;
};

export type RemoveChallengeTeamImageMutationVariables = Exact<{
  request: Types.RemoveChallengeTeamImageInput;
}>;

export type RemoveChallengeTeamImageMutation = {
  __typename: 'Mutation';
  removeChallengeTeamImage: {
    __typename: 'RemoveChallengeTeamImageResponse';
    team: {
      __typename: 'Team';
      id: string;
      name: string;
      image: { __typename: 'Image'; url: string } | null;
      userPermissions: {
        __typename: 'TeamPermissions';
        canCreateATeam: boolean | null;
        canChangeTeamName: boolean | null;
        canChangeTeamImage: boolean | null;
        canRemoveTeamImage: boolean | null;
        isTeamAdmin: boolean | null;
        membershipPrompt: Types.TeamMembershipPrompt;
      } | null;
    };
  };
};

export type ChallengeJoinedFragment = {
  __typename: 'HabitChallenge';
  challengeId: string;
  wasJoined: boolean;
};

export type ChallengeJoinedStepFragment = {
  __typename: 'StepChallenge';
  challengeId: string;
  wasJoined: boolean;
  status: Types.ChallengeStatus;
};

export type JoinChallengeMutationVariables = Exact<{
  id: string | number;
}>;

export type JoinChallengeMutation = {
  __typename: 'Mutation';
  joinChallenge: {
    __typename: 'JoinChallengeResponse';
    challenge:
      | {
          __typename: 'HabitChallenge';
          challengeId: string;
          wasJoined: boolean;
        }
      | {
          __typename: 'StepChallenge';
          challengeId: string;
          wasJoined: boolean;
          status: Types.ChallengeStatus;
        }
      | null;
  };
};

export type SelectHabitsMutationVariables = Exact<{
  challengeId: string;
  templateId?: string | null | undefined;
  habits: Array<Types.SelectHabitsData> | Types.SelectHabitsData;
}>;

export type SelectHabitsMutation = {
  __typename: 'Mutation';
  selectHabits: {
    __typename: 'SelectedHabitsResponse';
    habits: Array<{
      __typename: 'Habit';
      habitId: string;
      selected: boolean | null;
    }>;
  } | null;
};

export type HubListFragment = {
  __typename: 'fetchChallengesResponse';
  challenges: Array<
    | {
        __typename: 'HabitChallenge';
        title: string;
        subtitle: string | null;
        challengeId: string;
        status: Types.ChallengeStatus;
        goal: number;
        participationType: Types.ChallengeParticipationType;
        category: Types.ChallengeCategory;
        wasJoined: boolean;
        categoryDisplayText: string;
        endDateTimeISO: string | null;
        startDateTimeISO: string | null;
        image: { __typename: 'Image'; url: string } | null;
        introduction: Array<{
          __typename: 'ChallengeIntroduction';
          id: string;
          info: string;
          title: string;
        } | null> | null;
        completionReward: { __typename: 'TierReward'; points: string } | null;
        activity: {
          __typename: 'HabitActivityResponse';
          activity: Array<{
            __typename: 'HabitDailyActivity';
            tracked: number;
          }> | null;
        };
        leaderboardIndividuals: {
          __typename: 'LeaderboardIndividualResponse';
          leaderboard: Array<{
            __typename: 'IndividualsLeaderboardEntry';
            position: number | null;
          }> | null;
        };
      }
    | {
        __typename: 'StepChallenge';
        title: string;
        subtitle: string | null;
        challengeId: string;
        status: Types.ChallengeStatus;
        goal: number;
        participationType: Types.ChallengeParticipationType;
        lastUploaded: string | null;
        category: Types.ChallengeCategory;
        wasJoined: boolean;
        categoryDisplayText: string;
        endDateTimeISO: string | null;
        startDateTimeISO: string | null;
        image: { __typename: 'Image'; url: string } | null;
        introduction: Array<{
          __typename: 'ChallengeIntroduction';
          id: string;
          info: string;
          title: string;
        } | null> | null;
        completionReward: { __typename: 'TierReward'; points: string } | null;
        stepActivity: {
          __typename: 'StepActivityResponse';
          activity: Array<{
            __typename: 'StepDailyActivity';
            tracked: number;
          }> | null;
        };
        leaderboardIndividuals: {
          __typename: 'LeaderboardIndividualResponse';
          leaderboard: Array<{
            __typename: 'IndividualsLeaderboardEntry';
            position: number | null;
          }> | null;
        };
      }
  > | null;
};

export type ChallengesHubPageQueryVariables = Exact<{
  from?: string | null | undefined;
}>;

export type ChallengesHubPageQuery = {
  __typename: 'Query';
  challenges: {
    __typename: 'fetchChallengesResponse';
    challenges: Array<
      | {
          __typename: 'HabitChallenge';
          title: string;
          subtitle: string | null;
          challengeId: string;
          status: Types.ChallengeStatus;
          goal: number;
          participationType: Types.ChallengeParticipationType;
          category: Types.ChallengeCategory;
          wasJoined: boolean;
          categoryDisplayText: string;
          endDateTimeISO: string | null;
          startDateTimeISO: string | null;
          image: { __typename: 'Image'; url: string } | null;
          introduction: Array<{
            __typename: 'ChallengeIntroduction';
            id: string;
            info: string;
            title: string;
          } | null> | null;
          completionReward: { __typename: 'TierReward'; points: string } | null;
          activity: {
            __typename: 'HabitActivityResponse';
            activity: Array<{
              __typename: 'HabitDailyActivity';
              tracked: number;
            }> | null;
          };
          leaderboardIndividuals: {
            __typename: 'LeaderboardIndividualResponse';
            leaderboard: Array<{
              __typename: 'IndividualsLeaderboardEntry';
              position: number | null;
            }> | null;
          };
        }
      | {
          __typename: 'StepChallenge';
          title: string;
          subtitle: string | null;
          challengeId: string;
          status: Types.ChallengeStatus;
          goal: number;
          participationType: Types.ChallengeParticipationType;
          lastUploaded: string | null;
          category: Types.ChallengeCategory;
          wasJoined: boolean;
          categoryDisplayText: string;
          endDateTimeISO: string | null;
          startDateTimeISO: string | null;
          image: { __typename: 'Image'; url: string } | null;
          introduction: Array<{
            __typename: 'ChallengeIntroduction';
            id: string;
            info: string;
            title: string;
          } | null> | null;
          completionReward: { __typename: 'TierReward'; points: string } | null;
          stepActivity: {
            __typename: 'StepActivityResponse';
            activity: Array<{
              __typename: 'StepDailyActivity';
              tracked: number;
            }> | null;
          };
          leaderboardIndividuals: {
            __typename: 'LeaderboardIndividualResponse';
            leaderboard: Array<{
              __typename: 'IndividualsLeaderboardEntry';
              position: number | null;
            }> | null;
          };
        }
    > | null;
  } | null;
};

export type LeaderboardUserFragment = {
  __typename: 'User';
  id: string;
  fullName: string;
  image: { __typename: 'Image'; url: string } | null;
};

export type LeaderboardIndividualFragment = {
  __typename: 'IndividualsLeaderboardEntry';
  score: string | null;
  position: number | null;
  user: {
    __typename: 'User';
    id: string;
    fullName: string;
    image: { __typename: 'Image'; url: string } | null;
  };
};

export type LeaderboardIndividualQueryVariables = Exact<{
  id: string | number;
  after?: string | null | undefined;
}>;

export type LeaderboardIndividualQuery = {
  __typename: 'Query';
  fetchChallenge: {
    __typename: 'fetchChallengeResponse';
    challenge:
      | {
          __typename: 'HabitChallenge';
          challengeId: string;
          leaderboardIndividuals: {
            __typename: 'LeaderboardIndividualResponse';
            pagination: {
              __typename: 'Pagination';
              isLastPage: boolean;
              limit: number | null;
              cursors: {
                __typename: 'PaginationCursors';
                after: string | null;
                before: string | null;
              };
            } | null;
            leaderboard: Array<{
              __typename: 'IndividualsLeaderboardEntry';
              score: string | null;
              position: number | null;
              user: {
                __typename: 'User';
                id: string;
                fullName: string;
                image: { __typename: 'Image'; url: string } | null;
              };
            }> | null;
          };
        }
      | {
          __typename: 'StepChallenge';
          challengeId: string;
          leaderboardIndividuals: {
            __typename: 'LeaderboardIndividualResponse';
            pagination: {
              __typename: 'Pagination';
              isLastPage: boolean;
              limit: number | null;
              cursors: {
                __typename: 'PaginationCursors';
                after: string | null;
                before: string | null;
              };
            } | null;
            leaderboard: Array<{
              __typename: 'IndividualsLeaderboardEntry';
              score: string | null;
              position: number | null;
              user: {
                __typename: 'User';
                id: string;
                fullName: string;
                image: { __typename: 'Image'; url: string } | null;
              };
            }> | null;
          };
        }
      | null;
  };
};

export type TeamsLeaderboardListItemFragment = {
  __typename: 'TeamsLeaderboardEntry';
  position: number | null;
  score: string | null;
  team: {
    __typename: 'Team';
    id: string;
    name: string;
    image: { __typename: 'Image'; url: string } | null;
    userPermissions: {
      __typename: 'TeamPermissions';
      canCreateATeam: boolean | null;
      canChangeTeamName: boolean | null;
      canChangeTeamImage: boolean | null;
      canRemoveTeamImage: boolean | null;
      isTeamAdmin: boolean | null;
      membershipPrompt: Types.TeamMembershipPrompt;
    } | null;
  };
};

export type LeaderboardTeamQueryVariables = Exact<{
  id: string | number;
  after?: string | null | undefined;
}>;

export type LeaderboardTeamQuery = {
  __typename: 'Query';
  fetchChallenge: {
    __typename: 'fetchChallengeResponse';
    challenge:
      | {
          __typename: 'HabitChallenge';
          challengeId: string;
          status: Types.ChallengeStatus;
          leaderboardTeams: {
            __typename: 'LeaderboardTeamResponse';
            pagination: {
              __typename: 'Pagination';
              isLastPage: boolean;
              limit: number | null;
              cursors: {
                __typename: 'PaginationCursors';
                after: string | null;
                before: string | null;
              };
            } | null;
            leaderboard: Array<{
              __typename: 'TeamsLeaderboardEntry';
              position: number | null;
              score: string | null;
              team: {
                __typename: 'Team';
                id: string;
                name: string;
                image: { __typename: 'Image'; url: string } | null;
                userPermissions: {
                  __typename: 'TeamPermissions';
                  canCreateATeam: boolean | null;
                  canChangeTeamName: boolean | null;
                  canChangeTeamImage: boolean | null;
                  canRemoveTeamImage: boolean | null;
                  isTeamAdmin: boolean | null;
                  membershipPrompt: Types.TeamMembershipPrompt;
                } | null;
              };
            }> | null;
          };
          userTeamMembership: {
            __typename: 'UserTeamMembershipResponse';
            canCreateATeam: boolean;
          };
        }
      | {
          __typename: 'StepChallenge';
          challengeId: string;
          status: Types.ChallengeStatus;
          leaderboardTeams: {
            __typename: 'LeaderboardTeamResponse';
            pagination: {
              __typename: 'Pagination';
              isLastPage: boolean;
              limit: number | null;
              cursors: {
                __typename: 'PaginationCursors';
                after: string | null;
                before: string | null;
              };
            } | null;
            leaderboard: Array<{
              __typename: 'TeamsLeaderboardEntry';
              position: number | null;
              score: string | null;
              team: {
                __typename: 'Team';
                id: string;
                name: string;
                image: { __typename: 'Image'; url: string } | null;
                userPermissions: {
                  __typename: 'TeamPermissions';
                  canCreateATeam: boolean | null;
                  canChangeTeamName: boolean | null;
                  canChangeTeamImage: boolean | null;
                  canRemoveTeamImage: boolean | null;
                  isTeamAdmin: boolean | null;
                  membershipPrompt: Types.TeamMembershipPrompt;
                } | null;
              };
            }> | null;
          };
          userTeamMembership: {
            __typename: 'UserTeamMembershipResponse';
            canCreateATeam: boolean;
          };
        }
      | null;
  };
};

export type LeaveChallengeMutationVariables = Exact<{
  id: string | number;
}>;

export type LeaveChallengeMutation = {
  __typename: 'Mutation';
  leaveChallenge: {
    __typename: 'LeaveChallengeResponse';
    challenge:
      | {
          __typename: 'HabitChallenge';
          challengeId: string;
          status: Types.ChallengeStatus;
          wasJoined: boolean;
        }
      | {
          __typename: 'StepChallenge';
          challengeId: string;
          status: Types.ChallengeStatus;
          wasJoined: boolean;
        }
      | null;
  };
};

export type TeamCreateMutationVariables = Exact<{
  id: string | number;
  name: string;
}>;

export type TeamCreateMutation = {
  __typename: 'Mutation';
  createChallengeTeam: {
    __typename: 'CreateChallengeTeamResponse';
    team: { __typename: 'Team'; id: string };
  } | null;
};

export type TeamMemberFragment = {
  __typename: 'User';
  fullName: string;
  id: string;
  image: { __typename: 'Image'; url: string } | null;
};

export type TeamLeaderboardFragment = {
  __typename: 'LeaderboardTeamMembersResponse';
  leaderboard: Array<{
    __typename: 'IndividualsLeaderboardEntry';
    score: string | null;
    position: number | null;
    user: {
      __typename: 'User';
      fullName: string;
      id: string;
      image: { __typename: 'Image'; url: string } | null;
    };
  }> | null;
  pagination: {
    __typename: 'Pagination';
    isLastPage: boolean;
    limit: number | null;
    cursors: {
      __typename: 'PaginationCursors';
      after: string | null;
      before: string | null;
    };
  } | null;
};

export type TeamMembersQueryVariables = Exact<{
  id: string | number;
  afterCursor?: string | null | undefined;
  challengeId: string | number;
}>;

export type TeamMembersQuery = {
  __typename: 'Query';
  fetchChallengeTeam: {
    __typename: 'FetchTeamResponse';
    team: {
      __typename: 'Team';
      id: string;
      name: string;
      image: { __typename: 'Image'; url: string } | null;
      userPermissions: {
        __typename: 'TeamPermissions';
        canCreateATeam: boolean | null;
        canChangeTeamName: boolean | null;
        canChangeTeamImage: boolean | null;
        canRemoveTeamImage: boolean | null;
        isTeamAdmin: boolean | null;
        membershipPrompt: Types.TeamMembershipPrompt;
      } | null;
    } | null;
    leaderboardTeamMembers: {
      __typename: 'LeaderboardTeamMembersResponse';
      leaderboard: Array<{
        __typename: 'IndividualsLeaderboardEntry';
        score: string | null;
        position: number | null;
        user: {
          __typename: 'User';
          fullName: string;
          id: string;
          image: { __typename: 'Image'; url: string } | null;
        };
      }> | null;
      pagination: {
        __typename: 'Pagination';
        isLastPage: boolean;
        limit: number | null;
        cursors: {
          __typename: 'PaginationCursors';
          after: string | null;
          before: string | null;
        };
      } | null;
    };
  } | null;
};

export type ChallengeHubListFragment = {
  __typename: 'fetchChallengesResponse';
  challenges: Array<
    | {
        __typename: 'HabitChallenge';
        challengeId: string;
        title: string;
        status: Types.ChallengeStatus;
        category: Types.ChallengeCategory;
        participationType: Types.ChallengeParticipationType;
        wasJoined: boolean;
        goal: number;
        startDateTimeISO: string | null;
        endDateTimeISO: string | null;
        image: { __typename: 'Image'; url: string } | null;
      }
    | {
        __typename: 'StepChallenge';
        challengeId: string;
        title: string;
        status: Types.ChallengeStatus;
        category: Types.ChallengeCategory;
        participationType: Types.ChallengeParticipationType;
        wasJoined: boolean;
        goal: number;
        startDateTimeISO: string | null;
        endDateTimeISO: string | null;
        image: { __typename: 'Image'; url: string } | null;
      }
  > | null;
};

export type ChallengeHubQueryVariables = Exact<{ [key: string]: never }>;

export type ChallengeHubQuery = {
  __typename: 'Query';
  challenges: {
    __typename: 'fetchChallengesResponse';
    challenges: Array<
      | {
          __typename: 'HabitChallenge';
          challengeId: string;
          title: string;
          status: Types.ChallengeStatus;
          category: Types.ChallengeCategory;
          participationType: Types.ChallengeParticipationType;
          wasJoined: boolean;
          goal: number;
          startDateTimeISO: string | null;
          endDateTimeISO: string | null;
          image: { __typename: 'Image'; url: string } | null;
        }
      | {
          __typename: 'StepChallenge';
          challengeId: string;
          title: string;
          status: Types.ChallengeStatus;
          category: Types.ChallengeCategory;
          participationType: Types.ChallengeParticipationType;
          wasJoined: boolean;
          goal: number;
          startDateTimeISO: string | null;
          endDateTimeISO: string | null;
          image: { __typename: 'Image'; url: string } | null;
        }
    > | null;
  } | null;
};

export type ReportContentMutationVariables = Exact<{
  input: Types.ReportInput;
}>;

export type ReportContentMutation = {
  __typename: 'Mutation';
  report: {
    __typename: 'ContentReportResponse';
    kind: Types.ReportTargetKind;
  } | null;
};

export type SubmitGlobalIntakeAppointmentRequestMutationVariables = Exact<{
  input: Types.GlobalIntakeAppointmentRequestInput;
}>;

export type SubmitGlobalIntakeAppointmentRequestMutation = {
  __typename: 'Mutation';
  submitGlobalIntakeAppointmentRequest: {
    __typename: 'GlobalIntakeAppointmentRequestResponse';
    timezone: string;
    language: string;
    email: string;
    preferredDate: string;
    preferredMeridiem: Types.PreferredMeridiem;
  } | null;
};

export type SubmitGlobalIntakeRequestFragment = {
  __typename: 'GlobalIntakeAppointmentRequestResponse';
  timezone: string;
  language: string;
  email: string;
  preferredDate: string;
  preferredMeridiem: Types.PreferredMeridiem;
};

export type DigitalClinicalProgramListItemFieldsFragment = {
  __typename: 'DigitalClinicalProgramListItem';
  programId: string;
  programType: Types.DigitalClinicalProgramType;
  description: string;
  wasJoined: boolean;
  title: string;
  status: Types.DigitalClinicalProgramStatus;
  isLite: boolean | null;
  progress: {
    __typename: 'DigitalClinicalProgramProgress';
    totalModules: number;
    completedModules: number;
    percentageComplete: number;
    remainingModules: number;
  };
  icon: { __typename: 'Image'; url: string } | null;
};

export type InterestsQueryVariables = Exact<{ [key: string]: never }>;

export type InterestsQuery = {
  __typename: 'Query';
  interests: {
    __typename: 'InterestsResponse';
    groups: Array<{
      __typename: 'InterestGroup';
      focused: boolean;
      id: string;
      name: string;
      icon: { __typename: 'Image'; url: string };
      interests: Array<{
        __typename: 'Interest';
        id: string;
        name: string;
        selected: boolean;
      }>;
    }>;
  } | null;
};

export type RecommendationsQueryVariables = Exact<{
  recommendationsInput2: Types.RecommendationsInput;
}>;

export type RecommendationsQuery = {
  __typename: 'Query';
  recommendations: {
    __typename: 'RecommendationsResponse';
    recommendations: {
      __typename: 'PaginatedRecommendations';
      data: Array<{
        __typename: 'Recommendation';
        id: string;
        payload: {
          __typename: 'DigitalClinicalProgramListItem';
          programId: string;
          programType: Types.DigitalClinicalProgramType;
          description: string;
          wasJoined: boolean;
          title: string;
          status: Types.DigitalClinicalProgramStatus;
          isLite: boolean | null;
          progress: {
            __typename: 'DigitalClinicalProgramProgress';
            totalModules: number;
            completedModules: number;
            percentageComplete: number;
            remainingModules: number;
          };
          icon: { __typename: 'Image'; url: string } | null;
        };
      }>;
      paging: {
        __typename: 'Pagination';
        isLastPage: boolean;
        limit: number | null;
        cursors: {
          __typename: 'PaginationCursors';
          after: string | null;
          before: string | null;
        };
      };
    } | null;
  } | null;
};

export type SelectInterestsMutationVariables = Exact<{
  input: Types.SelectInterestsInput;
}>;

export type SelectInterestsMutation = {
  __typename: 'Mutation';
  selectInterests: {
    __typename: 'SelectInterestsResponse';
    immediateRecommendation: {
      __typename: 'Recommendation';
      id: string;
      payload: {
        __typename: 'DigitalClinicalProgramListItem';
        programId: string;
        programType: Types.DigitalClinicalProgramType;
        description: string;
        wasJoined: boolean;
        title: string;
        status: Types.DigitalClinicalProgramStatus;
        isLite: boolean | null;
        progress: {
          __typename: 'DigitalClinicalProgramProgress';
          totalModules: number;
          completedModules: number;
          percentageComplete: number;
          remainingModules: number;
        };
        icon: { __typename: 'Image'; url: string } | null;
      };
    } | null;
  } | null;
};

export type JournalingEntryFragment = {
  __typename: 'JournalEntry';
  body: string | null;
  date: string;
  id: string;
  title: string;
};

export type JournalEntriesQueryVariables = Exact<{
  input: Types.JournalEntriesInput;
}>;

export type JournalEntriesQuery = {
  __typename: 'Query';
  journalEntries: {
    __typename: 'JournalEntriesResponse';
    entries: {
      __typename: 'PaginatedJournalEntries';
      paging: {
        __typename: 'Pagination';
        isLastPage: boolean;
        cursors: { __typename: 'PaginationCursors'; after: string | null };
      };
      data: Array<{
        __typename: 'JournalEntry';
        body: string | null;
        date: string;
        id: string;
        title: string;
      }>;
    };
  } | null;
};

export type DeleteJournalEntryMutationVariables = Exact<{
  input: Types.DeleteJournalEntryInput;
}>;

export type DeleteJournalEntryMutation = {
  __typename: 'Mutation';
  deleteJournalEntry: {
    __typename: 'DeleteJournalEntryResponse';
    received: boolean | null;
  } | null;
};

export type EditJournalEntryMutationVariables = Exact<{
  input: Types.EditJournalEntryInput;
}>;

export type EditJournalEntryMutation = {
  __typename: 'Mutation';
  editJournalEntry: {
    __typename: 'EditJournalEntryResponse';
    entry: {
      __typename: 'JournalEntry';
      body: string | null;
      date: string;
      id: string;
      title: string;
    };
  } | null;
};

export type CreateJournalEntryMutationVariables = Exact<{
  input: Types.CreateJournalEntryInput;
}>;

export type CreateJournalEntryMutation = {
  __typename: 'Mutation';
  createJournalEntry: {
    __typename: 'CreateJournalEntryResponse';
    entry: {
      __typename: 'JournalEntry';
      body: string | null;
      date: string;
      id: string;
      title: string;
    };
  } | null;
};

export type AverageDailyMoodInsightsQueryVariables = Exact<{
  input?: Types.AverageDailyMoodInsightsInput | null | undefined;
}>;

export type AverageDailyMoodInsightsQuery = {
  __typename: 'Query';
  averageDailyMoodInsights: {
    __typename: 'AverageDailyMoodInsightsResponse';
    message: string;
    sampleSize: number;
    title: string;
    data: Array<{
      __typename: 'DailyMoodDataPoint';
      date: string;
      value: number | null;
    }>;
  } | null;
};

export type InfluencesMoodInsightsQueryVariables = Exact<{
  input?: Types.InfluencesMoodInsightsInput | null | undefined;
}>;

export type InfluencesMoodInsightsQuery = {
  __typename: 'Query';
  influencesMoodInsights: {
    __typename: 'InfluencesMoodInsightsResponse';
    message: string;
    sampleSize: number;
    title: string;
    data: Array<{
      __typename: 'InfluencesMoodDataPoint';
      factor: string;
      valueMax: number;
      valueMin: number;
    }>;
  } | null;
};

export type MoodFactorFragment = {
  __typename: 'MoodFactor';
  id: string;
  title: string;
  isCustom: boolean;
};

export type MoodTrackingEntryFragment = {
  __typename: 'MoodEntry';
  createdAt: string;
  id: string;
  note: string | null;
  value: Types.MoodValue;
  factors: Array<{
    __typename: 'MoodFactor';
    id: string;
    title: string;
    isCustom: boolean;
  }>;
};

export type MoodEntriesQueryVariables = Exact<{
  input: Types.MoodEntriesInput;
}>;

export type MoodEntriesQuery = {
  __typename: 'Query';
  moodEntries: {
    __typename: 'MoodEntriesResponse';
    entries: {
      __typename: 'PaginatedMoodEntries';
      paging: {
        __typename: 'Pagination';
        isLastPage: boolean;
        cursors: { __typename: 'PaginationCursors'; after: string | null };
      };
      data: Array<{
        __typename: 'MoodEntry';
        createdAt: string;
        id: string;
        note: string | null;
        value: Types.MoodValue;
        factors: Array<{
          __typename: 'MoodFactor';
          id: string;
          title: string;
          isCustom: boolean;
        }>;
      }>;
    };
  } | null;
};

export type DeleteMoodEntryMutationVariables = Exact<{
  input: Types.DeleteMoodEntryInput;
}>;

export type DeleteMoodEntryMutation = {
  __typename: 'Mutation';
  deleteMoodEntry: {
    __typename: 'DeleteMoodEntryResponse';
    received: boolean | null;
  } | null;
};

export type EditMoodEntryMutationVariables = Exact<{
  input: Types.EditMoodEntryInput;
}>;

export type EditMoodEntryMutation = {
  __typename: 'Mutation';
  editMoodEntry: {
    __typename: 'EditMoodEntryResponse';
    entry: {
      __typename: 'MoodEntry';
      createdAt: string;
      id: string;
      note: string | null;
      value: Types.MoodValue;
      factors: Array<{
        __typename: 'MoodFactor';
        id: string;
        title: string;
        isCustom: boolean;
      }>;
    };
  } | null;
};

export type AvailableMoodFactorsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AvailableMoodFactorsQuery = {
  __typename: 'Query';
  availableMoodFactors: {
    __typename: 'AvailableMoodFactorsResponse';
    factors: Array<{
      __typename: 'MoodFactor';
      id: string;
      title: string;
      isCustom: boolean;
    }>;
  } | null;
};

export type CreateMoodEntryMutationVariables = Exact<{
  input: Types.CreateMoodEntryInput;
}>;

export type CreateMoodEntryMutation = {
  __typename: 'Mutation';
  createMoodEntry: {
    __typename: 'CreateMoodEntryResponse';
    entry: {
      __typename: 'MoodEntry';
      createdAt: string;
      id: string;
      note: string | null;
      value: Types.MoodValue;
      factors: Array<{
        __typename: 'MoodFactor';
        id: string;
        title: string;
        isCustom: boolean;
      }>;
    };
  } | null;
};

export type CreateCustomMoodFactorMutationVariables = Exact<{
  input: Types.CreateCustomMoodFactorInput;
}>;

export type CreateCustomMoodFactorMutation = {
  __typename: 'Mutation';
  createCustomMoodFactor: {
    __typename: 'CreateCustomMoodFactorResponse';
    moodFactor: {
      __typename: 'MoodFactor';
      id: string;
      title: string;
      isCustom: boolean;
    };
  } | null;
};

export type DeleteCustomMoodFactorsMutationVariables = Exact<{
  input: Types.DeleteCustomMoodFactorsInput;
}>;

export type DeleteCustomMoodFactorsMutation = {
  __typename: 'Mutation';
  deleteCustomMoodFactors: {
    __typename: 'DeleteCustomMoodFactorsResponse';
    received: boolean | null;
  } | null;
};

export type NeedToRetakeAssessmentsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type NeedToRetakeAssessmentsQuery = {
  __typename: 'Query';
  preAssessmentResults: {
    __typename: 'PreAssessmentResultsResponse';
    isTimeToRetakeAssessments: boolean;
  } | null;
};

export type MyCareAppointmentFragment = {
  __typename: 'Appointment';
  id: string;
  startDateTime: string;
  endDateTime: string;
  typeDescription: Types.AppointmentType;
  status: Types.AppointmentStatus;
  isVisibleToUser: boolean;
};

export type MyCareUpcomingAppointmentsQueryVariables = Exact<{
  input: Types.FetchAppointmentsInput;
}>;

export type MyCareUpcomingAppointmentsQuery = {
  __typename: 'Query';
  fetchAppointments: {
    __typename: 'FetchAppointmentsResponse';
    appointments: {
      __typename: 'PaginatedAppointments';
      data: Array<{
        __typename: 'Appointment';
        id: string;
        startDateTime: string;
        endDateTime: string;
        typeDescription: Types.AppointmentType;
        status: Types.AppointmentStatus;
        isVisibleToUser: boolean;
      }>;
    };
  } | null;
};

export type PaymentRequirementsQueryVariables = Exact<{ [key: string]: never }>;

export type PaymentRequirementsQuery = {
  __typename: 'Query';
  paymentRequirements: {
    __typename: 'PaymentRequirementsResponse';
    isPaymentRequired: boolean;
  } | null;
};

export type FetchPreAssessmentResultsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type FetchPreAssessmentResultsQuery = {
  __typename: 'Query';
  preAssessmentResults: {
    __typename: 'PreAssessmentResultsResponse';
    results: {
      __typename: 'PreAssessmentResults';
      shouldSpeakToCounsellor: boolean;
      assessments: Array<
        | {
            __typename: 'PreAssessmentNotTaken';
            id: string;
            sessionId: string;
            title: string;
          }
        | {
            __typename: 'PreAssessmentResult';
            title: string;
            severities: Array<string>;
            score: number;
            maxScore: number;
            displayMaxScore: number;
            description: string;
            completedAt: string | null;
            sessionId: string;
            id: string;
            retakeData: {
              __typename: 'RetakeData';
              earlyRetakeWarningMessage: string | null;
            };
          }
      >;
    };
  } | null;
};

export type CareIssueSelectedFragment = {
  __typename: 'CareIssue';
  selected: boolean | null;
};

export type CareIssuesSelectedQueryVariables = Exact<{ [key: string]: never }>;

export type CareIssuesSelectedQuery = {
  __typename: 'Query';
  getCareIssues: {
    __typename: 'CareIssuesResponse';
    careIssues: Array<{ __typename: 'CareIssue'; selected: boolean | null }>;
  } | null;
};

export type CarePlansQueryVariables = Exact<{
  input?: Types.AvailableCarePlansInput | null | undefined;
}>;

export type CarePlansQuery = {
  __typename: 'Query';
  availableCarePlans: {
    __typename: 'AvailableCarePlansResponse';
    carePlans: {
      __typename: 'PaginatedCarePlans';
      data: Array<{
        __typename: 'CarePlan';
        id: string;
        name: string;
        description: string;
      }>;
    };
  } | null;
};

export type AssessedAsSuicideRiskQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AssessedAsSuicideRiskQuery = {
  __typename: 'Query';
  assessedAsSuicideRisk: {
    __typename: 'AssessedAsSuicideRiskResponse';
    ccsTeamTelephoneNumber: string;
  } | null;
};

export type WorkLifeServicesFragment = {
  __typename: 'WorkLifeService';
  id: string;
  name: string;
  description: string;
  icon: { __typename: 'Image'; url: string } | null;
};

export type WorkLifeServicesPaginationFragment = {
  __typename: 'Pagination';
  isLastPage: boolean;
  cursors: { __typename: 'PaginationCursors'; after: string | null };
};

export type FetchWorkLifeServicesQueryVariables = Exact<{
  after?: string | null | undefined;
}>;

export type FetchWorkLifeServicesQuery = {
  __typename: 'Query';
  workLifeServices: {
    __typename: 'WorkLifeServicesResponse';
    services: {
      __typename: 'PaginatedWorkLifeServices';
      data: Array<{
        __typename: 'WorkLifeService';
        id: string;
        name: string;
        description: string;
        icon: { __typename: 'Image'; url: string } | null;
      }>;
      paging: {
        __typename: 'Pagination';
        isLastPage: boolean;
        cursors: { __typename: 'PaginationCursors'; after: string | null };
      };
    };
  } | null;
};

export type PensionBenefitsTitleAndNotificationCountFragment = {
  __typename: 'PensionAndBenefitsSummary';
  title: string;
  notifications: {
    __typename: 'PensionsAndBenefitsNotificationSummary';
    count: number;
  } | null;
  pension: { __typename: 'PensionSummary'; title: string } | null;
  benefits: { __typename: 'BenefitsSummary'; title: string } | null;
};

export type PensionBenefitsNotificationsFragment = {
  __typename: 'PensionAndBenefitsSummary';
  notifications: {
    __typename: 'PensionsAndBenefitsNotificationSummary';
    count: number;
    items: Array<{
      __typename: 'PensionsAndBenefitsNotification';
      title: string;
      details: string;
      expiryDate: string | null;
      portalUrlId: string;
    }> | null;
  } | null;
};

export type PensionBenefitsPensionFragment = {
  __typename: 'PensionAndBenefitsSummary';
  pension: {
    __typename: 'PensionSummary';
    title: string;
    portalUrlId: string;
    totals: Array<{
      __typename: 'PensionAndBenefitsTotal';
      label: string;
      value: string;
    }> | null;
  } | null;
};

export type PensionBenefitsBenefitFragment = {
  __typename: 'PensionAndBenefitsSummary';
  benefits: {
    __typename: 'BenefitsSummary';
    title: string;
    portalUrlId: string;
    totals: Array<{
      __typename: 'PensionAndBenefitsTotal';
      label: string;
      value: string;
    }> | null;
    plans: Array<{
      __typename: 'BenefitPlan';
      title: string;
      details: string | null;
      choices: string | null;
    }> | null;
  } | null;
};

export type PensionBenefitsTitleAndNotificationCountQueryVariables = Exact<{
  [key: string]: never;
}>;

export type PensionBenefitsTitleAndNotificationCountQuery = {
  __typename: 'Query';
  pensionAndBenefitsSummary: {
    __typename: 'PensionAndBenefitsSummary';
    title: string;
    notifications: {
      __typename: 'PensionsAndBenefitsNotificationSummary';
      count: number;
    } | null;
    pension: { __typename: 'PensionSummary'; title: string } | null;
    benefits: { __typename: 'BenefitsSummary'; title: string } | null;
  } | null;
};

export type PensionBenefitsSummaryPageQueryVariables = Exact<{
  [key: string]: never;
}>;

export type PensionBenefitsSummaryPageQuery = {
  __typename: 'Query';
  pensionAndBenefitsSummary: {
    __typename: 'PensionAndBenefitsSummary';
    title: string;
    notifications: {
      __typename: 'PensionsAndBenefitsNotificationSummary';
      count: number;
      items: Array<{
        __typename: 'PensionsAndBenefitsNotification';
        title: string;
        details: string;
        expiryDate: string | null;
        portalUrlId: string;
      }> | null;
    } | null;
    pension: {
      __typename: 'PensionSummary';
      title: string;
      portalUrlId: string;
      totals: Array<{
        __typename: 'PensionAndBenefitsTotal';
        label: string;
        value: string;
      }> | null;
    } | null;
    benefits: {
      __typename: 'BenefitsSummary';
      title: string;
      portalUrlId: string;
      totals: Array<{
        __typename: 'PensionAndBenefitsTotal';
        label: string;
        value: string;
      }> | null;
      plans: Array<{
        __typename: 'BenefitPlan';
        title: string;
        details: string | null;
        choices: string | null;
      }> | null;
    } | null;
  } | null;
};

export type PensionAndBenefitsPortalUrlQueryVariables = Exact<{
  portalUrlId: string;
}>;

export type PensionAndBenefitsPortalUrlQuery = {
  __typename: 'Query';
  pensionAndBenefitsPortalUrl: {
    __typename: 'PensionAndBenefitsTemporaryUrl';
    url: string;
    expiry: string;
  } | null;
};

export type CategoryModalContainerQueryVariables = Exact<{
  categoryId?: string | number | null | undefined;
}>;

export type CategoryModalContainerQuery = {
  __typename: 'Query';
  digitalClinicalPrograms: Array<{
    __typename: 'DigitalClinicalProgramListItem';
    description: string;
    wasJoined: boolean;
    programId: string;
    title: string;
    status: Types.DigitalClinicalProgramStatus;
    icon: { __typename: 'Image'; url: string } | null;
    progress: {
      __typename: 'DigitalClinicalProgramProgress';
      percentageComplete: number;
    };
    nextModule: {
      __typename: 'DigitalClinicalModuleListItem';
      moduleId: string;
      title: string;
    } | null;
  }> | null;
};

export type DigitalClinicalProgramCategoriesFragment = {
  __typename: 'DigitalClinicalProgramCategory';
  description: string | null;
  id: string;
  name: string;
  icon: { __typename: 'Image'; url: string } | null;
  iconBackground: { __typename: 'Image'; url: string } | null;
};

export type AllProgramsQueryVariables = Exact<{ [key: string]: never }>;

export type AllProgramsQuery = {
  __typename: 'Query';
  digitalClinicalPrograms: Array<{
    __typename: 'DigitalClinicalProgramListItem';
    description: string;
    wasJoined: boolean;
    programId: string;
    title: string;
    status: Types.DigitalClinicalProgramStatus;
    icon: { __typename: 'Image'; url: string } | null;
    progress: {
      __typename: 'DigitalClinicalProgramProgress';
      percentageComplete: number;
    };
    nextModule: {
      __typename: 'DigitalClinicalModuleListItem';
      moduleId: string;
      title: string;
    } | null;
  }> | null;
  programsWalkthrough: {
    __typename: 'Walkthrough';
    wasCompleted: boolean;
    steps: Array<{
      __typename: 'WalkthroughStep';
      title: string;
      text: string;
      image: { __typename: 'Image'; url: string } | null;
    }>;
  };
  digitalClinicalProgramCategories: Array<{
    __typename: 'DigitalClinicalProgramCategory';
    description: string | null;
    id: string;
    name: string;
    icon: { __typename: 'Image'; url: string } | null;
    iconBackground: { __typename: 'Image'; url: string } | null;
  } | null> | null;
};

export type WalkthroughCacheQueryVariables = Exact<{ [key: string]: never }>;

export type WalkthroughCacheQuery = {
  __typename: 'Query';
  programsWalkthrough: {
    __typename: 'Walkthrough';
    wasCompleted: boolean;
    steps: Array<{
      __typename: 'WalkthroughStep';
      title: string;
      text: string;
      image: { __typename: 'Image'; url: string } | null;
    }>;
  };
};

export type CompleteWalkthroughMutationVariables = Exact<{
  walkthroughType: Types.WalkthroughTypeInput;
}>;

export type CompleteWalkthroughMutation = {
  __typename: 'Mutation';
  completeWalkthrough: boolean | null;
};

export type ModuleStatusFieldsFragment = {
  __typename: 'DigitalClinicalModule';
  moduleId: string;
  status: Types.DigitalClinicalModuleStatus;
  progress: {
    __typename: 'DigitalClinicalModuleProgress';
    totalContentItems: number;
    completedContentItems: number;
    remainingContentItems: number;
    percentageComplete: number;
  };
};

export type DigitalClinicalModuleArticleFieldsFragment = {
  __typename: 'Article';
  contentItemId: string;
  body: string;
  title: string;
  author: {
    __typename: 'ArticleAuthor';
    name: string;
    surname: string;
    jobTitle: string | null;
    image: { __typename: 'Image'; url: string } | null;
  } | null;
  heroImage: { __typename: 'Image'; url: string } | null;
  audios: Array<{
    __typename: 'ArticleAudio';
    title: string | null;
    url: string;
  }> | null;
  videos: Array<{
    __typename: 'ArticleVideo';
    title: string | null;
    url: string;
    hlsUrl: string | null;
  }> | null;
  userInteraction: {
    __typename: 'ArticleInteraction';
    seenByUser: boolean;
  } | null;
};

export type DigitalClinicalModuleChoiceQuestionFieldsFragment = {
  __typename: 'ChoiceQuestion';
  contentItemId: string;
  title: string;
  description: string | null;
  responseType: Types.ChoiceQuestionResponseType;
  options: Array<{
    __typename: 'ChoiceQuestionOption';
    label: string;
    optionId: string;
  }>;
  userInteraction: {
    __typename: 'ChoiceQuestionInteraction';
    seenByUser: boolean;
    choices: Array<string | null> | null;
  } | null;
};

export type DigitalClinicalModuleFreeTextQuestionFieldsFragment = {
  __typename: 'FreeTextQuestion';
  contentItemId: string;
  title: string;
  description: string | null;
  hint: string | null;
  userInteraction: {
    __typename: 'FreeTextQuestionInteraction';
    seenByUser: boolean;
    text: string | null;
  } | null;
};

export type DigitalClinicalModuleScaleQuestionFieldsFragment = {
  __typename: 'ScaleQuestion';
  contentItemId: string;
  title: string;
  description: string | null;
  scale: Array<{
    __typename: 'ScalePoint';
    label: string | null;
    scalePointId: string;
    isDefault: boolean;
  }>;
  userInteraction: {
    __typename: 'ScaleQuestionInteraction';
    seenByUser: boolean;
    scalePointId: string | null;
  } | null;
};

export type DigitalClinicalModuleStarRatingQuestionFieldsFragment = {
  __typename: 'StarRatingQuestion';
  contentItemId: string;
  title: string;
  description: string | null;
  starRatings: Array<{
    __typename: 'StarRating';
    label: string | null;
    starRatingId: string;
    isDefault: boolean;
  }>;
  userInteraction: {
    __typename: 'StarRatingQuestionInteraction';
    seenByUser: boolean;
    starRatingId: string | null;
  } | null;
};

export type DigitalClinicalModuleDetailsFieldsFragment = {
  __typename: 'DigitalClinicalModule';
  moduleId: string;
  title: string;
  introduction: string;
  status: Types.DigitalClinicalModuleStatus;
  heroImage: { __typename: 'Image'; url: string } | null;
  timeEstimate: { __typename: 'TimeSpan'; minutes: number | null } | null;
  progress: {
    __typename: 'DigitalClinicalModuleProgress';
    totalContentItems: number;
    completedContentItems: number;
    remainingContentItems: number;
    percentageComplete: number;
  };
};

export type DigitalClinicalModuleSectionsFieldsFragment = {
  __typename: 'DigitalClinicalModule';
  sections: Array<{
    __typename: 'DigitalClinicalModuleSection';
    title: string;
    contentItems: Array<
      | {
          __typename: 'Article';
          contentItemId: string;
          body: string;
          title: string;
          author: {
            __typename: 'ArticleAuthor';
            name: string;
            surname: string;
            jobTitle: string | null;
            image: { __typename: 'Image'; url: string } | null;
          } | null;
          heroImage: { __typename: 'Image'; url: string } | null;
          audios: Array<{
            __typename: 'ArticleAudio';
            title: string | null;
            url: string;
          }> | null;
          videos: Array<{
            __typename: 'ArticleVideo';
            title: string | null;
            url: string;
            hlsUrl: string | null;
          }> | null;
          userInteraction: {
            __typename: 'ArticleInteraction';
            seenByUser: boolean;
          } | null;
        }
      | {
          __typename: 'ChoiceQuestion';
          contentItemId: string;
          title: string;
          description: string | null;
          responseType: Types.ChoiceQuestionResponseType;
          options: Array<{
            __typename: 'ChoiceQuestionOption';
            label: string;
            optionId: string;
          }>;
          userInteraction: {
            __typename: 'ChoiceQuestionInteraction';
            seenByUser: boolean;
            choices: Array<string | null> | null;
          } | null;
        }
      | {
          __typename: 'FreeTextQuestion';
          contentItemId: string;
          title: string;
          description: string | null;
          hint: string | null;
          userInteraction: {
            __typename: 'FreeTextQuestionInteraction';
            seenByUser: boolean;
            text: string | null;
          } | null;
        }
      | {
          __typename: 'ScaleQuestion';
          contentItemId: string;
          title: string;
          description: string | null;
          scale: Array<{
            __typename: 'ScalePoint';
            label: string | null;
            scalePointId: string;
            isDefault: boolean;
          }>;
          userInteraction: {
            __typename: 'ScaleQuestionInteraction';
            seenByUser: boolean;
            scalePointId: string | null;
          } | null;
        }
      | {
          __typename: 'StarRatingQuestion';
          contentItemId: string;
          title: string;
          description: string | null;
          starRatings: Array<{
            __typename: 'StarRating';
            label: string | null;
            starRatingId: string;
            isDefault: boolean;
          }>;
          userInteraction: {
            __typename: 'StarRatingQuestionInteraction';
            seenByUser: boolean;
            starRatingId: string | null;
          } | null;
        }
    > | null;
  }> | null;
};

export type DigitalClinicalModuleQueryVariables = Exact<{
  where: Types.FindDigitalClinicalModuleInput;
}>;

export type DigitalClinicalModuleQuery = {
  __typename: 'Query';
  digitalClinicalModule: {
    __typename: 'DigitalClinicalModule';
    moduleId: string;
    title: string;
    introduction: string;
    status: Types.DigitalClinicalModuleStatus;
    heroImage: { __typename: 'Image'; url: string } | null;
    timeEstimate: { __typename: 'TimeSpan'; minutes: number | null } | null;
    sections: Array<{
      __typename: 'DigitalClinicalModuleSection';
      title: string;
      contentItems: Array<
        | {
            __typename: 'Article';
            contentItemId: string;
            body: string;
            title: string;
            author: {
              __typename: 'ArticleAuthor';
              name: string;
              surname: string;
              jobTitle: string | null;
              image: { __typename: 'Image'; url: string } | null;
            } | null;
            heroImage: { __typename: 'Image'; url: string } | null;
            audios: Array<{
              __typename: 'ArticleAudio';
              title: string | null;
              url: string;
            }> | null;
            videos: Array<{
              __typename: 'ArticleVideo';
              title: string | null;
              url: string;
              hlsUrl: string | null;
            }> | null;
            userInteraction: {
              __typename: 'ArticleInteraction';
              seenByUser: boolean;
            } | null;
          }
        | {
            __typename: 'ChoiceQuestion';
            contentItemId: string;
            title: string;
            description: string | null;
            responseType: Types.ChoiceQuestionResponseType;
            options: Array<{
              __typename: 'ChoiceQuestionOption';
              label: string;
              optionId: string;
            }>;
            userInteraction: {
              __typename: 'ChoiceQuestionInteraction';
              seenByUser: boolean;
              choices: Array<string | null> | null;
            } | null;
          }
        | {
            __typename: 'FreeTextQuestion';
            contentItemId: string;
            title: string;
            description: string | null;
            hint: string | null;
            userInteraction: {
              __typename: 'FreeTextQuestionInteraction';
              seenByUser: boolean;
              text: string | null;
            } | null;
          }
        | {
            __typename: 'ScaleQuestion';
            contentItemId: string;
            title: string;
            description: string | null;
            scale: Array<{
              __typename: 'ScalePoint';
              label: string | null;
              scalePointId: string;
              isDefault: boolean;
            }>;
            userInteraction: {
              __typename: 'ScaleQuestionInteraction';
              seenByUser: boolean;
              scalePointId: string | null;
            } | null;
          }
        | {
            __typename: 'StarRatingQuestion';
            contentItemId: string;
            title: string;
            description: string | null;
            starRatings: Array<{
              __typename: 'StarRating';
              label: string | null;
              starRatingId: string;
              isDefault: boolean;
            }>;
            userInteraction: {
              __typename: 'StarRatingQuestionInteraction';
              seenByUser: boolean;
              starRatingId: string | null;
            } | null;
          }
      > | null;
    }> | null;
    progress: {
      __typename: 'DigitalClinicalModuleProgress';
      totalContentItems: number;
      completedContentItems: number;
      remainingContentItems: number;
      percentageComplete: number;
    };
  } | null;
};

export type ModuleOverviewFieldsFragment = {
  __typename: 'DigitalClinicalModule';
  moduleId: string;
  title: string;
  introduction: string;
  status: Types.DigitalClinicalModuleStatus;
  progress: {
    __typename: 'DigitalClinicalModuleProgress';
    totalContentItems: number;
    completedContentItems: number;
    remainingContentItems: number;
    percentageComplete: number;
  };
  timeEstimate: { __typename: 'TimeSpan'; minutes: number | null } | null;
  heroImage: { __typename: 'Image'; url: string } | null;
  backgroundImage: {
    __typename: 'Image';
    url: string;
    font: {
      __typename: 'Font';
      color: { __typename: 'Color'; hexCode: string } | null;
    } | null;
  } | null;
  sections: Array<{
    __typename: 'DigitalClinicalModuleSection';
    description: string | null;
    title: string;
  }> | null;
};

export type ModuleOverviewQueryVariables = Exact<{
  where: Types.FindDigitalClinicalModuleInput;
}>;

export type ModuleOverviewQuery = {
  __typename: 'Query';
  digitalClinicalModule: {
    __typename: 'DigitalClinicalModule';
    moduleId: string;
    title: string;
    introduction: string;
    status: Types.DigitalClinicalModuleStatus;
    progress: {
      __typename: 'DigitalClinicalModuleProgress';
      totalContentItems: number;
      completedContentItems: number;
      remainingContentItems: number;
      percentageComplete: number;
    };
    timeEstimate: { __typename: 'TimeSpan'; minutes: number | null } | null;
    heroImage: { __typename: 'Image'; url: string } | null;
    backgroundImage: {
      __typename: 'Image';
      url: string;
      font: {
        __typename: 'Font';
        color: { __typename: 'Color'; hexCode: string } | null;
      } | null;
    } | null;
    sections: Array<{
      __typename: 'DigitalClinicalModuleSection';
      description: string | null;
      title: string;
    }> | null;
  } | null;
};

export type ProgramStatusFieldsFragment = {
  __typename: 'DigitalClinicalProgram';
  programId: string;
  status: Types.DigitalClinicalProgramStatus;
  progress: {
    __typename: 'DigitalClinicalProgramProgress';
    totalModules: number;
    completedModules: number;
    percentageComplete: number;
  };
};

export type ModuleListItemStatusFieldsFragment = {
  __typename: 'DigitalClinicalModuleListItem';
  moduleId: string;
  status: Types.DigitalClinicalModuleStatus;
  progress: {
    __typename: 'DigitalClinicalModuleProgress';
    totalContentItems: number;
    completedContentItems: number;
    remainingContentItems: number;
    percentageComplete: number;
  };
};

export type SingleProgramFieldsFragment = {
  __typename: 'DigitalClinicalProgram';
  programId: string;
  title: string;
  status: Types.DigitalClinicalProgramStatus;
  modules: Array<{
    __typename: 'DigitalClinicalModuleListItem';
    moduleId: string;
    title: string;
    introduction: string;
    status: Types.DigitalClinicalModuleStatus;
    heroImage: { __typename: 'Image'; url: string } | null;
    backgroundImage: {
      __typename: 'Image';
      url: string;
      font: {
        __typename: 'Font';
        color: { __typename: 'Color'; hexCode: string } | null;
      } | null;
    } | null;
    timeEstimate: { __typename: 'TimeSpan'; minutes: number | null } | null;
    progress: {
      __typename: 'DigitalClinicalModuleProgress';
      totalContentItems: number;
      completedContentItems: number;
      remainingContentItems: number;
      percentageComplete: number;
    };
  }> | null;
  progress: {
    __typename: 'DigitalClinicalProgramProgress';
    totalModules: number;
    completedModules: number;
    percentageComplete: number;
  };
};

export type SingleProgramQueryVariables = Exact<{
  where: Types.FindDigitalClinicalProgramInput;
}>;

export type SingleProgramQuery = {
  __typename: 'Query';
  digitalClinicalProgram: {
    __typename: 'DigitalClinicalProgram';
    programId: string;
    title: string;
    status: Types.DigitalClinicalProgramStatus;
    modules: Array<{
      __typename: 'DigitalClinicalModuleListItem';
      moduleId: string;
      title: string;
      introduction: string;
      status: Types.DigitalClinicalModuleStatus;
      heroImage: { __typename: 'Image'; url: string } | null;
      backgroundImage: {
        __typename: 'Image';
        url: string;
        font: {
          __typename: 'Font';
          color: { __typename: 'Color'; hexCode: string } | null;
        } | null;
      } | null;
      timeEstimate: { __typename: 'TimeSpan'; minutes: number | null } | null;
      progress: {
        __typename: 'DigitalClinicalModuleProgress';
        totalContentItems: number;
        completedContentItems: number;
        remainingContentItems: number;
        percentageComplete: number;
      };
    }> | null;
    progress: {
      __typename: 'DigitalClinicalProgramProgress';
      totalModules: number;
      completedModules: number;
      percentageComplete: number;
    };
  } | null;
};

export type ProgramInfoFieldsFragment = {
  __typename: 'DigitalClinicalProgram';
  title: string;
  description: string;
  icon: { __typename: 'Image'; url: string } | null;
};

export type ProgramMenuQueryVariables = Exact<{
  where: Types.FindDigitalClinicalProgramInput;
}>;

export type ProgramMenuQuery = {
  __typename: 'Query';
  digitalClinicalProgram: {
    __typename: 'DigitalClinicalProgram';
    programId: string;
    title: string;
    description: string;
    icon: { __typename: 'Image'; url: string } | null;
  } | null;
};

export type LeaveProgramMenuMutationVariables = Exact<{
  request: Types.LeaveDigitalClinicalProgramInput;
}>;

export type LeaveProgramMenuMutation = {
  __typename: 'Mutation';
  leaveDigitalClinicalProgram: boolean | null;
};

export type TrackProgramProgressMutationVariables = Exact<{
  trackProgramInput: Types.DigitalClinicalProgramInteractionInput;
}>;

export type TrackProgramProgressMutation = {
  __typename: 'Mutation';
  trackDigitalClinicalProgramProgress: {
    __typename: 'DigitalClinicalProgram';
    programId: string;
    status: Types.DigitalClinicalProgramStatus;
    modules: Array<{
      __typename: 'DigitalClinicalModuleListItem';
      moduleId: string;
      status: Types.DigitalClinicalModuleStatus;
      progress: {
        __typename: 'DigitalClinicalModuleProgress';
        totalContentItems: number;
        completedContentItems: number;
        remainingContentItems: number;
        percentageComplete: number;
      };
    }> | null;
    progress: {
      __typename: 'DigitalClinicalProgramProgress';
      totalModules: number;
      completedModules: number;
      percentageComplete: number;
    };
  } | null;
};

export type WellbeingHubProgramFieldsFragment = {
  __typename: 'DigitalClinicalProgramListItem';
  programId: string;
  title: string;
  description: string;
  status: Types.DigitalClinicalProgramStatus;
  wasJoined: boolean;
  icon: { __typename: 'Image'; url: string } | null;
  progress: {
    __typename: 'DigitalClinicalProgramProgress';
    totalModules: number;
    completedModules: number;
    percentageComplete: number;
  };
};

export type AssessmentTypeFragment = {
  __typename: 'AssessmentType';
  description: string | null;
  id: string;
  title: string;
};

export type AssessmentQuestionOptionFragment = {
  __typename: 'AssessmentItemQuestionnaireOptionsList';
  label: string | null;
  priority: boolean | null;
  jumpTo: string | null;
  uuid: string;
  alert: {
    __typename: 'AssessmentItemQuestionnaireOptionAlert';
    message: string | null;
  } | null;
};

export type AssessmentQuestionMeasurementRangesFragment = {
  __typename: 'MeasurementRanges';
  jumpTo: string | null;
  range: string | null;
  number: string | null;
};

export type AssessmentQuestionMeasurementRangeFragment = {
  __typename: 'AssessmentItemQuestionnaireMeasurementRanges';
  unit: string | null;
  label: string | null;
  ranges: Array<{
    __typename: 'MeasurementRanges';
    jumpTo: string | null;
    range: string | null;
    number: string | null;
  }> | null;
};

export type AssessmentQuestionMeasurementFragment = {
  __typename: 'AssessmentItemQuestionnaireMeasurements';
  uuid: string | null;
  unitOfMeasurement: string | null;
  calculationType: string | null;
  measurementRanges: Array<{
    __typename: 'AssessmentItemQuestionnaireMeasurementRanges';
    unit: string | null;
    label: string | null;
    ranges: Array<{
      __typename: 'MeasurementRanges';
      jumpTo: string | null;
      range: string | null;
      number: string | null;
    }> | null;
  } | null> | null;
};

export type AssessmentQuestionFragment = {
  __typename: 'AssessmentItemQuestionnaire';
  reference: string | null;
  uuid: string;
  multipleChoice: boolean | null;
  questionType: Types.QuestionnaireQuestionType | null;
  introduction: string;
  options: Array<{
    __typename: 'AssessmentItemQuestionnaireOptionsList';
    label: string | null;
    priority: boolean | null;
    jumpTo: string | null;
    uuid: string;
    alert: {
      __typename: 'AssessmentItemQuestionnaireOptionAlert';
      message: string | null;
    } | null;
  } | null> | null;
  measurements: Array<{
    __typename: 'AssessmentItemQuestionnaireMeasurements';
    uuid: string | null;
    unitOfMeasurement: string | null;
    calculationType: string | null;
    measurementRanges: Array<{
      __typename: 'AssessmentItemQuestionnaireMeasurementRanges';
      unit: string | null;
      label: string | null;
      ranges: Array<{
        __typename: 'MeasurementRanges';
        jumpTo: string | null;
        range: string | null;
        number: string | null;
      }> | null;
    } | null> | null;
  } | null> | null;
};

export type AssessmentImageFragment = { __typename: 'Image'; url: string };

export type AssessmentAnswerMeasurementFragment = {
  __typename: 'AssessmentItemAnswersMeasurements';
  measurementUuid: string;
  measurementType: string | null;
  calculationType: string | null;
  unit: string | null;
  value: string | null;
};

export type AssessmentAnswerFragment = {
  __typename: 'AssessmentItemAnswers';
  optionUuids: Array<string> | null;
  questionUuid: string;
  type: string | null;
  measurements: Array<{
    __typename: 'AssessmentItemAnswersMeasurements';
    measurementUuid: string;
    measurementType: string | null;
    calculationType: string | null;
    unit: string | null;
    value: string | null;
  } | null> | null;
};

export type AssessmentRemainingFragment = {
  __typename: 'RemainingAssessmentsCompletionPoints';
  type: Types.AssessmentGroupType | null;
  count: number | null;
  bonusPoints: number | null;
  resetDate: string | null;
};

export type AssessmentStatusFieldsFragment = {
  __typename: 'AssessmentListItem';
  status: Types.AssessmentStatus;
  percentageComplete: number;
  nextQuestionReference: string | null;
  canBeRetaken: boolean | null;
  cooldownPeriodExpirationDate: string | null;
};

export type AssessmentFragment = {
  __typename: 'AssessmentListItem';
  uuid: string;
  localisedUuid: string;
  version: string | null;
  title: string;
  introduction: string;
  numberOfQuestions: number;
  status: Types.AssessmentStatus;
  percentageComplete: number;
  nextQuestionReference: string | null;
  canBeRetaken: boolean | null;
  cooldownPeriodExpirationDate: string | null;
  type: {
    __typename: 'AssessmentType';
    description: string | null;
    id: string;
    title: string;
  };
  questionnaire: Array<{
    __typename: 'AssessmentItemQuestionnaire';
    reference: string | null;
    uuid: string;
    multipleChoice: boolean | null;
    questionType: Types.QuestionnaireQuestionType | null;
    introduction: string;
    options: Array<{
      __typename: 'AssessmentItemQuestionnaireOptionsList';
      label: string | null;
      priority: boolean | null;
      jumpTo: string | null;
      uuid: string;
      alert: {
        __typename: 'AssessmentItemQuestionnaireOptionAlert';
        message: string | null;
      } | null;
    } | null> | null;
    measurements: Array<{
      __typename: 'AssessmentItemQuestionnaireMeasurements';
      uuid: string | null;
      unitOfMeasurement: string | null;
      calculationType: string | null;
      measurementRanges: Array<{
        __typename: 'AssessmentItemQuestionnaireMeasurementRanges';
        unit: string | null;
        label: string | null;
        ranges: Array<{
          __typename: 'MeasurementRanges';
          jumpTo: string | null;
          range: string | null;
          number: string | null;
        }> | null;
      } | null> | null;
    } | null> | null;
  } | null> | null;
  icon: { __typename: 'Image'; url: string } | null;
  answers: Array<{
    __typename: 'AssessmentItemAnswers';
    optionUuids: Array<string> | null;
    questionUuid: string;
    type: string | null;
    measurements: Array<{
      __typename: 'AssessmentItemAnswersMeasurements';
      measurementUuid: string;
      measurementType: string | null;
      calculationType: string | null;
      unit: string | null;
      value: string | null;
    } | null> | null;
  } | null> | null;
  remainingAssessmentsCompletionPoints: {
    __typename: 'RemainingAssessmentsCompletionPoints';
    type: Types.AssessmentGroupType | null;
    count: number | null;
    bonusPoints: number | null;
    resetDate: string | null;
  } | null;
};

export type AssessmentQueryVariables = Exact<{
  id: string | number;
  requestGlobalContent?: boolean | null | undefined;
}>;

export type AssessmentQuery = {
  __typename: 'Query';
  assessment: {
    __typename: 'AssessmentListItem';
    uuid: string;
    localisedUuid: string;
    version: string | null;
    title: string;
    introduction: string;
    numberOfQuestions: number;
    status: Types.AssessmentStatus;
    percentageComplete: number;
    nextQuestionReference: string | null;
    canBeRetaken: boolean | null;
    cooldownPeriodExpirationDate: string | null;
    type: {
      __typename: 'AssessmentType';
      description: string | null;
      id: string;
      title: string;
    };
    questionnaire: Array<{
      __typename: 'AssessmentItemQuestionnaire';
      reference: string | null;
      uuid: string;
      multipleChoice: boolean | null;
      questionType: Types.QuestionnaireQuestionType | null;
      introduction: string;
      options: Array<{
        __typename: 'AssessmentItemQuestionnaireOptionsList';
        label: string | null;
        priority: boolean | null;
        jumpTo: string | null;
        uuid: string;
        alert: {
          __typename: 'AssessmentItemQuestionnaireOptionAlert';
          message: string | null;
        } | null;
      } | null> | null;
      measurements: Array<{
        __typename: 'AssessmentItemQuestionnaireMeasurements';
        uuid: string | null;
        unitOfMeasurement: string | null;
        calculationType: string | null;
        measurementRanges: Array<{
          __typename: 'AssessmentItemQuestionnaireMeasurementRanges';
          unit: string | null;
          label: string | null;
          ranges: Array<{
            __typename: 'MeasurementRanges';
            jumpTo: string | null;
            range: string | null;
            number: string | null;
          }> | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
    icon: { __typename: 'Image'; url: string } | null;
    answers: Array<{
      __typename: 'AssessmentItemAnswers';
      optionUuids: Array<string> | null;
      questionUuid: string;
      type: string | null;
      measurements: Array<{
        __typename: 'AssessmentItemAnswersMeasurements';
        measurementUuid: string;
        measurementType: string | null;
        calculationType: string | null;
        unit: string | null;
        value: string | null;
      } | null> | null;
    } | null> | null;
    remainingAssessmentsCompletionPoints: {
      __typename: 'RemainingAssessmentsCompletionPoints';
      type: Types.AssessmentGroupType | null;
      count: number | null;
      bonusPoints: number | null;
      resetDate: string | null;
    } | null;
  } | null;
};

export type AssessmentHistoryResultFragment = {
  __typename: 'AssessmentItemHistoryResult';
  digestTitle: string;
  digest: string | null;
  percentageScore: number | null;
};

export type AssessmentHistoryFragment = {
  __typename: 'AssessmentItemHistory';
  archiveId: string;
  assessmentUuid: string;
  title: string;
  introduction: string;
  numberOfQuestions: number;
  completedAt: string | null;
  cooldownPeriodExpirationDate: string | null;
  result: {
    __typename: 'AssessmentItemHistoryResult';
    digestTitle: string;
    digest: string | null;
    percentageScore: number | null;
  } | null;
};

export type AssessmentResultFeedbackFragment = {
  __typename: 'ResultFeedback';
  title: string;
  body: string;
  type: string | null;
};

export type AssessmentResultContentCategoryFragment = {
  __typename: 'AssessmentContentCategory';
  title: string;
};

export type AssessmentResultContentTypeFragment = {
  __typename: 'AssessmentContentType';
  title: string;
  typeGroup: string | null;
  description: string | null;
};

export type AssessmentResultImageFragment = {
  __typename: 'AssessmentItemContentImages';
  articlethumbnail: string | null;
};

export type AssessmentResultContentAuthorFragment = {
  __typename: 'AssessmentItemContentAuthor';
  name: string | null;
  surname: string | null;
};

export type AssessmentResultContentFragment = {
  __typename: 'AssessmentListItemResultContentList';
  uuid: string;
  url: string | null;
  sanitizedBody: string | null;
  lastModificationDate: string | null;
  title: string;
  resourcePath: string | null;
  author: {
    __typename: 'AssessmentItemContentAuthor';
    name: string | null;
    surname: string | null;
  } | null;
  category: { __typename: 'AssessmentContentCategory'; title: string } | null;
  type: {
    __typename: 'AssessmentContentType';
    title: string;
    typeGroup: string | null;
    description: string | null;
  } | null;
  images: {
    __typename: 'AssessmentItemContentImages';
    articlethumbnail: string | null;
  } | null;
  thumbnail: { __typename: 'Image'; url: string } | null;
};

export type MeasurementResultFeedbackFragment = {
  __typename: 'MeasurementResultFeedback';
  title: string;
  body: string;
};

export type MeasurementResultFragment = {
  __typename: 'AssessmentContentMeasurementResult';
  score: number | null;
  feedback: {
    __typename: 'MeasurementResultFeedback';
    title: string;
    body: string;
  } | null;
};

export type AssessmentResultFragment = {
  __typename: 'AssessmentListItemResult';
  digestTitle: string;
  digest: string | null;
  gender: string | null;
  score: number;
  minScore: number | null;
  maxScore: number | null;
  percentageScore: number;
  shouldDisplayPercentage: boolean | null;
  minScaleLabel: string;
  maxScaleLabel: string;
  feedback: Array<{
    __typename: 'ResultFeedback';
    title: string;
    body: string;
    type: string | null;
  } | null> | null;
  content: Array<{
    __typename: 'AssessmentListItemResultContentList';
    uuid: string;
    url: string | null;
    sanitizedBody: string | null;
    lastModificationDate: string | null;
    title: string;
    resourcePath: string | null;
    author: {
      __typename: 'AssessmentItemContentAuthor';
      name: string | null;
      surname: string | null;
    } | null;
    category: { __typename: 'AssessmentContentCategory'; title: string } | null;
    type: {
      __typename: 'AssessmentContentType';
      title: string;
      typeGroup: string | null;
      description: string | null;
    } | null;
    images: {
      __typename: 'AssessmentItemContentImages';
      articlethumbnail: string | null;
    } | null;
    thumbnail: { __typename: 'Image'; url: string } | null;
  } | null> | null;
  measurementResult: {
    __typename: 'AssessmentContentMeasurementResult';
    score: number | null;
    feedback: {
      __typename: 'MeasurementResultFeedback';
      title: string;
      body: string;
    } | null;
  } | null;
};

export type NextAssessmentFragment = {
  __typename: 'AssessmentListItem';
  uuid: string;
  title: string;
};

export type AssessmentTierStateFragment = {
  __typename: 'AssessmentItemCurrentTierProgress';
  pointsForCompletingAssessment: number | null;
  bonusPointsForCompletingAllAssessments: number | null;
  tierSummary: {
    __typename: 'CurrentTierProgressSummary';
    nextTier: {
      __typename: 'NextTier';
      id: string | null;
      name: string;
      rank: number | null;
      meetsRequirementsForTier: boolean | null;
    } | null;
    currentTier: {
      __typename: 'CurrentTier';
      id: string | null;
      name: string;
      rank: number;
      motivationalMessage: string;
    } | null;
    points: {
      __typename: 'TierPoints';
      id: string | null;
      remainingToReachNextTier: number | null;
      earned: {
        __typename: 'TierPointsEarned';
        total: number;
        thisMonth: {
          __typename: 'TierPointsEarnedInTimePeriod';
          value: number | null;
          since: string | null;
        };
      };
      requiredToNotRegress: {
        __typename: 'TierPointsRequired';
        total: number;
        remaining: number;
        thisMonth: {
          __typename: 'TierPointsRequiredInTimePeriod';
          value: number;
          remaining: number;
          daysRemaining: number;
        };
      } | null;
    } | null;
  } | null;
};

export type FinalAnswerMutationResponseFragment = {
  __typename: 'AssessmentListItem';
  uuid: string;
  tierPoints: number | null;
  status: Types.AssessmentStatus;
  percentageComplete: number;
  nextQuestionReference: string | null;
  canBeRetaken: boolean | null;
  cooldownPeriodExpirationDate: string | null;
  answers: Array<{
    __typename: 'AssessmentItemAnswers';
    optionUuids: Array<string> | null;
    questionUuid: string;
    type: string | null;
    measurements: Array<{
      __typename: 'AssessmentItemAnswersMeasurements';
      measurementUuid: string;
      measurementType: string | null;
      calculationType: string | null;
      unit: string | null;
      value: string | null;
    } | null> | null;
  } | null> | null;
  result: {
    __typename: 'AssessmentListItemResult';
    digestTitle: string;
    digest: string | null;
    gender: string | null;
    score: number;
    minScore: number | null;
    maxScore: number | null;
    percentageScore: number;
    shouldDisplayPercentage: boolean | null;
    minScaleLabel: string;
    maxScaleLabel: string;
    feedback: Array<{
      __typename: 'ResultFeedback';
      title: string;
      body: string;
      type: string | null;
    } | null> | null;
    content: Array<{
      __typename: 'AssessmentListItemResultContentList';
      uuid: string;
      url: string | null;
      sanitizedBody: string | null;
      lastModificationDate: string | null;
      title: string;
      resourcePath: string | null;
      author: {
        __typename: 'AssessmentItemContentAuthor';
        name: string | null;
        surname: string | null;
      } | null;
      category: {
        __typename: 'AssessmentContentCategory';
        title: string;
      } | null;
      type: {
        __typename: 'AssessmentContentType';
        title: string;
        typeGroup: string | null;
        description: string | null;
      } | null;
      images: {
        __typename: 'AssessmentItemContentImages';
        articlethumbnail: string | null;
      } | null;
      thumbnail: { __typename: 'Image'; url: string } | null;
    } | null> | null;
    measurementResult: {
      __typename: 'AssessmentContentMeasurementResult';
      score: number | null;
      feedback: {
        __typename: 'MeasurementResultFeedback';
        title: string;
        body: string;
      } | null;
    } | null;
  } | null;
  nextAssessment: {
    __typename: 'AssessmentListItem';
    uuid: string;
    title: string;
  } | null;
  tierProgress: {
    __typename: 'AssessmentItemCurrentTierProgress';
    pointsForCompletingAssessment: number | null;
    bonusPointsForCompletingAllAssessments: number | null;
    tierSummary: {
      __typename: 'CurrentTierProgressSummary';
      nextTier: {
        __typename: 'NextTier';
        id: string | null;
        name: string;
        rank: number | null;
        meetsRequirementsForTier: boolean | null;
      } | null;
      currentTier: {
        __typename: 'CurrentTier';
        id: string | null;
        name: string;
        rank: number;
        motivationalMessage: string;
      } | null;
      points: {
        __typename: 'TierPoints';
        id: string | null;
        remainingToReachNextTier: number | null;
        earned: {
          __typename: 'TierPointsEarned';
          total: number;
          thisMonth: {
            __typename: 'TierPointsEarnedInTimePeriod';
            value: number | null;
            since: string | null;
          };
        };
        requiredToNotRegress: {
          __typename: 'TierPointsRequired';
          total: number;
          remaining: number;
          thisMonth: {
            __typename: 'TierPointsRequiredInTimePeriod';
            value: number;
            remaining: number;
            daysRemaining: number;
          };
        } | null;
      } | null;
    } | null;
  } | null;
};

export type AnswerMutationResponseFragment = {
  __typename: 'AssessmentListItem';
  uuid: string;
  status: Types.AssessmentStatus;
  percentageComplete: number;
  nextQuestionReference: string | null;
  canBeRetaken: boolean | null;
  cooldownPeriodExpirationDate: string | null;
  answers: Array<{
    __typename: 'AssessmentItemAnswers';
    optionUuids: Array<string> | null;
    questionUuid: string;
    type: string | null;
    measurements: Array<{
      __typename: 'AssessmentItemAnswersMeasurements';
      measurementUuid: string;
      measurementType: string | null;
      calculationType: string | null;
      unit: string | null;
      value: string | null;
    } | null> | null;
  } | null> | null;
};

export type CompletedAssessmentFragment = {
  __typename: 'AssessmentListItem';
  uuid: string;
  localisedUuid: string;
  version: string | null;
  title: string;
  introduction: string;
  numberOfQuestions: number;
  tierPoints: number | null;
  status: Types.AssessmentStatus;
  percentageComplete: number;
  nextQuestionReference: string | null;
  canBeRetaken: boolean | null;
  cooldownPeriodExpirationDate: string | null;
  type: {
    __typename: 'AssessmentType';
    description: string | null;
    id: string;
    title: string;
  };
  questionnaire: Array<{
    __typename: 'AssessmentItemQuestionnaire';
    reference: string | null;
    uuid: string;
    multipleChoice: boolean | null;
    questionType: Types.QuestionnaireQuestionType | null;
    introduction: string;
    options: Array<{
      __typename: 'AssessmentItemQuestionnaireOptionsList';
      label: string | null;
      priority: boolean | null;
      jumpTo: string | null;
      uuid: string;
      alert: {
        __typename: 'AssessmentItemQuestionnaireOptionAlert';
        message: string | null;
      } | null;
    } | null> | null;
    measurements: Array<{
      __typename: 'AssessmentItemQuestionnaireMeasurements';
      uuid: string | null;
      unitOfMeasurement: string | null;
      calculationType: string | null;
      measurementRanges: Array<{
        __typename: 'AssessmentItemQuestionnaireMeasurementRanges';
        unit: string | null;
        label: string | null;
        ranges: Array<{
          __typename: 'MeasurementRanges';
          jumpTo: string | null;
          range: string | null;
          number: string | null;
        }> | null;
      } | null> | null;
    } | null> | null;
  } | null> | null;
  icon: { __typename: 'Image'; url: string } | null;
  answers: Array<{
    __typename: 'AssessmentItemAnswers';
    optionUuids: Array<string> | null;
    questionUuid: string;
    type: string | null;
    measurements: Array<{
      __typename: 'AssessmentItemAnswersMeasurements';
      measurementUuid: string;
      measurementType: string | null;
      calculationType: string | null;
      unit: string | null;
      value: string | null;
    } | null> | null;
  } | null> | null;
  remainingAssessmentsCompletionPoints: {
    __typename: 'RemainingAssessmentsCompletionPoints';
    type: Types.AssessmentGroupType | null;
    count: number | null;
    bonusPoints: number | null;
    resetDate: string | null;
  } | null;
  result: {
    __typename: 'AssessmentListItemResult';
    digestTitle: string;
    digest: string | null;
    gender: string | null;
    score: number;
    minScore: number | null;
    maxScore: number | null;
    percentageScore: number;
    shouldDisplayPercentage: boolean | null;
    minScaleLabel: string;
    maxScaleLabel: string;
    feedback: Array<{
      __typename: 'ResultFeedback';
      title: string;
      body: string;
      type: string | null;
    } | null> | null;
    content: Array<{
      __typename: 'AssessmentListItemResultContentList';
      uuid: string;
      url: string | null;
      sanitizedBody: string | null;
      lastModificationDate: string | null;
      title: string;
      resourcePath: string | null;
      author: {
        __typename: 'AssessmentItemContentAuthor';
        name: string | null;
        surname: string | null;
      } | null;
      category: {
        __typename: 'AssessmentContentCategory';
        title: string;
      } | null;
      type: {
        __typename: 'AssessmentContentType';
        title: string;
        typeGroup: string | null;
        description: string | null;
      } | null;
      images: {
        __typename: 'AssessmentItemContentImages';
        articlethumbnail: string | null;
      } | null;
      thumbnail: { __typename: 'Image'; url: string } | null;
    } | null> | null;
    measurementResult: {
      __typename: 'AssessmentContentMeasurementResult';
      score: number | null;
      feedback: {
        __typename: 'MeasurementResultFeedback';
        title: string;
        body: string;
      } | null;
    } | null;
  } | null;
  nextAssessment: {
    __typename: 'AssessmentListItem';
    uuid: string;
    title: string;
  } | null;
  tierProgress: {
    __typename: 'AssessmentItemCurrentTierProgress';
    pointsForCompletingAssessment: number | null;
    bonusPointsForCompletingAllAssessments: number | null;
    tierSummary: {
      __typename: 'CurrentTierProgressSummary';
      nextTier: {
        __typename: 'NextTier';
        id: string | null;
        name: string;
        rank: number | null;
        meetsRequirementsForTier: boolean | null;
      } | null;
      currentTier: {
        __typename: 'CurrentTier';
        id: string | null;
        name: string;
        rank: number;
        motivationalMessage: string;
      } | null;
      points: {
        __typename: 'TierPoints';
        id: string | null;
        remainingToReachNextTier: number | null;
        earned: {
          __typename: 'TierPointsEarned';
          total: number;
          thisMonth: {
            __typename: 'TierPointsEarnedInTimePeriod';
            value: number | null;
            since: string | null;
          };
        };
        requiredToNotRegress: {
          __typename: 'TierPointsRequired';
          total: number;
          remaining: number;
          thisMonth: {
            __typename: 'TierPointsRequiredInTimePeriod';
            value: number;
            remaining: number;
            daysRemaining: number;
          };
        } | null;
      } | null;
    } | null;
  } | null;
};

export type AnswerAssessmentQuestionsMutationVariables = Exact<{
  assesmentId: string | number;
  answers: Array<Types.AssessmentAnswersInput> | Types.AssessmentAnswersInput;
  requestGlobalContent?: boolean | null | undefined;
}>;

export type AnswerAssessmentQuestionsMutation = {
  __typename: 'Mutation';
  answerAssessmentQuestions: {
    __typename: 'AnswerAssessmentQuestionsResponse';
    assessment: {
      __typename: 'AssessmentListItem';
      uuid: string;
      status: Types.AssessmentStatus;
      percentageComplete: number;
      nextQuestionReference: string | null;
      canBeRetaken: boolean | null;
      cooldownPeriodExpirationDate: string | null;
      answers: Array<{
        __typename: 'AssessmentItemAnswers';
        optionUuids: Array<string> | null;
        questionUuid: string;
        type: string | null;
        measurements: Array<{
          __typename: 'AssessmentItemAnswersMeasurements';
          measurementUuid: string;
          measurementType: string | null;
          calculationType: string | null;
          unit: string | null;
          value: string | null;
        } | null> | null;
      } | null> | null;
    } | null;
  } | null;
};

export type FinishAnsweringAssessmentQuestionsMutationVariables = Exact<{
  assesmentId: string | number;
  answers: Array<Types.AssessmentAnswersInput> | Types.AssessmentAnswersInput;
  requestGlobalContent?: boolean | null | undefined;
}>;

export type FinishAnsweringAssessmentQuestionsMutation = {
  __typename: 'Mutation';
  answerAssessmentQuestions: {
    __typename: 'AnswerAssessmentQuestionsResponse';
    assessment: {
      __typename: 'AssessmentListItem';
      uuid: string;
      tierPoints: number | null;
      status: Types.AssessmentStatus;
      percentageComplete: number;
      nextQuestionReference: string | null;
      canBeRetaken: boolean | null;
      cooldownPeriodExpirationDate: string | null;
      answers: Array<{
        __typename: 'AssessmentItemAnswers';
        optionUuids: Array<string> | null;
        questionUuid: string;
        type: string | null;
        measurements: Array<{
          __typename: 'AssessmentItemAnswersMeasurements';
          measurementUuid: string;
          measurementType: string | null;
          calculationType: string | null;
          unit: string | null;
          value: string | null;
        } | null> | null;
      } | null> | null;
      result: {
        __typename: 'AssessmentListItemResult';
        digestTitle: string;
        digest: string | null;
        gender: string | null;
        score: number;
        minScore: number | null;
        maxScore: number | null;
        percentageScore: number;
        shouldDisplayPercentage: boolean | null;
        minScaleLabel: string;
        maxScaleLabel: string;
        feedback: Array<{
          __typename: 'ResultFeedback';
          title: string;
          body: string;
          type: string | null;
        } | null> | null;
        content: Array<{
          __typename: 'AssessmentListItemResultContentList';
          uuid: string;
          url: string | null;
          sanitizedBody: string | null;
          lastModificationDate: string | null;
          title: string;
          resourcePath: string | null;
          author: {
            __typename: 'AssessmentItemContentAuthor';
            name: string | null;
            surname: string | null;
          } | null;
          category: {
            __typename: 'AssessmentContentCategory';
            title: string;
          } | null;
          type: {
            __typename: 'AssessmentContentType';
            title: string;
            typeGroup: string | null;
            description: string | null;
          } | null;
          images: {
            __typename: 'AssessmentItemContentImages';
            articlethumbnail: string | null;
          } | null;
          thumbnail: { __typename: 'Image'; url: string } | null;
        } | null> | null;
        measurementResult: {
          __typename: 'AssessmentContentMeasurementResult';
          score: number | null;
          feedback: {
            __typename: 'MeasurementResultFeedback';
            title: string;
            body: string;
          } | null;
        } | null;
      } | null;
      nextAssessment: {
        __typename: 'AssessmentListItem';
        uuid: string;
        title: string;
      } | null;
      tierProgress: {
        __typename: 'AssessmentItemCurrentTierProgress';
        pointsForCompletingAssessment: number | null;
        bonusPointsForCompletingAllAssessments: number | null;
        tierSummary: {
          __typename: 'CurrentTierProgressSummary';
          nextTier: {
            __typename: 'NextTier';
            id: string | null;
            name: string;
            rank: number | null;
            meetsRequirementsForTier: boolean | null;
          } | null;
          currentTier: {
            __typename: 'CurrentTier';
            id: string | null;
            name: string;
            rank: number;
            motivationalMessage: string;
          } | null;
          points: {
            __typename: 'TierPoints';
            id: string | null;
            remainingToReachNextTier: number | null;
            earned: {
              __typename: 'TierPointsEarned';
              total: number;
              thisMonth: {
                __typename: 'TierPointsEarnedInTimePeriod';
                value: number | null;
                since: string | null;
              };
            };
            requiredToNotRegress: {
              __typename: 'TierPointsRequired';
              total: number;
              remaining: number;
              thisMonth: {
                __typename: 'TierPointsRequiredInTimePeriod';
                value: number;
                remaining: number;
                daysRemaining: number;
              };
            } | null;
          } | null;
        } | null;
      } | null;
    } | null;
    originalTierState: {
      __typename: 'AssessmentItemCurrentTierProgress';
      pointsForCompletingAssessment: number | null;
      bonusPointsForCompletingAllAssessments: number | null;
      tierSummary: {
        __typename: 'CurrentTierProgressSummary';
        nextTier: {
          __typename: 'NextTier';
          id: string | null;
          name: string;
          rank: number | null;
          meetsRequirementsForTier: boolean | null;
        } | null;
        currentTier: {
          __typename: 'CurrentTier';
          id: string | null;
          name: string;
          rank: number;
          motivationalMessage: string;
        } | null;
        points: {
          __typename: 'TierPoints';
          id: string | null;
          remainingToReachNextTier: number | null;
          earned: {
            __typename: 'TierPointsEarned';
            total: number;
            thisMonth: {
              __typename: 'TierPointsEarnedInTimePeriod';
              value: number | null;
              since: string | null;
            };
          };
          requiredToNotRegress: {
            __typename: 'TierPointsRequired';
            total: number;
            remaining: number;
            thisMonth: {
              __typename: 'TierPointsRequiredInTimePeriod';
              value: number;
              remaining: number;
              daysRemaining: number;
            };
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type AllTiersQueryVariables = Exact<{ [key: string]: never }>;

export type AllTiersQuery = {
  __typename: 'Query';
  allTiers: Array<{
    __typename: 'TierDefinition';
    name: string;
    rank: number;
    points: number;
  }> | null;
};

export type HistoricalAssessmentFragment = {
  __typename: 'HistoricalAssessment';
  assessmentUuid: string;
  archiveId: string;
  result: {
    __typename: 'AssessmentListItemResult';
    digestTitle: string;
    digest: string | null;
    gender: string | null;
    score: number;
    minScore: number | null;
    maxScore: number | null;
    percentageScore: number;
    shouldDisplayPercentage: boolean | null;
    minScaleLabel: string;
    maxScaleLabel: string;
    feedback: Array<{
      __typename: 'ResultFeedback';
      title: string;
      body: string;
      type: string | null;
    } | null> | null;
    content: Array<{
      __typename: 'AssessmentListItemResultContentList';
      uuid: string;
      url: string | null;
      sanitizedBody: string | null;
      lastModificationDate: string | null;
      title: string;
      resourcePath: string | null;
      author: {
        __typename: 'AssessmentItemContentAuthor';
        name: string | null;
        surname: string | null;
      } | null;
      category: {
        __typename: 'AssessmentContentCategory';
        title: string;
      } | null;
      type: {
        __typename: 'AssessmentContentType';
        title: string;
        typeGroup: string | null;
        description: string | null;
      } | null;
      images: {
        __typename: 'AssessmentItemContentImages';
        articlethumbnail: string | null;
      } | null;
      thumbnail: { __typename: 'Image'; url: string } | null;
    } | null> | null;
    measurementResult: {
      __typename: 'AssessmentContentMeasurementResult';
      score: number | null;
      feedback: {
        __typename: 'MeasurementResultFeedback';
        title: string;
        body: string;
      } | null;
    } | null;
  } | null;
};

export type AssessmentResultCommonFieldsFragment = {
  __typename: 'AssessmentListItem';
  canBeRetaken: boolean | null;
  uuid: string;
  title: string;
  icon: { __typename: 'Image'; url: string } | null;
};

export type RegressionInformationFragment = {
  __typename: 'TierRegressionInfo';
  image: {
    __typename: 'Image';
    url: string;
    font: {
      __typename: 'Font';
      color: { __typename: 'Color'; hexCode: string } | null;
    } | null;
  } | null;
  timePeriods: Array<{
    __typename: 'TierRegressionTimePeriodInfo';
    isCurrent: boolean | null;
    pointsEarned: number | null;
    pointGoal: number | null;
    timePeriod: { __typename: 'TimePeriod'; from: string; to: string } | null;
  }>;
  currentTierDefinition: {
    __typename: 'TierDefinition';
    name: string;
    rank: number;
    points: number;
  };
};

export type AssessmentHistoryQueryVariables = Exact<{
  archiveId: string | number;
  id: string | number;
  requestGlobalContent?: boolean | null | undefined;
}>;

export type AssessmentHistoryQuery = {
  __typename: 'Query';
  resultData: {
    __typename: 'HistoricalAssessment';
    assessmentUuid: string;
    archiveId: string;
    result: {
      __typename: 'AssessmentListItemResult';
      digestTitle: string;
      digest: string | null;
      gender: string | null;
      score: number;
      minScore: number | null;
      maxScore: number | null;
      percentageScore: number;
      shouldDisplayPercentage: boolean | null;
      minScaleLabel: string;
      maxScaleLabel: string;
      feedback: Array<{
        __typename: 'ResultFeedback';
        title: string;
        body: string;
        type: string | null;
      } | null> | null;
      content: Array<{
        __typename: 'AssessmentListItemResultContentList';
        uuid: string;
        url: string | null;
        sanitizedBody: string | null;
        lastModificationDate: string | null;
        title: string;
        resourcePath: string | null;
        author: {
          __typename: 'AssessmentItemContentAuthor';
          name: string | null;
          surname: string | null;
        } | null;
        category: {
          __typename: 'AssessmentContentCategory';
          title: string;
        } | null;
        type: {
          __typename: 'AssessmentContentType';
          title: string;
          typeGroup: string | null;
          description: string | null;
        } | null;
        images: {
          __typename: 'AssessmentItemContentImages';
          articlethumbnail: string | null;
        } | null;
        thumbnail: { __typename: 'Image'; url: string } | null;
      } | null> | null;
      measurementResult: {
        __typename: 'AssessmentContentMeasurementResult';
        score: number | null;
        feedback: {
          __typename: 'MeasurementResultFeedback';
          title: string;
          body: string;
        } | null;
      } | null;
    } | null;
  } | null;
  commonAssessmentProperties: {
    __typename: 'AssessmentListItem';
    canBeRetaken: boolean | null;
    uuid: string;
    title: string;
    icon: { __typename: 'Image'; url: string } | null;
  } | null;
};

export type AssessmentFullHistoryQueryVariables = Exact<{
  id: string | number;
}>;

export type AssessmentFullHistoryQuery = {
  __typename: 'Query';
  assessmentHistory: Array<{
    __typename: 'AssessmentItemHistory';
    archiveId: string;
    assessmentUuid: string;
    title: string;
    introduction: string;
    numberOfQuestions: number;
    completedAt: string | null;
    cooldownPeriodExpirationDate: string | null;
    result: {
      __typename: 'AssessmentItemHistoryResult';
      digestTitle: string;
      digest: string | null;
      percentageScore: number | null;
    } | null;
  } | null> | null;
};

export type AssessmentResultQueryVariables = Exact<{
  id: string | number;
  requestGlobalContent?: boolean | null | undefined;
}>;

export type AssessmentResultQuery = {
  __typename: 'Query';
  resultData: {
    __typename: 'AssessmentListItem';
    uuid: string;
    tierPoints: number | null;
    status: Types.AssessmentStatus;
    percentageComplete: number;
    nextQuestionReference: string | null;
    canBeRetaken: boolean | null;
    cooldownPeriodExpirationDate: string | null;
    answers: Array<{
      __typename: 'AssessmentItemAnswers';
      optionUuids: Array<string> | null;
      questionUuid: string;
      type: string | null;
      measurements: Array<{
        __typename: 'AssessmentItemAnswersMeasurements';
        measurementUuid: string;
        measurementType: string | null;
        calculationType: string | null;
        unit: string | null;
        value: string | null;
      } | null> | null;
    } | null> | null;
    result: {
      __typename: 'AssessmentListItemResult';
      digestTitle: string;
      digest: string | null;
      gender: string | null;
      score: number;
      minScore: number | null;
      maxScore: number | null;
      percentageScore: number;
      shouldDisplayPercentage: boolean | null;
      minScaleLabel: string;
      maxScaleLabel: string;
      feedback: Array<{
        __typename: 'ResultFeedback';
        title: string;
        body: string;
        type: string | null;
      } | null> | null;
      content: Array<{
        __typename: 'AssessmentListItemResultContentList';
        uuid: string;
        url: string | null;
        sanitizedBody: string | null;
        lastModificationDate: string | null;
        title: string;
        resourcePath: string | null;
        author: {
          __typename: 'AssessmentItemContentAuthor';
          name: string | null;
          surname: string | null;
        } | null;
        category: {
          __typename: 'AssessmentContentCategory';
          title: string;
        } | null;
        type: {
          __typename: 'AssessmentContentType';
          title: string;
          typeGroup: string | null;
          description: string | null;
        } | null;
        images: {
          __typename: 'AssessmentItemContentImages';
          articlethumbnail: string | null;
        } | null;
        thumbnail: { __typename: 'Image'; url: string } | null;
      } | null> | null;
      measurementResult: {
        __typename: 'AssessmentContentMeasurementResult';
        score: number | null;
        feedback: {
          __typename: 'MeasurementResultFeedback';
          title: string;
          body: string;
        } | null;
      } | null;
    } | null;
    nextAssessment: {
      __typename: 'AssessmentListItem';
      uuid: string;
      title: string;
    } | null;
    tierProgress: {
      __typename: 'AssessmentItemCurrentTierProgress';
      pointsForCompletingAssessment: number | null;
      bonusPointsForCompletingAllAssessments: number | null;
      tierSummary: {
        __typename: 'CurrentTierProgressSummary';
        nextTier: {
          __typename: 'NextTier';
          id: string | null;
          name: string;
          rank: number | null;
          meetsRequirementsForTier: boolean | null;
        } | null;
        currentTier: {
          __typename: 'CurrentTier';
          id: string | null;
          name: string;
          rank: number;
          motivationalMessage: string;
        } | null;
        points: {
          __typename: 'TierPoints';
          id: string | null;
          remainingToReachNextTier: number | null;
          earned: {
            __typename: 'TierPointsEarned';
            total: number;
            thisMonth: {
              __typename: 'TierPointsEarnedInTimePeriod';
              value: number | null;
              since: string | null;
            };
          };
          requiredToNotRegress: {
            __typename: 'TierPointsRequired';
            total: number;
            remaining: number;
            thisMonth: {
              __typename: 'TierPointsRequiredInTimePeriod';
              value: number;
              remaining: number;
              daysRemaining: number;
            };
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
  commonAssessmentProperties: {
    __typename: 'AssessmentListItem';
    canBeRetaken: boolean | null;
    uuid: string;
    title: string;
    icon: { __typename: 'Image'; url: string } | null;
  } | null;
};

export type RetakeAssessmentMutationVariables = Exact<{
  uuid: string | number;
  requestGlobalContent?: boolean | null | undefined;
}>;

export type RetakeAssessmentMutation = {
  __typename: 'Mutation';
  retakeAssessment: {
    __typename: 'retakeAssessmentResponse';
    assessment: {
      __typename: 'AssessmentListItem';
      uuid: string;
      localisedUuid: string;
      version: string | null;
      title: string;
      introduction: string;
      numberOfQuestions: number;
      status: Types.AssessmentStatus;
      percentageComplete: number;
      nextQuestionReference: string | null;
      canBeRetaken: boolean | null;
      cooldownPeriodExpirationDate: string | null;
      type: {
        __typename: 'AssessmentType';
        description: string | null;
        id: string;
        title: string;
      };
      questionnaire: Array<{
        __typename: 'AssessmentItemQuestionnaire';
        reference: string | null;
        uuid: string;
        multipleChoice: boolean | null;
        questionType: Types.QuestionnaireQuestionType | null;
        introduction: string;
        options: Array<{
          __typename: 'AssessmentItemQuestionnaireOptionsList';
          label: string | null;
          priority: boolean | null;
          jumpTo: string | null;
          uuid: string;
          alert: {
            __typename: 'AssessmentItemQuestionnaireOptionAlert';
            message: string | null;
          } | null;
        } | null> | null;
        measurements: Array<{
          __typename: 'AssessmentItemQuestionnaireMeasurements';
          uuid: string | null;
          unitOfMeasurement: string | null;
          calculationType: string | null;
          measurementRanges: Array<{
            __typename: 'AssessmentItemQuestionnaireMeasurementRanges';
            unit: string | null;
            label: string | null;
            ranges: Array<{
              __typename: 'MeasurementRanges';
              jumpTo: string | null;
              range: string | null;
              number: string | null;
            }> | null;
          } | null> | null;
        } | null> | null;
      } | null> | null;
      icon: { __typename: 'Image'; url: string } | null;
      answers: Array<{
        __typename: 'AssessmentItemAnswers';
        optionUuids: Array<string> | null;
        questionUuid: string;
        type: string | null;
        measurements: Array<{
          __typename: 'AssessmentItemAnswersMeasurements';
          measurementUuid: string;
          measurementType: string | null;
          calculationType: string | null;
          unit: string | null;
          value: string | null;
        } | null> | null;
      } | null> | null;
      remainingAssessmentsCompletionPoints: {
        __typename: 'RemainingAssessmentsCompletionPoints';
        type: Types.AssessmentGroupType | null;
        count: number | null;
        bonusPoints: number | null;
        resetDate: string | null;
      } | null;
    } | null;
  } | null;
};

export type ChangeGenderMutationVariables = Exact<{
  id: string | number;
  gender: string;
  answers: Array<Types.AssessmentAnswersInput> | Types.AssessmentAnswersInput;
  requestGlobalContent?: boolean | null | undefined;
}>;

export type ChangeGenderMutation = {
  __typename: 'Mutation';
  changeGender: {
    __typename: 'changeGenderResponse';
    assessment: {
      __typename: 'AssessmentListItem';
      uuid: string;
      result: {
        __typename: 'AssessmentListItemResult';
        digestTitle: string;
        digest: string | null;
        gender: string | null;
        score: number;
        minScore: number | null;
        maxScore: number | null;
        percentageScore: number;
        shouldDisplayPercentage: boolean | null;
        minScaleLabel: string;
        maxScaleLabel: string;
        feedback: Array<{
          __typename: 'ResultFeedback';
          title: string;
          body: string;
          type: string | null;
        } | null> | null;
        content: Array<{
          __typename: 'AssessmentListItemResultContentList';
          uuid: string;
          url: string | null;
          sanitizedBody: string | null;
          lastModificationDate: string | null;
          title: string;
          resourcePath: string | null;
          author: {
            __typename: 'AssessmentItemContentAuthor';
            name: string | null;
            surname: string | null;
          } | null;
          category: {
            __typename: 'AssessmentContentCategory';
            title: string;
          } | null;
          type: {
            __typename: 'AssessmentContentType';
            title: string;
            typeGroup: string | null;
            description: string | null;
          } | null;
          images: {
            __typename: 'AssessmentItemContentImages';
            articlethumbnail: string | null;
          } | null;
          thumbnail: { __typename: 'Image'; url: string } | null;
        } | null> | null;
        measurementResult: {
          __typename: 'AssessmentContentMeasurementResult';
          score: number | null;
          feedback: {
            __typename: 'MeasurementResultFeedback';
            title: string;
            body: string;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type RegressionInfoQueryVariables = Exact<{ [key: string]: never }>;

export type RegressionInfoQuery = {
  __typename: 'Query';
  tierRegressionInfo: {
    __typename: 'TierRegressionInfo';
    image: {
      __typename: 'Image';
      url: string;
      font: {
        __typename: 'Font';
        color: { __typename: 'Color'; hexCode: string } | null;
      } | null;
    } | null;
    timePeriods: Array<{
      __typename: 'TierRegressionTimePeriodInfo';
      isCurrent: boolean | null;
      pointsEarned: number | null;
      pointGoal: number | null;
      timePeriod: { __typename: 'TimePeriod'; from: string; to: string } | null;
    }>;
    currentTierDefinition: {
      __typename: 'TierDefinition';
      name: string;
      rank: number;
      points: number;
    };
  } | null;
  currentTier: {
    __typename: 'CurrentTier';
    id: string | null;
    name: string;
    rank: number;
    motivationalMessage: string;
  } | null;
};

export type AssessmentsHubAssessmentResultFragment = {
  __typename: 'AssessmentListItemResult';
  digestTitle: string;
  digest: string | null;
  minScaleLabel: string;
  maxScaleLabel: string;
  percentageScore: number;
  shouldDisplayPercentage: boolean | null;
  score: number;
};

export type AssessmentListItemFragment = {
  __typename: 'AssessmentListItem';
  tierPoints: number | null;
  uuid: string;
  localisedUuid: string;
  version: string | null;
  title: string;
  introduction: string;
  numberOfQuestions: number;
  status: Types.AssessmentStatus;
  percentageComplete: number;
  nextQuestionReference: string | null;
  canBeRetaken: boolean | null;
  cooldownPeriodExpirationDate: string | null;
  type: {
    __typename: 'AssessmentType';
    description: string | null;
    id: string;
    title: string;
  };
  questionnaire: Array<{
    __typename: 'AssessmentItemQuestionnaire';
    reference: string | null;
    uuid: string;
    multipleChoice: boolean | null;
    questionType: Types.QuestionnaireQuestionType | null;
    introduction: string;
    options: Array<{
      __typename: 'AssessmentItemQuestionnaireOptionsList';
      label: string | null;
      priority: boolean | null;
      jumpTo: string | null;
      uuid: string;
      alert: {
        __typename: 'AssessmentItemQuestionnaireOptionAlert';
        message: string | null;
      } | null;
    } | null> | null;
    measurements: Array<{
      __typename: 'AssessmentItemQuestionnaireMeasurements';
      uuid: string | null;
      unitOfMeasurement: string | null;
      calculationType: string | null;
      measurementRanges: Array<{
        __typename: 'AssessmentItemQuestionnaireMeasurementRanges';
        unit: string | null;
        label: string | null;
        ranges: Array<{
          __typename: 'MeasurementRanges';
          jumpTo: string | null;
          range: string | null;
          number: string | null;
        }> | null;
      } | null> | null;
    } | null> | null;
  } | null> | null;
  icon: { __typename: 'Image'; url: string } | null;
  answers: Array<{
    __typename: 'AssessmentItemAnswers';
    optionUuids: Array<string> | null;
    questionUuid: string;
    type: string | null;
    measurements: Array<{
      __typename: 'AssessmentItemAnswersMeasurements';
      measurementUuid: string;
      measurementType: string | null;
      calculationType: string | null;
      unit: string | null;
      value: string | null;
    } | null> | null;
  } | null> | null;
  remainingAssessmentsCompletionPoints: {
    __typename: 'RemainingAssessmentsCompletionPoints';
    type: Types.AssessmentGroupType | null;
    count: number | null;
    bonusPoints: number | null;
    resetDate: string | null;
  } | null;
};

export type SingleAssessmentHeroCardFragment = {
  __typename: 'SingleAssessmentCard';
  completedAt: string | null;
  status: Types.AssessmentStatus;
  title: string;
  tierPoints: number | null;
  icon: { __typename: 'Image'; url: string } | null;
  assessment: {
    __typename: 'AssessmentListItem';
    title: string;
    status: Types.AssessmentStatus;
    numberOfQuestions: number;
    percentageComplete: number;
    uuid: string;
    result: {
      __typename: 'AssessmentListItemResult';
      percentageScore: number;
    } | null;
    type: {
      __typename: 'AssessmentType';
      id: string;
      title: string;
      description: string | null;
      filter: string | null;
    };
  };
};

export type HealthRiskAssessmentHeroCardFragment = {
  __typename: 'HealthRiskAssessmentCard';
  completedAt: string | null;
  status: Types.AssessmentStatus;
  title: string;
  tierPoints: number | null;
  numberOfAssessments: number;
  assessmentsRemaining: number;
  icon: { __typename: 'Image'; url: string } | null;
  nextAssessment: {
    __typename: 'AssessmentListItem';
    title: string;
    status: Types.AssessmentStatus;
    numberOfQuestions: number;
    percentageComplete: number;
    uuid: string;
    result: {
      __typename: 'AssessmentListItemResult';
      percentageScore: number;
    } | null;
    type: {
      __typename: 'AssessmentType';
      id: string;
      title: string;
      description: string | null;
      filter: string | null;
    };
  };
};

export type AssessmentTypeFiltersFragment = {
  __typename: 'AssessmentTypeFilter';
  typeId: string;
  name: string;
  count: number;
};

export type AssessmentHubListItemFragment = {
  __typename: 'AssessmentListItem';
  tierPoints: number | null;
  uuid: string;
  localisedUuid: string;
  version: string | null;
  title: string;
  introduction: string;
  numberOfQuestions: number;
  status: Types.AssessmentStatus;
  percentageComplete: number;
  nextQuestionReference: string | null;
  canBeRetaken: boolean | null;
  cooldownPeriodExpirationDate: string | null;
  result: {
    __typename: 'AssessmentListItemResult';
    digestTitle: string;
    digest: string | null;
    minScaleLabel: string;
    maxScaleLabel: string;
    percentageScore: number;
    shouldDisplayPercentage: boolean | null;
    score: number;
  } | null;
  type: {
    __typename: 'AssessmentType';
    description: string | null;
    id: string;
    title: string;
  };
  questionnaire: Array<{
    __typename: 'AssessmentItemQuestionnaire';
    reference: string | null;
    uuid: string;
    multipleChoice: boolean | null;
    questionType: Types.QuestionnaireQuestionType | null;
    introduction: string;
    options: Array<{
      __typename: 'AssessmentItemQuestionnaireOptionsList';
      label: string | null;
      priority: boolean | null;
      jumpTo: string | null;
      uuid: string;
      alert: {
        __typename: 'AssessmentItemQuestionnaireOptionAlert';
        message: string | null;
      } | null;
    } | null> | null;
    measurements: Array<{
      __typename: 'AssessmentItemQuestionnaireMeasurements';
      uuid: string | null;
      unitOfMeasurement: string | null;
      calculationType: string | null;
      measurementRanges: Array<{
        __typename: 'AssessmentItemQuestionnaireMeasurementRanges';
        unit: string | null;
        label: string | null;
        ranges: Array<{
          __typename: 'MeasurementRanges';
          jumpTo: string | null;
          range: string | null;
          number: string | null;
        }> | null;
      } | null> | null;
    } | null> | null;
  } | null> | null;
  icon: { __typename: 'Image'; url: string } | null;
  answers: Array<{
    __typename: 'AssessmentItemAnswers';
    optionUuids: Array<string> | null;
    questionUuid: string;
    type: string | null;
    measurements: Array<{
      __typename: 'AssessmentItemAnswersMeasurements';
      measurementUuid: string;
      measurementType: string | null;
      calculationType: string | null;
      unit: string | null;
      value: string | null;
    } | null> | null;
  } | null> | null;
  remainingAssessmentsCompletionPoints: {
    __typename: 'RemainingAssessmentsCompletionPoints';
    type: Types.AssessmentGroupType | null;
    count: number | null;
    bonusPoints: number | null;
    resetDate: string | null;
  } | null;
};

export type AssessmentHeroCardsQueryVariables = Exact<{ [key: string]: never }>;

export type AssessmentHeroCardsQuery = {
  __typename: 'Query';
  assessmentHeroCards: Array<
    | {
        __typename: 'HealthRiskAssessmentCard';
        completedAt: string | null;
        status: Types.AssessmentStatus;
        title: string;
        tierPoints: number | null;
        numberOfAssessments: number;
        assessmentsRemaining: number;
        icon: { __typename: 'Image'; url: string } | null;
        nextAssessment: {
          __typename: 'AssessmentListItem';
          title: string;
          status: Types.AssessmentStatus;
          numberOfQuestions: number;
          percentageComplete: number;
          uuid: string;
          result: {
            __typename: 'AssessmentListItemResult';
            percentageScore: number;
          } | null;
          type: {
            __typename: 'AssessmentType';
            id: string;
            title: string;
            description: string | null;
            filter: string | null;
          };
        };
      }
    | {
        __typename: 'SingleAssessmentCard';
        completedAt: string | null;
        status: Types.AssessmentStatus;
        title: string;
        tierPoints: number | null;
        icon: { __typename: 'Image'; url: string } | null;
        assessment: {
          __typename: 'AssessmentListItem';
          title: string;
          status: Types.AssessmentStatus;
          numberOfQuestions: number;
          percentageComplete: number;
          uuid: string;
          result: {
            __typename: 'AssessmentListItemResult';
            percentageScore: number;
          } | null;
          type: {
            __typename: 'AssessmentType';
            id: string;
            title: string;
            description: string | null;
            filter: string | null;
          };
        };
      }
    | {
        __typename: 'TotalHealthIndexCard';
        title: string;
        subtitle: string;
        status: Types.AssessmentStatus;
        tierPoints: number | null;
        nextPillar: {
          __typename: 'AssessmentListItem';
          uuid: string;
          title: string;
        } | null;
        score: {
          __typename: 'TotalHealthIndexScore';
          percentage: number;
          bracket: {
            __typename: 'TotalHealthIndexBracket';
            bracketId: string;
            description: string | null;
            color: { __typename: 'Color'; hexCode: string };
          };
        };
      }
  > | null;
};

export type AssessmentContentLanguageMessageQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AssessmentContentLanguageMessageQuery = {
  __typename: 'Query';
  assessmentContentLanguageMessage: {
    __typename: 'WellbeingContentLanguageMessageResponse';
    banner:
      | {
          __typename: 'WellbeingContentLanguageMessageChangeLanguage';
          section: Types.WellbeingContentLanguageMessageSection;
          bannerText: string;
          bannerTextPopUp: string;
        }
      | {
          __typename: 'WellbeingContentLanguageMessageNoChoice';
          section: Types.WellbeingContentLanguageMessageSection;
          bannerText: string;
          bannerTextPopUp: string;
        }
      | {
          __typename: 'WellbeingContentLanguageMessageNoContent';
          section: Types.WellbeingContentLanguageMessageSection;
          bannerText: string;
        }
      | null;
  } | null;
};

export type AssessmentsHubQueryVariables = Exact<{
  requestGlobalContent?: boolean | null | undefined;
}>;

export type AssessmentsHubQuery = {
  __typename: 'Query';
  allAssessments: {
    __typename: 'FetchAssessmentsResponse';
    contentLanguage: string | null;
    translatedGlobalContentExists: boolean;
    assessments: Array<{
      __typename: 'AssessmentListItem';
      tierPoints: number | null;
      uuid: string;
      localisedUuid: string;
      version: string | null;
      title: string;
      introduction: string;
      numberOfQuestions: number;
      status: Types.AssessmentStatus;
      percentageComplete: number;
      nextQuestionReference: string | null;
      canBeRetaken: boolean | null;
      cooldownPeriodExpirationDate: string | null;
      result: {
        __typename: 'AssessmentListItemResult';
        digestTitle: string;
        digest: string | null;
        minScaleLabel: string;
        maxScaleLabel: string;
        percentageScore: number;
        shouldDisplayPercentage: boolean | null;
        score: number;
      } | null;
      type: {
        __typename: 'AssessmentType';
        description: string | null;
        id: string;
        title: string;
      };
      questionnaire: Array<{
        __typename: 'AssessmentItemQuestionnaire';
        reference: string | null;
        uuid: string;
        multipleChoice: boolean | null;
        questionType: Types.QuestionnaireQuestionType | null;
        introduction: string;
        options: Array<{
          __typename: 'AssessmentItemQuestionnaireOptionsList';
          label: string | null;
          priority: boolean | null;
          jumpTo: string | null;
          uuid: string;
          alert: {
            __typename: 'AssessmentItemQuestionnaireOptionAlert';
            message: string | null;
          } | null;
        } | null> | null;
        measurements: Array<{
          __typename: 'AssessmentItemQuestionnaireMeasurements';
          uuid: string | null;
          unitOfMeasurement: string | null;
          calculationType: string | null;
          measurementRanges: Array<{
            __typename: 'AssessmentItemQuestionnaireMeasurementRanges';
            unit: string | null;
            label: string | null;
            ranges: Array<{
              __typename: 'MeasurementRanges';
              jumpTo: string | null;
              range: string | null;
              number: string | null;
            }> | null;
          } | null> | null;
        } | null> | null;
      } | null> | null;
      icon: { __typename: 'Image'; url: string } | null;
      answers: Array<{
        __typename: 'AssessmentItemAnswers';
        optionUuids: Array<string> | null;
        questionUuid: string;
        type: string | null;
        measurements: Array<{
          __typename: 'AssessmentItemAnswersMeasurements';
          measurementUuid: string;
          measurementType: string | null;
          calculationType: string | null;
          unit: string | null;
          value: string | null;
        } | null> | null;
      } | null> | null;
      remainingAssessmentsCompletionPoints: {
        __typename: 'RemainingAssessmentsCompletionPoints';
        type: Types.AssessmentGroupType | null;
        count: number | null;
        bonusPoints: number | null;
        resetDate: string | null;
      } | null;
    }> | null;
  } | null;
  assessmentTypeFilters: Array<{
    __typename: 'AssessmentTypeFilter';
    typeId: string;
    name: string;
    count: number;
  }> | null;
};

export type PointsModalQueryVariables = Exact<{ [key: string]: never }>;

export type PointsModalQuery = {
  __typename: 'Query';
  assessmentTierPoints: {
    __typename: 'AssessmentTierPoints';
    assessmentCooldownFrequency: string | null;
    pointsForAnAssessment: number | null;
    pointsForHRA: number | null;
    pointsForTHI: number | null;
  };
};

export type GetPermissionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetPermissionsQuery = {
  __typename: 'Query';
  howDoesPersonalisationWork: {
    __typename: 'HowDoesPersonalisationWorkResponse';
    permission: {
      __typename: 'HowPersonalisationWorksPermission';
      allowPersonalisation: boolean | null;
      body: string;
      footer: string | null;
      subtitle: string;
      title: string;
    } | null;
  } | null;
};

export type CompleteCustomTierActivityMutationVariables = Exact<{
  request?: Types.FindCustomTierActivityInput | null | undefined;
}>;

export type CompleteCustomTierActivityMutation = {
  __typename: 'Mutation';
  completeCustomTierActivity: {
    __typename: 'CompletedCustomTierActivity';
    customTierActivity: {
      __typename: 'CustomTierActivity';
      activityId: string;
      title: string;
      description: string | null;
      status: Types.CustomTierActivityStatus;
      tierPointAward: {
        __typename: 'TierPointAward';
        frequency: Types.TierPointFrequencyType;
        points: number;
      } | null;
      image: { __typename: 'Image'; url: string } | null;
    };
    currentTier: {
      __typename: 'CurrentTier';
      id: string | null;
      name: string;
      rank: number;
      motivationalMessage: string;
    } | null;
    nextTier: {
      __typename: 'NextTier';
      id: string | null;
      name: string;
      rank: number | null;
      meetsRequirementsForTier: boolean | null;
    } | null;
    tierPoints: {
      __typename: 'TierPoints';
      id: string | null;
      remainingToReachNextTier: number | null;
      earned: {
        __typename: 'TierPointsEarned';
        total: number;
        thisMonth: {
          __typename: 'TierPointsEarnedInTimePeriod';
          value: number | null;
          since: string | null;
        };
      };
      requiredToNotRegress: {
        __typename: 'TierPointsRequired';
        total: number;
        remaining: number;
        thisMonth: {
          __typename: 'TierPointsRequiredInTimePeriod';
          value: number;
          remaining: number;
          daysRemaining: number;
        };
      } | null;
    } | null;
  } | null;
};

export type ActivityModalRegressionInfoQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ActivityModalRegressionInfoQuery = {
  __typename: 'Query';
  tierRegressionInfo: {
    __typename: 'TierRegressionInfo';
    image: {
      __typename: 'Image';
      url: string;
      font: {
        __typename: 'Font';
        color: { __typename: 'Color'; hexCode: string } | null;
      } | null;
    } | null;
    timePeriods: Array<{
      __typename: 'TierRegressionTimePeriodInfo';
      isCurrent: boolean | null;
      pointsEarned: number | null;
      pointGoal: number | null;
      timePeriod: { __typename: 'TimePeriod'; from: string; to: string } | null;
    }>;
  } | null;
};

export type CustomActivityModalQueryVariables = Exact<{ [key: string]: never }>;

export type CustomActivityModalQuery = {
  __typename: 'Query';
  currentTier: {
    __typename: 'CurrentTier';
    id: string | null;
    name: string;
    rank: number;
    motivationalMessage: string;
  } | null;
  nextTier: {
    __typename: 'NextTier';
    id: string | null;
    name: string;
    rank: number | null;
    meetsRequirementsForTier: boolean | null;
  } | null;
  allTiers: Array<{
    __typename: 'TierDefinition';
    name: string;
    rank: number;
    points: number;
  }> | null;
  tierPoints: {
    __typename: 'TierPoints';
    id: string | null;
    remainingToReachNextTier: number | null;
    earned: {
      __typename: 'TierPointsEarned';
      total: number;
      thisMonth: {
        __typename: 'TierPointsEarnedInTimePeriod';
        value: number | null;
        since: string | null;
      };
    };
    requiredToNotRegress: {
      __typename: 'TierPointsRequired';
      total: number;
      remaining: number;
      thisMonth: {
        __typename: 'TierPointsRequiredInTimePeriod';
        value: number;
        remaining: number;
        daysRemaining: number;
      };
    } | null;
  } | null;
};

export type FeedbackScreenQueryVariables = Exact<{ [key: string]: never }>;

export type FeedbackScreenQuery = {
  __typename: 'Query';
  customTierActivities: Array<{
    __typename: 'CustomTierActivity';
    activityId: string;
    title: string;
    description: string | null;
    status: Types.CustomTierActivityStatus;
    tierPointAward: {
      __typename: 'TierPointAward';
      frequency: Types.TierPointFrequencyType;
      points: number;
    } | null;
    image: { __typename: 'Image'; url: string } | null;
  }> | null;
  tierPoints: {
    __typename: 'TierPoints';
    id: string | null;
    remainingToReachNextTier: number | null;
    earned: {
      __typename: 'TierPointsEarned';
      total: number;
      thisMonth: {
        __typename: 'TierPointsEarnedInTimePeriod';
        value: number | null;
        since: string | null;
      };
    };
    requiredToNotRegress: {
      __typename: 'TierPointsRequired';
      total: number;
      remaining: number;
      thisMonth: {
        __typename: 'TierPointsRequiredInTimePeriod';
        value: number;
        remaining: number;
        daysRemaining: number;
      };
    } | null;
  } | null;
  nextTier: {
    __typename: 'NextTier';
    id: string | null;
    name: string;
    rank: number | null;
    meetsRequirementsForTier: boolean | null;
  } | null;
  currentTier: {
    __typename: 'CurrentTier';
    id: string | null;
    name: string;
    rank: number;
    motivationalMessage: string;
  } | null;
  allTiers: Array<{
    __typename: 'TierDefinition';
    name: string;
    rank: number;
    points: number;
  }> | null;
};

export type TierRewardsPageQueryVariables = Exact<{ [key: string]: never }>;

export type TierRewardsPageQuery = {
  __typename: 'Query';
  allTiers: Array<{
    __typename: 'TierDefinition';
    name: string;
    rank: number;
    points: number;
  }> | null;
};

export type PaginatedTieringActivitiesQueryVariables = Exact<{
  cursor?: string | null | undefined;
}>;

export type PaginatedTieringActivitiesQuery = {
  __typename: 'Query';
  allTierActivities: {
    __typename: 'PaginatedTierActivities';
    data: Array<{
      __typename: 'TierActivity';
      icon: string;
      description: string;
      pointsEarned: number | null;
      category: string | null;
      completedAt: string;
      additionalInformation: string | null;
    }> | null;
    paging: {
      __typename: 'Pagination';
      isLastPage: boolean;
      cursors: { __typename: 'PaginationCursors'; after: string | null };
    };
  } | null;
};

export type CustomTieringActivityListItemFragment = {
  __typename: 'CustomTierActivity';
  activityId: string;
  title: string;
  description: string | null;
  status: Types.CustomTierActivityStatus;
  tierPointAward: {
    __typename: 'TierPointAward';
    frequency: Types.TierPointFrequencyType;
    points: number;
  } | null;
  image: { __typename: 'Image'; url: string } | null;
};

export type TieringHubTierPointsFragment = {
  __typename: 'TierPoints';
  id: string | null;
  remainingToReachNextTier: number | null;
  earned: {
    __typename: 'TierPointsEarned';
    total: number;
    thisMonth: {
      __typename: 'TierPointsEarnedInTimePeriod';
      value: number | null;
      since: string | null;
    };
  };
  requiredToNotRegress: {
    __typename: 'TierPointsRequired';
    total: number;
    remaining: number;
    thisMonth: {
      __typename: 'TierPointsRequiredInTimePeriod';
      value: number;
      remaining: number;
      daysRemaining: number;
    };
  } | null;
};

export type TieringHubNextTierFragment = {
  __typename: 'NextTier';
  id: string | null;
  name: string;
  rank: number | null;
  meetsRequirementsForTier: boolean | null;
};

export type TieringHubCurrentTierFragment = {
  __typename: 'CurrentTier';
  id: string | null;
  name: string;
  rank: number;
  motivationalMessage: string;
};

export type TieringHubAllTiersFragment = {
  __typename: 'TierDefinition';
  name: string;
  rank: number;
  points: number;
};

export type TierRegressionInfoFragment = {
  __typename: 'TierRegressionInfo';
  image: {
    __typename: 'Image';
    url: string;
    font: {
      __typename: 'Font';
      color: { __typename: 'Color'; hexCode: string } | null;
    } | null;
  } | null;
  timePeriods: Array<{
    __typename: 'TierRegressionTimePeriodInfo';
    isCurrent: boolean | null;
    pointsEarned: number | null;
    pointGoal: number | null;
    timePeriod: { __typename: 'TimePeriod'; from: string; to: string } | null;
  }>;
};

export type TieringHubQueryVariables = Exact<{ [key: string]: never }>;

export type TieringHubQuery = {
  __typename: 'Query';
  tierPoints: {
    __typename: 'TierPoints';
    id: string | null;
    remainingToReachNextTier: number | null;
    earned: {
      __typename: 'TierPointsEarned';
      total: number;
      thisMonth: {
        __typename: 'TierPointsEarnedInTimePeriod';
        value: number | null;
        since: string | null;
      };
    };
    requiredToNotRegress: {
      __typename: 'TierPointsRequired';
      total: number;
      remaining: number;
      thisMonth: {
        __typename: 'TierPointsRequiredInTimePeriod';
        value: number;
        remaining: number;
        daysRemaining: number;
      };
    } | null;
  } | null;
  nextTier: {
    __typename: 'NextTier';
    id: string | null;
    name: string;
    rank: number | null;
    meetsRequirementsForTier: boolean | null;
  } | null;
  currentTier: {
    __typename: 'CurrentTier';
    id: string | null;
    name: string;
    rank: number;
    motivationalMessage: string;
  } | null;
  allTiers: Array<{
    __typename: 'TierDefinition';
    name: string;
    rank: number;
    points: number;
  }> | null;
  tierRegressionInfo: {
    __typename: 'TierRegressionInfo';
    image: {
      __typename: 'Image';
      url: string;
      font: {
        __typename: 'Font';
        color: { __typename: 'Color'; hexCode: string } | null;
      } | null;
    } | null;
    timePeriods: Array<{
      __typename: 'TierRegressionTimePeriodInfo';
      isCurrent: boolean | null;
      pointsEarned: number | null;
      pointGoal: number | null;
      timePeriod: { __typename: 'TimePeriod'; from: string; to: string } | null;
    }>;
  } | null;
};

export type GetGroupChallengeConfigQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetGroupChallengeConfigQuery = {
  __typename: 'Query';
  groupChallengeConfig: {
    __typename: 'GroupChallengeConfig';
    activityTypes: Array<{
      __typename: 'ChallengeActivityTypeOption';
      value: Types.ChallengeActivityType;
      label: string;
      status: Types.ChallengeActivityStatus;
      emoji: string;
    }>;
    limits: { __typename: 'GroupChallengeLimits'; titleMaxLength: number };
  };
};

export type CreateGroupChallengeMutationVariables = Exact<{
  input: Types.CreateGroupChallengeInput;
}>;

export type CreateGroupChallengeMutation = {
  __typename: 'Mutation';
  createGroupChallenge: {
    __typename: 'CreateGroupChallengeResponse';
    challenge: {
      __typename: 'GroupStepChallenge';
      challengeId: string;
      status: Types.GroupChallengeStatus;
      startDate: string;
      endDate: string;
      image: { __typename: 'Image'; url: string };
    } | null;
  };
};

export type UpdatePersonalisationPermissionMutationVariables = Exact<{
  allowPersonalisation: boolean;
}>;

export type UpdatePersonalisationPermissionMutation = {
  __typename: 'Mutation';
  updatePersonalisationPermission: {
    __typename: 'UpdatePersonalisationPermissionResponse';
    permission: {
      __typename: 'HowPersonalisationWorksPermission';
      allowPersonalisation: boolean | null;
      body: string;
      footer: string | null;
      subtitle: string;
      title: string;
    } | null;
  } | null;
};

export type JoinDigitalClinicalProgramMutationVariables = Exact<{
  joinProgramInput: Types.JoinDigitalClinicalProgramInput;
}>;

export type JoinDigitalClinicalProgramMutation = {
  __typename: 'Mutation';
  joinDigitalClinicalProgram: boolean | null;
};

export type RecommendedArticlesQueryVariables = Exact<{ [key: string]: never }>;

export type RecommendedArticlesQuery = {
  __typename: 'Query';
  recommendedArticles: {
    __typename: 'RecommendedArticlesResponse';
    recommendations: Array<{
      __typename: 'Article';
      body: string;
      categoryTitle: string | null;
      contentItemId: string;
      lastModificationDate: string | null;
      title: string;
      url: string | null;
      author: { __typename: 'ArticleAuthor'; name: string } | null;
      heroImage: { __typename: 'Image'; url: string } | null;
    }> | null;
  } | null;
  howDoesPersonalisationWork: {
    __typename: 'HowDoesPersonalisationWorkResponse';
    body: string;
    button: string;
    title: string;
    icon: { __typename: 'Image'; url: string } | null;
    permission: {
      __typename: 'HowPersonalisationWorksPermission';
      allowPersonalisation: boolean | null;
      body: string;
      footer: string | null;
      subtitle: string;
      title: string;
    } | null;
  } | null;
};

export type FetchFeaturedChallengesQueryVariables = Exact<{
  from?: string | null | undefined;
}>;

export type FetchFeaturedChallengesQuery = {
  __typename: 'Query';
  featuredChallenges: {
    __typename: 'fetchFeaturedChallengesResponse';
    challenges: Array<
      | {
          __typename: 'HabitChallenge';
          participationType: Types.ChallengeParticipationType;
          challengeId: string;
          category: Types.ChallengeCategory;
          title: string;
          status: Types.ChallengeStatus;
          goal: number;
          wasJoined: boolean;
          endDateTimeISO: string | null;
          startDateTimeISO: string | null;
          image: { __typename: 'Image'; url: string } | null;
          completionReward: { __typename: 'TierReward'; points: string } | null;
          activity: {
            __typename: 'HabitActivityResponse';
            activity: Array<{
              __typename: 'HabitDailyActivity';
              tracked: number;
            }> | null;
          };
        }
      | {
          __typename: 'StepChallenge';
          participationType: Types.ChallengeParticipationType;
          challengeId: string;
          category: Types.ChallengeCategory;
          title: string;
          status: Types.ChallengeStatus;
          goal: number;
          wasJoined: boolean;
          endDateTimeISO: string | null;
          startDateTimeISO: string | null;
          image: { __typename: 'Image'; url: string } | null;
          completionReward: { __typename: 'TierReward'; points: string } | null;
          stepActivity: {
            __typename: 'StepActivityResponse';
            activity: Array<{
              __typename: 'StepDailyActivity';
              tracked: number;
            }> | null;
          };
        }
    > | null;
  } | null;
};

export type WalkthroughFieldsFragment = {
  __typename: 'Walkthrough';
  wasCompleted: boolean;
  steps: Array<{
    __typename: 'WalkthroughStep';
    title: string;
    text: string;
    image: { __typename: 'Image'; url: string } | null;
  }>;
};

export type ProgramListFieldsFragment = {
  __typename: 'DigitalClinicalProgramListItem';
  description: string;
  wasJoined: boolean;
  programId: string;
  title: string;
  status: Types.DigitalClinicalProgramStatus;
  icon: { __typename: 'Image'; url: string } | null;
  progress: {
    __typename: 'DigitalClinicalProgramProgress';
    percentageComplete: number;
  };
  nextModule: {
    __typename: 'DigitalClinicalModuleListItem';
    moduleId: string;
    title: string;
  } | null;
};

export type SingleAssessmentsCardFieldsFragment = {
  __typename: 'SingleAssessmentCard';
  completedAt: string | null;
  status: Types.AssessmentStatus;
  title: string;
  tierPoints: number | null;
  icon: { __typename: 'Image'; url: string } | null;
  assessment: {
    __typename: 'AssessmentListItem';
    title: string;
    status: Types.AssessmentStatus;
    numberOfQuestions: number;
    percentageComplete: number;
    uuid: string;
    tierPoints: number | null;
    result: {
      __typename: 'AssessmentListItemResult';
      percentageScore: number;
    } | null;
    icon: { __typename: 'Image'; url: string } | null;
  };
};

export type ThiCardFieldsFragment = {
  __typename: 'TotalHealthIndexCard';
  title: string;
  subtitle: string;
  status: Types.AssessmentStatus;
  tierPoints: number | null;
  nextPillar: {
    __typename: 'AssessmentListItem';
    uuid: string;
    title: string;
  } | null;
  score: {
    __typename: 'TotalHealthIndexScore';
    percentage: number;
    bracket: {
      __typename: 'TotalHealthIndexBracket';
      bracketId: string;
      description: string | null;
      color: { __typename: 'Color'; hexCode: string };
    };
  };
};

export type HraCardFieldsFragment = {
  __typename: 'HealthRiskAssessmentCard';
  completedAt: string | null;
  status: Types.AssessmentStatus;
  title: string;
  tierPoints: number | null;
  numberOfAssessments: number;
  assessmentsRemaining: number;
  icon: { __typename: 'Image'; url: string } | null;
  nextAssessment: {
    __typename: 'AssessmentListItem';
    title: string;
    status: Types.AssessmentStatus;
    numberOfQuestions: number;
    percentageComplete: number;
    uuid: string;
    result: {
      __typename: 'AssessmentListItemResult';
      percentageScore: number;
    } | null;
  };
};

export type FetchAssessmentHeroCardsQueryVariables = Exact<{
  requestGlobalContent?: boolean | null | undefined;
}>;

export type FetchAssessmentHeroCardsQuery = {
  __typename: 'Query';
  assessmentHeroCards: Array<
    | {
        __typename: 'HealthRiskAssessmentCard';
        completedAt: string | null;
        status: Types.AssessmentStatus;
        title: string;
        tierPoints: number | null;
        numberOfAssessments: number;
        assessmentsRemaining: number;
        icon: { __typename: 'Image'; url: string } | null;
        nextAssessment: {
          __typename: 'AssessmentListItem';
          title: string;
          status: Types.AssessmentStatus;
          numberOfQuestions: number;
          percentageComplete: number;
          uuid: string;
          result: {
            __typename: 'AssessmentListItemResult';
            percentageScore: number;
          } | null;
        };
      }
    | {
        __typename: 'SingleAssessmentCard';
        completedAt: string | null;
        status: Types.AssessmentStatus;
        title: string;
        tierPoints: number | null;
        icon: { __typename: 'Image'; url: string } | null;
        assessment: {
          __typename: 'AssessmentListItem';
          title: string;
          status: Types.AssessmentStatus;
          numberOfQuestions: number;
          percentageComplete: number;
          uuid: string;
          tierPoints: number | null;
          result: {
            __typename: 'AssessmentListItemResult';
            percentageScore: number;
          } | null;
          icon: { __typename: 'Image'; url: string } | null;
        };
      }
    | {
        __typename: 'TotalHealthIndexCard';
        title: string;
        subtitle: string;
        status: Types.AssessmentStatus;
        tierPoints: number | null;
        nextPillar: {
          __typename: 'AssessmentListItem';
          uuid: string;
          title: string;
        } | null;
        score: {
          __typename: 'TotalHealthIndexScore';
          percentage: number;
          bracket: {
            __typename: 'TotalHealthIndexBracket';
            bracketId: string;
            description: string | null;
            color: { __typename: 'Color'; hexCode: string };
          };
        };
      }
  > | null;
};

export type HraPromotionFieldsFragment = {
  __typename: 'HraPromotion';
  title: string;
  image: { __typename: 'Image'; url: string } | null;
  icon: { __typename: 'Image'; url: string } | null;
  assessment: {
    __typename: 'FeaturedAssessment';
    completedAt: string | null;
    status: Types.AssessmentStatus;
    title: string;
    tierPoints: number | null;
    numberOfAssessments: number | null;
    assessmentsRemaining: number | null;
    icon: { __typename: 'Image'; url: string } | null;
    assessment: {
      __typename: 'AssessmentListItem';
      title: string;
      status: Types.AssessmentStatus;
      numberOfQuestions: number;
      percentageComplete: number;
      uuid: string;
      result: {
        __typename: 'AssessmentListItemResult';
        percentageScore: number;
      } | null;
    };
  } | null;
};

export type FetchWellbeingPromotionsQueryVariables = Exact<{
  from?: string | null | undefined;
}>;

export type FetchWellbeingPromotionsQuery = {
  __typename: 'Query';
  wellbeingPromotions: Array<
    | { __typename: 'AssessmentPromotion' }
    | {
        __typename: 'ChallengePromotion';
        challengeUnion:
          | {
              __typename: 'HabitChallenge';
              participationType: Types.ChallengeParticipationType;
              challengeId: string;
              category: Types.ChallengeCategory;
              title: string;
              status: Types.ChallengeStatus;
              goal: number;
              wasJoined: boolean;
              endDateTimeISO: string | null;
              startDateTimeISO: string | null;
              image: { __typename: 'Image'; url: string } | null;
              completionReward: {
                __typename: 'TierReward';
                points: string;
              } | null;
              activity: {
                __typename: 'HabitActivityResponse';
                activity: Array<{
                  __typename: 'HabitDailyActivity';
                  tracked: number;
                }> | null;
              };
            }
          | {
              __typename: 'StepChallenge';
              participationType: Types.ChallengeParticipationType;
              challengeId: string;
              category: Types.ChallengeCategory;
              title: string;
              status: Types.ChallengeStatus;
              goal: number;
              wasJoined: boolean;
              endDateTimeISO: string | null;
              startDateTimeISO: string | null;
              image: { __typename: 'Image'; url: string } | null;
              completionReward: {
                __typename: 'TierReward';
                points: string;
              } | null;
              stepActivity: {
                __typename: 'StepActivityResponse';
                activity: Array<{
                  __typename: 'StepDailyActivity';
                  tracked: number;
                }> | null;
              };
            }
          | null;
      }
    | { __typename: 'HraPromotion' }
    | { __typename: 'TotalHealthIndexPromotion' }
  > | null;
};

export type RecommendationFieldsFragment = {
  __typename: 'Article';
  body: string;
  categoryTitle: string | null;
  contentItemId: string;
  lastModificationDate: string | null;
  title: string;
  url: string | null;
  author: { __typename: 'ArticleAuthor'; name: string } | null;
  heroImage: { __typename: 'Image'; url: string } | null;
};

export type PersonalisationPermissionFragment = {
  __typename: 'HowPersonalisationWorksPermission';
  allowPersonalisation: boolean | null;
  body: string;
  footer: string | null;
  subtitle: string;
  title: string;
};

export type HowDoesPersonalisationWorkFragment = {
  __typename: 'HowDoesPersonalisationWorkResponse';
  body: string;
  button: string;
  title: string;
  icon: { __typename: 'Image'; url: string } | null;
  permission: {
    __typename: 'HowPersonalisationWorksPermission';
    allowPersonalisation: boolean | null;
    body: string;
    footer: string | null;
    subtitle: string;
    title: string;
  } | null;
};

export type WellbeingContentLanguageMessageFragment = {
  __typename: 'WellbeingContentLanguageMessageResponse';
  banner:
    | {
        __typename: 'WellbeingContentLanguageMessageChangeLanguage';
        section: Types.WellbeingContentLanguageMessageSection;
        bannerText: string;
        bannerTextPopUp: string;
      }
    | {
        __typename: 'WellbeingContentLanguageMessageNoChoice';
        section: Types.WellbeingContentLanguageMessageSection;
        bannerText: string;
        bannerTextPopUp: string;
      }
    | {
        __typename: 'WellbeingContentLanguageMessageNoContent';
        section: Types.WellbeingContentLanguageMessageSection;
        bannerText: string;
      }
    | null;
};

export type FetchWellbeingContentLanguageMessageQueryVariables = Exact<{
  [key: string]: never;
}>;

export type FetchWellbeingContentLanguageMessageQuery = {
  __typename: 'Query';
  assessmentContentLanguageMessage: {
    __typename: 'WellbeingContentLanguageMessageResponse';
    banner:
      | {
          __typename: 'WellbeingContentLanguageMessageChangeLanguage';
          section: Types.WellbeingContentLanguageMessageSection;
          bannerText: string;
          bannerTextPopUp: string;
        }
      | {
          __typename: 'WellbeingContentLanguageMessageNoChoice';
          section: Types.WellbeingContentLanguageMessageSection;
          bannerText: string;
          bannerTextPopUp: string;
        }
      | {
          __typename: 'WellbeingContentLanguageMessageNoContent';
          section: Types.WellbeingContentLanguageMessageSection;
          bannerText: string;
        }
      | null;
  } | null;
};

export type TieringQueryVariables = Exact<{ [key: string]: never }>;

export type TieringQuery = {
  __typename: 'Query';
  currentTier: { __typename: 'CurrentTier'; rank: number; name: string } | null;
  tierPoints: {
    __typename: 'TierPoints';
    earned: { __typename: 'TierPointsEarned'; total: number };
  } | null;
  allTiers: Array<{
    __typename: 'TierDefinition';
    name: string;
    points: number;
    rank: number;
  }> | null;
};

export type RecommendedResourcesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type RecommendedResourcesQuery = {
  __typename: 'Query';
  recommendedArticles: {
    __typename: 'RecommendedArticlesResponse';
    recommendations: Array<{
      __typename: 'Article';
      title: string;
      lastModificationDate: string | null;
      url: string | null;
      categoryTitle: string | null;
      author: {
        __typename: 'ArticleAuthor';
        name: string;
        surname: string;
      } | null;
      heroImage: { __typename: 'Image'; url: string } | null;
      audios: Array<{ __typename: 'ArticleAudio' }> | null;
      videos: Array<{ __typename: 'ArticleVideo' }> | null;
    }> | null;
  } | null;
  howDoesPersonalisationWork: {
    __typename: 'HowDoesPersonalisationWorkResponse';
    body: string;
    button: string;
    title: string;
    icon: { __typename: 'Image'; url: string } | null;
    permission: {
      __typename: 'HowPersonalisationWorksPermission';
      allowPersonalisation: boolean | null;
      body: string;
      footer: string | null;
      subtitle: string;
      title: string;
    } | null;
  } | null;
};

export type ChallengesOverviewQueryVariables = Exact<{
  from?: string | null | undefined;
}>;

export type ChallengesOverviewQuery = {
  __typename: 'Query';
  joinedChallenges: {
    __typename: 'fetchChallengesResponse';
    challenges: Array<
      | {
          __typename: 'HabitChallenge';
          title: string;
          subtitle: string | null;
          challengeId: string;
          status: Types.ChallengeStatus;
          goal: number;
          participationType: Types.ChallengeParticipationType;
          category: Types.ChallengeCategory;
          wasJoined: boolean;
          categoryDisplayText: string;
          endDateTimeISO: string | null;
          startDateTimeISO: string | null;
          image: { __typename: 'Image'; url: string } | null;
          introduction: Array<{
            __typename: 'ChallengeIntroduction';
            id: string;
            info: string;
            title: string;
          } | null> | null;
          completionReward: { __typename: 'TierReward'; points: string } | null;
          activity: {
            __typename: 'HabitActivityResponse';
            activity: Array<{
              __typename: 'HabitDailyActivity';
              tracked: number;
            }> | null;
          };
          leaderboardIndividuals: {
            __typename: 'LeaderboardIndividualResponse';
            leaderboard: Array<{
              __typename: 'IndividualsLeaderboardEntry';
              position: number | null;
            }> | null;
          };
        }
      | {
          __typename: 'StepChallenge';
          title: string;
          subtitle: string | null;
          challengeId: string;
          status: Types.ChallengeStatus;
          goal: number;
          participationType: Types.ChallengeParticipationType;
          lastUploaded: string | null;
          category: Types.ChallengeCategory;
          wasJoined: boolean;
          categoryDisplayText: string;
          endDateTimeISO: string | null;
          startDateTimeISO: string | null;
          image: { __typename: 'Image'; url: string } | null;
          introduction: Array<{
            __typename: 'ChallengeIntroduction';
            id: string;
            info: string;
            title: string;
          } | null> | null;
          completionReward: { __typename: 'TierReward'; points: string } | null;
          stepActivity: {
            __typename: 'StepActivityResponse';
            activity: Array<{
              __typename: 'StepDailyActivity';
              tracked: number;
            }> | null;
          };
          leaderboardIndividuals: {
            __typename: 'LeaderboardIndividualResponse';
            leaderboard: Array<{
              __typename: 'IndividualsLeaderboardEntry';
              position: number | null;
            }> | null;
          };
        }
    > | null;
  } | null;
  notJoinedChallenges: {
    __typename: 'fetchChallengesResponse';
    challenges: Array<
      | {
          __typename: 'HabitChallenge';
          title: string;
          subtitle: string | null;
          challengeId: string;
          status: Types.ChallengeStatus;
          goal: number;
          participationType: Types.ChallengeParticipationType;
          category: Types.ChallengeCategory;
          wasJoined: boolean;
          categoryDisplayText: string;
          endDateTimeISO: string | null;
          startDateTimeISO: string | null;
          image: { __typename: 'Image'; url: string } | null;
          introduction: Array<{
            __typename: 'ChallengeIntroduction';
            id: string;
            info: string;
            title: string;
          } | null> | null;
          completionReward: { __typename: 'TierReward'; points: string } | null;
          activity: {
            __typename: 'HabitActivityResponse';
            activity: Array<{
              __typename: 'HabitDailyActivity';
              tracked: number;
            }> | null;
          };
          leaderboardIndividuals: {
            __typename: 'LeaderboardIndividualResponse';
            leaderboard: Array<{
              __typename: 'IndividualsLeaderboardEntry';
              position: number | null;
            }> | null;
          };
        }
      | {
          __typename: 'StepChallenge';
          title: string;
          subtitle: string | null;
          challengeId: string;
          status: Types.ChallengeStatus;
          goal: number;
          participationType: Types.ChallengeParticipationType;
          lastUploaded: string | null;
          category: Types.ChallengeCategory;
          wasJoined: boolean;
          categoryDisplayText: string;
          endDateTimeISO: string | null;
          startDateTimeISO: string | null;
          image: { __typename: 'Image'; url: string } | null;
          introduction: Array<{
            __typename: 'ChallengeIntroduction';
            id: string;
            info: string;
            title: string;
          } | null> | null;
          completionReward: { __typename: 'TierReward'; points: string } | null;
          stepActivity: {
            __typename: 'StepActivityResponse';
            activity: Array<{
              __typename: 'StepDailyActivity';
              tracked: number;
            }> | null;
          };
          leaderboardIndividuals: {
            __typename: 'LeaderboardIndividualResponse';
            leaderboard: Array<{
              __typename: 'IndividualsLeaderboardEntry';
              position: number | null;
            }> | null;
          };
        }
    > | null;
  } | null;
  completedChallenges: {
    __typename: 'fetchChallengesResponse';
    challenges: Array<
      | {
          __typename: 'HabitChallenge';
          title: string;
          subtitle: string | null;
          challengeId: string;
          status: Types.ChallengeStatus;
          goal: number;
          participationType: Types.ChallengeParticipationType;
          category: Types.ChallengeCategory;
          wasJoined: boolean;
          categoryDisplayText: string;
          endDateTimeISO: string | null;
          startDateTimeISO: string | null;
          image: { __typename: 'Image'; url: string } | null;
          introduction: Array<{
            __typename: 'ChallengeIntroduction';
            id: string;
            info: string;
            title: string;
          } | null> | null;
          completionReward: { __typename: 'TierReward'; points: string } | null;
          activity: {
            __typename: 'HabitActivityResponse';
            activity: Array<{
              __typename: 'HabitDailyActivity';
              tracked: number;
            }> | null;
          };
          leaderboardIndividuals: {
            __typename: 'LeaderboardIndividualResponse';
            leaderboard: Array<{
              __typename: 'IndividualsLeaderboardEntry';
              position: number | null;
            }> | null;
          };
        }
      | {
          __typename: 'StepChallenge';
          title: string;
          subtitle: string | null;
          challengeId: string;
          status: Types.ChallengeStatus;
          goal: number;
          participationType: Types.ChallengeParticipationType;
          lastUploaded: string | null;
          category: Types.ChallengeCategory;
          wasJoined: boolean;
          categoryDisplayText: string;
          endDateTimeISO: string | null;
          startDateTimeISO: string | null;
          image: { __typename: 'Image'; url: string } | null;
          introduction: Array<{
            __typename: 'ChallengeIntroduction';
            id: string;
            info: string;
            title: string;
          } | null> | null;
          completionReward: { __typename: 'TierReward'; points: string } | null;
          stepActivity: {
            __typename: 'StepActivityResponse';
            activity: Array<{
              __typename: 'StepDailyActivity';
              tracked: number;
            }> | null;
          };
          leaderboardIndividuals: {
            __typename: 'LeaderboardIndividualResponse';
            leaderboard: Array<{
              __typename: 'IndividualsLeaderboardEntry';
              position: number | null;
            }> | null;
          };
        }
    > | null;
  } | null;
};

export type WellbeingPromotionsQueryVariables = Exact<{
  from?: string | null | undefined;
}>;

export type WellbeingPromotionsQuery = {
  __typename: 'Query';
  wellbeingPromotions: Array<
    | {
        __typename: 'AssessmentPromotion';
        title: string;
        assessment: {
          __typename: 'AssessmentListItem';
          uuid: string;
          status: Types.AssessmentStatus;
          title: string;
          numberOfQuestions: number;
          percentageComplete: number;
          tierPoints: number | null;
          icon: { __typename: 'Image'; url: string } | null;
        } | null;
      }
    | {
        __typename: 'ChallengePromotion';
        challengeUnion:
          | {
              __typename: 'HabitChallenge';
              participationType: Types.ChallengeParticipationType;
              challengeId: string;
              category: Types.ChallengeCategory;
              title: string;
              status: Types.ChallengeStatus;
              goal: number;
              wasJoined: boolean;
              endDateTimeISO: string | null;
              startDateTimeISO: string | null;
              image: { __typename: 'Image'; url: string } | null;
              completionReward: {
                __typename: 'TierReward';
                points: string;
              } | null;
              activity: {
                __typename: 'HabitActivityResponse';
                activity: Array<{
                  __typename: 'HabitDailyActivity';
                  tracked: number;
                }> | null;
              };
            }
          | {
              __typename: 'StepChallenge';
              participationType: Types.ChallengeParticipationType;
              challengeId: string;
              category: Types.ChallengeCategory;
              title: string;
              status: Types.ChallengeStatus;
              goal: number;
              wasJoined: boolean;
              endDateTimeISO: string | null;
              startDateTimeISO: string | null;
              image: { __typename: 'Image'; url: string } | null;
              completionReward: {
                __typename: 'TierReward';
                points: string;
              } | null;
              stepActivity: {
                __typename: 'StepActivityResponse';
                activity: Array<{
                  __typename: 'StepDailyActivity';
                  tracked: number;
                }> | null;
              };
            }
          | null;
      }
    | {
        __typename: 'HraPromotion';
        title: string;
        image: { __typename: 'Image'; url: string } | null;
        icon: { __typename: 'Image'; url: string } | null;
        assessment: {
          __typename: 'FeaturedAssessment';
          completedAt: string | null;
          status: Types.AssessmentStatus;
          title: string;
          tierPoints: number | null;
          numberOfAssessments: number | null;
          assessmentsRemaining: number | null;
          icon: { __typename: 'Image'; url: string } | null;
          assessment: {
            __typename: 'AssessmentListItem';
            title: string;
            status: Types.AssessmentStatus;
            numberOfQuestions: number;
            percentageComplete: number;
            uuid: string;
            result: {
              __typename: 'AssessmentListItemResult';
              percentageScore: number;
            } | null;
          };
        } | null;
      }
    | { __typename: 'TotalHealthIndexPromotion' }
  > | null;
};

export type CareNowProgramsQueryVariables = Exact<{ [key: string]: never }>;

export type CareNowProgramsQuery = {
  __typename: 'Query';
  notJoinedPrograms: Array<{
    __typename: 'DigitalClinicalProgramListItem';
    programId: string;
    title: string;
    description: string;
    status: Types.DigitalClinicalProgramStatus;
    wasJoined: boolean;
    icon: { __typename: 'Image'; url: string } | null;
    progress: {
      __typename: 'DigitalClinicalProgramProgress';
      totalModules: number;
      completedModules: number;
      percentageComplete: number;
    };
  }> | null;
  joinedPrograms: Array<{
    __typename: 'DigitalClinicalProgramListItem';
    programId: string;
    title: string;
    description: string;
    status: Types.DigitalClinicalProgramStatus;
    wasJoined: boolean;
    icon: { __typename: 'Image'; url: string } | null;
    progress: {
      __typename: 'DigitalClinicalProgramProgress';
      totalModules: number;
      completedModules: number;
      percentageComplete: number;
    };
  }> | null;
  completedPrograms: Array<{
    __typename: 'DigitalClinicalProgramListItem';
    programId: string;
    title: string;
    description: string;
    status: Types.DigitalClinicalProgramStatus;
    wasJoined: boolean;
    icon: { __typename: 'Image'; url: string } | null;
    progress: {
      __typename: 'DigitalClinicalProgramProgress';
      totalModules: number;
      completedModules: number;
      percentageComplete: number;
    };
  }> | null;
};

export type PromotedActivitiesQueryVariables = Exact<{ [key: string]: never }>;

export type PromotedActivitiesQuery = {
  __typename: 'Query';
  customTierActivities: Array<{
    __typename: 'CustomTierActivity';
    activityId: string;
    title: string;
    description: string | null;
    status: Types.CustomTierActivityStatus;
    tierPointAward: {
      __typename: 'TierPointAward';
      frequency: Types.TierPointFrequencyType;
      points: number;
    } | null;
    image: { __typename: 'Image'; url: string } | null;
  }> | null;
  tierRegressionInfo: {
    __typename: 'TierRegressionInfo';
    image: {
      __typename: 'Image';
      url: string;
      font: {
        __typename: 'Font';
        color: { __typename: 'Color'; hexCode: string } | null;
      } | null;
    } | null;
    timePeriods: Array<{
      __typename: 'TierRegressionTimePeriodInfo';
      isCurrent: boolean | null;
      pointsEarned: number | null;
      pointGoal: number | null;
      timePeriod: { __typename: 'TimePeriod'; from: string; to: string } | null;
    }>;
  } | null;
  currentTier: {
    __typename: 'CurrentTier';
    id: string | null;
    name: string;
    rank: number;
    motivationalMessage: string;
  } | null;
};

export type WpoCreateAppointmentMutationVariables = Exact<{
  input: Types.WpoCreateAppointmentInput;
}>;

export type WpoCreateAppointmentMutation = {
  __typename: 'Mutation';
  wpoCreateAppointment: {
    __typename: 'WpoCreateAppointmentResponse';
    success: boolean;
    userEmail: string;
    appointmentId: number;
    appointmentStartDateTime: string;
    appointmentEndDateTime: string;
    message: string;
    counsellorId: number;
    counsellorFirstName: string;
    counsellorLastName: string;
    userFirstName: string;
    userLastName: string;
    appointmentMode: Types.WpoAppointmentType;
  };
};

export type WpoCreateAppointmentFragment = {
  __typename: 'WpoCreateAppointmentResponse';
  success: boolean;
  userEmail: string;
  appointmentId: number;
  appointmentStartDateTime: string;
  appointmentEndDateTime: string;
  message: string;
  counsellorId: number;
  counsellorFirstName: string;
  counsellorLastName: string;
  userFirstName: string;
  userLastName: string;
  appointmentMode: Types.WpoAppointmentType;
};

export type GetWpoAppointmentHistoryQueryVariables = Exact<{
  input: Types.WpoGetAppointmentHistoryInput;
}>;

export type GetWpoAppointmentHistoryQuery = {
  __typename: 'Query';
  wpoGetAppointmentHistory: {
    __typename: 'WpoGetAppointmentHistoryResponse';
    appointments: Array<{
      __typename: 'WpoAppointment';
      appointmentId: string;
      dateFrom: string;
      dateTo: string;
      appointmentMode: Types.WpoAppointmentType;
      counsellorName: string;
      status: Types.WpoAppointmentStatus;
    }>;
  };
};

export type GetWpoAppointmentsAreasOfConcernQueryVariables = Exact<{
  input?: Types.WpoGetFiltersInput | null | undefined;
}>;

export type GetWpoAppointmentsAreasOfConcernQuery = {
  __typename: 'Query';
  wpoGetFilters: {
    __typename: 'WpoGetFiltersResponse';
    areaOfConcerns: Array<{
      __typename: 'WpoFilter';
      id: string;
      name: string;
    }> | null;
  };
};

export type WpoCancelAppointmentMutationVariables = Exact<{
  input: Types.WpoCancelAppointmentInput;
}>;

export type WpoCancelAppointmentMutation = {
  __typename: 'Mutation';
  wpoCancelAppointment: {
    __typename: 'WpoCancelAppointmentResponse';
    success: boolean;
  };
};

export type GetAvailableWpoCounsellorsQueryVariables = Exact<{
  input: Types.WpoGetAvailableCounsellorsInput;
}>;

export type GetAvailableWpoCounsellorsQuery = {
  __typename: 'Query';
  wpoGetAvailableCounsellors: {
    __typename: 'WpoGetAvailableCounsellorsResponse';
    counsellorList: Array<{
      __typename: 'WpoCounsellorResponse';
      counsellorId: string;
      firstName: string;
      lastName: string;
      bio: string;
      gender: string;
    }> | null;
  };
};

export type GetHowItWorksQueryVariables = Exact<{
  input?: Types.GetHowItWorksInput | null | undefined;
}>;

export type GetHowItWorksQuery = {
  __typename: 'Query';
  getHowItWorks: {
    __typename: 'GetHowItWorksResponse';
    headerImageUrl: string;
  };
};

export type GetHasUpcomingWpoAppointmentQueryVariables = Exact<{
  input?: Types.WpoUserHasUpcomingAppointmentInput | null | undefined;
}>;

export type GetHasUpcomingWpoAppointmentQuery = {
  __typename: 'Query';
  wpoUserHasUpcomingAppointment: {
    __typename: 'WpoUserHasUpcomingAppointment';
    appointment: boolean;
    wpoServiceConfig: {
      __typename: 'WpoServiceConfig';
      serviceId: string;
      appointmentTypeId: string;
    };
  };
};

export type GetWpoAppointmentsLanguagesQueryVariables = Exact<{
  input?: Types.WpoGetFiltersInput | null | undefined;
}>;

export type GetWpoAppointmentsLanguagesQuery = {
  __typename: 'Query';
  wpoGetFilters: {
    __typename: 'WpoGetFiltersResponse';
    counsellorLanguages: Array<{
      __typename: 'WpoFilter';
      id: string;
      name: string;
    }> | null;
  };
};

export type GetAvailableWpoTimeslotsQueryVariables = Exact<{
  input: Types.WpoGetAvailableTimeSlotsInput;
}>;

export type GetAvailableWpoTimeslotsQuery = {
  __typename: 'Query';
  wpoGetAvailableTimeSlots: {
    __typename: 'WpoAvailableDateTimeSlotsResponse';
    availableTimeSlots: Array<{
      __typename: 'WpoAvailableTimeSlot';
      startDateTime: string;
      endDateTime: string;
      timeslotId: string;
    }> | null;
  };
};

export type BannerFragment = {
  __typename: 'BannerResponse';
  banner: { __typename: 'Banner'; dismissed: boolean; id: Types.BannerId };
};

export type FetchBannerQueryVariables = Exact<{
  bannerId: Types.BannerId;
}>;

export type FetchBannerQuery = {
  __typename: 'Query';
  banner: {
    __typename: 'BannerResponse';
    banner: { __typename: 'Banner'; dismissed: boolean; id: Types.BannerId };
  } | null;
};

export type DismissBannerMutationVariables = Exact<{
  bannerId: Types.BannerId;
}>;

export type DismissBannerMutation = {
  __typename: 'Mutation';
  markAsDismissed: {
    __typename: 'BannerResponse';
    banner: { __typename: 'Banner'; dismissed: boolean; id: Types.BannerId };
  } | null;
};

export type TooltipFieldsFragment = {
  __typename: 'Tooltip';
  tooltipId: Types.TooltipId;
  title: string;
  icon: { __typename: 'Image'; url: string } | null;
};

export type TooltipQueryVariables = Exact<{
  findTooltip: Types.FindTooltipInput;
}>;

export type TooltipQuery = {
  __typename: 'Query';
  tooltip: {
    __typename: 'Tooltip';
    tooltipId: Types.TooltipId;
    title: string;
    icon: { __typename: 'Image'; url: string } | null;
  } | null;
};

export type DismissTooltipMutationVariables = Exact<{
  findTooltip: Types.FindTooltipInput;
}>;

export type DismissTooltipMutation = {
  __typename: 'Mutation';
  dismissTooltip: { __typename: 'Tooltip'; tooltipId: Types.TooltipId } | null;
};

export type FeedbackRequestQueryVariables = Exact<{
  input: Types.FeedbackRequestInput;
}>;

export type FeedbackRequestQuery = {
  __typename: 'Query';
  feedbackRequest: {
    __typename: 'FeedbackRequestResponse';
    feedbackRequest: {
      __typename: 'FeedbackRequest';
      negativeFreeTextInputPrompt: string;
      positiveFreeTextInputPrompt: string;
      question: string;
      textInputMaxLength: number;
    } | null;
  } | null;
};

export type SubmitFeedbackMutationVariables = Exact<{
  submitFeedbackInput: Types.SubmitFeedbackInput;
}>;

export type SubmitFeedbackMutation = {
  __typename: 'Mutation';
  submitFeedback: {
    __typename: 'SubmitFeedbackResponse';
    id: Types.FeedbackId;
  } | null;
};

export type WellBeingButtonQueryVariables = Exact<{
  walkthroughType?: Types.WalkthroughType | null | undefined;
}>;

export type WellBeingButtonQuery = {
  __typename: 'Query';
  walkthrough: {
    __typename: 'Walkthrough';
    wasCompleted: boolean;
    steps: Array<{
      __typename: 'WalkthroughStep';
      title: string;
      text: string;
      image: { __typename: 'Image'; url: string } | null;
    }>;
  };
};

export type ConnectChatInitializationQueryVariables = Exact<{
  input: Types.ConnectChatInitializationInput;
}>;

export type ConnectChatInitializationQuery = {
  __typename: 'Query';
  connectChatInitialization: {
    __typename: 'ConnectChatInitializationResponse';
    chatDetails: {
      __typename: 'ConnectChatDetails';
      awsRegion: string;
      contactId: string;
      participantId: string;
      participantToken: string;
      langCode: string;
    } | null;
  } | null;
};

export type ConversationItemFragment = {
  __typename: 'ConversationItem';
  sessionId: string;
  title: string;
  updatedAt: string;
  createdAt: string;
};

export type AiNavigatorPagingFragment = {
  __typename: 'Pagination';
  isLastPage: boolean;
  cursors: { __typename: 'PaginationCursors'; after: string | null };
};

export type MemberAssistGreetingQueryVariables = Exact<{
  locale?: string | null | undefined;
}>;

export type MemberAssistGreetingQuery = {
  __typename: 'Query';
  memberAssistGreeting: {
    __typename: 'GreetingResponse';
    greeting: string;
    introduction: string;
    capabilityStatement: string;
  };
};

export type GetSuggestedPromptsQueryVariables = Exact<{
  input?: Types.SuggestedPromptsInput | null | undefined;
}>;

export type GetSuggestedPromptsQuery = {
  __typename: 'Query';
  getSuggestedPrompts: {
    __typename: 'SuggestedPromptsResponse';
    suggestedPrompts: Array<{
      __typename: 'SuggestedPrompt';
      label: string;
      prompt: string;
    }>;
  };
};

export type GetFeedbackReasonsQueryVariables = Exact<{
  input?: Types.FeedbackReasonsInput | null | undefined;
}>;

export type GetFeedbackReasonsQuery = {
  __typename: 'Query';
  getFeedbackReasons: {
    __typename: 'FeedbackReasonsResponse';
    reasons: Array<{ __typename: 'FeedbackReason'; id: string; label: string }>;
  };
};

export type GetConversationsListQueryVariables = Exact<{
  input?: Types.ConversationsInput | null | undefined;
}>;

export type GetConversationsListQuery = {
  __typename: 'Query';
  conversations: {
    __typename: 'ConversationsResponse';
    data: Array<{
      __typename: 'ConversationItem';
      sessionId: string;
      title: string;
      updatedAt: string;
      createdAt: string;
    }> | null;
    paging: {
      __typename: 'Pagination';
      isLastPage: boolean;
      cursors: { __typename: 'PaginationCursors'; after: string | null };
    };
  };
};

export type GetConversationMessagesQueryVariables = Exact<{
  sessionId: string | number;
  input?: Types.ConversationMessagesInput | null | undefined;
}>;

export type GetConversationMessagesQuery = {
  __typename: 'Query';
  conversationMessages: {
    __typename: 'ConversationMessagesResponse';
    data: Array<{
      __typename: 'ConversationMessage';
      traceId: string | null;
      role: Types.ConversationMessageRole;
      content: string;
      feedback: number | null;
      citations: Array<{
        __typename: 'Citation';
        id: string;
        content: string;
        url: string | null;
        title: string | null;
      }> | null;
      media: Array<
        | {
            __typename: 'ChatMedia';
            type: string;
            url: string;
            hlsUrl: string | null;
            title: string | null;
          }
        | {
            __typename: 'ChatMediaCard';
            type: string;
            url: string;
            title: string | null;
            category: string;
            id: string | null;
            author: string | null;
            thumbnail: string | null;
          }
      > | null;
    }> | null;
    paging: {
      __typename: 'Pagination';
      isLastPage: boolean;
      cursors: { __typename: 'PaginationCursors'; after: string | null };
    };
  };
};

export type SearchConversationsQueryVariables = Exact<{
  input: Types.SearchConversationsInput;
}>;

export type SearchConversationsQuery = {
  __typename: 'Query';
  searchConversations: {
    __typename: 'ConversationsResponse';
    data: Array<{
      __typename: 'ConversationItem';
      sessionId: string;
      title: string;
      updatedAt: string;
      createdAt: string;
    }> | null;
    paging: {
      __typename: 'Pagination';
      isLastPage: boolean;
      cursors: { __typename: 'PaginationCursors'; after: string | null };
    };
  };
};

export type SubmitChatFeedbackMutationVariables = Exact<{
  input: Types.ChatFeedbackInput;
}>;

export type SubmitChatFeedbackMutation = {
  __typename: 'Mutation';
  submitChatFeedback: { __typename: 'ChatFeedbackResponse'; message: string };
};

export type DeleteConversationMutationVariables = Exact<{
  sessionId: string | number;
}>;

export type DeleteConversationMutation = {
  __typename: 'Mutation';
  deleteConversation: {
    __typename: 'DeleteConversationResult';
    deletedSessionId: string;
  };
};

export type DeleteAllConversationsMutationVariables = Exact<{
  [key: string]: never;
}>;

export type DeleteAllConversationsMutation = {
  __typename: 'Mutation';
  deleteAllConversations: {
    __typename: 'DeleteAllConversationsResult';
    deletedSessionIds: Array<string>;
  };
};

export type UpdateConversationMutationVariables = Exact<{
  input: Types.UpdateConversationInput;
}>;

export type UpdateConversationMutation = {
  __typename: 'Mutation';
  updateConversation: {
    __typename: 'UpdateConversationResponse';
    message: string;
    title: string;
    archived: boolean;
  };
};

export type DeleteAllMemoriesMutationVariables = Exact<{
  [key: string]: never;
}>;

export type DeleteAllMemoriesMutation = {
  __typename: 'Mutation';
  deleteAllMemories: {
    __typename: 'DeleteAllMemoriesResult';
    deletedCount: number;
  };
};

export type GetUpcomingWpoAppointmentQueryVariables = Exact<{
  input?: Types.WpoGetUpcomingAppointmentInput | null | undefined;
}>;

export type GetUpcomingWpoAppointmentQuery = {
  __typename: 'Query';
  wpoGetUpcomingAppointment: {
    __typename: 'WpoGetUpcomingAppointmentResponse';
    appointment: {
      __typename: 'WpoAppointment';
      appointmentId: string;
      dateFrom: string;
      dateTo: string;
      displayDateFrom: string;
      displayDateTo: string;
      timeZoneCode: string;
      appointmentMode: Types.WpoAppointmentType;
      counsellorName: string;
      status: Types.WpoAppointmentStatus;
      isCancelAllowed: boolean;
      serviceTypeId: number;
      serviceName: string;
    };
  } | null;
};

export type ThiResultModalFieldsFragment = {
  __typename: 'TotalHealthIndexResult';
  title: string;
  subtitle: string;
  summary: string;
  score: {
    __typename: 'TotalHealthIndexScore';
    percentage: number;
    bracket: {
      __typename: 'TotalHealthIndexBracket';
      color: { __typename: 'Color'; hexCode: string };
    };
  };
  articles: Array<{
    __typename: 'Article';
    title: string;
    body: string;
  }> | null;
};

export type ThiResultQueryVariables = Exact<{ [key: string]: never }>;

export type ThiResultQuery = {
  __typename: 'Query';
  totalHealthIndexResult: {
    __typename: 'TotalHealthIndexResult';
    title: string;
    subtitle: string;
    summary: string;
    score: {
      __typename: 'TotalHealthIndexScore';
      percentage: number;
      bracket: {
        __typename: 'TotalHealthIndexBracket';
        color: { __typename: 'Color'; hexCode: string };
      };
    };
    articles: Array<{
      __typename: 'Article';
      title: string;
      body: string;
    }> | null;
  };
};

export const BookedCounsellorFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BookedCounsellor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Counsellor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentTypes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatarImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobTitles' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const BookedAppointmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BookedAppointment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Appointment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'counsellor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'BookedCounsellor' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'typeDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allowsCancellation' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BookedCounsellor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Counsellor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentTypes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatarImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobTitles' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AppointmentDetailsCounsellorFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentDetailsCounsellor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Counsellor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentTypes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatarImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobTitles' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CancelledAppointmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CancelledAppointment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Appointment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'counsellor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentTypes' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jobTitles' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatarImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'typeDescription' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CounsellorEducationsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CounsellorEducations' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CounsellorEducation' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'institution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CounsellorLanguagesFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CounsellorLanguages' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Language' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CounsellorInfoFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CounsellorInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CounsellorInfo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'disability' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenses' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ethnicBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'religion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sexualOrientation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'specializations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CounsellorProfileFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CounsellorProfile' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Counsellor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatarImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobTitles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentTypes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableInNearFuture' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'spokenLanguages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CounsellorLanguages' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'info' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CounsellorInfo' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'allowsBooking' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CounsellorLanguages' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Language' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CounsellorInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CounsellorInfo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'disability' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenses' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ethnicBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'religion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sexualOrientation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'specializations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CounsellorSelectionLanguagesFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CounsellorSelectionLanguages' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Language' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CounsellorSelectionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CounsellorSelection' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Counsellor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatarImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobTitles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentTypes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableInNearFuture' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'spokenLanguages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CounsellorSelectionLanguages' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'info' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CounsellorSelectionLanguages' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Language' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const FirstOfferedCounsellorFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FirstOfferedCounsellor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Counsellor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'allowsBooking' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const FirstOfferedTimeslotFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FirstOfferedTimeslot' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AvailableTimeSlot' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'types' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'counsellor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'FirstOfferedCounsellor' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FirstOfferedCounsellor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Counsellor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'allowsBooking' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CounsellorSelectionPaginationFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CounsellorSelectionPagination' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Pagination' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isLastPage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cursors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AvailableFilterOptionsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AvailableFilterOptions' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CounsellorFilterOption' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const TimeslotCounsellorFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TimeslotCounsellor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Counsellor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatarImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobTitles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const TimeSlotFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TimeSlot' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AvailableTimeSlot' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'types' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AppointmentsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Appointments' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Appointment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'counsellor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatarImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jobTitles' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allowsBooking' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'typeDescription' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AppointmentsPaginationFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentsPagination' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Pagination' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isLastPage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cursors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const YourCounsellorFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YourCounsellor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Counsellor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentTypes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatarImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobTitles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allowsBooking' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayHistory' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const WellbeingHubAssessmentListItemFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WellbeingHubAssessmentListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfQuestions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'percentageComplete' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tierPoints' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const WellbeingHubAssessmentPromotionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WellbeingHubAssessmentPromotion' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentPromotion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'WellbeingHubAssessmentListItem',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WellbeingHubAssessmentListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfQuestions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'percentageComplete' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tierPoints' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const HraPromotionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HRAPromotionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HraPromotion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'icon' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tierPoints' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'numberOfAssessments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assessmentsRemaining' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assessment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfQuestions' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'percentageComplete' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'result' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'percentageScore' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const WellbeingHubHraPromotionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WellbeingHubHraPromotion' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HraPromotion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'HRAPromotionFields' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HRAPromotionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HraPromotion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'icon' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tierPoints' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'numberOfAssessments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assessmentsRemaining' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assessment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfQuestions' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'percentageComplete' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'result' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'percentageScore' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const PreAssessmentResultHistoryFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PreAssessmentResultHistory' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PreAssessmentResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayMaxScore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxScore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'severities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CareAssessmentChoiceQuestionOptionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CareAssessmentChoiceQuestionOption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CareAssessmentChoiceQuestionOption' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextQuestionId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CareAssessmentsChoiceQuestionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CareAssessmentsChoiceQuestion' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CareAssessmentChoiceQuestion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CareAssessmentChoiceQuestionOption',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CareAssessmentChoiceQuestionOption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CareAssessmentChoiceQuestionOption' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextQuestionId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CareAssessmentsTextQuestionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CareAssessmentsTextQuestion' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CareAssessmentTextQuestion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxLength' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextQuestionId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CareAssessmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CareAssessment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CareAssessment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'questions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CareAssessmentsChoiceQuestion',
                  },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CareAssessmentsTextQuestion' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CareAssessmentChoiceQuestionOption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CareAssessmentChoiceQuestionOption' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextQuestionId' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CareAssessmentsChoiceQuestion' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CareAssessmentChoiceQuestion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CareAssessmentChoiceQuestionOption',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CareAssessmentsTextQuestion' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CareAssessmentTextQuestion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxLength' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextQuestionId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const PreAssessmentResultFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PreAssessmentResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PreAssessmentResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'severities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxScore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayMaxScore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retakeData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'earlyRetakeWarningMessage' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const PreAssessmentNotTakenFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PreAssessmentNotTaken' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PreAssessmentNotTaken' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const PreAssessmentResultsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PreAssessmentResults' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PreAssessmentResults' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shouldSpeakToCounsellor' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PreAssessmentResult' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PreAssessmentNotTaken' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PreAssessmentResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PreAssessmentResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'severities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxScore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayMaxScore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retakeData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'earlyRetakeWarningMessage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PreAssessmentNotTaken' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PreAssessmentNotTaken' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const RecommendationFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Recommendation' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'PreAssessmentRecommendationSuicideRiskCallNow',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ccsTeamTelephoneNumber' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CareIssueFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CareIssue' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CareIssue' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'analyticsId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'default' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ModuleWithoutActivitiesFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModuleWithoutActivities' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CarePlanModule' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ActivityFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Activity' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CarePlanActivityArticle' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'module' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ModuleWithoutActivities' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CarePlanActivityArticle' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModuleWithoutActivities' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CarePlanModule' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CarePlanActivityWithHippoFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CarePlanActivityWithHippo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CarePlanActivityArticle' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audios' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'copyright' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heroImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hlsUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'format' } },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'path' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CarePlanActivityFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CarePlanActivity' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CarePlanActivityArticle' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Activity' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'CarePlanActivityWithHippo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextActivity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Activity' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previousActivity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Activity' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CarePlanActivityWithHippo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CarePlanActivityArticle' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audios' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'copyright' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heroImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hlsUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'format' } },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'path' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModuleWithoutActivities' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CarePlanModule' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Activity' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CarePlanActivityArticle' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'module' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ModuleWithoutActivities' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CarePlanActivityArticle' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CarePlanModulesFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CarePlanModules' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CarePlanModule' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'ModuleWithoutActivities' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activities' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Activity' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModuleWithoutActivities' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CarePlanModule' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Activity' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CarePlanActivityArticle' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'module' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ModuleWithoutActivities' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CarePlanActivityArticle' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CarePlanSectionsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CarePlanSections' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CarePlanSection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'modules' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CarePlanModules' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModuleWithoutActivities' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CarePlanModule' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Activity' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CarePlanActivityArticle' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'module' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ModuleWithoutActivities' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CarePlanActivityArticle' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CarePlanModules' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CarePlanModule' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'ModuleWithoutActivities' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activities' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Activity' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CarePlanFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CarePlan' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CarePlan' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CarePlanSections' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentActivity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Activity' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModuleWithoutActivities' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CarePlanModule' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Activity' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CarePlanActivityArticle' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'module' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ModuleWithoutActivities' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CarePlanActivityArticle' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CarePlanModules' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CarePlanModule' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'ModuleWithoutActivities' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activities' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Activity' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CarePlanSections' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CarePlanSection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'modules' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CarePlanModules' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const HabitBasicInfoFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitBasicInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Habit' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'habitId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'selected' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const HabitSelectionStateFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitSelectionState' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Habit' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'habitId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'selected' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const HabitFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Habit' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Habit' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'habitId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tradeCaptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'thumbnailImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'font' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'color' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hexCode' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tracked' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'HabitBasicInfo' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'HabitSelectionState' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitSelectionState' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Habit' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'habitId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'selected' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitBasicInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Habit' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'habitId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'selected' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const OptionActivityFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OptionActivity' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitOptionActivity' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'option' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'optionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tracked' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const HabitActivityFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitActivity' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitActivity' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'habit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Habit' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'optionActivity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OptionActivity' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitSelectionState' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Habit' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'habitId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'selected' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitBasicInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Habit' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'habitId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'selected' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Habit' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Habit' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'habitId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tradeCaptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'thumbnailImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'font' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'color' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hexCode' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tracked' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'HabitBasicInfo' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'HabitSelectionState' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OptionActivity' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitOptionActivity' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'option' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'optionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tracked' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const HabitDailyActivityInputFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitDailyActivityInput' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitDailyActivity' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tracked' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'HabitActivity' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitSelectionState' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Habit' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'habitId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'selected' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitBasicInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Habit' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'habitId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'selected' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Habit' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Habit' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'habitId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tradeCaptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'thumbnailImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'font' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'color' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hexCode' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tracked' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'HabitBasicInfo' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'HabitSelectionState' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OptionActivity' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitOptionActivity' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'option' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'optionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tracked' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitActivity' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitActivity' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'habit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Habit' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'optionActivity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OptionActivity' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const StepActivityFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StepActivity' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepActivity' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emoji' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'durationInMs' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const StepDailyActivityInputFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StepDailyActivityInput' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepDailyActivity' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tracked' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'StepActivity' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StepActivity' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepActivity' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emoji' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'durationInMs' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ActivitySummaryDataFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActivitySummaryData' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EndOfChallengeSummaryTotal' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }],
      },
    },
  ],
} as unknown as DocumentNode;
export const ChallengeResultFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengeResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ChallengeResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pointsAwarded' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newTier' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tieringStatus' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const FeaturedStepChallengeFieldFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FeaturedStepChallengeField' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'participationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stepActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const FeaturedHabitChallengeFieldFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FeaturedHabitChallengeField' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'participationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'from' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'from' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const FeaturedChallengeFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FeaturedChallengeFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'fetchFeaturedChallengesResponse' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'challenges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'FeaturedStepChallengeField' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'FeaturedHabitChallengeField' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FeaturedStepChallengeField' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'participationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stepActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FeaturedHabitChallengeField' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'participationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'from' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'from' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const StepChallengeListItemFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StepChallengeListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categoryDisplayText' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'participationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stepActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaderboardIndividuals' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leaderboard' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'position' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ChallengeIntroductionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengeIntroduction' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ChallengeIntroduction' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'info' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const StepChallengeDateInfoFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StepChallengeDateInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUploaded' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const StepChallengeBasicInfoFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StepChallengeBasicInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'StepChallengeListItem' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'introduction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ChallengeIntroduction' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'StepChallengeDateInfo' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengeIntroduction' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ChallengeIntroduction' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'info' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StepChallengeDateInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUploaded' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StepChallengeListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categoryDisplayText' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'participationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stepActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaderboardIndividuals' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leaderboard' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'position' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ChallengePromotionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengePromotion' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ChallengePromotion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'challengeUnion' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'FeaturedHabitChallengeField' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'FeaturedStepChallengeField' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FeaturedStepChallengeField' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'participationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stepActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FeaturedHabitChallengeField' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'participationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'from' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'from' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const FetchChallengesHabitChallengeFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FetchChallengesHabitChallenge' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'FeaturedHabitChallengeField' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categoryDisplayText' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FeaturedHabitChallengeField' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'participationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'from' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'from' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const FetchChallengesStepChallengeFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FetchChallengesStepChallenge' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'FeaturedStepChallengeField' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categoryDisplayText' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FeaturedStepChallengeField' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'participationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stepActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const FetchChallengesFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FetchChallenges' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'fetchChallengesResponse' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'challenges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HabitChallenge' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'FetchChallengesHabitChallenge',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'StepChallenge' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'FetchChallengesStepChallenge',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FeaturedStepChallengeField' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'participationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stepActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FeaturedHabitChallengeField' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'participationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'from' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'from' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FetchChallengesHabitChallenge' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'FeaturedHabitChallengeField' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categoryDisplayText' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FetchChallengesStepChallenge' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'FeaturedStepChallengeField' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categoryDisplayText' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ChallengeStatusFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengeStatus' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Challenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'HabitChallenge' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'StepChallenge' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const HabitChallengeListItemFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitChallengeListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categoryDisplayText' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'participationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'from' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'from' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaderboardIndividuals' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leaderboard' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'position' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const HabitChallengeDateInfoFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitChallengeDateInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const HabitChallengeBasicInfoFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitChallengeBasicInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateId' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'HabitChallengeListItem' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'introduction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ChallengeIntroduction' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'challengeHabits' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editSelectedHabits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subtitle' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selectHabit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'habits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'HabitBasicInfo' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'HabitChallengeDateInfo' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengeIntroduction' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ChallengeIntroduction' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'info' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitBasicInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Habit' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'habitId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'selected' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitChallengeDateInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitChallengeListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categoryDisplayText' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'participationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'from' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'from' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaderboardIndividuals' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leaderboard' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'position' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const StepDailyActivityFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StepDailyActivity' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepDailyActivity' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tracked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const HabitDailyActivityFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitDailyActivity' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitDailyActivity' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tracked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tradeLimit' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'habit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'habitId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'thumbnailImage' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'font' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'color' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'hexCode',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optionActivity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'option' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'optionId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'title' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ChallengeJoinedFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengeJoined' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ChallengeJoinedStepFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengeJoinedStep' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ChallengePageFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengePage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Challenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'HabitChallenge' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participationType' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'introduction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ChallengeIntroduction' },
                      },
                    ],
                  },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'HabitChallengeDateInfo' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'StepChallenge' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participationType' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastUploaded' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'introduction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ChallengeIntroduction' },
                      },
                    ],
                  },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'StepChallengeDateInfo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengeIntroduction' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ChallengeIntroduction' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'info' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StepChallengeDateInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUploaded' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitChallengeDateInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const HubListFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HubList' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'fetchChallengesResponse' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'challenges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ChallengePage' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'StepChallengeListItem' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'HabitChallengeListItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengeIntroduction' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ChallengeIntroduction' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'info' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StepChallengeDateInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUploaded' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StepChallengeListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categoryDisplayText' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'participationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stepActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaderboardIndividuals' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leaderboard' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'position' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitChallengeDateInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengePage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Challenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'HabitChallenge' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participationType' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'introduction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ChallengeIntroduction' },
                      },
                    ],
                  },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'HabitChallengeDateInfo' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'StepChallenge' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participationType' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastUploaded' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'introduction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ChallengeIntroduction' },
                      },
                    ],
                  },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'StepChallengeDateInfo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitChallengeListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categoryDisplayText' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'participationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'from' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'from' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaderboardIndividuals' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leaderboard' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'position' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const LeaderboardUserFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LeaderboardUser' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const LeaderboardIndividualFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LeaderboardIndividual' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'IndividualsLeaderboardEntry' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LeaderboardUser' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LeaderboardUser' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const TeamUserPermissionsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamUserPermissions' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamPermissions' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canCreateATeam' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canChangeTeamName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canChangeTeamImage' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canRemoveTeamImage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isTeamAdmin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'membershipPrompt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ChallengeTeamFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengeTeam' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Team' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TeamUserPermissions' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamUserPermissions' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamPermissions' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canCreateATeam' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canChangeTeamName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canChangeTeamImage' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canRemoveTeamImage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isTeamAdmin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'membershipPrompt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const TeamsLeaderboardListItemFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamsLeaderboardListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamsLeaderboardEntry' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'team' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ChallengeTeam' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamUserPermissions' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamPermissions' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canCreateATeam' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canChangeTeamName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canChangeTeamImage' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canRemoveTeamImage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isTeamAdmin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'membershipPrompt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengeTeam' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Team' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TeamUserPermissions' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const TeamMemberFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamMember' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const PaginationFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Pagination' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Pagination' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isLastPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cursors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const TeamLeaderboardFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamLeaderboard' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LeaderboardTeamMembersResponse' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaderboard' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamMember' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pagination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Pagination' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Pagination' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Pagination' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isLastPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cursors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamMember' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ChallengeHubListFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengeHubList' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'fetchChallengesResponse' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'challenges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'StepChallenge' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'challengeId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'participationType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'wasJoined' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startDateTimeISO' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endDateTimeISO' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HabitChallenge' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'challengeId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'participationType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'wasJoined' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startDateTimeISO' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endDateTimeISO' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const SubmitGlobalIntakeRequestFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SubmitGlobalIntakeRequest' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GlobalIntakeAppointmentRequestResponse' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preferredDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preferredMeridiem' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const DigitalClinicalProgramListItemFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DigitalClinicalProgramListItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalProgramListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'programId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'programType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'progress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalModules' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedModules' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'percentageComplete' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'remainingModules' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isLite' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const JournalingEntryFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JournalingEntry' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JournalEntry' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const MoodFactorFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MoodFactor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MoodFactor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCustom' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const MoodTrackingEntryFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MoodTrackingEntry' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MoodEntry' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'factors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MoodFactor' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MoodFactor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MoodFactor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCustom' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const MyCareAppointmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyCareAppointment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Appointment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'typeDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVisibleToUser' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CareIssueSelectedFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CareIssueSelected' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CareIssue' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'selected' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const WorkLifeServicesFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkLifeServices' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'WorkLifeService' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const WorkLifeServicesPaginationFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkLifeServicesPagination' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Pagination' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isLastPage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cursors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const PensionBenefitsTitleAndNotificationCountFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PensionBenefitsTitleAndNotificationCount' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PensionAndBenefitsSummary' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notifications' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pension' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'benefits' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const PensionBenefitsNotificationsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PensionBenefitsNotifications' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PensionAndBenefitsSummary' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notifications' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expiryDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'portalUrlId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const PensionBenefitsPensionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PensionBenefitsPension' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PensionAndBenefitsSummary' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pension' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totals' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'portalUrlId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const PensionBenefitsBenefitFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PensionBenefitsBenefit' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PensionAndBenefitsSummary' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'benefits' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totals' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'plans' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'choices' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'portalUrlId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const DigitalClinicalProgramCategoriesFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DigitalClinicalProgramCategories' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalProgramCategory' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'iconBackground' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ModuleStatusFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModuleStatusFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalModule' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'moduleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'progress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalContentItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedContentItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'remainingContentItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'percentageComplete' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const DigitalClinicalModuleDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DigitalClinicalModuleDetailsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalModule' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'ModuleStatusFields' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moduleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introduction' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heroImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'timeEstimate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'minutes' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModuleStatusFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalModule' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'moduleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'progress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalContentItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedContentItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'remainingContentItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'percentageComplete' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const DigitalClinicalModuleArticleFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DigitalClinicalModuleArticleFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Article' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentItemId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'author' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heroImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audios' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hlsUrl' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userInteraction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'seenByUser' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const DigitalClinicalModuleChoiceQuestionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'DigitalClinicalModuleChoiceQuestionFields',
      },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ChoiceQuestion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentItemId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optionId' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'responseType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userInteraction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'seenByUser' } },
                { kind: 'Field', name: { kind: 'Name', value: 'choices' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const DigitalClinicalModuleFreeTextQuestionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'DigitalClinicalModuleFreeTextQuestionFields',
      },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FreeTextQuestion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentItemId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hint' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userInteraction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'seenByUser' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const DigitalClinicalModuleScaleQuestionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DigitalClinicalModuleScaleQuestionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ScaleQuestion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentItemId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scale' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scalePointId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userInteraction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'seenByUser' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scalePointId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const DigitalClinicalModuleStarRatingQuestionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'DigitalClinicalModuleStarRatingQuestionFields',
      },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StarRatingQuestion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentItemId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'starRatings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'starRatingId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userInteraction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'seenByUser' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'starRatingId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const DigitalClinicalModuleSectionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DigitalClinicalModuleSectionsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalModule' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'DigitalClinicalModuleArticleFields',
                        },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'DigitalClinicalModuleChoiceQuestionFields',
                        },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'DigitalClinicalModuleFreeTextQuestionFields',
                        },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'DigitalClinicalModuleScaleQuestionFields',
                        },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value:
                            'DigitalClinicalModuleStarRatingQuestionFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DigitalClinicalModuleArticleFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Article' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentItemId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'author' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heroImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audios' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hlsUrl' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userInteraction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'seenByUser' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'DigitalClinicalModuleChoiceQuestionFields',
      },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ChoiceQuestion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentItemId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optionId' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'responseType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userInteraction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'seenByUser' } },
                { kind: 'Field', name: { kind: 'Name', value: 'choices' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'DigitalClinicalModuleFreeTextQuestionFields',
      },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FreeTextQuestion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentItemId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hint' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userInteraction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'seenByUser' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DigitalClinicalModuleScaleQuestionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ScaleQuestion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentItemId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scale' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scalePointId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userInteraction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'seenByUser' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scalePointId' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'DigitalClinicalModuleStarRatingQuestionFields',
      },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StarRatingQuestion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentItemId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'starRatings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'starRatingId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userInteraction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'seenByUser' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'starRatingId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ModuleOverviewFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModuleOverviewFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalModule' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'moduleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introduction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'progress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalContentItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedContentItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'remainingContentItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'percentageComplete' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'timeEstimate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'minutes' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heroImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'font' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'color' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hexCode' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ProgramStatusFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProgramStatusFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalProgram' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'programId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'progress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalModules' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedModules' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'percentageComplete' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ModuleListItemStatusFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModuleListItemStatusFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalModuleListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'moduleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'progress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalContentItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedContentItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'remainingContentItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'percentageComplete' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const SingleProgramFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SingleProgramFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalProgram' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'ProgramStatusFields' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'programId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'modules' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ModuleListItemStatusFields' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'heroImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'backgroundImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'font' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'color' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hexCode' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'moduleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'introduction' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'timeEstimate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutes' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProgramStatusFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalProgram' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'programId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'progress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalModules' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedModules' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'percentageComplete' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModuleListItemStatusFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalModuleListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'moduleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'progress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalContentItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedContentItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'remainingContentItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'percentageComplete' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ProgramInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProgramInfoFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalProgram' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const WellbeingHubProgramFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WellbeingHubProgramFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalProgramListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'programId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'progress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalModules' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedModules' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'percentageComplete' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AssessmentHistoryResultFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentHistoryResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemHistoryResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'digestTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'digest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percentageScore' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AssessmentHistoryFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentHistory' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemHistory' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'archiveId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assessmentUuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introduction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfQuestions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cooldownPeriodExpirationDate' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'result' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentHistoryResult' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentHistoryResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemHistoryResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'digestTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'digest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percentageScore' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AssessmentStatusFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentStatusFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'percentageComplete' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextQuestionReference' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeRetaken' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cooldownPeriodExpirationDate' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AssessmentAnswerMeasurementFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentAnswerMeasurement' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemAnswersMeasurements' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'measurementUuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'measurementType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calculationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AssessmentAnswerFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentAnswer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemAnswers' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'optionUuids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionUuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentAnswerMeasurement' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentAnswerMeasurement' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemAnswersMeasurements' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'measurementUuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'measurementType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calculationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AnswerMutationResponseFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnswerMutationResponse' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'AssessmentStatusFields' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentAnswer' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentAnswerMeasurement' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemAnswersMeasurements' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'measurementUuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'measurementType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calculationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentAnswer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemAnswers' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'optionUuids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionUuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentAnswerMeasurement' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentStatusFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'percentageComplete' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextQuestionReference' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeRetaken' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cooldownPeriodExpirationDate' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AssessmentTypeFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentType' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentType' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AssessmentQuestionOptionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionOption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemQuestionnaireOptionsList' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jumpTo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AssessmentQuestionMeasurementRangesFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurementRanges' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MeasurementRanges' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'jumpTo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'range' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AssessmentQuestionMeasurementRangeFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurementRange' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'AssessmentItemQuestionnaireMeasurementRanges',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ranges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentQuestionMeasurementRanges',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurementRanges' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MeasurementRanges' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'jumpTo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'range' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AssessmentQuestionMeasurementFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurement' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'AssessmentItemQuestionnaireMeasurements',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unitOfMeasurement' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calculationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurementRanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentQuestionMeasurementRange',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurementRanges' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MeasurementRanges' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'jumpTo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'range' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurementRange' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'AssessmentItemQuestionnaireMeasurementRanges',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ranges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentQuestionMeasurementRanges',
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AssessmentQuestionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestion' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemQuestionnaire' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reference' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'multipleChoice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introduction' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentQuestionOption' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentQuestionMeasurement',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionOption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemQuestionnaireOptionsList' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jumpTo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurementRanges' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MeasurementRanges' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'jumpTo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'range' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurementRange' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'AssessmentItemQuestionnaireMeasurementRanges',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ranges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentQuestionMeasurementRanges',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurement' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'AssessmentItemQuestionnaireMeasurements',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unitOfMeasurement' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calculationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurementRanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentQuestionMeasurementRange',
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AssessmentImageFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Image' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
      },
    },
  ],
} as unknown as DocumentNode;
export const AssessmentRemainingFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentRemaining' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RemainingAssessmentsCompletionPoints' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bonusPoints' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resetDate' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AssessmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Assessment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'localisedUuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introduction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfQuestions' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'AssessmentStatusFields' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'type' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'questionnaire' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentQuestion' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentAnswer' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'remainingAssessmentsCompletionPoints',
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentRemaining' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentType' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentType' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionOption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemQuestionnaireOptionsList' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jumpTo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurementRanges' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MeasurementRanges' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'jumpTo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'range' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurementRange' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'AssessmentItemQuestionnaireMeasurementRanges',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ranges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentQuestionMeasurementRanges',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurement' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'AssessmentItemQuestionnaireMeasurements',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unitOfMeasurement' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calculationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurementRanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentQuestionMeasurementRange',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestion' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemQuestionnaire' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reference' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'multipleChoice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introduction' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentQuestionOption' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentQuestionMeasurement',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Image' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentAnswerMeasurement' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemAnswersMeasurements' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'measurementUuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'measurementType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calculationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentAnswer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemAnswers' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'optionUuids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionUuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentAnswerMeasurement' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentRemaining' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RemainingAssessmentsCompletionPoints' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bonusPoints' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resetDate' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentStatusFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'percentageComplete' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextQuestionReference' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeRetaken' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cooldownPeriodExpirationDate' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AssessmentResultFeedbackFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultFeedback' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResultFeedback' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AssessmentResultContentAuthorFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentAuthor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemContentAuthor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AssessmentResultContentCategoryFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentCategory' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentContentCategory' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
      },
    },
  ],
} as unknown as DocumentNode;
export const AssessmentResultContentTypeFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentType' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentContentType' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'typeGroup' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AssessmentResultImageFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemContentImages' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'articlethumbnail' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AssessmentResultContentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItemResultContentList' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sanitizedBody' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastModificationDate' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourcePath' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'author' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentResultContentAuthor',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'category' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentResultContentCategory',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'type' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultContentType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'images' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'thumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Image' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentCategory' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentContentCategory' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentType' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentContentType' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'typeGroup' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemContentImages' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'articlethumbnail' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentAuthor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemContentAuthor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const MeasurementResultFeedbackFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MeasurementResultFeedback' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MeasurementResultFeedback' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const MeasurementResultFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MeasurementResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentContentMeasurementResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'feedback' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MeasurementResultFeedback' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MeasurementResultFeedback' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MeasurementResultFeedback' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AssessmentResultFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItemResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'digestTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'digest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minScore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxScore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percentageScore' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shouldDisplayPercentage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'minScaleLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxScaleLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'feedback' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultFeedback' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurementResult' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MeasurementResult' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Image' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultFeedback' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResultFeedback' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentCategory' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentContentCategory' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentType' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentContentType' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'typeGroup' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemContentImages' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'articlethumbnail' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentAuthor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemContentAuthor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItemResultContentList' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sanitizedBody' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastModificationDate' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourcePath' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'author' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentResultContentAuthor',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'category' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentResultContentCategory',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'type' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultContentType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'images' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'thumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MeasurementResultFeedback' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MeasurementResultFeedback' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MeasurementResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentContentMeasurementResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'feedback' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MeasurementResultFeedback' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const NextAssessmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NextAssessment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const TieringHubNextTierFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubNextTier' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NextTier' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'meetsRequirementsForTier' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const TieringHubCurrentTierFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubCurrentTier' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CurrentTier' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'motivationalMessage' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const TieringHubTierPointsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubTierPoints' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TierPoints' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'earned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thisMonth' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'since' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'remainingToReachNextTier' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requiredToNotRegress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remaining' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thisMonth' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'remaining' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'daysRemaining' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AssessmentTierStateFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentTierState' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemCurrentTierProgress' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pointsForCompletingAssessment' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'bonusPointsForCompletingAllAssessments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tierSummary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextTier' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TieringHubNextTier' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentTier' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TieringHubCurrentTier' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'points' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TieringHubTierPoints' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubTierPoints' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TierPoints' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'earned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thisMonth' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'since' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'remainingToReachNextTier' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requiredToNotRegress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remaining' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thisMonth' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'remaining' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'daysRemaining' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubNextTier' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NextTier' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'meetsRequirementsForTier' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubCurrentTier' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CurrentTier' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'motivationalMessage' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const FinalAnswerMutationResponseFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FinalAnswerMutationResponse' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'AssessmentStatusFields' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tierPoints' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentAnswer' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'result' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResult' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextAssessment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NextAssessment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tierProgress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentTierState' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Image' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentAnswerMeasurement' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemAnswersMeasurements' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'measurementUuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'measurementType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calculationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentAnswer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemAnswers' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'optionUuids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionUuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentAnswerMeasurement' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentStatusFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'percentageComplete' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextQuestionReference' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeRetaken' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cooldownPeriodExpirationDate' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultFeedback' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResultFeedback' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentCategory' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentContentCategory' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentType' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentContentType' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'typeGroup' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemContentImages' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'articlethumbnail' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentAuthor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemContentAuthor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItemResultContentList' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sanitizedBody' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastModificationDate' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourcePath' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'author' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentResultContentAuthor',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'category' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentResultContentCategory',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'type' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultContentType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'images' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'thumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MeasurementResultFeedback' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MeasurementResultFeedback' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MeasurementResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentContentMeasurementResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'feedback' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MeasurementResultFeedback' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItemResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'digestTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'digest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minScore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxScore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percentageScore' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shouldDisplayPercentage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'minScaleLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxScaleLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'feedback' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultFeedback' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurementResult' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MeasurementResult' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NextAssessment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentTierState' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemCurrentTierProgress' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pointsForCompletingAssessment' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'bonusPointsForCompletingAllAssessments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tierSummary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextTier' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TieringHubNextTier' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentTier' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TieringHubCurrentTier' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'points' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TieringHubTierPoints' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubTierPoints' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TierPoints' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'earned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thisMonth' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'since' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'remainingToReachNextTier' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requiredToNotRegress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remaining' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thisMonth' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'remaining' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'daysRemaining' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubNextTier' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NextTier' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'meetsRequirementsForTier' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubCurrentTier' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CurrentTier' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'motivationalMessage' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CompletedAssessmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CompletedAssessment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Assessment' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'FinalAnswerMutationResponse' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentType' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentType' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionOption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemQuestionnaireOptionsList' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jumpTo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurementRanges' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MeasurementRanges' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'jumpTo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'range' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurementRange' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'AssessmentItemQuestionnaireMeasurementRanges',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ranges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentQuestionMeasurementRanges',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurement' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'AssessmentItemQuestionnaireMeasurements',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unitOfMeasurement' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calculationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurementRanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentQuestionMeasurementRange',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestion' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemQuestionnaire' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reference' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'multipleChoice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introduction' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentQuestionOption' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentQuestionMeasurement',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Image' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentAnswerMeasurement' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemAnswersMeasurements' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'measurementUuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'measurementType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calculationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentAnswer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemAnswers' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'optionUuids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionUuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentAnswerMeasurement' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentRemaining' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RemainingAssessmentsCompletionPoints' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bonusPoints' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resetDate' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentStatusFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'percentageComplete' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextQuestionReference' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeRetaken' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cooldownPeriodExpirationDate' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Assessment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'localisedUuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introduction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfQuestions' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'AssessmentStatusFields' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'type' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'questionnaire' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentQuestion' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentAnswer' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'remainingAssessmentsCompletionPoints',
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentRemaining' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultFeedback' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResultFeedback' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentCategory' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentContentCategory' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentType' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentContentType' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'typeGroup' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemContentImages' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'articlethumbnail' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentAuthor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemContentAuthor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItemResultContentList' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sanitizedBody' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastModificationDate' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourcePath' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'author' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentResultContentAuthor',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'category' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentResultContentCategory',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'type' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultContentType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'images' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'thumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MeasurementResultFeedback' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MeasurementResultFeedback' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MeasurementResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentContentMeasurementResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'feedback' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MeasurementResultFeedback' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItemResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'digestTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'digest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minScore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxScore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percentageScore' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shouldDisplayPercentage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'minScaleLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxScaleLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'feedback' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultFeedback' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurementResult' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MeasurementResult' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NextAssessment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentTierState' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemCurrentTierProgress' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pointsForCompletingAssessment' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'bonusPointsForCompletingAllAssessments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tierSummary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextTier' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TieringHubNextTier' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentTier' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TieringHubCurrentTier' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'points' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TieringHubTierPoints' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FinalAnswerMutationResponse' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'AssessmentStatusFields' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tierPoints' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentAnswer' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'result' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResult' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextAssessment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NextAssessment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tierProgress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentTierState' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubTierPoints' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TierPoints' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'earned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thisMonth' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'since' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'remainingToReachNextTier' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requiredToNotRegress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remaining' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thisMonth' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'remaining' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'daysRemaining' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubNextTier' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NextTier' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'meetsRequirementsForTier' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubCurrentTier' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CurrentTier' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'motivationalMessage' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const HistoricalAssessmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HistoricalAssessment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HistoricalAssessment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'assessmentUuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archiveId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'result' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResult' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Image' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultFeedback' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResultFeedback' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentCategory' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentContentCategory' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentType' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentContentType' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'typeGroup' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemContentImages' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'articlethumbnail' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentAuthor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemContentAuthor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItemResultContentList' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sanitizedBody' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastModificationDate' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourcePath' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'author' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentResultContentAuthor',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'category' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentResultContentCategory',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'type' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultContentType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'images' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'thumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MeasurementResultFeedback' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MeasurementResultFeedback' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MeasurementResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentContentMeasurementResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'feedback' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MeasurementResultFeedback' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItemResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'digestTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'digest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minScore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxScore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percentageScore' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shouldDisplayPercentage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'minScaleLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxScaleLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'feedback' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultFeedback' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurementResult' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MeasurementResult' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AssessmentResultCommonFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultCommonFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canBeRetaken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Image' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
      },
    },
  ],
} as unknown as DocumentNode;
export const RegressionInformationFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegressionInformation' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TierRegressionInfo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'font' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'color' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hexCode' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'timePeriods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isCurrent' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'timePeriod' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pointsEarned' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'pointGoal' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentTierDefinition' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const SingleAssessmentHeroCardFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SingleAssessmentHeroCard' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SingleAssessmentCard' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tierPoints' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'numberOfQuestions' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'percentageComplete' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'percentageScore' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'type' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'filter' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const HealthRiskAssessmentHeroCardFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HealthRiskAssessmentHeroCard' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HealthRiskAssessmentCard' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tierPoints' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numberOfAssessments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessmentsRemaining' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextAssessment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'numberOfQuestions' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'percentageComplete' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'percentageScore' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'type' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'filter' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AssessmentTypeFiltersFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentTypeFilters' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentTypeFilter' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'typeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AssessmentListItemFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Assessment' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tierPoints' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentType' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentType' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionOption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemQuestionnaireOptionsList' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jumpTo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurementRanges' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MeasurementRanges' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'jumpTo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'range' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurementRange' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'AssessmentItemQuestionnaireMeasurementRanges',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ranges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentQuestionMeasurementRanges',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurement' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'AssessmentItemQuestionnaireMeasurements',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unitOfMeasurement' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calculationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurementRanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentQuestionMeasurementRange',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestion' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemQuestionnaire' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reference' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'multipleChoice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introduction' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentQuestionOption' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentQuestionMeasurement',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Image' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentAnswerMeasurement' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemAnswersMeasurements' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'measurementUuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'measurementType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calculationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentAnswer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemAnswers' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'optionUuids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionUuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentAnswerMeasurement' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentRemaining' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RemainingAssessmentsCompletionPoints' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bonusPoints' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resetDate' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentStatusFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'percentageComplete' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextQuestionReference' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeRetaken' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cooldownPeriodExpirationDate' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Assessment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'localisedUuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introduction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfQuestions' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'AssessmentStatusFields' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'type' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'questionnaire' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentQuestion' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentAnswer' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'remainingAssessmentsCompletionPoints',
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentRemaining' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AssessmentsHubAssessmentResultFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentsHubAssessmentResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItemResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'digestTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'digest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minScaleLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxScaleLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percentageScore' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shouldDisplayPercentage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AssessmentHubListItemFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentHubListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'AssessmentListItem' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'result' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentsHubAssessmentResult',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentType' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentType' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionOption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemQuestionnaireOptionsList' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jumpTo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurementRanges' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MeasurementRanges' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'jumpTo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'range' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurementRange' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'AssessmentItemQuestionnaireMeasurementRanges',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ranges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentQuestionMeasurementRanges',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurement' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'AssessmentItemQuestionnaireMeasurements',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unitOfMeasurement' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calculationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurementRanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentQuestionMeasurementRange',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestion' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemQuestionnaire' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reference' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'multipleChoice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introduction' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentQuestionOption' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentQuestionMeasurement',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Image' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentAnswerMeasurement' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemAnswersMeasurements' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'measurementUuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'measurementType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calculationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentAnswer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemAnswers' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'optionUuids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionUuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentAnswerMeasurement' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentRemaining' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RemainingAssessmentsCompletionPoints' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bonusPoints' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resetDate' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentStatusFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'percentageComplete' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextQuestionReference' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeRetaken' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cooldownPeriodExpirationDate' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Assessment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'localisedUuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introduction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfQuestions' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'AssessmentStatusFields' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'type' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'questionnaire' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentQuestion' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentAnswer' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'remainingAssessmentsCompletionPoints',
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentRemaining' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentsHubAssessmentResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItemResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'digestTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'digest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minScaleLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxScaleLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percentageScore' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shouldDisplayPercentage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Assessment' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tierPoints' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CustomTieringActivityListItemFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomTieringActivityListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CustomTierActivity' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'activityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tierPointAward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const TieringHubAllTiersFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubAllTiers' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TierDefinition' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          { kind: 'Field', name: { kind: 'Name', value: 'points' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const TierRegressionInfoFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TierRegressionInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TierRegressionInfo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'font' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'color' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hexCode' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'timePeriods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isCurrent' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'timePeriod' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pointsEarned' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'pointGoal' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const WalkthroughFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WalkthroughFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Walkthrough' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'wasCompleted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'steps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ProgramListFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProgramListFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalProgramListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          { kind: 'Field', name: { kind: 'Name', value: 'programId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'progress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'percentageComplete' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextModule' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'moduleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const SingleAssessmentsCardFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SingleAssessmentsCardFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SingleAssessmentCard' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tierPoints' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'numberOfQuestions' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'percentageComplete' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'percentageScore' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'icon' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'tierPoints' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ThiCardFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'THICardFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TotalHealthIndexCard' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextPillar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'score' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bracket' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bracketId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'color' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hexCode' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tierPoints' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const HraCardFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HRACardFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HealthRiskAssessmentCard' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tierPoints' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numberOfAssessments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessmentsRemaining' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextAssessment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'numberOfQuestions' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'percentageComplete' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'percentageScore' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const RecommendationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RecommendationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Article' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'author' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'categoryTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentItemId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heroImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastModificationDate' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const PersonalisationPermissionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PersonalisationPermission' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HowPersonalisationWorksPermission' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allowPersonalisation' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'footer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const HowDoesPersonalisationWorkFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HowDoesPersonalisationWork' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HowDoesPersonalisationWorkResponse' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'button' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permission' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PersonalisationPermission' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PersonalisationPermission' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HowPersonalisationWorksPermission' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allowPersonalisation' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'footer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const WellbeingContentLanguageMessageFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WellbeingContentLanguageMessage' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'WellbeingContentLanguageMessageResponse',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'banner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'WellbeingContentLanguageMessageNoContent',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'section' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bannerText' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'WellbeingContentLanguageMessageNoChoice',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'section' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bannerText' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bannerTextPopUp' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'WellbeingContentLanguageMessageChangeLanguage',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'section' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bannerText' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bannerTextPopUp' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const WpoCreateAppointmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WpoCreateAppointment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'WpoCreateAppointmentResponse' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'success' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentStartDateTime' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentEndDateTime' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'counsellorId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'counsellorFirstName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'counsellorLastName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'userFirstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userLastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentMode' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const BannerFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Banner' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BannerResponse' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'banner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'dismissed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const TooltipFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TooltipFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Tooltip' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'tooltipId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ConversationItemFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AiNavigatorPagingFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AiNavigatorPaging' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Pagination' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isLastPage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cursors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ThiResultModalFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'THIResultModalFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TotalHealthIndexResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'score' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bracket' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'color' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hexCode' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'articles' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'body' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ChangeCounsellorDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ChangeCounsellorData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FetchAppointmentsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchAppointments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'data' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'allowsCancellation',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCounsellor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'counsellor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appointmentTypes' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessedAsSuicideRisk' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ccsTeamTelephoneNumber' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useChangeCounsellorDataQuery__
 *
 * To run a query within a React component, call `useChangeCounsellorDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeCounsellorDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeCounsellorDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeCounsellorDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    ChangeCounsellorDataQuery,
    ChangeCounsellorDataQueryVariables
  > &
    (
      | { variables: ChangeCounsellorDataQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ChangeCounsellorDataQuery,
    ChangeCounsellorDataQueryVariables
  >(ChangeCounsellorDataDocument, options);
}
export function useChangeCounsellorDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChangeCounsellorDataQuery,
    ChangeCounsellorDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ChangeCounsellorDataQuery,
    ChangeCounsellorDataQueryVariables
  >(ChangeCounsellorDataDocument, options);
}
// @ts-ignore
export function useChangeCounsellorDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ChangeCounsellorDataQuery,
    ChangeCounsellorDataQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ChangeCounsellorDataQuery,
  ChangeCounsellorDataQueryVariables
>;
export function useChangeCounsellorDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChangeCounsellorDataQuery,
        ChangeCounsellorDataQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ChangeCounsellorDataQuery | undefined,
  ChangeCounsellorDataQueryVariables
>;
export function useChangeCounsellorDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChangeCounsellorDataQuery,
        ChangeCounsellorDataQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ChangeCounsellorDataQuery,
    ChangeCounsellorDataQueryVariables
  >(ChangeCounsellorDataDocument, options);
}
export type ChangeCounsellorDataQueryHookResult = ReturnType<
  typeof useChangeCounsellorDataQuery
>;
export type ChangeCounsellorDataLazyQueryHookResult = ReturnType<
  typeof useChangeCounsellorDataLazyQuery
>;
export type ChangeCounsellorDataSuspenseQueryHookResult = ReturnType<
  typeof useChangeCounsellorDataSuspenseQuery
>;
export type ChangeCounsellorDataQueryResult = Apollo.QueryResult<
  ChangeCounsellorDataQuery,
  ChangeCounsellorDataQueryVariables
>;
export const BookAppointmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BookAppointment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BookAppointmentInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookAppointment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BookedAppointment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BookedCounsellor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Counsellor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentTypes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatarImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobTitles' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BookedAppointment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Appointment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'counsellor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'BookedCounsellor' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'typeDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allowsCancellation' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type BookAppointmentMutationFn = Apollo.MutationFunction<
  BookAppointmentMutation,
  BookAppointmentMutationVariables
>;

/**
 * __useBookAppointmentMutation__
 *
 * To run a mutation, you first call `useBookAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookAppointmentMutation, { data, loading, error }] = useBookAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBookAppointmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BookAppointmentMutation,
    BookAppointmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BookAppointmentMutation,
    BookAppointmentMutationVariables
  >(BookAppointmentDocument, options);
}
export type BookAppointmentMutationHookResult = ReturnType<
  typeof useBookAppointmentMutation
>;
export type BookAppointmentMutationResult =
  Apollo.MutationResult<BookAppointmentMutation>;
export type BookAppointmentMutationOptions = Apollo.BaseMutationOptions<
  BookAppointmentMutation,
  BookAppointmentMutationVariables
>;
export const FetchAppointmentByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FetchAppointmentById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'appointmentId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchAppointmentById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'appointmentId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'appointmentId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'counsellor' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'AppointmentDetailsCounsellor',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startDateTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endDateTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'typeDescription' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allowsCancellation' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isVisibleToUser' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentDetailsCounsellor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Counsellor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentTypes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatarImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobTitles' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFetchAppointmentByIdQuery__
 *
 * To run a query within a React component, call `useFetchAppointmentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAppointmentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAppointmentByIdQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useFetchAppointmentByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchAppointmentByIdQuery,
    FetchAppointmentByIdQueryVariables
  > &
    (
      | { variables: FetchAppointmentByIdQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchAppointmentByIdQuery,
    FetchAppointmentByIdQueryVariables
  >(FetchAppointmentByIdDocument, options);
}
export function useFetchAppointmentByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchAppointmentByIdQuery,
    FetchAppointmentByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchAppointmentByIdQuery,
    FetchAppointmentByIdQueryVariables
  >(FetchAppointmentByIdDocument, options);
}
// @ts-ignore
export function useFetchAppointmentByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchAppointmentByIdQuery,
    FetchAppointmentByIdQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchAppointmentByIdQuery,
  FetchAppointmentByIdQueryVariables
>;
export function useFetchAppointmentByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchAppointmentByIdQuery,
        FetchAppointmentByIdQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchAppointmentByIdQuery | undefined,
  FetchAppointmentByIdQueryVariables
>;
export function useFetchAppointmentByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchAppointmentByIdQuery,
        FetchAppointmentByIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchAppointmentByIdQuery,
    FetchAppointmentByIdQueryVariables
  >(FetchAppointmentByIdDocument, options);
}
export type FetchAppointmentByIdQueryHookResult = ReturnType<
  typeof useFetchAppointmentByIdQuery
>;
export type FetchAppointmentByIdLazyQueryHookResult = ReturnType<
  typeof useFetchAppointmentByIdLazyQuery
>;
export type FetchAppointmentByIdSuspenseQueryHookResult = ReturnType<
  typeof useFetchAppointmentByIdSuspenseQuery
>;
export type FetchAppointmentByIdQueryResult = Apollo.QueryResult<
  FetchAppointmentByIdQuery,
  FetchAppointmentByIdQueryVariables
>;
export const CancelAppointmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CancelAppointment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancelAppointment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'appointmentId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'CancelledAppointment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CancelledAppointment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Appointment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'counsellor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentTypes' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jobTitles' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatarImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'typeDescription' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CancelAppointmentMutationFn = Apollo.MutationFunction<
  CancelAppointmentMutation,
  CancelAppointmentMutationVariables
>;

/**
 * __useCancelAppointmentMutation__
 *
 * To run a mutation, you first call `useCancelAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAppointmentMutation, { data, loading, error }] = useCancelAppointmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelAppointmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelAppointmentMutation,
    CancelAppointmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CancelAppointmentMutation,
    CancelAppointmentMutationVariables
  >(CancelAppointmentDocument, options);
}
export type CancelAppointmentMutationHookResult = ReturnType<
  typeof useCancelAppointmentMutation
>;
export type CancelAppointmentMutationResult =
  Apollo.MutationResult<CancelAppointmentMutation>;
export type CancelAppointmentMutationOptions = Apollo.BaseMutationOptions<
  CancelAppointmentMutation,
  CancelAppointmentMutationVariables
>;
export const FetchCounsellorByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FetchCounsellorById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'counsellorId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCounsellorById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'counsellorId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'counsellorId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'counsellor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'CounsellorProfile' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CounsellorLanguages' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Language' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CounsellorInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CounsellorInfo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'disability' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenses' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ethnicBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'religion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sexualOrientation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'specializations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CounsellorProfile' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Counsellor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatarImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobTitles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentTypes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableInNearFuture' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'spokenLanguages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CounsellorLanguages' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'info' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CounsellorInfo' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'allowsBooking' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFetchCounsellorByIdQuery__
 *
 * To run a query within a React component, call `useFetchCounsellorByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCounsellorByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCounsellorByIdQuery({
 *   variables: {
 *      counsellorId: // value for 'counsellorId'
 *   },
 * });
 */
export function useFetchCounsellorByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchCounsellorByIdQuery,
    FetchCounsellorByIdQueryVariables
  > &
    (
      | { variables: FetchCounsellorByIdQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchCounsellorByIdQuery,
    FetchCounsellorByIdQueryVariables
  >(FetchCounsellorByIdDocument, options);
}
export function useFetchCounsellorByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCounsellorByIdQuery,
    FetchCounsellorByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchCounsellorByIdQuery,
    FetchCounsellorByIdQueryVariables
  >(FetchCounsellorByIdDocument, options);
}
// @ts-ignore
export function useFetchCounsellorByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchCounsellorByIdQuery,
    FetchCounsellorByIdQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchCounsellorByIdQuery,
  FetchCounsellorByIdQueryVariables
>;
export function useFetchCounsellorByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchCounsellorByIdQuery,
        FetchCounsellorByIdQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchCounsellorByIdQuery | undefined,
  FetchCounsellorByIdQueryVariables
>;
export function useFetchCounsellorByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchCounsellorByIdQuery,
        FetchCounsellorByIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchCounsellorByIdQuery,
    FetchCounsellorByIdQueryVariables
  >(FetchCounsellorByIdDocument, options);
}
export type FetchCounsellorByIdQueryHookResult = ReturnType<
  typeof useFetchCounsellorByIdQuery
>;
export type FetchCounsellorByIdLazyQueryHookResult = ReturnType<
  typeof useFetchCounsellorByIdLazyQuery
>;
export type FetchCounsellorByIdSuspenseQueryHookResult = ReturnType<
  typeof useFetchCounsellorByIdSuspenseQuery
>;
export type FetchCounsellorByIdQueryResult = Apollo.QueryResult<
  FetchCounsellorByIdQuery,
  FetchCounsellorByIdQueryVariables
>;
export const FetchCounsellorForChatDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FetchCounsellorForChat' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'counsellorId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCounsellorById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'counsellorId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'counsellorId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'counsellor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFetchCounsellorForChatQuery__
 *
 * To run a query within a React component, call `useFetchCounsellorForChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCounsellorForChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCounsellorForChatQuery({
 *   variables: {
 *      counsellorId: // value for 'counsellorId'
 *   },
 * });
 */
export function useFetchCounsellorForChatQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchCounsellorForChatQuery,
    FetchCounsellorForChatQueryVariables
  > &
    (
      | { variables: FetchCounsellorForChatQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchCounsellorForChatQuery,
    FetchCounsellorForChatQueryVariables
  >(FetchCounsellorForChatDocument, options);
}
export function useFetchCounsellorForChatLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCounsellorForChatQuery,
    FetchCounsellorForChatQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchCounsellorForChatQuery,
    FetchCounsellorForChatQueryVariables
  >(FetchCounsellorForChatDocument, options);
}
// @ts-ignore
export function useFetchCounsellorForChatSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchCounsellorForChatQuery,
    FetchCounsellorForChatQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchCounsellorForChatQuery,
  FetchCounsellorForChatQueryVariables
>;
export function useFetchCounsellorForChatSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchCounsellorForChatQuery,
        FetchCounsellorForChatQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchCounsellorForChatQuery | undefined,
  FetchCounsellorForChatQueryVariables
>;
export function useFetchCounsellorForChatSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchCounsellorForChatQuery,
        FetchCounsellorForChatQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchCounsellorForChatQuery,
    FetchCounsellorForChatQueryVariables
  >(FetchCounsellorForChatDocument, options);
}
export type FetchCounsellorForChatQueryHookResult = ReturnType<
  typeof useFetchCounsellorForChatQuery
>;
export type FetchCounsellorForChatLazyQueryHookResult = ReturnType<
  typeof useFetchCounsellorForChatLazyQuery
>;
export type FetchCounsellorForChatSuspenseQueryHookResult = ReturnType<
  typeof useFetchCounsellorForChatSuspenseQuery
>;
export type FetchCounsellorForChatQueryResult = Apollo.QueryResult<
  FetchCounsellorForChatQuery,
  FetchCounsellorForChatQueryVariables
>;
export const FetchCounsellorsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FetchCounsellors' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FetchCounsellorsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCounsellors' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'counsellors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'data' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'CounsellorSelection',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paging' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'CounsellorSelectionPagination',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CounsellorSelectionLanguages' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Language' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CounsellorSelection' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Counsellor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatarImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobTitles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentTypes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableInNearFuture' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'spokenLanguages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CounsellorSelectionLanguages' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'info' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CounsellorSelectionPagination' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Pagination' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isLastPage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cursors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFetchCounsellorsQuery__
 *
 * To run a query within a React component, call `useFetchCounsellorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCounsellorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCounsellorsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchCounsellorsQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchCounsellorsQuery,
    FetchCounsellorsQueryVariables
  > &
    (
      | { variables: FetchCounsellorsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FetchCounsellorsQuery, FetchCounsellorsQueryVariables>(
    FetchCounsellorsDocument,
    options,
  );
}
export function useFetchCounsellorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCounsellorsQuery,
    FetchCounsellorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchCounsellorsQuery,
    FetchCounsellorsQueryVariables
  >(FetchCounsellorsDocument, options);
}
// @ts-ignore
export function useFetchCounsellorsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchCounsellorsQuery,
    FetchCounsellorsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchCounsellorsQuery,
  FetchCounsellorsQueryVariables
>;
export function useFetchCounsellorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchCounsellorsQuery,
        FetchCounsellorsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchCounsellorsQuery | undefined,
  FetchCounsellorsQueryVariables
>;
export function useFetchCounsellorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchCounsellorsQuery,
        FetchCounsellorsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchCounsellorsQuery,
    FetchCounsellorsQueryVariables
  >(FetchCounsellorsDocument, options);
}
export type FetchCounsellorsQueryHookResult = ReturnType<
  typeof useFetchCounsellorsQuery
>;
export type FetchCounsellorsLazyQueryHookResult = ReturnType<
  typeof useFetchCounsellorsLazyQuery
>;
export type FetchCounsellorsSuspenseQueryHookResult = ReturnType<
  typeof useFetchCounsellorsSuspenseQuery
>;
export type FetchCounsellorsQueryResult = Apollo.QueryResult<
  FetchCounsellorsQuery,
  FetchCounsellorsQueryVariables
>;
export const FetchCounsellorFiltersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FetchCounsellorFilters' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locationId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCounsellorFilters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'locationId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'locationId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'filters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'options' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'AvailableFilterOptions',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AvailableFilterOptions' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CounsellorFilterOption' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFetchCounsellorFiltersQuery__
 *
 * To run a query within a React component, call `useFetchCounsellorFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCounsellorFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCounsellorFiltersQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useFetchCounsellorFiltersQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchCounsellorFiltersQuery,
    FetchCounsellorFiltersQueryVariables
  > &
    (
      | { variables: FetchCounsellorFiltersQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchCounsellorFiltersQuery,
    FetchCounsellorFiltersQueryVariables
  >(FetchCounsellorFiltersDocument, options);
}
export function useFetchCounsellorFiltersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchCounsellorFiltersQuery,
    FetchCounsellorFiltersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchCounsellorFiltersQuery,
    FetchCounsellorFiltersQueryVariables
  >(FetchCounsellorFiltersDocument, options);
}
// @ts-ignore
export function useFetchCounsellorFiltersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchCounsellorFiltersQuery,
    FetchCounsellorFiltersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchCounsellorFiltersQuery,
  FetchCounsellorFiltersQueryVariables
>;
export function useFetchCounsellorFiltersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchCounsellorFiltersQuery,
        FetchCounsellorFiltersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchCounsellorFiltersQuery | undefined,
  FetchCounsellorFiltersQueryVariables
>;
export function useFetchCounsellorFiltersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchCounsellorFiltersQuery,
        FetchCounsellorFiltersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchCounsellorFiltersQuery,
    FetchCounsellorFiltersQueryVariables
  >(FetchCounsellorFiltersDocument, options);
}
export type FetchCounsellorFiltersQueryHookResult = ReturnType<
  typeof useFetchCounsellorFiltersQuery
>;
export type FetchCounsellorFiltersLazyQueryHookResult = ReturnType<
  typeof useFetchCounsellorFiltersLazyQuery
>;
export type FetchCounsellorFiltersSuspenseQueryHookResult = ReturnType<
  typeof useFetchCounsellorFiltersSuspenseQuery
>;
export type FetchCounsellorFiltersQueryResult = Apollo.QueryResult<
  FetchCounsellorFiltersQuery,
  FetchCounsellorFiltersQueryVariables
>;
export const FetchFirstOfferedAppointmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FetchFirstOfferedAppointment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locationId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchFirstOfferedAvailableTimeSlot' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'locationId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'locationId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availableTimeSlot' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'FirstOfferedTimeslot' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FirstOfferedCounsellor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Counsellor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'allowsBooking' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FirstOfferedTimeslot' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AvailableTimeSlot' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'types' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'counsellor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'FirstOfferedCounsellor' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFetchFirstOfferedAppointmentQuery__
 *
 * To run a query within a React component, call `useFetchFirstOfferedAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFirstOfferedAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFirstOfferedAppointmentQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useFetchFirstOfferedAppointmentQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchFirstOfferedAppointmentQuery,
    FetchFirstOfferedAppointmentQueryVariables
  > &
    (
      | {
          variables: FetchFirstOfferedAppointmentQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchFirstOfferedAppointmentQuery,
    FetchFirstOfferedAppointmentQueryVariables
  >(FetchFirstOfferedAppointmentDocument, options);
}
export function useFetchFirstOfferedAppointmentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchFirstOfferedAppointmentQuery,
    FetchFirstOfferedAppointmentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchFirstOfferedAppointmentQuery,
    FetchFirstOfferedAppointmentQueryVariables
  >(FetchFirstOfferedAppointmentDocument, options);
}
// @ts-ignore
export function useFetchFirstOfferedAppointmentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchFirstOfferedAppointmentQuery,
    FetchFirstOfferedAppointmentQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchFirstOfferedAppointmentQuery,
  FetchFirstOfferedAppointmentQueryVariables
>;
export function useFetchFirstOfferedAppointmentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchFirstOfferedAppointmentQuery,
        FetchFirstOfferedAppointmentQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchFirstOfferedAppointmentQuery | undefined,
  FetchFirstOfferedAppointmentQueryVariables
>;
export function useFetchFirstOfferedAppointmentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchFirstOfferedAppointmentQuery,
        FetchFirstOfferedAppointmentQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchFirstOfferedAppointmentQuery,
    FetchFirstOfferedAppointmentQueryVariables
  >(FetchFirstOfferedAppointmentDocument, options);
}
export type FetchFirstOfferedAppointmentQueryHookResult = ReturnType<
  typeof useFetchFirstOfferedAppointmentQuery
>;
export type FetchFirstOfferedAppointmentLazyQueryHookResult = ReturnType<
  typeof useFetchFirstOfferedAppointmentLazyQuery
>;
export type FetchFirstOfferedAppointmentSuspenseQueryHookResult = ReturnType<
  typeof useFetchFirstOfferedAppointmentSuspenseQuery
>;
export type FetchFirstOfferedAppointmentQueryResult = Apollo.QueryResult<
  FetchFirstOfferedAppointmentQuery,
  FetchFirstOfferedAppointmentQueryVariables
>;
export const StripeInitializationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StripeInitialization' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stripeInitialization' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stripeInitialization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishableKey' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentPaymentSetupIntent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stripeIntent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customerId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'intentClientSecret' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'customerSessionClientSecret',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useStripeInitializationQuery__
 *
 * To run a query within a React component, call `useStripeInitializationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeInitializationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeInitializationQuery({
 *   variables: {
 *   },
 * });
 */
export function useStripeInitializationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    StripeInitializationQuery,
    StripeInitializationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    StripeInitializationQuery,
    StripeInitializationQueryVariables
  >(StripeInitializationDocument, options);
}
export function useStripeInitializationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StripeInitializationQuery,
    StripeInitializationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    StripeInitializationQuery,
    StripeInitializationQueryVariables
  >(StripeInitializationDocument, options);
}
// @ts-ignore
export function useStripeInitializationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    StripeInitializationQuery,
    StripeInitializationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  StripeInitializationQuery,
  StripeInitializationQueryVariables
>;
export function useStripeInitializationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StripeInitializationQuery,
        StripeInitializationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  StripeInitializationQuery | undefined,
  StripeInitializationQueryVariables
>;
export function useStripeInitializationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StripeInitializationQuery,
        StripeInitializationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    StripeInitializationQuery,
    StripeInitializationQueryVariables
  >(StripeInitializationDocument, options);
}
export type StripeInitializationQueryHookResult = ReturnType<
  typeof useStripeInitializationQuery
>;
export type StripeInitializationLazyQueryHookResult = ReturnType<
  typeof useStripeInitializationLazyQuery
>;
export type StripeInitializationSuspenseQueryHookResult = ReturnType<
  typeof useStripeInitializationSuspenseQuery
>;
export type StripeInitializationQueryResult = Apollo.QueryResult<
  StripeInitializationQuery,
  StripeInitializationQueryVariables
>;
export const SelectedCardDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SelectedCard' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectedCard' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selectedCard' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'last4Digits' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cardBrand' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expirationMonth' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expirationYear' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isExpired' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSelectedCardQuery__
 *
 * To run a query within a React component, call `useSelectedCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectedCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectedCardQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectedCardQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SelectedCardQuery,
    SelectedCardQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SelectedCardQuery, SelectedCardQueryVariables>(
    SelectedCardDocument,
    options,
  );
}
export function useSelectedCardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SelectedCardQuery,
    SelectedCardQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SelectedCardQuery, SelectedCardQueryVariables>(
    SelectedCardDocument,
    options,
  );
}
// @ts-ignore
export function useSelectedCardSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SelectedCardQuery,
    SelectedCardQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SelectedCardQuery, SelectedCardQueryVariables>;
export function useSelectedCardSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SelectedCardQuery,
        SelectedCardQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SelectedCardQuery | undefined,
  SelectedCardQueryVariables
>;
export function useSelectedCardSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SelectedCardQuery,
        SelectedCardQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SelectedCardQuery, SelectedCardQueryVariables>(
    SelectedCardDocument,
    options,
  );
}
export type SelectedCardQueryHookResult = ReturnType<
  typeof useSelectedCardQuery
>;
export type SelectedCardLazyQueryHookResult = ReturnType<
  typeof useSelectedCardLazyQuery
>;
export type SelectedCardSuspenseQueryHookResult = ReturnType<
  typeof useSelectedCardSuspenseQuery
>;
export type SelectedCardQueryResult = Apollo.QueryResult<
  SelectedCardQuery,
  SelectedCardQueryVariables
>;
export const CounsellorWithTimeslotsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CounsellorWithTimeslots' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCounsellor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'counsellor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TimeslotCounsellor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timeSlots' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'input' },
                            value: { kind: 'ObjectValue', fields: [] },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'TimeSlot' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TimeslotCounsellor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Counsellor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatarImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobTitles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TimeSlot' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AvailableTimeSlot' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'types' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCounsellorWithTimeslotsQuery__
 *
 * To run a query within a React component, call `useCounsellorWithTimeslotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCounsellorWithTimeslotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCounsellorWithTimeslotsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCounsellorWithTimeslotsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CounsellorWithTimeslotsQuery,
    CounsellorWithTimeslotsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CounsellorWithTimeslotsQuery,
    CounsellorWithTimeslotsQueryVariables
  >(CounsellorWithTimeslotsDocument, options);
}
export function useCounsellorWithTimeslotsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CounsellorWithTimeslotsQuery,
    CounsellorWithTimeslotsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CounsellorWithTimeslotsQuery,
    CounsellorWithTimeslotsQueryVariables
  >(CounsellorWithTimeslotsDocument, options);
}
// @ts-ignore
export function useCounsellorWithTimeslotsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CounsellorWithTimeslotsQuery,
    CounsellorWithTimeslotsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CounsellorWithTimeslotsQuery,
  CounsellorWithTimeslotsQueryVariables
>;
export function useCounsellorWithTimeslotsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CounsellorWithTimeslotsQuery,
        CounsellorWithTimeslotsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CounsellorWithTimeslotsQuery | undefined,
  CounsellorWithTimeslotsQueryVariables
>;
export function useCounsellorWithTimeslotsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CounsellorWithTimeslotsQuery,
        CounsellorWithTimeslotsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CounsellorWithTimeslotsQuery,
    CounsellorWithTimeslotsQueryVariables
  >(CounsellorWithTimeslotsDocument, options);
}
export type CounsellorWithTimeslotsQueryHookResult = ReturnType<
  typeof useCounsellorWithTimeslotsQuery
>;
export type CounsellorWithTimeslotsLazyQueryHookResult = ReturnType<
  typeof useCounsellorWithTimeslotsLazyQuery
>;
export type CounsellorWithTimeslotsSuspenseQueryHookResult = ReturnType<
  typeof useCounsellorWithTimeslotsSuspenseQuery
>;
export type CounsellorWithTimeslotsQueryResult = Apollo.QueryResult<
  CounsellorWithTimeslotsQuery,
  CounsellorWithTimeslotsQueryVariables
>;
export const CounsellorByIdWithTimeslotsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CounsellorByIdWithTimeslots' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'counsellorId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCounsellorById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'counsellorId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'counsellorId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'counsellor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TimeslotCounsellor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timeSlots' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'input' },
                            value: { kind: 'ObjectValue', fields: [] },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'TimeSlot' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TimeslotCounsellor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Counsellor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatarImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobTitles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TimeSlot' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AvailableTimeSlot' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'types' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCounsellorByIdWithTimeslotsQuery__
 *
 * To run a query within a React component, call `useCounsellorByIdWithTimeslotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCounsellorByIdWithTimeslotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCounsellorByIdWithTimeslotsQuery({
 *   variables: {
 *      counsellorId: // value for 'counsellorId'
 *   },
 * });
 */
export function useCounsellorByIdWithTimeslotsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CounsellorByIdWithTimeslotsQuery,
    CounsellorByIdWithTimeslotsQueryVariables
  > &
    (
      | { variables: CounsellorByIdWithTimeslotsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CounsellorByIdWithTimeslotsQuery,
    CounsellorByIdWithTimeslotsQueryVariables
  >(CounsellorByIdWithTimeslotsDocument, options);
}
export function useCounsellorByIdWithTimeslotsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CounsellorByIdWithTimeslotsQuery,
    CounsellorByIdWithTimeslotsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CounsellorByIdWithTimeslotsQuery,
    CounsellorByIdWithTimeslotsQueryVariables
  >(CounsellorByIdWithTimeslotsDocument, options);
}
// @ts-ignore
export function useCounsellorByIdWithTimeslotsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CounsellorByIdWithTimeslotsQuery,
    CounsellorByIdWithTimeslotsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CounsellorByIdWithTimeslotsQuery,
  CounsellorByIdWithTimeslotsQueryVariables
>;
export function useCounsellorByIdWithTimeslotsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CounsellorByIdWithTimeslotsQuery,
        CounsellorByIdWithTimeslotsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CounsellorByIdWithTimeslotsQuery | undefined,
  CounsellorByIdWithTimeslotsQueryVariables
>;
export function useCounsellorByIdWithTimeslotsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CounsellorByIdWithTimeslotsQuery,
        CounsellorByIdWithTimeslotsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CounsellorByIdWithTimeslotsQuery,
    CounsellorByIdWithTimeslotsQueryVariables
  >(CounsellorByIdWithTimeslotsDocument, options);
}
export type CounsellorByIdWithTimeslotsQueryHookResult = ReturnType<
  typeof useCounsellorByIdWithTimeslotsQuery
>;
export type CounsellorByIdWithTimeslotsLazyQueryHookResult = ReturnType<
  typeof useCounsellorByIdWithTimeslotsLazyQuery
>;
export type CounsellorByIdWithTimeslotsSuspenseQueryHookResult = ReturnType<
  typeof useCounsellorByIdWithTimeslotsSuspenseQuery
>;
export type CounsellorByIdWithTimeslotsQueryResult = Apollo.QueryResult<
  CounsellorByIdWithTimeslotsQuery,
  CounsellorByIdWithTimeslotsQueryVariables
>;
export const SubdivisionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Subdivision' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchUserSubdivisions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subdivisions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSubdivisionQuery__
 *
 * To run a query within a React component, call `useSubdivisionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubdivisionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubdivisionQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubdivisionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SubdivisionQuery,
    SubdivisionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SubdivisionQuery, SubdivisionQueryVariables>(
    SubdivisionDocument,
    options,
  );
}
export function useSubdivisionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SubdivisionQuery,
    SubdivisionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SubdivisionQuery, SubdivisionQueryVariables>(
    SubdivisionDocument,
    options,
  );
}
// @ts-ignore
export function useSubdivisionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SubdivisionQuery,
    SubdivisionQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SubdivisionQuery, SubdivisionQueryVariables>;
export function useSubdivisionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SubdivisionQuery,
        SubdivisionQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SubdivisionQuery | undefined,
  SubdivisionQueryVariables
>;
export function useSubdivisionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SubdivisionQuery,
        SubdivisionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SubdivisionQuery, SubdivisionQueryVariables>(
    SubdivisionDocument,
    options,
  );
}
export type SubdivisionQueryHookResult = ReturnType<typeof useSubdivisionQuery>;
export type SubdivisionLazyQueryHookResult = ReturnType<
  typeof useSubdivisionLazyQuery
>;
export type SubdivisionSuspenseQueryHookResult = ReturnType<
  typeof useSubdivisionSuspenseQuery
>;
export type SubdivisionQueryResult = Apollo.QueryResult<
  SubdivisionQuery,
  SubdivisionQueryVariables
>;
export const FetchUpcomingAppointmentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FetchUpcomingAppointments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FetchAppointmentsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchAppointments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'data' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Appointments' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Appointments' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Appointment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'counsellor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatarImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jobTitles' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allowsBooking' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'typeDescription' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFetchUpcomingAppointmentsQuery__
 *
 * To run a query within a React component, call `useFetchUpcomingAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUpcomingAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUpcomingAppointmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchUpcomingAppointmentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchUpcomingAppointmentsQuery,
    FetchUpcomingAppointmentsQueryVariables
  > &
    (
      | { variables: FetchUpcomingAppointmentsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchUpcomingAppointmentsQuery,
    FetchUpcomingAppointmentsQueryVariables
  >(FetchUpcomingAppointmentsDocument, options);
}
export function useFetchUpcomingAppointmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchUpcomingAppointmentsQuery,
    FetchUpcomingAppointmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchUpcomingAppointmentsQuery,
    FetchUpcomingAppointmentsQueryVariables
  >(FetchUpcomingAppointmentsDocument, options);
}
// @ts-ignore
export function useFetchUpcomingAppointmentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchUpcomingAppointmentsQuery,
    FetchUpcomingAppointmentsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchUpcomingAppointmentsQuery,
  FetchUpcomingAppointmentsQueryVariables
>;
export function useFetchUpcomingAppointmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchUpcomingAppointmentsQuery,
        FetchUpcomingAppointmentsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchUpcomingAppointmentsQuery | undefined,
  FetchUpcomingAppointmentsQueryVariables
>;
export function useFetchUpcomingAppointmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchUpcomingAppointmentsQuery,
        FetchUpcomingAppointmentsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchUpcomingAppointmentsQuery,
    FetchUpcomingAppointmentsQueryVariables
  >(FetchUpcomingAppointmentsDocument, options);
}
export type FetchUpcomingAppointmentsQueryHookResult = ReturnType<
  typeof useFetchUpcomingAppointmentsQuery
>;
export type FetchUpcomingAppointmentsLazyQueryHookResult = ReturnType<
  typeof useFetchUpcomingAppointmentsLazyQuery
>;
export type FetchUpcomingAppointmentsSuspenseQueryHookResult = ReturnType<
  typeof useFetchUpcomingAppointmentsSuspenseQuery
>;
export type FetchUpcomingAppointmentsQueryResult = Apollo.QueryResult<
  FetchUpcomingAppointmentsQuery,
  FetchUpcomingAppointmentsQueryVariables
>;
export const FetchPastAppointmentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FetchPastAppointments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FetchAppointmentsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchAppointments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'data' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Appointments' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paging' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'AppointmentsPagination',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Appointments' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Appointment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'counsellor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatarImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jobTitles' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allowsBooking' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'typeDescription' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentsPagination' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Pagination' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isLastPage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cursors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFetchPastAppointmentsQuery__
 *
 * To run a query within a React component, call `useFetchPastAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPastAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPastAppointmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchPastAppointmentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchPastAppointmentsQuery,
    FetchPastAppointmentsQueryVariables
  > &
    (
      | { variables: FetchPastAppointmentsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchPastAppointmentsQuery,
    FetchPastAppointmentsQueryVariables
  >(FetchPastAppointmentsDocument, options);
}
export function useFetchPastAppointmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchPastAppointmentsQuery,
    FetchPastAppointmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchPastAppointmentsQuery,
    FetchPastAppointmentsQueryVariables
  >(FetchPastAppointmentsDocument, options);
}
// @ts-ignore
export function useFetchPastAppointmentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchPastAppointmentsQuery,
    FetchPastAppointmentsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchPastAppointmentsQuery,
  FetchPastAppointmentsQueryVariables
>;
export function useFetchPastAppointmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchPastAppointmentsQuery,
        FetchPastAppointmentsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchPastAppointmentsQuery | undefined,
  FetchPastAppointmentsQueryVariables
>;
export function useFetchPastAppointmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchPastAppointmentsQuery,
        FetchPastAppointmentsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchPastAppointmentsQuery,
    FetchPastAppointmentsQueryVariables
  >(FetchPastAppointmentsDocument, options);
}
export type FetchPastAppointmentsQueryHookResult = ReturnType<
  typeof useFetchPastAppointmentsQuery
>;
export type FetchPastAppointmentsLazyQueryHookResult = ReturnType<
  typeof useFetchPastAppointmentsLazyQuery
>;
export type FetchPastAppointmentsSuspenseQueryHookResult = ReturnType<
  typeof useFetchPastAppointmentsSuspenseQuery
>;
export type FetchPastAppointmentsQueryResult = Apollo.QueryResult<
  FetchPastAppointmentsQuery,
  FetchPastAppointmentsQueryVariables
>;
export const FetchYourCounsellorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FetchYourCounsellor' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchCounsellor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'counsellor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'YourCounsellor' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'YourCounsellor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Counsellor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentTypes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatarImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobTitles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allowsBooking' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayHistory' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFetchYourCounsellorQuery__
 *
 * To run a query within a React component, call `useFetchYourCounsellorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchYourCounsellorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchYourCounsellorQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchYourCounsellorQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchYourCounsellorQuery,
    FetchYourCounsellorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchYourCounsellorQuery,
    FetchYourCounsellorQueryVariables
  >(FetchYourCounsellorDocument, options);
}
export function useFetchYourCounsellorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchYourCounsellorQuery,
    FetchYourCounsellorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchYourCounsellorQuery,
    FetchYourCounsellorQueryVariables
  >(FetchYourCounsellorDocument, options);
}
// @ts-ignore
export function useFetchYourCounsellorSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchYourCounsellorQuery,
    FetchYourCounsellorQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchYourCounsellorQuery,
  FetchYourCounsellorQueryVariables
>;
export function useFetchYourCounsellorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchYourCounsellorQuery,
        FetchYourCounsellorQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchYourCounsellorQuery | undefined,
  FetchYourCounsellorQueryVariables
>;
export function useFetchYourCounsellorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchYourCounsellorQuery,
        FetchYourCounsellorQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchYourCounsellorQuery,
    FetchYourCounsellorQueryVariables
  >(FetchYourCounsellorDocument, options);
}
export type FetchYourCounsellorQueryHookResult = ReturnType<
  typeof useFetchYourCounsellorQuery
>;
export type FetchYourCounsellorLazyQueryHookResult = ReturnType<
  typeof useFetchYourCounsellorLazyQuery
>;
export type FetchYourCounsellorSuspenseQueryHookResult = ReturnType<
  typeof useFetchYourCounsellorSuspenseQuery
>;
export type FetchYourCounsellorQueryResult = Apollo.QueryResult<
  FetchYourCounsellorQuery,
  FetchYourCounsellorQueryVariables
>;
export const PreAssessmentResultsHistoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PreAssessmentResultsHistory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'where' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'FilterPreAssessmentHistoryInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preAssessmentResultsHistory' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'where' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'history' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'PreAssessmentResultHistory',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isLastPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cursors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'after' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PreAssessmentResultHistory' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PreAssessmentResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayMaxScore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxScore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'severities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePreAssessmentResultsHistoryQuery__
 *
 * To run a query within a React component, call `usePreAssessmentResultsHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreAssessmentResultsHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreAssessmentResultsHistoryQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePreAssessmentResultsHistoryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PreAssessmentResultsHistoryQuery,
    PreAssessmentResultsHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PreAssessmentResultsHistoryQuery,
    PreAssessmentResultsHistoryQueryVariables
  >(PreAssessmentResultsHistoryDocument, options);
}
export function usePreAssessmentResultsHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PreAssessmentResultsHistoryQuery,
    PreAssessmentResultsHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PreAssessmentResultsHistoryQuery,
    PreAssessmentResultsHistoryQueryVariables
  >(PreAssessmentResultsHistoryDocument, options);
}
// @ts-ignore
export function usePreAssessmentResultsHistorySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PreAssessmentResultsHistoryQuery,
    PreAssessmentResultsHistoryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  PreAssessmentResultsHistoryQuery,
  PreAssessmentResultsHistoryQueryVariables
>;
export function usePreAssessmentResultsHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PreAssessmentResultsHistoryQuery,
        PreAssessmentResultsHistoryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PreAssessmentResultsHistoryQuery | undefined,
  PreAssessmentResultsHistoryQueryVariables
>;
export function usePreAssessmentResultsHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PreAssessmentResultsHistoryQuery,
        PreAssessmentResultsHistoryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PreAssessmentResultsHistoryQuery,
    PreAssessmentResultsHistoryQueryVariables
  >(PreAssessmentResultsHistoryDocument, options);
}
export type PreAssessmentResultsHistoryQueryHookResult = ReturnType<
  typeof usePreAssessmentResultsHistoryQuery
>;
export type PreAssessmentResultsHistoryLazyQueryHookResult = ReturnType<
  typeof usePreAssessmentResultsHistoryLazyQuery
>;
export type PreAssessmentResultsHistorySuspenseQueryHookResult = ReturnType<
  typeof usePreAssessmentResultsHistorySuspenseQuery
>;
export type PreAssessmentResultsHistoryQueryResult = Apollo.QueryResult<
  PreAssessmentResultsHistoryQuery,
  PreAssessmentResultsHistoryQueryVariables
>;
export const PreAssessmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PreAssessment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'where' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'FilterPreAssessmentInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preAssessment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'where' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextAssessment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'CareAssessment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CareAssessmentChoiceQuestionOption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CareAssessmentChoiceQuestionOption' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextQuestionId' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CareAssessmentsChoiceQuestion' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CareAssessmentChoiceQuestion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CareAssessmentChoiceQuestionOption',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CareAssessmentsTextQuestion' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CareAssessmentTextQuestion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxLength' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextQuestionId' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CareAssessment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CareAssessment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'questions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CareAssessmentsChoiceQuestion',
                  },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CareAssessmentsTextQuestion' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePreAssessmentQuery__
 *
 * To run a query within a React component, call `usePreAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreAssessmentQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePreAssessmentQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PreAssessmentQuery,
    PreAssessmentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PreAssessmentQuery, PreAssessmentQueryVariables>(
    PreAssessmentDocument,
    options,
  );
}
export function usePreAssessmentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PreAssessmentQuery,
    PreAssessmentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PreAssessmentQuery, PreAssessmentQueryVariables>(
    PreAssessmentDocument,
    options,
  );
}
// @ts-ignore
export function usePreAssessmentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PreAssessmentQuery,
    PreAssessmentQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  PreAssessmentQuery,
  PreAssessmentQueryVariables
>;
export function usePreAssessmentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PreAssessmentQuery,
        PreAssessmentQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PreAssessmentQuery | undefined,
  PreAssessmentQueryVariables
>;
export function usePreAssessmentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PreAssessmentQuery,
        PreAssessmentQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PreAssessmentQuery,
    PreAssessmentQueryVariables
  >(PreAssessmentDocument, options);
}
export type PreAssessmentQueryHookResult = ReturnType<
  typeof usePreAssessmentQuery
>;
export type PreAssessmentLazyQueryHookResult = ReturnType<
  typeof usePreAssessmentLazyQuery
>;
export type PreAssessmentSuspenseQueryHookResult = ReturnType<
  typeof usePreAssessmentSuspenseQuery
>;
export type PreAssessmentQueryResult = Apollo.QueryResult<
  PreAssessmentQuery,
  PreAssessmentQueryVariables
>;
export const AnswerPreAssessmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AnswerPreAssessment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'request' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AnswerPreAssessmentInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answerPreAssessment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'request' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'request' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextAssessment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'CareAssessment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recommendation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Recommendation' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'results' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PreAssessmentResults' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CareAssessmentChoiceQuestionOption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CareAssessmentChoiceQuestionOption' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextQuestionId' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CareAssessmentsChoiceQuestion' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CareAssessmentChoiceQuestion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CareAssessmentChoiceQuestionOption',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CareAssessmentsTextQuestion' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CareAssessmentTextQuestion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxLength' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextQuestionId' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CareAssessment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CareAssessment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'questions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CareAssessmentsChoiceQuestion',
                  },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CareAssessmentsTextQuestion' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PreAssessmentResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PreAssessmentResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'severities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxScore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayMaxScore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retakeData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'earlyRetakeWarningMessage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PreAssessmentNotTaken' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PreAssessmentNotTaken' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PreAssessmentResults' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PreAssessmentResults' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shouldSpeakToCounsellor' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PreAssessmentResult' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PreAssessmentNotTaken' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Recommendation' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'PreAssessmentRecommendationSuicideRiskCallNow',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ccsTeamTelephoneNumber' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AnswerPreAssessmentMutationFn = Apollo.MutationFunction<
  AnswerPreAssessmentMutation,
  AnswerPreAssessmentMutationVariables
>;

/**
 * __useAnswerPreAssessmentMutation__
 *
 * To run a mutation, you first call `useAnswerPreAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerPreAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerPreAssessmentMutation, { data, loading, error }] = useAnswerPreAssessmentMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useAnswerPreAssessmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AnswerPreAssessmentMutation,
    AnswerPreAssessmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AnswerPreAssessmentMutation,
    AnswerPreAssessmentMutationVariables
  >(AnswerPreAssessmentDocument, options);
}
export type AnswerPreAssessmentMutationHookResult = ReturnType<
  typeof useAnswerPreAssessmentMutation
>;
export type AnswerPreAssessmentMutationResult =
  Apollo.MutationResult<AnswerPreAssessmentMutation>;
export type AnswerPreAssessmentMutationOptions = Apollo.BaseMutationOptions<
  AnswerPreAssessmentMutation,
  AnswerPreAssessmentMutationVariables
>;
export const RequestCallbackForAtRiskMemberDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RequestCallbackForAtRiskMember' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'RequestCallbackForAtRiskMemberInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestCallbackForAtRiskMember' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'telephoneNumber' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RequestCallbackForAtRiskMemberMutationFn = Apollo.MutationFunction<
  RequestCallbackForAtRiskMemberMutation,
  RequestCallbackForAtRiskMemberMutationVariables
>;

/**
 * __useRequestCallbackForAtRiskMemberMutation__
 *
 * To run a mutation, you first call `useRequestCallbackForAtRiskMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCallbackForAtRiskMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCallbackForAtRiskMemberMutation, { data, loading, error }] = useRequestCallbackForAtRiskMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestCallbackForAtRiskMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestCallbackForAtRiskMemberMutation,
    RequestCallbackForAtRiskMemberMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestCallbackForAtRiskMemberMutation,
    RequestCallbackForAtRiskMemberMutationVariables
  >(RequestCallbackForAtRiskMemberDocument, options);
}
export type RequestCallbackForAtRiskMemberMutationHookResult = ReturnType<
  typeof useRequestCallbackForAtRiskMemberMutation
>;
export type RequestCallbackForAtRiskMemberMutationResult =
  Apollo.MutationResult<RequestCallbackForAtRiskMemberMutation>;
export type RequestCallbackForAtRiskMemberMutationOptions =
  Apollo.BaseMutationOptions<
    RequestCallbackForAtRiskMemberMutation,
    RequestCallbackForAtRiskMemberMutationVariables
  >;
export const SelectedCareServiceOptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SelectedCareServiceOption' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectedCareServiceOption' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'option' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSelectedCareServiceOptionQuery__
 *
 * To run a query within a React component, call `useSelectedCareServiceOptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectedCareServiceOptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectedCareServiceOptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectedCareServiceOptionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SelectedCareServiceOptionQuery,
    SelectedCareServiceOptionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SelectedCareServiceOptionQuery,
    SelectedCareServiceOptionQueryVariables
  >(SelectedCareServiceOptionDocument, options);
}
export function useSelectedCareServiceOptionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SelectedCareServiceOptionQuery,
    SelectedCareServiceOptionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SelectedCareServiceOptionQuery,
    SelectedCareServiceOptionQueryVariables
  >(SelectedCareServiceOptionDocument, options);
}
// @ts-ignore
export function useSelectedCareServiceOptionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SelectedCareServiceOptionQuery,
    SelectedCareServiceOptionQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SelectedCareServiceOptionQuery,
  SelectedCareServiceOptionQueryVariables
>;
export function useSelectedCareServiceOptionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SelectedCareServiceOptionQuery,
        SelectedCareServiceOptionQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SelectedCareServiceOptionQuery | undefined,
  SelectedCareServiceOptionQueryVariables
>;
export function useSelectedCareServiceOptionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SelectedCareServiceOptionQuery,
        SelectedCareServiceOptionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SelectedCareServiceOptionQuery,
    SelectedCareServiceOptionQueryVariables
  >(SelectedCareServiceOptionDocument, options);
}
export type SelectedCareServiceOptionQueryHookResult = ReturnType<
  typeof useSelectedCareServiceOptionQuery
>;
export type SelectedCareServiceOptionLazyQueryHookResult = ReturnType<
  typeof useSelectedCareServiceOptionLazyQuery
>;
export type SelectedCareServiceOptionSuspenseQueryHookResult = ReturnType<
  typeof useSelectedCareServiceOptionSuspenseQuery
>;
export type SelectedCareServiceOptionQueryResult = Apollo.QueryResult<
  SelectedCareServiceOptionQuery,
  SelectedCareServiceOptionQueryVariables
>;
export const CareIssuesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CareIssues' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCareIssues' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'careIssues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'CareIssue' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CareIssue' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CareIssue' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'analyticsId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'default' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCareIssuesQuery__
 *
 * To run a query within a React component, call `useCareIssuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCareIssuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCareIssuesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCareIssuesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CareIssuesQuery,
    CareIssuesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CareIssuesQuery, CareIssuesQueryVariables>(
    CareIssuesDocument,
    options,
  );
}
export function useCareIssuesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CareIssuesQuery,
    CareIssuesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CareIssuesQuery, CareIssuesQueryVariables>(
    CareIssuesDocument,
    options,
  );
}
// @ts-ignore
export function useCareIssuesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CareIssuesQuery,
    CareIssuesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CareIssuesQuery, CareIssuesQueryVariables>;
export function useCareIssuesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CareIssuesQuery,
        CareIssuesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CareIssuesQuery | undefined,
  CareIssuesQueryVariables
>;
export function useCareIssuesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CareIssuesQuery,
        CareIssuesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CareIssuesQuery, CareIssuesQueryVariables>(
    CareIssuesDocument,
    options,
  );
}
export type CareIssuesQueryHookResult = ReturnType<typeof useCareIssuesQuery>;
export type CareIssuesLazyQueryHookResult = ReturnType<
  typeof useCareIssuesLazyQuery
>;
export type CareIssuesSuspenseQueryHookResult = ReturnType<
  typeof useCareIssuesSuspenseQuery
>;
export type CareIssuesQueryResult = Apollo.QueryResult<
  CareIssuesQuery,
  CareIssuesQueryVariables
>;
export const SetCareIssueDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetCareIssue' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'request' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SetCareIssueInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setCareIssue' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'request' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'request' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'careIssue' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'CareIssue' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CareIssue' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CareIssue' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'analyticsId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'default' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SetCareIssueMutationFn = Apollo.MutationFunction<
  SetCareIssueMutation,
  SetCareIssueMutationVariables
>;

/**
 * __useSetCareIssueMutation__
 *
 * To run a mutation, you first call `useSetCareIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCareIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCareIssueMutation, { data, loading, error }] = useSetCareIssueMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useSetCareIssueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCareIssueMutation,
    SetCareIssueMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetCareIssueMutation,
    SetCareIssueMutationVariables
  >(SetCareIssueDocument, options);
}
export type SetCareIssueMutationHookResult = ReturnType<
  typeof useSetCareIssueMutation
>;
export type SetCareIssueMutationResult =
  Apollo.MutationResult<SetCareIssueMutation>;
export type SetCareIssueMutationOptions = Apollo.BaseMutationOptions<
  SetCareIssueMutation,
  SetCareIssueMutationVariables
>;
export const AskForImmediateHelpDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AskForImmediateHelp' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'askForImmediateHelp' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ccsTeamTelephoneNumber' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AskForImmediateHelpMutationFn = Apollo.MutationFunction<
  AskForImmediateHelpMutation,
  AskForImmediateHelpMutationVariables
>;

/**
 * __useAskForImmediateHelpMutation__
 *
 * To run a mutation, you first call `useAskForImmediateHelpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAskForImmediateHelpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [askForImmediateHelpMutation, { data, loading, error }] = useAskForImmediateHelpMutation({
 *   variables: {
 *   },
 * });
 */
export function useAskForImmediateHelpMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AskForImmediateHelpMutation,
    AskForImmediateHelpMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AskForImmediateHelpMutation,
    AskForImmediateHelpMutationVariables
  >(AskForImmediateHelpDocument, options);
}
export type AskForImmediateHelpMutationHookResult = ReturnType<
  typeof useAskForImmediateHelpMutation
>;
export type AskForImmediateHelpMutationResult =
  Apollo.MutationResult<AskForImmediateHelpMutation>;
export type AskForImmediateHelpMutationOptions = Apollo.BaseMutationOptions<
  AskForImmediateHelpMutation,
  AskForImmediateHelpMutationVariables
>;
export const SelectCareServiceOptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SelectCareServiceOption' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'request' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SelectCareServiceOptionInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectCareServiceOption' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'request' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'request' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'option' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SelectCareServiceOptionMutationFn = Apollo.MutationFunction<
  SelectCareServiceOptionMutation,
  SelectCareServiceOptionMutationVariables
>;

/**
 * __useSelectCareServiceOptionMutation__
 *
 * To run a mutation, you first call `useSelectCareServiceOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectCareServiceOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectCareServiceOptionMutation, { data, loading, error }] = useSelectCareServiceOptionMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useSelectCareServiceOptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SelectCareServiceOptionMutation,
    SelectCareServiceOptionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SelectCareServiceOptionMutation,
    SelectCareServiceOptionMutationVariables
  >(SelectCareServiceOptionDocument, options);
}
export type SelectCareServiceOptionMutationHookResult = ReturnType<
  typeof useSelectCareServiceOptionMutation
>;
export type SelectCareServiceOptionMutationResult =
  Apollo.MutationResult<SelectCareServiceOptionMutation>;
export type SelectCareServiceOptionMutationOptions = Apollo.BaseMutationOptions<
  SelectCareServiceOptionMutation,
  SelectCareServiceOptionMutationVariables
>;
export const CarePlanActivityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CarePlanActivity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'where' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'CarePlanActivityInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carePlanActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'where' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'carePlanActivity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'CarePlanActivity' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CarePlanActivityWithHippo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CarePlanActivityArticle' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audios' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'copyright' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heroImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hlsUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'format' } },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'path' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModuleWithoutActivities' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CarePlanModule' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Activity' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CarePlanActivityArticle' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'module' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ModuleWithoutActivities' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CarePlanActivityArticle' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CarePlanActivity' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CarePlanActivityArticle' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Activity' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'CarePlanActivityWithHippo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextActivity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Activity' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previousActivity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Activity' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCarePlanActivityQuery__
 *
 * To run a query within a React component, call `useCarePlanActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarePlanActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarePlanActivityQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCarePlanActivityQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CarePlanActivityQuery,
    CarePlanActivityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CarePlanActivityQuery, CarePlanActivityQueryVariables>(
    CarePlanActivityDocument,
    options,
  );
}
export function useCarePlanActivityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CarePlanActivityQuery,
    CarePlanActivityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CarePlanActivityQuery,
    CarePlanActivityQueryVariables
  >(CarePlanActivityDocument, options);
}
// @ts-ignore
export function useCarePlanActivitySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CarePlanActivityQuery,
    CarePlanActivityQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CarePlanActivityQuery,
  CarePlanActivityQueryVariables
>;
export function useCarePlanActivitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CarePlanActivityQuery,
        CarePlanActivityQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CarePlanActivityQuery | undefined,
  CarePlanActivityQueryVariables
>;
export function useCarePlanActivitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CarePlanActivityQuery,
        CarePlanActivityQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CarePlanActivityQuery,
    CarePlanActivityQueryVariables
  >(CarePlanActivityDocument, options);
}
export type CarePlanActivityQueryHookResult = ReturnType<
  typeof useCarePlanActivityQuery
>;
export type CarePlanActivityLazyQueryHookResult = ReturnType<
  typeof useCarePlanActivityLazyQuery
>;
export type CarePlanActivitySuspenseQueryHookResult = ReturnType<
  typeof useCarePlanActivitySuspenseQuery
>;
export type CarePlanActivityQueryResult = Apollo.QueryResult<
  CarePlanActivityQuery,
  CarePlanActivityQueryVariables
>;
export const CompleteCarePlanActivityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CompleteCarePlanActivity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'CompleteCarePlanActivityInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completeCarePlanActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'carePlanActivity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completed' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CompleteCarePlanActivityMutationFn = Apollo.MutationFunction<
  CompleteCarePlanActivityMutation,
  CompleteCarePlanActivityMutationVariables
>;

/**
 * __useCompleteCarePlanActivityMutation__
 *
 * To run a mutation, you first call `useCompleteCarePlanActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteCarePlanActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeCarePlanActivityMutation, { data, loading, error }] = useCompleteCarePlanActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteCarePlanActivityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompleteCarePlanActivityMutation,
    CompleteCarePlanActivityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompleteCarePlanActivityMutation,
    CompleteCarePlanActivityMutationVariables
  >(CompleteCarePlanActivityDocument, options);
}
export type CompleteCarePlanActivityMutationHookResult = ReturnType<
  typeof useCompleteCarePlanActivityMutation
>;
export type CompleteCarePlanActivityMutationResult =
  Apollo.MutationResult<CompleteCarePlanActivityMutation>;
export type CompleteCarePlanActivityMutationOptions =
  Apollo.BaseMutationOptions<
    CompleteCarePlanActivityMutation,
    CompleteCarePlanActivityMutationVariables
  >;
export const CarePlanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CarePlan' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'carePlan' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'CarePlan' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModuleWithoutActivities' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CarePlanModule' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Activity' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CarePlanActivityArticle' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'module' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ModuleWithoutActivities' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CarePlanActivityArticle' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CarePlanModules' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CarePlanModule' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'ModuleWithoutActivities' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activities' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Activity' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CarePlanSections' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CarePlanSection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'modules' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CarePlanModules' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CarePlan' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CarePlan' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CarePlanSections' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentActivity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Activity' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCarePlanQuery__
 *
 * To run a query within a React component, call `useCarePlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarePlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarePlanQuery({
 *   variables: {
 *   },
 * });
 */
export function useCarePlanQuery(
  baseOptions?: Apollo.QueryHookOptions<CarePlanQuery, CarePlanQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CarePlanQuery, CarePlanQueryVariables>(
    CarePlanDocument,
    options,
  );
}
export function useCarePlanLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CarePlanQuery,
    CarePlanQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CarePlanQuery, CarePlanQueryVariables>(
    CarePlanDocument,
    options,
  );
}
// @ts-ignore
export function useCarePlanSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CarePlanQuery,
    CarePlanQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CarePlanQuery, CarePlanQueryVariables>;
export function useCarePlanSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CarePlanQuery, CarePlanQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  CarePlanQuery | undefined,
  CarePlanQueryVariables
>;
export function useCarePlanSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CarePlanQuery, CarePlanQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CarePlanQuery, CarePlanQueryVariables>(
    CarePlanDocument,
    options,
  );
}
export type CarePlanQueryHookResult = ReturnType<typeof useCarePlanQuery>;
export type CarePlanLazyQueryHookResult = ReturnType<
  typeof useCarePlanLazyQuery
>;
export type CarePlanSuspenseQueryHookResult = ReturnType<
  typeof useCarePlanSuspenseQuery
>;
export type CarePlanQueryResult = Apollo.QueryResult<
  CarePlanQuery,
  CarePlanQueryVariables
>;
export const AssignCarePlanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AssignCarePlan' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AssignCarePlanInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignCarePlan' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'received' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AssignCarePlanMutationFn = Apollo.MutationFunction<
  AssignCarePlanMutation,
  AssignCarePlanMutationVariables
>;

/**
 * __useAssignCarePlanMutation__
 *
 * To run a mutation, you first call `useAssignCarePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignCarePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignCarePlanMutation, { data, loading, error }] = useAssignCarePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignCarePlanMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignCarePlanMutation,
    AssignCarePlanMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AssignCarePlanMutation,
    AssignCarePlanMutationVariables
  >(AssignCarePlanDocument, options);
}
export type AssignCarePlanMutationHookResult = ReturnType<
  typeof useAssignCarePlanMutation
>;
export type AssignCarePlanMutationResult =
  Apollo.MutationResult<AssignCarePlanMutation>;
export type AssignCarePlanMutationOptions = Apollo.BaseMutationOptions<
  AssignCarePlanMutation,
  AssignCarePlanMutationVariables
>;
export const ActivityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Activity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'challengeId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'from' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'GraphQLDate' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchChallenge' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'challengeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'challenge' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'HabitChallenge' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'challengeId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'activity' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'from' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'from' },
                                  },
                                },
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'first' },
                                  value: { kind: 'IntValue', value: '5' },
                                },
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'afterCursor' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'after' },
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'activity' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'HabitDailyActivity',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pagination' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'Pagination',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'challengeHabits' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'habits' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'HabitBasicInfo',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'thumbnailImage',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'url',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'options',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'optionId',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'title',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'subtitle' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'goal' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'StepChallenge' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'challengeId' },
                            },
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'activity' },
                              name: { kind: 'Name', value: 'stepActivity' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'from' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'from' },
                                  },
                                },
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'first' },
                                  value: { kind: 'IntValue', value: '5' },
                                },
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'afterCursor' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'after' },
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'activity' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'StepDailyActivity',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pagination' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'Pagination',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'goal' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Pagination' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Pagination' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isLastPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cursors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitBasicInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Habit' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'habitId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'selected' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StepDailyActivity' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepDailyActivity' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tracked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitDailyActivity' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitDailyActivity' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tracked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tradeLimit' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'habit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'habitId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'thumbnailImage' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'font' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'color' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'hexCode',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optionActivity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'option' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'optionId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'title' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useActivityQuery__
 *
 * To run a query within a React component, call `useActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityQuery({
 *   variables: {
 *      challengeId: // value for 'challengeId'
 *      from: // value for 'from'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useActivityQuery(
  baseOptions: Apollo.QueryHookOptions<ActivityQuery, ActivityQueryVariables> &
    ({ variables: ActivityQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ActivityQuery, ActivityQueryVariables>(
    ActivityDocument,
    options,
  );
}
export function useActivityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActivityQuery,
    ActivityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ActivityQuery, ActivityQueryVariables>(
    ActivityDocument,
    options,
  );
}
// @ts-ignore
export function useActivitySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ActivityQuery,
    ActivityQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ActivityQuery, ActivityQueryVariables>;
export function useActivitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ActivityQuery, ActivityQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ActivityQuery | undefined,
  ActivityQueryVariables
>;
export function useActivitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ActivityQuery, ActivityQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ActivityQuery, ActivityQueryVariables>(
    ActivityDocument,
    options,
  );
}
export type ActivityQueryHookResult = ReturnType<typeof useActivityQuery>;
export type ActivityLazyQueryHookResult = ReturnType<
  typeof useActivityLazyQuery
>;
export type ActivitySuspenseQueryHookResult = ReturnType<
  typeof useActivitySuspenseQuery
>;
export type ActivityQueryResult = Apollo.QueryResult<
  ActivityQuery,
  ActivityQueryVariables
>;
export const FetchActivityHabitInputDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FetchActivityHabitInput' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'date' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GraphQLDate' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchChallenge' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'challenge' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'HabitChallenge' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'challengeId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'activity' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'first' },
                                  value: { kind: 'IntValue', value: '1' },
                                },
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'from' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'date' },
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'activity' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'HabitDailyActivityInput',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'challengeHabits' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'habits' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'HabitBasicInfo',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'thumbnailImage',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'url',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'options',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'optionId',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'title',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitDailyActivityInput' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitDailyActivity' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tracked' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'HabitActivity' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitSelectionState' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Habit' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'habitId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'selected' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitBasicInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Habit' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'habitId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'selected' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Habit' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Habit' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'habitId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tradeCaptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'thumbnailImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'font' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'color' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hexCode' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tracked' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'HabitBasicInfo' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'HabitSelectionState' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OptionActivity' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitOptionActivity' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'option' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'optionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tracked' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitActivity' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitActivity' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'habit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Habit' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'optionActivity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OptionActivity' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFetchActivityHabitInputQuery__
 *
 * To run a query within a React component, call `useFetchActivityHabitInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchActivityHabitInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchActivityHabitInputQuery({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useFetchActivityHabitInputQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchActivityHabitInputQuery,
    FetchActivityHabitInputQueryVariables
  > &
    (
      | { variables: FetchActivityHabitInputQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchActivityHabitInputQuery,
    FetchActivityHabitInputQueryVariables
  >(FetchActivityHabitInputDocument, options);
}
export function useFetchActivityHabitInputLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchActivityHabitInputQuery,
    FetchActivityHabitInputQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchActivityHabitInputQuery,
    FetchActivityHabitInputQueryVariables
  >(FetchActivityHabitInputDocument, options);
}
// @ts-ignore
export function useFetchActivityHabitInputSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchActivityHabitInputQuery,
    FetchActivityHabitInputQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchActivityHabitInputQuery,
  FetchActivityHabitInputQueryVariables
>;
export function useFetchActivityHabitInputSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchActivityHabitInputQuery,
        FetchActivityHabitInputQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchActivityHabitInputQuery | undefined,
  FetchActivityHabitInputQueryVariables
>;
export function useFetchActivityHabitInputSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchActivityHabitInputQuery,
        FetchActivityHabitInputQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchActivityHabitInputQuery,
    FetchActivityHabitInputQueryVariables
  >(FetchActivityHabitInputDocument, options);
}
export type FetchActivityHabitInputQueryHookResult = ReturnType<
  typeof useFetchActivityHabitInputQuery
>;
export type FetchActivityHabitInputLazyQueryHookResult = ReturnType<
  typeof useFetchActivityHabitInputLazyQuery
>;
export type FetchActivityHabitInputSuspenseQueryHookResult = ReturnType<
  typeof useFetchActivityHabitInputSuspenseQuery
>;
export type FetchActivityHabitInputQueryResult = Apollo.QueryResult<
  FetchActivityHabitInputQuery,
  FetchActivityHabitInputQueryVariables
>;
export const UpdateActivityHabitInputDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateActivityHabitInput' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'habitId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'date' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'options' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: {
                    kind: 'Name',
                    value: 'UpdateHabitOptionActivityInput',
                  },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateHabitActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'request' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'challengeId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'habitId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'habitId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'date' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'date' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'habitOptions' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'options' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'updatedHabitActivityTotals' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'challengeTrackedActivityTotal',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'habitTrackedActivityTotal',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateActivityHabitInputMutationFn = Apollo.MutationFunction<
  UpdateActivityHabitInputMutation,
  UpdateActivityHabitInputMutationVariables
>;

/**
 * __useUpdateActivityHabitInputMutation__
 *
 * To run a mutation, you first call `useUpdateActivityHabitInputMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActivityHabitInputMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActivityHabitInputMutation, { data, loading, error }] = useUpdateActivityHabitInputMutation({
 *   variables: {
 *      id: // value for 'id'
 *      habitId: // value for 'habitId'
 *      date: // value for 'date'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useUpdateActivityHabitInputMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateActivityHabitInputMutation,
    UpdateActivityHabitInputMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateActivityHabitInputMutation,
    UpdateActivityHabitInputMutationVariables
  >(UpdateActivityHabitInputDocument, options);
}
export type UpdateActivityHabitInputMutationHookResult = ReturnType<
  typeof useUpdateActivityHabitInputMutation
>;
export type UpdateActivityHabitInputMutationResult =
  Apollo.MutationResult<UpdateActivityHabitInputMutation>;
export type UpdateActivityHabitInputMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateActivityHabitInputMutation,
    UpdateActivityHabitInputMutationVariables
  >;
export const RetakeIndividualChallengeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RetakeIndividualChallenge' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retakeIndividualChallenge' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'challenge' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'HabitChallenge' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'challengeId' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RetakeIndividualChallengeMutationFn = Apollo.MutationFunction<
  RetakeIndividualChallengeMutation,
  RetakeIndividualChallengeMutationVariables
>;

/**
 * __useRetakeIndividualChallengeMutation__
 *
 * To run a mutation, you first call `useRetakeIndividualChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetakeIndividualChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retakeIndividualChallengeMutation, { data, loading, error }] = useRetakeIndividualChallengeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRetakeIndividualChallengeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetakeIndividualChallengeMutation,
    RetakeIndividualChallengeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RetakeIndividualChallengeMutation,
    RetakeIndividualChallengeMutationVariables
  >(RetakeIndividualChallengeDocument, options);
}
export type RetakeIndividualChallengeMutationHookResult = ReturnType<
  typeof useRetakeIndividualChallengeMutation
>;
export type RetakeIndividualChallengeMutationResult =
  Apollo.MutationResult<RetakeIndividualChallengeMutation>;
export type RetakeIndividualChallengeMutationOptions =
  Apollo.BaseMutationOptions<
    RetakeIndividualChallengeMutation,
    RetakeIndividualChallengeMutationVariables
  >;
export const ActivityStepsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActivitySteps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'date' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GraphQLDate' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchChallenge' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'challenge' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'StepChallenge' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'challengeId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stepActivity' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'first' },
                                  value: { kind: 'IntValue', value: '1' },
                                },
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'from' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'date' },
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'activity' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'StepDailyActivityInput',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StepActivity' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepActivity' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emoji' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'durationInMs' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StepDailyActivityInput' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepDailyActivity' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tracked' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'StepActivity' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useActivityStepsQuery__
 *
 * To run a query within a React component, call `useActivityStepsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityStepsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityStepsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useActivityStepsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ActivityStepsQuery,
    ActivityStepsQueryVariables
  > &
    (
      | { variables: ActivityStepsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ActivityStepsQuery, ActivityStepsQueryVariables>(
    ActivityStepsDocument,
    options,
  );
}
export function useActivityStepsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActivityStepsQuery,
    ActivityStepsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ActivityStepsQuery, ActivityStepsQueryVariables>(
    ActivityStepsDocument,
    options,
  );
}
// @ts-ignore
export function useActivityStepsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ActivityStepsQuery,
    ActivityStepsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ActivityStepsQuery,
  ActivityStepsQueryVariables
>;
export function useActivityStepsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ActivityStepsQuery,
        ActivityStepsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ActivityStepsQuery | undefined,
  ActivityStepsQueryVariables
>;
export function useActivityStepsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ActivityStepsQuery,
        ActivityStepsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ActivityStepsQuery,
    ActivityStepsQueryVariables
  >(ActivityStepsDocument, options);
}
export type ActivityStepsQueryHookResult = ReturnType<
  typeof useActivityStepsQuery
>;
export type ActivityStepsLazyQueryHookResult = ReturnType<
  typeof useActivityStepsLazyQuery
>;
export type ActivityStepsSuspenseQueryHookResult = ReturnType<
  typeof useActivityStepsSuspenseQuery
>;
export type ActivityStepsQueryResult = Apollo.QueryResult<
  ActivityStepsQuery,
  ActivityStepsQueryVariables
>;
export const ActivityStepsResultDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActivityStepsResult' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'date' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GraphQLDate' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchChallenge' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'challenge' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'StepChallenge' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'result' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'ChallengeResult',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'challengeId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stepActivity' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'first' },
                                  value: { kind: 'IntValue', value: '1' },
                                },
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'from' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'date' },
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'summary' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'ActivitySummaryData',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActivitySummaryData' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EndOfChallengeSummaryTotal' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengeResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ChallengeResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pointsAwarded' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newTier' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tieringStatus' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useActivityStepsResultQuery__
 *
 * To run a query within a React component, call `useActivityStepsResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityStepsResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityStepsResultQuery({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useActivityStepsResultQuery(
  baseOptions: Apollo.QueryHookOptions<
    ActivityStepsResultQuery,
    ActivityStepsResultQueryVariables
  > &
    (
      | { variables: ActivityStepsResultQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ActivityStepsResultQuery,
    ActivityStepsResultQueryVariables
  >(ActivityStepsResultDocument, options);
}
export function useActivityStepsResultLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActivityStepsResultQuery,
    ActivityStepsResultQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ActivityStepsResultQuery,
    ActivityStepsResultQueryVariables
  >(ActivityStepsResultDocument, options);
}
// @ts-ignore
export function useActivityStepsResultSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ActivityStepsResultQuery,
    ActivityStepsResultQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ActivityStepsResultQuery,
  ActivityStepsResultQueryVariables
>;
export function useActivityStepsResultSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ActivityStepsResultQuery,
        ActivityStepsResultQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ActivityStepsResultQuery | undefined,
  ActivityStepsResultQueryVariables
>;
export function useActivityStepsResultSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ActivityStepsResultQuery,
        ActivityStepsResultQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ActivityStepsResultQuery,
    ActivityStepsResultQueryVariables
  >(ActivityStepsResultDocument, options);
}
export type ActivityStepsResultQueryHookResult = ReturnType<
  typeof useActivityStepsResultQuery
>;
export type ActivityStepsResultLazyQueryHookResult = ReturnType<
  typeof useActivityStepsResultLazyQuery
>;
export type ActivityStepsResultSuspenseQueryHookResult = ReturnType<
  typeof useActivityStepsResultSuspenseQuery
>;
export type ActivityStepsResultQueryResult = Apollo.QueryResult<
  ActivityStepsResultQuery,
  ActivityStepsResultQueryVariables
>;
export const FetchChallengePageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FetchChallengePage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchChallenge' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'challenge' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ChallengePage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengeIntroduction' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ChallengeIntroduction' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'info' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StepChallengeDateInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUploaded' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitChallengeDateInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengePage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Challenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'HabitChallenge' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participationType' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'introduction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ChallengeIntroduction' },
                      },
                    ],
                  },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'HabitChallengeDateInfo' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'StepChallenge' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participationType' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastUploaded' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'introduction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ChallengeIntroduction' },
                      },
                    ],
                  },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'StepChallengeDateInfo' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFetchChallengePageQuery__
 *
 * To run a query within a React component, call `useFetchChallengePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchChallengePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchChallengePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchChallengePageQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchChallengePageQuery,
    FetchChallengePageQueryVariables
  > &
    (
      | { variables: FetchChallengePageQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchChallengePageQuery,
    FetchChallengePageQueryVariables
  >(FetchChallengePageDocument, options);
}
export function useFetchChallengePageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchChallengePageQuery,
    FetchChallengePageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchChallengePageQuery,
    FetchChallengePageQueryVariables
  >(FetchChallengePageDocument, options);
}
// @ts-ignore
export function useFetchChallengePageSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchChallengePageQuery,
    FetchChallengePageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchChallengePageQuery,
  FetchChallengePageQueryVariables
>;
export function useFetchChallengePageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchChallengePageQuery,
        FetchChallengePageQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchChallengePageQuery | undefined,
  FetchChallengePageQueryVariables
>;
export function useFetchChallengePageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchChallengePageQuery,
        FetchChallengePageQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchChallengePageQuery,
    FetchChallengePageQueryVariables
  >(FetchChallengePageDocument, options);
}
export type FetchChallengePageQueryHookResult = ReturnType<
  typeof useFetchChallengePageQuery
>;
export type FetchChallengePageLazyQueryHookResult = ReturnType<
  typeof useFetchChallengePageLazyQuery
>;
export type FetchChallengePageSuspenseQueryHookResult = ReturnType<
  typeof useFetchChallengePageSuspenseQuery
>;
export type FetchChallengePageQueryResult = Apollo.QueryResult<
  FetchChallengePageQuery,
  FetchChallengePageQueryVariables
>;
export const FetchChallengeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FetchChallenge' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'from' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'GraphQLDate' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchChallenge' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'challenge' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ChallengePage' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'HabitChallengeBasicInfo',
                        },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'StepChallengeBasicInfo' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengeIntroduction' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ChallengeIntroduction' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'info' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StepChallengeDateInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUploaded' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StepChallengeListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categoryDisplayText' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'participationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stepActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaderboardIndividuals' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leaderboard' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'position' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StepChallengeBasicInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'StepChallengeListItem' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'introduction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ChallengeIntroduction' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'StepChallengeDateInfo' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitBasicInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Habit' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'habitId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'selected' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitChallengeDateInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengePage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Challenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'HabitChallenge' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participationType' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'introduction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ChallengeIntroduction' },
                      },
                    ],
                  },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'HabitChallengeDateInfo' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'StepChallenge' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participationType' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastUploaded' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'introduction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ChallengeIntroduction' },
                      },
                    ],
                  },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'StepChallengeDateInfo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitChallengeListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categoryDisplayText' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'participationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'from' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'from' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaderboardIndividuals' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leaderboard' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'position' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitChallengeBasicInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'templateId' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'HabitChallengeListItem' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'introduction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ChallengeIntroduction' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'challengeHabits' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editSelectedHabits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subtitle' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selectHabit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'habits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'HabitBasicInfo' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'HabitChallengeDateInfo' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFetchChallengeQuery__
 *
 * To run a query within a React component, call `useFetchChallengeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchChallengeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchChallengeQuery({
 *   variables: {
 *      from: // value for 'from'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchChallengeQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchChallengeQuery,
    FetchChallengeQueryVariables
  > &
    (
      | { variables: FetchChallengeQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FetchChallengeQuery, FetchChallengeQueryVariables>(
    FetchChallengeDocument,
    options,
  );
}
export function useFetchChallengeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchChallengeQuery,
    FetchChallengeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FetchChallengeQuery, FetchChallengeQueryVariables>(
    FetchChallengeDocument,
    options,
  );
}
// @ts-ignore
export function useFetchChallengeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchChallengeQuery,
    FetchChallengeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchChallengeQuery,
  FetchChallengeQueryVariables
>;
export function useFetchChallengeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchChallengeQuery,
        FetchChallengeQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchChallengeQuery | undefined,
  FetchChallengeQueryVariables
>;
export function useFetchChallengeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchChallengeQuery,
        FetchChallengeQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchChallengeQuery,
    FetchChallengeQueryVariables
  >(FetchChallengeDocument, options);
}
export type FetchChallengeQueryHookResult = ReturnType<
  typeof useFetchChallengeQuery
>;
export type FetchChallengeLazyQueryHookResult = ReturnType<
  typeof useFetchChallengeLazyQuery
>;
export type FetchChallengeSuspenseQueryHookResult = ReturnType<
  typeof useFetchChallengeSuspenseQuery
>;
export type FetchChallengeQueryResult = Apollo.QueryResult<
  FetchChallengeQuery,
  FetchChallengeQueryVariables
>;
export const JoinTeamDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'JoinTeam' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'challengeId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'teamId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'joinChallengeTeam' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'request' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'teamId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'challengeId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'challengeId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'joinedTeam' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reasonNotJoined' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ChallengeTeam' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamUserPermissions' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamPermissions' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canCreateATeam' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canChangeTeamName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canChangeTeamImage' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canRemoveTeamImage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isTeamAdmin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'membershipPrompt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengeTeam' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Team' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TeamUserPermissions' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type JoinTeamMutationFn = Apollo.MutationFunction<
  JoinTeamMutation,
  JoinTeamMutationVariables
>;

/**
 * __useJoinTeamMutation__
 *
 * To run a mutation, you first call `useJoinTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinTeamMutation, { data, loading, error }] = useJoinTeamMutation({
 *   variables: {
 *      challengeId: // value for 'challengeId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useJoinTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    JoinTeamMutation,
    JoinTeamMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<JoinTeamMutation, JoinTeamMutationVariables>(
    JoinTeamDocument,
    options,
  );
}
export type JoinTeamMutationHookResult = ReturnType<typeof useJoinTeamMutation>;
export type JoinTeamMutationResult = Apollo.MutationResult<JoinTeamMutation>;
export type JoinTeamMutationOptions = Apollo.BaseMutationOptions<
  JoinTeamMutation,
  JoinTeamMutationVariables
>;
export const LeaveTeamDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'LeaveTeam' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'challengeId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'teamId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaveChallengeTeam' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'request' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'challengeId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'challengeId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'teamId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ChallengeTeam' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'departedTeam' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reasonNotDeparted' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamUserPermissions' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamPermissions' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canCreateATeam' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canChangeTeamName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canChangeTeamImage' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canRemoveTeamImage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isTeamAdmin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'membershipPrompt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengeTeam' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Team' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TeamUserPermissions' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type LeaveTeamMutationFn = Apollo.MutationFunction<
  LeaveTeamMutation,
  LeaveTeamMutationVariables
>;

/**
 * __useLeaveTeamMutation__
 *
 * To run a mutation, you first call `useLeaveTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveTeamMutation, { data, loading, error }] = useLeaveTeamMutation({
 *   variables: {
 *      challengeId: // value for 'challengeId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useLeaveTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LeaveTeamMutation,
    LeaveTeamMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LeaveTeamMutation, LeaveTeamMutationVariables>(
    LeaveTeamDocument,
    options,
  );
}
export type LeaveTeamMutationHookResult = ReturnType<
  typeof useLeaveTeamMutation
>;
export type LeaveTeamMutationResult = Apollo.MutationResult<LeaveTeamMutation>;
export type LeaveTeamMutationOptions = Apollo.BaseMutationOptions<
  LeaveTeamMutation,
  LeaveTeamMutationVariables
>;
export const UpdateChallengeTeamNameDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateChallengeTeamName' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'challengeId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'teamId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'teamName' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateChallengeTeamName' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'request' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'challengeId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'challengeId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'teamId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'teamName' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'teamName' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ChallengeTeam' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamUserPermissions' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamPermissions' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canCreateATeam' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canChangeTeamName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canChangeTeamImage' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canRemoveTeamImage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isTeamAdmin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'membershipPrompt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengeTeam' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Team' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TeamUserPermissions' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateChallengeTeamNameMutationFn = Apollo.MutationFunction<
  UpdateChallengeTeamNameMutation,
  UpdateChallengeTeamNameMutationVariables
>;

/**
 * __useUpdateChallengeTeamNameMutation__
 *
 * To run a mutation, you first call `useUpdateChallengeTeamNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChallengeTeamNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChallengeTeamNameMutation, { data, loading, error }] = useUpdateChallengeTeamNameMutation({
 *   variables: {
 *      challengeId: // value for 'challengeId'
 *      teamId: // value for 'teamId'
 *      teamName: // value for 'teamName'
 *   },
 * });
 */
export function useUpdateChallengeTeamNameMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateChallengeTeamNameMutation,
    UpdateChallengeTeamNameMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateChallengeTeamNameMutation,
    UpdateChallengeTeamNameMutationVariables
  >(UpdateChallengeTeamNameDocument, options);
}
export type UpdateChallengeTeamNameMutationHookResult = ReturnType<
  typeof useUpdateChallengeTeamNameMutation
>;
export type UpdateChallengeTeamNameMutationResult =
  Apollo.MutationResult<UpdateChallengeTeamNameMutation>;
export type UpdateChallengeTeamNameMutationOptions = Apollo.BaseMutationOptions<
  UpdateChallengeTeamNameMutation,
  UpdateChallengeTeamNameMutationVariables
>;
export const RemoveChallengeTeamImageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemoveChallengeTeamImage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'request' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RemoveChallengeTeamImageInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeChallengeTeamImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'request' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'request' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ChallengeTeam' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamUserPermissions' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamPermissions' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canCreateATeam' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canChangeTeamName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canChangeTeamImage' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canRemoveTeamImage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isTeamAdmin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'membershipPrompt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengeTeam' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Team' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TeamUserPermissions' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RemoveChallengeTeamImageMutationFn = Apollo.MutationFunction<
  RemoveChallengeTeamImageMutation,
  RemoveChallengeTeamImageMutationVariables
>;

/**
 * __useRemoveChallengeTeamImageMutation__
 *
 * To run a mutation, you first call `useRemoveChallengeTeamImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveChallengeTeamImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeChallengeTeamImageMutation, { data, loading, error }] = useRemoveChallengeTeamImageMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useRemoveChallengeTeamImageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveChallengeTeamImageMutation,
    RemoveChallengeTeamImageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveChallengeTeamImageMutation,
    RemoveChallengeTeamImageMutationVariables
  >(RemoveChallengeTeamImageDocument, options);
}
export type RemoveChallengeTeamImageMutationHookResult = ReturnType<
  typeof useRemoveChallengeTeamImageMutation
>;
export type RemoveChallengeTeamImageMutationResult =
  Apollo.MutationResult<RemoveChallengeTeamImageMutation>;
export type RemoveChallengeTeamImageMutationOptions =
  Apollo.BaseMutationOptions<
    RemoveChallengeTeamImageMutation,
    RemoveChallengeTeamImageMutationVariables
  >;
export const JoinChallengeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'JoinChallenge' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'joinChallenge' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'challenge' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ChallengeJoined' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ChallengeJoinedStep' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengeJoined' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengeJoinedStep' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type JoinChallengeMutationFn = Apollo.MutationFunction<
  JoinChallengeMutation,
  JoinChallengeMutationVariables
>;

/**
 * __useJoinChallengeMutation__
 *
 * To run a mutation, you first call `useJoinChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinChallengeMutation, { data, loading, error }] = useJoinChallengeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJoinChallengeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    JoinChallengeMutation,
    JoinChallengeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    JoinChallengeMutation,
    JoinChallengeMutationVariables
  >(JoinChallengeDocument, options);
}
export type JoinChallengeMutationHookResult = ReturnType<
  typeof useJoinChallengeMutation
>;
export type JoinChallengeMutationResult =
  Apollo.MutationResult<JoinChallengeMutation>;
export type JoinChallengeMutationOptions = Apollo.BaseMutationOptions<
  JoinChallengeMutation,
  JoinChallengeMutationVariables
>;
export const SelectHabitsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SelectHabits' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'challengeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'templateId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'habits' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'SelectHabitsData' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectHabits' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'request' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'habits' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'habits' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'challengeId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'challengeId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'templateId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'templateId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'habits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'HabitSelectionState' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitSelectionState' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Habit' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'habitId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'selected' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SelectHabitsMutationFn = Apollo.MutationFunction<
  SelectHabitsMutation,
  SelectHabitsMutationVariables
>;

/**
 * __useSelectHabitsMutation__
 *
 * To run a mutation, you first call `useSelectHabitsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectHabitsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectHabitsMutation, { data, loading, error }] = useSelectHabitsMutation({
 *   variables: {
 *      challengeId: // value for 'challengeId'
 *      templateId: // value for 'templateId'
 *      habits: // value for 'habits'
 *   },
 * });
 */
export function useSelectHabitsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SelectHabitsMutation,
    SelectHabitsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SelectHabitsMutation,
    SelectHabitsMutationVariables
  >(SelectHabitsDocument, options);
}
export type SelectHabitsMutationHookResult = ReturnType<
  typeof useSelectHabitsMutation
>;
export type SelectHabitsMutationResult =
  Apollo.MutationResult<SelectHabitsMutation>;
export type SelectHabitsMutationOptions = Apollo.BaseMutationOptions<
  SelectHabitsMutation,
  SelectHabitsMutationVariables
>;
export const ChallengesHubPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ChallengesHubPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'from' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'GraphQLDate' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'challenges' },
            name: { kind: 'Name', value: 'fetchChallenges' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          { kind: 'EnumValue', value: 'NotStarted' },
                          { kind: 'EnumValue', value: 'InProgress' },
                          { kind: 'EnumValue', value: 'Completed' },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'HubList' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengeIntroduction' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ChallengeIntroduction' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'info' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StepChallengeDateInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUploaded' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StepChallengeListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categoryDisplayText' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'participationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stepActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaderboardIndividuals' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leaderboard' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'position' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitChallengeDateInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengePage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Challenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'HabitChallenge' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participationType' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'introduction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ChallengeIntroduction' },
                      },
                    ],
                  },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'HabitChallengeDateInfo' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'StepChallenge' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participationType' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastUploaded' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'introduction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ChallengeIntroduction' },
                      },
                    ],
                  },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'StepChallengeDateInfo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitChallengeListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categoryDisplayText' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'participationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'from' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'from' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaderboardIndividuals' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leaderboard' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'position' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HubList' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'fetchChallengesResponse' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'challenges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ChallengePage' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'StepChallengeListItem' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'HabitChallengeListItem' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useChallengesHubPageQuery__
 *
 * To run a query within a React component, call `useChallengesHubPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useChallengesHubPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChallengesHubPageQuery({
 *   variables: {
 *      from: // value for 'from'
 *   },
 * });
 */
export function useChallengesHubPageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ChallengesHubPageQuery,
    ChallengesHubPageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ChallengesHubPageQuery,
    ChallengesHubPageQueryVariables
  >(ChallengesHubPageDocument, options);
}
export function useChallengesHubPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChallengesHubPageQuery,
    ChallengesHubPageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ChallengesHubPageQuery,
    ChallengesHubPageQueryVariables
  >(ChallengesHubPageDocument, options);
}
// @ts-ignore
export function useChallengesHubPageSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ChallengesHubPageQuery,
    ChallengesHubPageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ChallengesHubPageQuery,
  ChallengesHubPageQueryVariables
>;
export function useChallengesHubPageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChallengesHubPageQuery,
        ChallengesHubPageQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ChallengesHubPageQuery | undefined,
  ChallengesHubPageQueryVariables
>;
export function useChallengesHubPageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChallengesHubPageQuery,
        ChallengesHubPageQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ChallengesHubPageQuery,
    ChallengesHubPageQueryVariables
  >(ChallengesHubPageDocument, options);
}
export type ChallengesHubPageQueryHookResult = ReturnType<
  typeof useChallengesHubPageQuery
>;
export type ChallengesHubPageLazyQueryHookResult = ReturnType<
  typeof useChallengesHubPageLazyQuery
>;
export type ChallengesHubPageSuspenseQueryHookResult = ReturnType<
  typeof useChallengesHubPageSuspenseQuery
>;
export type ChallengesHubPageQueryResult = Apollo.QueryResult<
  ChallengesHubPageQuery,
  ChallengesHubPageQueryVariables
>;
export const LeaderboardIndividualDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LeaderboardIndividual' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchChallenge' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'challenge' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'StepChallenge' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'challengeId' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'leaderboardIndividuals',
                              },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'afterCursor' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'after' },
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pagination' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'Pagination',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'leaderboard',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'LeaderboardIndividual',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'HabitChallenge' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'challengeId' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'leaderboardIndividuals',
                              },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'afterCursor' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'after' },
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pagination' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'Pagination',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'leaderboard',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'LeaderboardIndividual',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Pagination' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Pagination' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isLastPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cursors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LeaderboardUser' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LeaderboardIndividual' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'IndividualsLeaderboardEntry' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LeaderboardUser' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useLeaderboardIndividualQuery__
 *
 * To run a query within a React component, call `useLeaderboardIndividualQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeaderboardIndividualQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeaderboardIndividualQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useLeaderboardIndividualQuery(
  baseOptions: Apollo.QueryHookOptions<
    LeaderboardIndividualQuery,
    LeaderboardIndividualQueryVariables
  > &
    (
      | { variables: LeaderboardIndividualQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LeaderboardIndividualQuery,
    LeaderboardIndividualQueryVariables
  >(LeaderboardIndividualDocument, options);
}
export function useLeaderboardIndividualLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LeaderboardIndividualQuery,
    LeaderboardIndividualQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LeaderboardIndividualQuery,
    LeaderboardIndividualQueryVariables
  >(LeaderboardIndividualDocument, options);
}
// @ts-ignore
export function useLeaderboardIndividualSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LeaderboardIndividualQuery,
    LeaderboardIndividualQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LeaderboardIndividualQuery,
  LeaderboardIndividualQueryVariables
>;
export function useLeaderboardIndividualSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LeaderboardIndividualQuery,
        LeaderboardIndividualQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LeaderboardIndividualQuery | undefined,
  LeaderboardIndividualQueryVariables
>;
export function useLeaderboardIndividualSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LeaderboardIndividualQuery,
        LeaderboardIndividualQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LeaderboardIndividualQuery,
    LeaderboardIndividualQueryVariables
  >(LeaderboardIndividualDocument, options);
}
export type LeaderboardIndividualQueryHookResult = ReturnType<
  typeof useLeaderboardIndividualQuery
>;
export type LeaderboardIndividualLazyQueryHookResult = ReturnType<
  typeof useLeaderboardIndividualLazyQuery
>;
export type LeaderboardIndividualSuspenseQueryHookResult = ReturnType<
  typeof useLeaderboardIndividualSuspenseQuery
>;
export type LeaderboardIndividualQueryResult = Apollo.QueryResult<
  LeaderboardIndividualQuery,
  LeaderboardIndividualQueryVariables
>;
export const LeaderboardTeamDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LeaderboardTeam' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchChallenge' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'challenge' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'StepChallenge' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'challengeId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'leaderboardTeams' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'afterCursor' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'after' },
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pagination' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'Pagination',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'leaderboard',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'TeamsLeaderboardListItem',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'userTeamMembership',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'canCreateATeam',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'HabitChallenge' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'challengeId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'leaderboardTeams' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'afterCursor' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'after' },
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pagination' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'Pagination',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'leaderboard',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'TeamsLeaderboardListItem',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'userTeamMembership',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'canCreateATeam',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamUserPermissions' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamPermissions' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canCreateATeam' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canChangeTeamName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canChangeTeamImage' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canRemoveTeamImage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isTeamAdmin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'membershipPrompt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengeTeam' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Team' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TeamUserPermissions' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Pagination' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Pagination' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isLastPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cursors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamsLeaderboardListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamsLeaderboardEntry' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'team' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ChallengeTeam' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useLeaderboardTeamQuery__
 *
 * To run a query within a React component, call `useLeaderboardTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeaderboardTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeaderboardTeamQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useLeaderboardTeamQuery(
  baseOptions: Apollo.QueryHookOptions<
    LeaderboardTeamQuery,
    LeaderboardTeamQueryVariables
  > &
    (
      | { variables: LeaderboardTeamQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LeaderboardTeamQuery, LeaderboardTeamQueryVariables>(
    LeaderboardTeamDocument,
    options,
  );
}
export function useLeaderboardTeamLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LeaderboardTeamQuery,
    LeaderboardTeamQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LeaderboardTeamQuery,
    LeaderboardTeamQueryVariables
  >(LeaderboardTeamDocument, options);
}
// @ts-ignore
export function useLeaderboardTeamSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LeaderboardTeamQuery,
    LeaderboardTeamQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LeaderboardTeamQuery,
  LeaderboardTeamQueryVariables
>;
export function useLeaderboardTeamSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LeaderboardTeamQuery,
        LeaderboardTeamQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LeaderboardTeamQuery | undefined,
  LeaderboardTeamQueryVariables
>;
export function useLeaderboardTeamSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LeaderboardTeamQuery,
        LeaderboardTeamQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LeaderboardTeamQuery,
    LeaderboardTeamQueryVariables
  >(LeaderboardTeamDocument, options);
}
export type LeaderboardTeamQueryHookResult = ReturnType<
  typeof useLeaderboardTeamQuery
>;
export type LeaderboardTeamLazyQueryHookResult = ReturnType<
  typeof useLeaderboardTeamLazyQuery
>;
export type LeaderboardTeamSuspenseQueryHookResult = ReturnType<
  typeof useLeaderboardTeamSuspenseQuery
>;
export type LeaderboardTeamQueryResult = Apollo.QueryResult<
  LeaderboardTeamQuery,
  LeaderboardTeamQueryVariables
>;
export const LeaveChallengeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'LeaveChallenge' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaveChallenge' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'challenge' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ChallengeStatus' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengeStatus' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Challenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'HabitChallenge' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'StepChallenge' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type LeaveChallengeMutationFn = Apollo.MutationFunction<
  LeaveChallengeMutation,
  LeaveChallengeMutationVariables
>;

/**
 * __useLeaveChallengeMutation__
 *
 * To run a mutation, you first call `useLeaveChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveChallengeMutation, { data, loading, error }] = useLeaveChallengeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLeaveChallengeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LeaveChallengeMutation,
    LeaveChallengeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    LeaveChallengeMutation,
    LeaveChallengeMutationVariables
  >(LeaveChallengeDocument, options);
}
export type LeaveChallengeMutationHookResult = ReturnType<
  typeof useLeaveChallengeMutation
>;
export type LeaveChallengeMutationResult =
  Apollo.MutationResult<LeaveChallengeMutation>;
export type LeaveChallengeMutationOptions = Apollo.BaseMutationOptions<
  LeaveChallengeMutation,
  LeaveChallengeMutationVariables
>;
export const TeamCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TeamCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createChallengeTeam' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'request' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'challengeId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'teamName' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'name' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type TeamCreateMutationFn = Apollo.MutationFunction<
  TeamCreateMutation,
  TeamCreateMutationVariables
>;

/**
 * __useTeamCreateMutation__
 *
 * To run a mutation, you first call `useTeamCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeamCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teamCreateMutation, { data, loading, error }] = useTeamCreateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useTeamCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TeamCreateMutation,
    TeamCreateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TeamCreateMutation, TeamCreateMutationVariables>(
    TeamCreateDocument,
    options,
  );
}
export type TeamCreateMutationHookResult = ReturnType<
  typeof useTeamCreateMutation
>;
export type TeamCreateMutationResult =
  Apollo.MutationResult<TeamCreateMutation>;
export type TeamCreateMutationOptions = Apollo.BaseMutationOptions<
  TeamCreateMutation,
  TeamCreateMutationVariables
>;
export const TeamMembersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TeamMembers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'afterCursor' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'challengeId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchChallengeTeam' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ChallengeTeam' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leaderboardTeamMembers' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'challengeId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'challengeId' },
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'afterCursor' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'afterCursor' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamLeaderboard' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamUserPermissions' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamPermissions' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canCreateATeam' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canChangeTeamName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canChangeTeamImage' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canRemoveTeamImage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isTeamAdmin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'membershipPrompt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengeTeam' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Team' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TeamUserPermissions' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Pagination' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Pagination' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isLastPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cursors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamMember' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamLeaderboard' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LeaderboardTeamMembersResponse' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaderboard' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamMember' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pagination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Pagination' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTeamMembersQuery__
 *
 * To run a query within a React component, call `useTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamMembersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      afterCursor: // value for 'afterCursor'
 *      challengeId: // value for 'challengeId'
 *   },
 * });
 */
export function useTeamMembersQuery(
  baseOptions: Apollo.QueryHookOptions<
    TeamMembersQuery,
    TeamMembersQueryVariables
  > &
    (
      | { variables: TeamMembersQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TeamMembersQuery, TeamMembersQueryVariables>(
    TeamMembersDocument,
    options,
  );
}
export function useTeamMembersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TeamMembersQuery,
    TeamMembersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TeamMembersQuery, TeamMembersQueryVariables>(
    TeamMembersDocument,
    options,
  );
}
// @ts-ignore
export function useTeamMembersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TeamMembersQuery,
    TeamMembersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<TeamMembersQuery, TeamMembersQueryVariables>;
export function useTeamMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TeamMembersQuery,
        TeamMembersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TeamMembersQuery | undefined,
  TeamMembersQueryVariables
>;
export function useTeamMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TeamMembersQuery,
        TeamMembersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TeamMembersQuery, TeamMembersQueryVariables>(
    TeamMembersDocument,
    options,
  );
}
export type TeamMembersQueryHookResult = ReturnType<typeof useTeamMembersQuery>;
export type TeamMembersLazyQueryHookResult = ReturnType<
  typeof useTeamMembersLazyQuery
>;
export type TeamMembersSuspenseQueryHookResult = ReturnType<
  typeof useTeamMembersSuspenseQuery
>;
export type TeamMembersQueryResult = Apollo.QueryResult<
  TeamMembersQuery,
  TeamMembersQueryVariables
>;
export const ChallengeHubDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ChallengeHub' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'challenges' },
            name: { kind: 'Name', value: 'fetchChallenges' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          { kind: 'EnumValue', value: 'NotStarted' },
                          { kind: 'EnumValue', value: 'InProgress' },
                          { kind: 'EnumValue', value: 'Completed' },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ChallengeHubList' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengeHubList' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'fetchChallengesResponse' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'challenges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'StepChallenge' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'challengeId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'participationType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'wasJoined' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startDateTimeISO' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endDateTimeISO' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HabitChallenge' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'challengeId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'participationType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'wasJoined' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startDateTimeISO' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endDateTimeISO' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useChallengeHubQuery__
 *
 * To run a query within a React component, call `useChallengeHubQuery` and pass it any options that fit your needs.
 * When your component renders, `useChallengeHubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChallengeHubQuery({
 *   variables: {
 *   },
 * });
 */
export function useChallengeHubQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ChallengeHubQuery,
    ChallengeHubQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChallengeHubQuery, ChallengeHubQueryVariables>(
    ChallengeHubDocument,
    options,
  );
}
export function useChallengeHubLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChallengeHubQuery,
    ChallengeHubQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChallengeHubQuery, ChallengeHubQueryVariables>(
    ChallengeHubDocument,
    options,
  );
}
// @ts-ignore
export function useChallengeHubSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ChallengeHubQuery,
    ChallengeHubQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ChallengeHubQuery, ChallengeHubQueryVariables>;
export function useChallengeHubSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChallengeHubQuery,
        ChallengeHubQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ChallengeHubQuery | undefined,
  ChallengeHubQueryVariables
>;
export function useChallengeHubSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChallengeHubQuery,
        ChallengeHubQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ChallengeHubQuery, ChallengeHubQueryVariables>(
    ChallengeHubDocument,
    options,
  );
}
export type ChallengeHubQueryHookResult = ReturnType<
  typeof useChallengeHubQuery
>;
export type ChallengeHubLazyQueryHookResult = ReturnType<
  typeof useChallengeHubLazyQuery
>;
export type ChallengeHubSuspenseQueryHookResult = ReturnType<
  typeof useChallengeHubSuspenseQuery
>;
export type ChallengeHubQueryResult = Apollo.QueryResult<
  ChallengeHubQuery,
  ChallengeHubQueryVariables
>;
export const ReportContentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReportContent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReportInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ReportContentMutationFn = Apollo.MutationFunction<
  ReportContentMutation,
  ReportContentMutationVariables
>;

/**
 * __useReportContentMutation__
 *
 * To run a mutation, you first call `useReportContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportContentMutation, { data, loading, error }] = useReportContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportContentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReportContentMutation,
    ReportContentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ReportContentMutation,
    ReportContentMutationVariables
  >(ReportContentDocument, options);
}
export type ReportContentMutationHookResult = ReturnType<
  typeof useReportContentMutation
>;
export type ReportContentMutationResult =
  Apollo.MutationResult<ReportContentMutation>;
export type ReportContentMutationOptions = Apollo.BaseMutationOptions<
  ReportContentMutation,
  ReportContentMutationVariables
>;
export const SubmitGlobalIntakeAppointmentRequestDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'submitGlobalIntakeAppointmentRequest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'GlobalIntakeAppointmentRequestInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'submitGlobalIntakeAppointmentRequest',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SubmitGlobalIntakeRequest' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SubmitGlobalIntakeRequest' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GlobalIntakeAppointmentRequestResponse' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preferredDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preferredMeridiem' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SubmitGlobalIntakeAppointmentRequestMutationFn =
  Apollo.MutationFunction<
    SubmitGlobalIntakeAppointmentRequestMutation,
    SubmitGlobalIntakeAppointmentRequestMutationVariables
  >;

/**
 * __useSubmitGlobalIntakeAppointmentRequestMutation__
 *
 * To run a mutation, you first call `useSubmitGlobalIntakeAppointmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitGlobalIntakeAppointmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitGlobalIntakeAppointmentRequestMutation, { data, loading, error }] = useSubmitGlobalIntakeAppointmentRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitGlobalIntakeAppointmentRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitGlobalIntakeAppointmentRequestMutation,
    SubmitGlobalIntakeAppointmentRequestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitGlobalIntakeAppointmentRequestMutation,
    SubmitGlobalIntakeAppointmentRequestMutationVariables
  >(SubmitGlobalIntakeAppointmentRequestDocument, options);
}
export type SubmitGlobalIntakeAppointmentRequestMutationHookResult = ReturnType<
  typeof useSubmitGlobalIntakeAppointmentRequestMutation
>;
export type SubmitGlobalIntakeAppointmentRequestMutationResult =
  Apollo.MutationResult<SubmitGlobalIntakeAppointmentRequestMutation>;
export type SubmitGlobalIntakeAppointmentRequestMutationOptions =
  Apollo.BaseMutationOptions<
    SubmitGlobalIntakeAppointmentRequestMutation,
    SubmitGlobalIntakeAppointmentRequestMutationVariables
  >;
export const InterestsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Interests' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interests' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'focused' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'icon' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'interests' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'selected' },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useInterestsQuery__
 *
 * To run a query within a React component, call `useInterestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInterestsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    InterestsQuery,
    InterestsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InterestsQuery, InterestsQueryVariables>(
    InterestsDocument,
    options,
  );
}
export function useInterestsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InterestsQuery,
    InterestsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InterestsQuery, InterestsQueryVariables>(
    InterestsDocument,
    options,
  );
}
// @ts-ignore
export function useInterestsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    InterestsQuery,
    InterestsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<InterestsQuery, InterestsQueryVariables>;
export function useInterestsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<InterestsQuery, InterestsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  InterestsQuery | undefined,
  InterestsQueryVariables
>;
export function useInterestsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<InterestsQuery, InterestsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<InterestsQuery, InterestsQueryVariables>(
    InterestsDocument,
    options,
  );
}
export type InterestsQueryHookResult = ReturnType<typeof useInterestsQuery>;
export type InterestsLazyQueryHookResult = ReturnType<
  typeof useInterestsLazyQuery
>;
export type InterestsSuspenseQueryHookResult = ReturnType<
  typeof useInterestsSuspenseQuery
>;
export type InterestsQueryResult = Apollo.QueryResult<
  InterestsQuery,
  InterestsQueryVariables
>;
export const RecommendationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Recommendations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'recommendationsInput2' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RecommendationsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'recommendationsInput2' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recommendations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'data' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'payload' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {
                                        kind: 'Name',
                                        value: 'DigitalClinicalProgramListItem',
                                      },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value:
                                              'DigitalClinicalProgramListItemFields',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paging' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isLastPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'limit' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cursors' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'after' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'before' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DigitalClinicalProgramListItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalProgramListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'programId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'programType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'progress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalModules' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedModules' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'percentageComplete' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'remainingModules' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isLite' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useRecommendationsQuery__
 *
 * To run a query within a React component, call `useRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendationsQuery({
 *   variables: {
 *      recommendationsInput2: // value for 'recommendationsInput2'
 *   },
 * });
 */
export function useRecommendationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    RecommendationsQuery,
    RecommendationsQueryVariables
  > &
    (
      | { variables: RecommendationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RecommendationsQuery, RecommendationsQueryVariables>(
    RecommendationsDocument,
    options,
  );
}
export function useRecommendationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RecommendationsQuery,
    RecommendationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RecommendationsQuery,
    RecommendationsQueryVariables
  >(RecommendationsDocument, options);
}
// @ts-ignore
export function useRecommendationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RecommendationsQuery,
    RecommendationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RecommendationsQuery,
  RecommendationsQueryVariables
>;
export function useRecommendationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RecommendationsQuery,
        RecommendationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RecommendationsQuery | undefined,
  RecommendationsQueryVariables
>;
export function useRecommendationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RecommendationsQuery,
        RecommendationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    RecommendationsQuery,
    RecommendationsQueryVariables
  >(RecommendationsDocument, options);
}
export type RecommendationsQueryHookResult = ReturnType<
  typeof useRecommendationsQuery
>;
export type RecommendationsLazyQueryHookResult = ReturnType<
  typeof useRecommendationsLazyQuery
>;
export type RecommendationsSuspenseQueryHookResult = ReturnType<
  typeof useRecommendationsSuspenseQuery
>;
export type RecommendationsQueryResult = Apollo.QueryResult<
  RecommendationsQuery,
  RecommendationsQueryVariables
>;
export const SelectInterestsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SelectInterests' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SelectInterestsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectInterests' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'immediateRecommendation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'payload' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'DigitalClinicalProgramListItem',
                                },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value:
                                        'DigitalClinicalProgramListItemFields',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DigitalClinicalProgramListItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalProgramListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'programId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'programType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'progress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalModules' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedModules' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'percentageComplete' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'remainingModules' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isLite' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SelectInterestsMutationFn = Apollo.MutationFunction<
  SelectInterestsMutation,
  SelectInterestsMutationVariables
>;

/**
 * __useSelectInterestsMutation__
 *
 * To run a mutation, you first call `useSelectInterestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectInterestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectInterestsMutation, { data, loading, error }] = useSelectInterestsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelectInterestsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SelectInterestsMutation,
    SelectInterestsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SelectInterestsMutation,
    SelectInterestsMutationVariables
  >(SelectInterestsDocument, options);
}
export type SelectInterestsMutationHookResult = ReturnType<
  typeof useSelectInterestsMutation
>;
export type SelectInterestsMutationResult =
  Apollo.MutationResult<SelectInterestsMutation>;
export type SelectInterestsMutationOptions = Apollo.BaseMutationOptions<
  SelectInterestsMutation,
  SelectInterestsMutationVariables
>;
export const JournalEntriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'JournalEntries' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'JournalEntriesInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'journalEntries' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paging' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isLastPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cursors' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'after' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'data' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'JournalingEntry' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JournalingEntry' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JournalEntry' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useJournalEntriesQuery__
 *
 * To run a query within a React component, call `useJournalEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useJournalEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJournalEntriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJournalEntriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    JournalEntriesQuery,
    JournalEntriesQueryVariables
  > &
    (
      | { variables: JournalEntriesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<JournalEntriesQuery, JournalEntriesQueryVariables>(
    JournalEntriesDocument,
    options,
  );
}
export function useJournalEntriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    JournalEntriesQuery,
    JournalEntriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<JournalEntriesQuery, JournalEntriesQueryVariables>(
    JournalEntriesDocument,
    options,
  );
}
// @ts-ignore
export function useJournalEntriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    JournalEntriesQuery,
    JournalEntriesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  JournalEntriesQuery,
  JournalEntriesQueryVariables
>;
export function useJournalEntriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        JournalEntriesQuery,
        JournalEntriesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  JournalEntriesQuery | undefined,
  JournalEntriesQueryVariables
>;
export function useJournalEntriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        JournalEntriesQuery,
        JournalEntriesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    JournalEntriesQuery,
    JournalEntriesQueryVariables
  >(JournalEntriesDocument, options);
}
export type JournalEntriesQueryHookResult = ReturnType<
  typeof useJournalEntriesQuery
>;
export type JournalEntriesLazyQueryHookResult = ReturnType<
  typeof useJournalEntriesLazyQuery
>;
export type JournalEntriesSuspenseQueryHookResult = ReturnType<
  typeof useJournalEntriesSuspenseQuery
>;
export type JournalEntriesQueryResult = Apollo.QueryResult<
  JournalEntriesQuery,
  JournalEntriesQueryVariables
>;
export const DeleteJournalEntryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteJournalEntry' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteJournalEntryInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteJournalEntry' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'received' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeleteJournalEntryMutationFn = Apollo.MutationFunction<
  DeleteJournalEntryMutation,
  DeleteJournalEntryMutationVariables
>;

/**
 * __useDeleteJournalEntryMutation__
 *
 * To run a mutation, you first call `useDeleteJournalEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJournalEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJournalEntryMutation, { data, loading, error }] = useDeleteJournalEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteJournalEntryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteJournalEntryMutation,
    DeleteJournalEntryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteJournalEntryMutation,
    DeleteJournalEntryMutationVariables
  >(DeleteJournalEntryDocument, options);
}
export type DeleteJournalEntryMutationHookResult = ReturnType<
  typeof useDeleteJournalEntryMutation
>;
export type DeleteJournalEntryMutationResult =
  Apollo.MutationResult<DeleteJournalEntryMutation>;
export type DeleteJournalEntryMutationOptions = Apollo.BaseMutationOptions<
  DeleteJournalEntryMutation,
  DeleteJournalEntryMutationVariables
>;
export const EditJournalEntryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EditJournalEntry' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'EditJournalEntryInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'editJournalEntry' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entry' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'JournalingEntry' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JournalingEntry' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JournalEntry' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type EditJournalEntryMutationFn = Apollo.MutationFunction<
  EditJournalEntryMutation,
  EditJournalEntryMutationVariables
>;

/**
 * __useEditJournalEntryMutation__
 *
 * To run a mutation, you first call `useEditJournalEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditJournalEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editJournalEntryMutation, { data, loading, error }] = useEditJournalEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditJournalEntryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditJournalEntryMutation,
    EditJournalEntryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EditJournalEntryMutation,
    EditJournalEntryMutationVariables
  >(EditJournalEntryDocument, options);
}
export type EditJournalEntryMutationHookResult = ReturnType<
  typeof useEditJournalEntryMutation
>;
export type EditJournalEntryMutationResult =
  Apollo.MutationResult<EditJournalEntryMutation>;
export type EditJournalEntryMutationOptions = Apollo.BaseMutationOptions<
  EditJournalEntryMutation,
  EditJournalEntryMutationVariables
>;
export const CreateJournalEntryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateJournalEntry' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateJournalEntryInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createJournalEntry' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entry' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'JournalingEntry' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JournalingEntry' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JournalEntry' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateJournalEntryMutationFn = Apollo.MutationFunction<
  CreateJournalEntryMutation,
  CreateJournalEntryMutationVariables
>;

/**
 * __useCreateJournalEntryMutation__
 *
 * To run a mutation, you first call `useCreateJournalEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJournalEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJournalEntryMutation, { data, loading, error }] = useCreateJournalEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJournalEntryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateJournalEntryMutation,
    CreateJournalEntryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateJournalEntryMutation,
    CreateJournalEntryMutationVariables
  >(CreateJournalEntryDocument, options);
}
export type CreateJournalEntryMutationHookResult = ReturnType<
  typeof useCreateJournalEntryMutation
>;
export type CreateJournalEntryMutationResult =
  Apollo.MutationResult<CreateJournalEntryMutation>;
export type CreateJournalEntryMutationOptions = Apollo.BaseMutationOptions<
  CreateJournalEntryMutation,
  CreateJournalEntryMutationVariables
>;
export const AverageDailyMoodInsightsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AverageDailyMoodInsights' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'AverageDailyMoodInsightsInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'averageDailyMoodInsights' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sampleSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAverageDailyMoodInsightsQuery__
 *
 * To run a query within a React component, call `useAverageDailyMoodInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAverageDailyMoodInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAverageDailyMoodInsightsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAverageDailyMoodInsightsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AverageDailyMoodInsightsQuery,
    AverageDailyMoodInsightsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AverageDailyMoodInsightsQuery,
    AverageDailyMoodInsightsQueryVariables
  >(AverageDailyMoodInsightsDocument, options);
}
export function useAverageDailyMoodInsightsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AverageDailyMoodInsightsQuery,
    AverageDailyMoodInsightsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AverageDailyMoodInsightsQuery,
    AverageDailyMoodInsightsQueryVariables
  >(AverageDailyMoodInsightsDocument, options);
}
// @ts-ignore
export function useAverageDailyMoodInsightsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AverageDailyMoodInsightsQuery,
    AverageDailyMoodInsightsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AverageDailyMoodInsightsQuery,
  AverageDailyMoodInsightsQueryVariables
>;
export function useAverageDailyMoodInsightsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AverageDailyMoodInsightsQuery,
        AverageDailyMoodInsightsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AverageDailyMoodInsightsQuery | undefined,
  AverageDailyMoodInsightsQueryVariables
>;
export function useAverageDailyMoodInsightsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AverageDailyMoodInsightsQuery,
        AverageDailyMoodInsightsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AverageDailyMoodInsightsQuery,
    AverageDailyMoodInsightsQueryVariables
  >(AverageDailyMoodInsightsDocument, options);
}
export type AverageDailyMoodInsightsQueryHookResult = ReturnType<
  typeof useAverageDailyMoodInsightsQuery
>;
export type AverageDailyMoodInsightsLazyQueryHookResult = ReturnType<
  typeof useAverageDailyMoodInsightsLazyQuery
>;
export type AverageDailyMoodInsightsSuspenseQueryHookResult = ReturnType<
  typeof useAverageDailyMoodInsightsSuspenseQuery
>;
export type AverageDailyMoodInsightsQueryResult = Apollo.QueryResult<
  AverageDailyMoodInsightsQuery,
  AverageDailyMoodInsightsQueryVariables
>;
export const InfluencesMoodInsightsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InfluencesMoodInsights' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'InfluencesMoodInsightsInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'influencesMoodInsights' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'factor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'valueMax' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'valueMin' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sampleSize' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useInfluencesMoodInsightsQuery__
 *
 * To run a query within a React component, call `useInfluencesMoodInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfluencesMoodInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfluencesMoodInsightsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInfluencesMoodInsightsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    InfluencesMoodInsightsQuery,
    InfluencesMoodInsightsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    InfluencesMoodInsightsQuery,
    InfluencesMoodInsightsQueryVariables
  >(InfluencesMoodInsightsDocument, options);
}
export function useInfluencesMoodInsightsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InfluencesMoodInsightsQuery,
    InfluencesMoodInsightsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    InfluencesMoodInsightsQuery,
    InfluencesMoodInsightsQueryVariables
  >(InfluencesMoodInsightsDocument, options);
}
// @ts-ignore
export function useInfluencesMoodInsightsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    InfluencesMoodInsightsQuery,
    InfluencesMoodInsightsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  InfluencesMoodInsightsQuery,
  InfluencesMoodInsightsQueryVariables
>;
export function useInfluencesMoodInsightsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InfluencesMoodInsightsQuery,
        InfluencesMoodInsightsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  InfluencesMoodInsightsQuery | undefined,
  InfluencesMoodInsightsQueryVariables
>;
export function useInfluencesMoodInsightsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InfluencesMoodInsightsQuery,
        InfluencesMoodInsightsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    InfluencesMoodInsightsQuery,
    InfluencesMoodInsightsQueryVariables
  >(InfluencesMoodInsightsDocument, options);
}
export type InfluencesMoodInsightsQueryHookResult = ReturnType<
  typeof useInfluencesMoodInsightsQuery
>;
export type InfluencesMoodInsightsLazyQueryHookResult = ReturnType<
  typeof useInfluencesMoodInsightsLazyQuery
>;
export type InfluencesMoodInsightsSuspenseQueryHookResult = ReturnType<
  typeof useInfluencesMoodInsightsSuspenseQuery
>;
export type InfluencesMoodInsightsQueryResult = Apollo.QueryResult<
  InfluencesMoodInsightsQuery,
  InfluencesMoodInsightsQueryVariables
>;
export const MoodEntriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MoodEntries' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MoodEntriesInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'moodEntries' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paging' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isLastPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cursors' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'after' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'data' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'MoodTrackingEntry',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MoodFactor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MoodFactor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCustom' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MoodTrackingEntry' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MoodEntry' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'factors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MoodFactor' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMoodEntriesQuery__
 *
 * To run a query within a React component, call `useMoodEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMoodEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMoodEntriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoodEntriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    MoodEntriesQuery,
    MoodEntriesQueryVariables
  > &
    (
      | { variables: MoodEntriesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MoodEntriesQuery, MoodEntriesQueryVariables>(
    MoodEntriesDocument,
    options,
  );
}
export function useMoodEntriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MoodEntriesQuery,
    MoodEntriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MoodEntriesQuery, MoodEntriesQueryVariables>(
    MoodEntriesDocument,
    options,
  );
}
// @ts-ignore
export function useMoodEntriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MoodEntriesQuery,
    MoodEntriesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<MoodEntriesQuery, MoodEntriesQueryVariables>;
export function useMoodEntriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MoodEntriesQuery,
        MoodEntriesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MoodEntriesQuery | undefined,
  MoodEntriesQueryVariables
>;
export function useMoodEntriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MoodEntriesQuery,
        MoodEntriesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MoodEntriesQuery, MoodEntriesQueryVariables>(
    MoodEntriesDocument,
    options,
  );
}
export type MoodEntriesQueryHookResult = ReturnType<typeof useMoodEntriesQuery>;
export type MoodEntriesLazyQueryHookResult = ReturnType<
  typeof useMoodEntriesLazyQuery
>;
export type MoodEntriesSuspenseQueryHookResult = ReturnType<
  typeof useMoodEntriesSuspenseQuery
>;
export type MoodEntriesQueryResult = Apollo.QueryResult<
  MoodEntriesQuery,
  MoodEntriesQueryVariables
>;
export const DeleteMoodEntryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteMoodEntry' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteMoodEntryInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteMoodEntry' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'received' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeleteMoodEntryMutationFn = Apollo.MutationFunction<
  DeleteMoodEntryMutation,
  DeleteMoodEntryMutationVariables
>;

/**
 * __useDeleteMoodEntryMutation__
 *
 * To run a mutation, you first call `useDeleteMoodEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMoodEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMoodEntryMutation, { data, loading, error }] = useDeleteMoodEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMoodEntryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteMoodEntryMutation,
    DeleteMoodEntryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteMoodEntryMutation,
    DeleteMoodEntryMutationVariables
  >(DeleteMoodEntryDocument, options);
}
export type DeleteMoodEntryMutationHookResult = ReturnType<
  typeof useDeleteMoodEntryMutation
>;
export type DeleteMoodEntryMutationResult =
  Apollo.MutationResult<DeleteMoodEntryMutation>;
export type DeleteMoodEntryMutationOptions = Apollo.BaseMutationOptions<
  DeleteMoodEntryMutation,
  DeleteMoodEntryMutationVariables
>;
export const EditMoodEntryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EditMoodEntry' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'EditMoodEntryInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'editMoodEntry' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entry' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MoodTrackingEntry' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MoodFactor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MoodFactor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCustom' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MoodTrackingEntry' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MoodEntry' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'factors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MoodFactor' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type EditMoodEntryMutationFn = Apollo.MutationFunction<
  EditMoodEntryMutation,
  EditMoodEntryMutationVariables
>;

/**
 * __useEditMoodEntryMutation__
 *
 * To run a mutation, you first call `useEditMoodEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMoodEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMoodEntryMutation, { data, loading, error }] = useEditMoodEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMoodEntryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditMoodEntryMutation,
    EditMoodEntryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EditMoodEntryMutation,
    EditMoodEntryMutationVariables
  >(EditMoodEntryDocument, options);
}
export type EditMoodEntryMutationHookResult = ReturnType<
  typeof useEditMoodEntryMutation
>;
export type EditMoodEntryMutationResult =
  Apollo.MutationResult<EditMoodEntryMutation>;
export type EditMoodEntryMutationOptions = Apollo.BaseMutationOptions<
  EditMoodEntryMutation,
  EditMoodEntryMutationVariables
>;
export const AvailableMoodFactorsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AvailableMoodFactors' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableMoodFactors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'factors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MoodFactor' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MoodFactor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MoodFactor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCustom' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAvailableMoodFactorsQuery__
 *
 * To run a query within a React component, call `useAvailableMoodFactorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableMoodFactorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableMoodFactorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableMoodFactorsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AvailableMoodFactorsQuery,
    AvailableMoodFactorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AvailableMoodFactorsQuery,
    AvailableMoodFactorsQueryVariables
  >(AvailableMoodFactorsDocument, options);
}
export function useAvailableMoodFactorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AvailableMoodFactorsQuery,
    AvailableMoodFactorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AvailableMoodFactorsQuery,
    AvailableMoodFactorsQueryVariables
  >(AvailableMoodFactorsDocument, options);
}
// @ts-ignore
export function useAvailableMoodFactorsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AvailableMoodFactorsQuery,
    AvailableMoodFactorsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AvailableMoodFactorsQuery,
  AvailableMoodFactorsQueryVariables
>;
export function useAvailableMoodFactorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AvailableMoodFactorsQuery,
        AvailableMoodFactorsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AvailableMoodFactorsQuery | undefined,
  AvailableMoodFactorsQueryVariables
>;
export function useAvailableMoodFactorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AvailableMoodFactorsQuery,
        AvailableMoodFactorsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AvailableMoodFactorsQuery,
    AvailableMoodFactorsQueryVariables
  >(AvailableMoodFactorsDocument, options);
}
export type AvailableMoodFactorsQueryHookResult = ReturnType<
  typeof useAvailableMoodFactorsQuery
>;
export type AvailableMoodFactorsLazyQueryHookResult = ReturnType<
  typeof useAvailableMoodFactorsLazyQuery
>;
export type AvailableMoodFactorsSuspenseQueryHookResult = ReturnType<
  typeof useAvailableMoodFactorsSuspenseQuery
>;
export type AvailableMoodFactorsQueryResult = Apollo.QueryResult<
  AvailableMoodFactorsQuery,
  AvailableMoodFactorsQueryVariables
>;
export const CreateMoodEntryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateMoodEntry' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateMoodEntryInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createMoodEntry' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entry' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MoodTrackingEntry' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MoodFactor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MoodFactor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCustom' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MoodTrackingEntry' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MoodEntry' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'factors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MoodFactor' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateMoodEntryMutationFn = Apollo.MutationFunction<
  CreateMoodEntryMutation,
  CreateMoodEntryMutationVariables
>;

/**
 * __useCreateMoodEntryMutation__
 *
 * To run a mutation, you first call `useCreateMoodEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMoodEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMoodEntryMutation, { data, loading, error }] = useCreateMoodEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMoodEntryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMoodEntryMutation,
    CreateMoodEntryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateMoodEntryMutation,
    CreateMoodEntryMutationVariables
  >(CreateMoodEntryDocument, options);
}
export type CreateMoodEntryMutationHookResult = ReturnType<
  typeof useCreateMoodEntryMutation
>;
export type CreateMoodEntryMutationResult =
  Apollo.MutationResult<CreateMoodEntryMutation>;
export type CreateMoodEntryMutationOptions = Apollo.BaseMutationOptions<
  CreateMoodEntryMutation,
  CreateMoodEntryMutationVariables
>;
export const CreateCustomMoodFactorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateCustomMoodFactor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateCustomMoodFactorInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCustomMoodFactor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'moodFactor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MoodFactor' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MoodFactor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MoodFactor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCustom' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateCustomMoodFactorMutationFn = Apollo.MutationFunction<
  CreateCustomMoodFactorMutation,
  CreateCustomMoodFactorMutationVariables
>;

/**
 * __useCreateCustomMoodFactorMutation__
 *
 * To run a mutation, you first call `useCreateCustomMoodFactorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomMoodFactorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomMoodFactorMutation, { data, loading, error }] = useCreateCustomMoodFactorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomMoodFactorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCustomMoodFactorMutation,
    CreateCustomMoodFactorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCustomMoodFactorMutation,
    CreateCustomMoodFactorMutationVariables
  >(CreateCustomMoodFactorDocument, options);
}
export type CreateCustomMoodFactorMutationHookResult = ReturnType<
  typeof useCreateCustomMoodFactorMutation
>;
export type CreateCustomMoodFactorMutationResult =
  Apollo.MutationResult<CreateCustomMoodFactorMutation>;
export type CreateCustomMoodFactorMutationOptions = Apollo.BaseMutationOptions<
  CreateCustomMoodFactorMutation,
  CreateCustomMoodFactorMutationVariables
>;
export const DeleteCustomMoodFactorsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteCustomMoodFactors' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteCustomMoodFactorsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteCustomMoodFactors' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'received' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeleteCustomMoodFactorsMutationFn = Apollo.MutationFunction<
  DeleteCustomMoodFactorsMutation,
  DeleteCustomMoodFactorsMutationVariables
>;

/**
 * __useDeleteCustomMoodFactorsMutation__
 *
 * To run a mutation, you first call `useDeleteCustomMoodFactorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomMoodFactorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomMoodFactorsMutation, { data, loading, error }] = useDeleteCustomMoodFactorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCustomMoodFactorsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCustomMoodFactorsMutation,
    DeleteCustomMoodFactorsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCustomMoodFactorsMutation,
    DeleteCustomMoodFactorsMutationVariables
  >(DeleteCustomMoodFactorsDocument, options);
}
export type DeleteCustomMoodFactorsMutationHookResult = ReturnType<
  typeof useDeleteCustomMoodFactorsMutation
>;
export type DeleteCustomMoodFactorsMutationResult =
  Apollo.MutationResult<DeleteCustomMoodFactorsMutation>;
export type DeleteCustomMoodFactorsMutationOptions = Apollo.BaseMutationOptions<
  DeleteCustomMoodFactorsMutation,
  DeleteCustomMoodFactorsMutationVariables
>;
export const NeedToRetakeAssessmentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NeedToRetakeAssessments' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preAssessmentResults' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isTimeToRetakeAssessments' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useNeedToRetakeAssessmentsQuery__
 *
 * To run a query within a React component, call `useNeedToRetakeAssessmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNeedToRetakeAssessmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNeedToRetakeAssessmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNeedToRetakeAssessmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    NeedToRetakeAssessmentsQuery,
    NeedToRetakeAssessmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    NeedToRetakeAssessmentsQuery,
    NeedToRetakeAssessmentsQueryVariables
  >(NeedToRetakeAssessmentsDocument, options);
}
export function useNeedToRetakeAssessmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NeedToRetakeAssessmentsQuery,
    NeedToRetakeAssessmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    NeedToRetakeAssessmentsQuery,
    NeedToRetakeAssessmentsQueryVariables
  >(NeedToRetakeAssessmentsDocument, options);
}
// @ts-ignore
export function useNeedToRetakeAssessmentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    NeedToRetakeAssessmentsQuery,
    NeedToRetakeAssessmentsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  NeedToRetakeAssessmentsQuery,
  NeedToRetakeAssessmentsQueryVariables
>;
export function useNeedToRetakeAssessmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        NeedToRetakeAssessmentsQuery,
        NeedToRetakeAssessmentsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  NeedToRetakeAssessmentsQuery | undefined,
  NeedToRetakeAssessmentsQueryVariables
>;
export function useNeedToRetakeAssessmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        NeedToRetakeAssessmentsQuery,
        NeedToRetakeAssessmentsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    NeedToRetakeAssessmentsQuery,
    NeedToRetakeAssessmentsQueryVariables
  >(NeedToRetakeAssessmentsDocument, options);
}
export type NeedToRetakeAssessmentsQueryHookResult = ReturnType<
  typeof useNeedToRetakeAssessmentsQuery
>;
export type NeedToRetakeAssessmentsLazyQueryHookResult = ReturnType<
  typeof useNeedToRetakeAssessmentsLazyQuery
>;
export type NeedToRetakeAssessmentsSuspenseQueryHookResult = ReturnType<
  typeof useNeedToRetakeAssessmentsSuspenseQuery
>;
export type NeedToRetakeAssessmentsQueryResult = Apollo.QueryResult<
  NeedToRetakeAssessmentsQuery,
  NeedToRetakeAssessmentsQueryVariables
>;
export const MyCareUpcomingAppointmentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MyCareUpcomingAppointments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FetchAppointmentsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchAppointments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'data' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'MyCareAppointment',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyCareAppointment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Appointment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'typeDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVisibleToUser' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMyCareUpcomingAppointmentsQuery__
 *
 * To run a query within a React component, call `useMyCareUpcomingAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCareUpcomingAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCareUpcomingAppointmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMyCareUpcomingAppointmentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    MyCareUpcomingAppointmentsQuery,
    MyCareUpcomingAppointmentsQueryVariables
  > &
    (
      | { variables: MyCareUpcomingAppointmentsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MyCareUpcomingAppointmentsQuery,
    MyCareUpcomingAppointmentsQueryVariables
  >(MyCareUpcomingAppointmentsDocument, options);
}
export function useMyCareUpcomingAppointmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyCareUpcomingAppointmentsQuery,
    MyCareUpcomingAppointmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MyCareUpcomingAppointmentsQuery,
    MyCareUpcomingAppointmentsQueryVariables
  >(MyCareUpcomingAppointmentsDocument, options);
}
// @ts-ignore
export function useMyCareUpcomingAppointmentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MyCareUpcomingAppointmentsQuery,
    MyCareUpcomingAppointmentsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  MyCareUpcomingAppointmentsQuery,
  MyCareUpcomingAppointmentsQueryVariables
>;
export function useMyCareUpcomingAppointmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MyCareUpcomingAppointmentsQuery,
        MyCareUpcomingAppointmentsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MyCareUpcomingAppointmentsQuery | undefined,
  MyCareUpcomingAppointmentsQueryVariables
>;
export function useMyCareUpcomingAppointmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MyCareUpcomingAppointmentsQuery,
        MyCareUpcomingAppointmentsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MyCareUpcomingAppointmentsQuery,
    MyCareUpcomingAppointmentsQueryVariables
  >(MyCareUpcomingAppointmentsDocument, options);
}
export type MyCareUpcomingAppointmentsQueryHookResult = ReturnType<
  typeof useMyCareUpcomingAppointmentsQuery
>;
export type MyCareUpcomingAppointmentsLazyQueryHookResult = ReturnType<
  typeof useMyCareUpcomingAppointmentsLazyQuery
>;
export type MyCareUpcomingAppointmentsSuspenseQueryHookResult = ReturnType<
  typeof useMyCareUpcomingAppointmentsSuspenseQuery
>;
export type MyCareUpcomingAppointmentsQueryResult = Apollo.QueryResult<
  MyCareUpcomingAppointmentsQuery,
  MyCareUpcomingAppointmentsQueryVariables
>;
export const PaymentRequirementsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PaymentRequirements' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequirements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isPaymentRequired' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePaymentRequirementsQuery__
 *
 * To run a query within a React component, call `usePaymentRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentRequirementsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentRequirementsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PaymentRequirementsQuery,
    PaymentRequirementsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PaymentRequirementsQuery,
    PaymentRequirementsQueryVariables
  >(PaymentRequirementsDocument, options);
}
export function usePaymentRequirementsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaymentRequirementsQuery,
    PaymentRequirementsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PaymentRequirementsQuery,
    PaymentRequirementsQueryVariables
  >(PaymentRequirementsDocument, options);
}
// @ts-ignore
export function usePaymentRequirementsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PaymentRequirementsQuery,
    PaymentRequirementsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  PaymentRequirementsQuery,
  PaymentRequirementsQueryVariables
>;
export function usePaymentRequirementsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PaymentRequirementsQuery,
        PaymentRequirementsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PaymentRequirementsQuery | undefined,
  PaymentRequirementsQueryVariables
>;
export function usePaymentRequirementsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PaymentRequirementsQuery,
        PaymentRequirementsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PaymentRequirementsQuery,
    PaymentRequirementsQueryVariables
  >(PaymentRequirementsDocument, options);
}
export type PaymentRequirementsQueryHookResult = ReturnType<
  typeof usePaymentRequirementsQuery
>;
export type PaymentRequirementsLazyQueryHookResult = ReturnType<
  typeof usePaymentRequirementsLazyQuery
>;
export type PaymentRequirementsSuspenseQueryHookResult = ReturnType<
  typeof usePaymentRequirementsSuspenseQuery
>;
export type PaymentRequirementsQueryResult = Apollo.QueryResult<
  PaymentRequirementsQuery,
  PaymentRequirementsQueryVariables
>;
export const FetchPreAssessmentResultsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FetchPreAssessmentResults' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preAssessmentResults' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'results' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PreAssessmentResults' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PreAssessmentResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PreAssessmentResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'severities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxScore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayMaxScore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retakeData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'earlyRetakeWarningMessage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PreAssessmentNotTaken' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PreAssessmentNotTaken' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PreAssessmentResults' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PreAssessmentResults' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shouldSpeakToCounsellor' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PreAssessmentResult' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PreAssessmentNotTaken' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFetchPreAssessmentResultsQuery__
 *
 * To run a query within a React component, call `useFetchPreAssessmentResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPreAssessmentResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPreAssessmentResultsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchPreAssessmentResultsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchPreAssessmentResultsQuery,
    FetchPreAssessmentResultsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchPreAssessmentResultsQuery,
    FetchPreAssessmentResultsQueryVariables
  >(FetchPreAssessmentResultsDocument, options);
}
export function useFetchPreAssessmentResultsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchPreAssessmentResultsQuery,
    FetchPreAssessmentResultsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchPreAssessmentResultsQuery,
    FetchPreAssessmentResultsQueryVariables
  >(FetchPreAssessmentResultsDocument, options);
}
// @ts-ignore
export function useFetchPreAssessmentResultsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchPreAssessmentResultsQuery,
    FetchPreAssessmentResultsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchPreAssessmentResultsQuery,
  FetchPreAssessmentResultsQueryVariables
>;
export function useFetchPreAssessmentResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchPreAssessmentResultsQuery,
        FetchPreAssessmentResultsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchPreAssessmentResultsQuery | undefined,
  FetchPreAssessmentResultsQueryVariables
>;
export function useFetchPreAssessmentResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchPreAssessmentResultsQuery,
        FetchPreAssessmentResultsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchPreAssessmentResultsQuery,
    FetchPreAssessmentResultsQueryVariables
  >(FetchPreAssessmentResultsDocument, options);
}
export type FetchPreAssessmentResultsQueryHookResult = ReturnType<
  typeof useFetchPreAssessmentResultsQuery
>;
export type FetchPreAssessmentResultsLazyQueryHookResult = ReturnType<
  typeof useFetchPreAssessmentResultsLazyQuery
>;
export type FetchPreAssessmentResultsSuspenseQueryHookResult = ReturnType<
  typeof useFetchPreAssessmentResultsSuspenseQuery
>;
export type FetchPreAssessmentResultsQueryResult = Apollo.QueryResult<
  FetchPreAssessmentResultsQuery,
  FetchPreAssessmentResultsQueryVariables
>;
export const CareIssuesSelectedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CareIssuesSelected' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCareIssues' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'careIssues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'CareIssueSelected' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CareIssueSelected' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CareIssue' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'selected' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCareIssuesSelectedQuery__
 *
 * To run a query within a React component, call `useCareIssuesSelectedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCareIssuesSelectedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCareIssuesSelectedQuery({
 *   variables: {
 *   },
 * });
 */
export function useCareIssuesSelectedQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CareIssuesSelectedQuery,
    CareIssuesSelectedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CareIssuesSelectedQuery,
    CareIssuesSelectedQueryVariables
  >(CareIssuesSelectedDocument, options);
}
export function useCareIssuesSelectedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CareIssuesSelectedQuery,
    CareIssuesSelectedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CareIssuesSelectedQuery,
    CareIssuesSelectedQueryVariables
  >(CareIssuesSelectedDocument, options);
}
// @ts-ignore
export function useCareIssuesSelectedSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CareIssuesSelectedQuery,
    CareIssuesSelectedQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CareIssuesSelectedQuery,
  CareIssuesSelectedQueryVariables
>;
export function useCareIssuesSelectedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CareIssuesSelectedQuery,
        CareIssuesSelectedQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CareIssuesSelectedQuery | undefined,
  CareIssuesSelectedQueryVariables
>;
export function useCareIssuesSelectedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CareIssuesSelectedQuery,
        CareIssuesSelectedQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CareIssuesSelectedQuery,
    CareIssuesSelectedQueryVariables
  >(CareIssuesSelectedDocument, options);
}
export type CareIssuesSelectedQueryHookResult = ReturnType<
  typeof useCareIssuesSelectedQuery
>;
export type CareIssuesSelectedLazyQueryHookResult = ReturnType<
  typeof useCareIssuesSelectedLazyQuery
>;
export type CareIssuesSelectedSuspenseQueryHookResult = ReturnType<
  typeof useCareIssuesSelectedSuspenseQuery
>;
export type CareIssuesSelectedQueryResult = Apollo.QueryResult<
  CareIssuesSelectedQuery,
  CareIssuesSelectedQueryVariables
>;
export const CarePlansDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CarePlans' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'AvailableCarePlansInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableCarePlans' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'carePlans' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'data' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCarePlansQuery__
 *
 * To run a query within a React component, call `useCarePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarePlansQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCarePlansQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CarePlansQuery,
    CarePlansQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CarePlansQuery, CarePlansQueryVariables>(
    CarePlansDocument,
    options,
  );
}
export function useCarePlansLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CarePlansQuery,
    CarePlansQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CarePlansQuery, CarePlansQueryVariables>(
    CarePlansDocument,
    options,
  );
}
// @ts-ignore
export function useCarePlansSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CarePlansQuery,
    CarePlansQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CarePlansQuery, CarePlansQueryVariables>;
export function useCarePlansSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CarePlansQuery, CarePlansQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  CarePlansQuery | undefined,
  CarePlansQueryVariables
>;
export function useCarePlansSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CarePlansQuery, CarePlansQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CarePlansQuery, CarePlansQueryVariables>(
    CarePlansDocument,
    options,
  );
}
export type CarePlansQueryHookResult = ReturnType<typeof useCarePlansQuery>;
export type CarePlansLazyQueryHookResult = ReturnType<
  typeof useCarePlansLazyQuery
>;
export type CarePlansSuspenseQueryHookResult = ReturnType<
  typeof useCarePlansSuspenseQuery
>;
export type CarePlansQueryResult = Apollo.QueryResult<
  CarePlansQuery,
  CarePlansQueryVariables
>;
export const AssessedAsSuicideRiskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AssessedAsSuicideRisk' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessedAsSuicideRisk' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ccsTeamTelephoneNumber' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAssessedAsSuicideRiskQuery__
 *
 * To run a query within a React component, call `useAssessedAsSuicideRiskQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessedAsSuicideRiskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessedAsSuicideRiskQuery({
 *   variables: {
 *   },
 * });
 */
export function useAssessedAsSuicideRiskQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AssessedAsSuicideRiskQuery,
    AssessedAsSuicideRiskQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssessedAsSuicideRiskQuery,
    AssessedAsSuicideRiskQueryVariables
  >(AssessedAsSuicideRiskDocument, options);
}
export function useAssessedAsSuicideRiskLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssessedAsSuicideRiskQuery,
    AssessedAsSuicideRiskQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssessedAsSuicideRiskQuery,
    AssessedAsSuicideRiskQueryVariables
  >(AssessedAsSuicideRiskDocument, options);
}
// @ts-ignore
export function useAssessedAsSuicideRiskSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AssessedAsSuicideRiskQuery,
    AssessedAsSuicideRiskQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AssessedAsSuicideRiskQuery,
  AssessedAsSuicideRiskQueryVariables
>;
export function useAssessedAsSuicideRiskSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssessedAsSuicideRiskQuery,
        AssessedAsSuicideRiskQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AssessedAsSuicideRiskQuery | undefined,
  AssessedAsSuicideRiskQueryVariables
>;
export function useAssessedAsSuicideRiskSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssessedAsSuicideRiskQuery,
        AssessedAsSuicideRiskQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssessedAsSuicideRiskQuery,
    AssessedAsSuicideRiskQueryVariables
  >(AssessedAsSuicideRiskDocument, options);
}
export type AssessedAsSuicideRiskQueryHookResult = ReturnType<
  typeof useAssessedAsSuicideRiskQuery
>;
export type AssessedAsSuicideRiskLazyQueryHookResult = ReturnType<
  typeof useAssessedAsSuicideRiskLazyQuery
>;
export type AssessedAsSuicideRiskSuspenseQueryHookResult = ReturnType<
  typeof useAssessedAsSuicideRiskSuspenseQuery
>;
export type AssessedAsSuicideRiskQueryResult = Apollo.QueryResult<
  AssessedAsSuicideRiskQuery,
  AssessedAsSuicideRiskQueryVariables
>;
export const FetchWorkLifeServicesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FetchWorkLifeServices' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workLifeServices' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'first' },
                      value: { kind: 'IntValue', value: '10' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'afterCursor' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'after' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'services' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'data' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'WorkLifeServices' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paging' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'WorkLifeServicesPagination',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkLifeServices' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'WorkLifeService' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkLifeServicesPagination' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Pagination' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isLastPage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cursors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFetchWorkLifeServicesQuery__
 *
 * To run a query within a React component, call `useFetchWorkLifeServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchWorkLifeServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchWorkLifeServicesQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFetchWorkLifeServicesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchWorkLifeServicesQuery,
    FetchWorkLifeServicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchWorkLifeServicesQuery,
    FetchWorkLifeServicesQueryVariables
  >(FetchWorkLifeServicesDocument, options);
}
export function useFetchWorkLifeServicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchWorkLifeServicesQuery,
    FetchWorkLifeServicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchWorkLifeServicesQuery,
    FetchWorkLifeServicesQueryVariables
  >(FetchWorkLifeServicesDocument, options);
}
// @ts-ignore
export function useFetchWorkLifeServicesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchWorkLifeServicesQuery,
    FetchWorkLifeServicesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchWorkLifeServicesQuery,
  FetchWorkLifeServicesQueryVariables
>;
export function useFetchWorkLifeServicesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchWorkLifeServicesQuery,
        FetchWorkLifeServicesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchWorkLifeServicesQuery | undefined,
  FetchWorkLifeServicesQueryVariables
>;
export function useFetchWorkLifeServicesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchWorkLifeServicesQuery,
        FetchWorkLifeServicesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchWorkLifeServicesQuery,
    FetchWorkLifeServicesQueryVariables
  >(FetchWorkLifeServicesDocument, options);
}
export type FetchWorkLifeServicesQueryHookResult = ReturnType<
  typeof useFetchWorkLifeServicesQuery
>;
export type FetchWorkLifeServicesLazyQueryHookResult = ReturnType<
  typeof useFetchWorkLifeServicesLazyQuery
>;
export type FetchWorkLifeServicesSuspenseQueryHookResult = ReturnType<
  typeof useFetchWorkLifeServicesSuspenseQuery
>;
export type FetchWorkLifeServicesQueryResult = Apollo.QueryResult<
  FetchWorkLifeServicesQuery,
  FetchWorkLifeServicesQueryVariables
>;
export const PensionBenefitsTitleAndNotificationCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'pensionBenefitsTitleAndNotificationCount' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pensionAndBenefitsSummary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'PensionBenefitsTitleAndNotificationCount',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PensionBenefitsTitleAndNotificationCount' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PensionAndBenefitsSummary' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notifications' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pension' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'benefits' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePensionBenefitsTitleAndNotificationCountQuery__
 *
 * To run a query within a React component, call `usePensionBenefitsTitleAndNotificationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePensionBenefitsTitleAndNotificationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePensionBenefitsTitleAndNotificationCountQuery({
 *   variables: {
 *   },
 * });
 */
export function usePensionBenefitsTitleAndNotificationCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PensionBenefitsTitleAndNotificationCountQuery,
    PensionBenefitsTitleAndNotificationCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PensionBenefitsTitleAndNotificationCountQuery,
    PensionBenefitsTitleAndNotificationCountQueryVariables
  >(PensionBenefitsTitleAndNotificationCountDocument, options);
}
export function usePensionBenefitsTitleAndNotificationCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PensionBenefitsTitleAndNotificationCountQuery,
    PensionBenefitsTitleAndNotificationCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PensionBenefitsTitleAndNotificationCountQuery,
    PensionBenefitsTitleAndNotificationCountQueryVariables
  >(PensionBenefitsTitleAndNotificationCountDocument, options);
}
// @ts-ignore
export function usePensionBenefitsTitleAndNotificationCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PensionBenefitsTitleAndNotificationCountQuery,
    PensionBenefitsTitleAndNotificationCountQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  PensionBenefitsTitleAndNotificationCountQuery,
  PensionBenefitsTitleAndNotificationCountQueryVariables
>;
export function usePensionBenefitsTitleAndNotificationCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PensionBenefitsTitleAndNotificationCountQuery,
        PensionBenefitsTitleAndNotificationCountQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PensionBenefitsTitleAndNotificationCountQuery | undefined,
  PensionBenefitsTitleAndNotificationCountQueryVariables
>;
export function usePensionBenefitsTitleAndNotificationCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PensionBenefitsTitleAndNotificationCountQuery,
        PensionBenefitsTitleAndNotificationCountQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PensionBenefitsTitleAndNotificationCountQuery,
    PensionBenefitsTitleAndNotificationCountQueryVariables
  >(PensionBenefitsTitleAndNotificationCountDocument, options);
}
export type PensionBenefitsTitleAndNotificationCountQueryHookResult =
  ReturnType<typeof usePensionBenefitsTitleAndNotificationCountQuery>;
export type PensionBenefitsTitleAndNotificationCountLazyQueryHookResult =
  ReturnType<typeof usePensionBenefitsTitleAndNotificationCountLazyQuery>;
export type PensionBenefitsTitleAndNotificationCountSuspenseQueryHookResult =
  ReturnType<typeof usePensionBenefitsTitleAndNotificationCountSuspenseQuery>;
export type PensionBenefitsTitleAndNotificationCountQueryResult =
  Apollo.QueryResult<
    PensionBenefitsTitleAndNotificationCountQuery,
    PensionBenefitsTitleAndNotificationCountQueryVariables
  >;
export const PensionBenefitsSummaryPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'pensionBenefitsSummaryPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pensionAndBenefitsSummary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PensionBenefitsNotifications' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PensionBenefitsPension' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PensionBenefitsBenefit' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PensionBenefitsNotifications' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PensionAndBenefitsSummary' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notifications' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expiryDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'portalUrlId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PensionBenefitsPension' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PensionAndBenefitsSummary' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pension' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totals' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'portalUrlId' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PensionBenefitsBenefit' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PensionAndBenefitsSummary' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'benefits' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totals' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'plans' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'choices' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'portalUrlId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePensionBenefitsSummaryPageQuery__
 *
 * To run a query within a React component, call `usePensionBenefitsSummaryPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePensionBenefitsSummaryPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePensionBenefitsSummaryPageQuery({
 *   variables: {
 *   },
 * });
 */
export function usePensionBenefitsSummaryPageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PensionBenefitsSummaryPageQuery,
    PensionBenefitsSummaryPageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PensionBenefitsSummaryPageQuery,
    PensionBenefitsSummaryPageQueryVariables
  >(PensionBenefitsSummaryPageDocument, options);
}
export function usePensionBenefitsSummaryPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PensionBenefitsSummaryPageQuery,
    PensionBenefitsSummaryPageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PensionBenefitsSummaryPageQuery,
    PensionBenefitsSummaryPageQueryVariables
  >(PensionBenefitsSummaryPageDocument, options);
}
// @ts-ignore
export function usePensionBenefitsSummaryPageSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PensionBenefitsSummaryPageQuery,
    PensionBenefitsSummaryPageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  PensionBenefitsSummaryPageQuery,
  PensionBenefitsSummaryPageQueryVariables
>;
export function usePensionBenefitsSummaryPageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PensionBenefitsSummaryPageQuery,
        PensionBenefitsSummaryPageQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PensionBenefitsSummaryPageQuery | undefined,
  PensionBenefitsSummaryPageQueryVariables
>;
export function usePensionBenefitsSummaryPageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PensionBenefitsSummaryPageQuery,
        PensionBenefitsSummaryPageQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PensionBenefitsSummaryPageQuery,
    PensionBenefitsSummaryPageQueryVariables
  >(PensionBenefitsSummaryPageDocument, options);
}
export type PensionBenefitsSummaryPageQueryHookResult = ReturnType<
  typeof usePensionBenefitsSummaryPageQuery
>;
export type PensionBenefitsSummaryPageLazyQueryHookResult = ReturnType<
  typeof usePensionBenefitsSummaryPageLazyQuery
>;
export type PensionBenefitsSummaryPageSuspenseQueryHookResult = ReturnType<
  typeof usePensionBenefitsSummaryPageSuspenseQuery
>;
export type PensionBenefitsSummaryPageQueryResult = Apollo.QueryResult<
  PensionBenefitsSummaryPageQuery,
  PensionBenefitsSummaryPageQueryVariables
>;
export const PensionAndBenefitsPortalUrlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'pensionAndBenefitsPortalUrl' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'portalUrlId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pensionAndBenefitsPortalUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'portalUrlId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiry' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePensionAndBenefitsPortalUrlQuery__
 *
 * To run a query within a React component, call `usePensionAndBenefitsPortalUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `usePensionAndBenefitsPortalUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePensionAndBenefitsPortalUrlQuery({
 *   variables: {
 *      portalUrlId: // value for 'portalUrlId'
 *   },
 * });
 */
export function usePensionAndBenefitsPortalUrlQuery(
  baseOptions: Apollo.QueryHookOptions<
    PensionAndBenefitsPortalUrlQuery,
    PensionAndBenefitsPortalUrlQueryVariables
  > &
    (
      | { variables: PensionAndBenefitsPortalUrlQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PensionAndBenefitsPortalUrlQuery,
    PensionAndBenefitsPortalUrlQueryVariables
  >(PensionAndBenefitsPortalUrlDocument, options);
}
export function usePensionAndBenefitsPortalUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PensionAndBenefitsPortalUrlQuery,
    PensionAndBenefitsPortalUrlQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PensionAndBenefitsPortalUrlQuery,
    PensionAndBenefitsPortalUrlQueryVariables
  >(PensionAndBenefitsPortalUrlDocument, options);
}
// @ts-ignore
export function usePensionAndBenefitsPortalUrlSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PensionAndBenefitsPortalUrlQuery,
    PensionAndBenefitsPortalUrlQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  PensionAndBenefitsPortalUrlQuery,
  PensionAndBenefitsPortalUrlQueryVariables
>;
export function usePensionAndBenefitsPortalUrlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PensionAndBenefitsPortalUrlQuery,
        PensionAndBenefitsPortalUrlQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PensionAndBenefitsPortalUrlQuery | undefined,
  PensionAndBenefitsPortalUrlQueryVariables
>;
export function usePensionAndBenefitsPortalUrlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PensionAndBenefitsPortalUrlQuery,
        PensionAndBenefitsPortalUrlQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PensionAndBenefitsPortalUrlQuery,
    PensionAndBenefitsPortalUrlQueryVariables
  >(PensionAndBenefitsPortalUrlDocument, options);
}
export type PensionAndBenefitsPortalUrlQueryHookResult = ReturnType<
  typeof usePensionAndBenefitsPortalUrlQuery
>;
export type PensionAndBenefitsPortalUrlLazyQueryHookResult = ReturnType<
  typeof usePensionAndBenefitsPortalUrlLazyQuery
>;
export type PensionAndBenefitsPortalUrlSuspenseQueryHookResult = ReturnType<
  typeof usePensionAndBenefitsPortalUrlSuspenseQuery
>;
export type PensionAndBenefitsPortalUrlQueryResult = Apollo.QueryResult<
  PensionAndBenefitsPortalUrlQuery,
  PensionAndBenefitsPortalUrlQueryVariables
>;
export const CategoryModalContainerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CategoryModalContainer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'categoryId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'digitalClinicalPrograms' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'category' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'categoryId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ProgramListFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProgramListFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalProgramListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          { kind: 'Field', name: { kind: 'Name', value: 'programId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'progress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'percentageComplete' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextModule' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'moduleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCategoryModalContainerQuery__
 *
 * To run a query within a React component, call `useCategoryModalContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryModalContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryModalContainerQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useCategoryModalContainerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CategoryModalContainerQuery,
    CategoryModalContainerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CategoryModalContainerQuery,
    CategoryModalContainerQueryVariables
  >(CategoryModalContainerDocument, options);
}
export function useCategoryModalContainerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CategoryModalContainerQuery,
    CategoryModalContainerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CategoryModalContainerQuery,
    CategoryModalContainerQueryVariables
  >(CategoryModalContainerDocument, options);
}
// @ts-ignore
export function useCategoryModalContainerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CategoryModalContainerQuery,
    CategoryModalContainerQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CategoryModalContainerQuery,
  CategoryModalContainerQueryVariables
>;
export function useCategoryModalContainerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CategoryModalContainerQuery,
        CategoryModalContainerQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CategoryModalContainerQuery | undefined,
  CategoryModalContainerQueryVariables
>;
export function useCategoryModalContainerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CategoryModalContainerQuery,
        CategoryModalContainerQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CategoryModalContainerQuery,
    CategoryModalContainerQueryVariables
  >(CategoryModalContainerDocument, options);
}
export type CategoryModalContainerQueryHookResult = ReturnType<
  typeof useCategoryModalContainerQuery
>;
export type CategoryModalContainerLazyQueryHookResult = ReturnType<
  typeof useCategoryModalContainerLazyQuery
>;
export type CategoryModalContainerSuspenseQueryHookResult = ReturnType<
  typeof useCategoryModalContainerSuspenseQuery
>;
export type CategoryModalContainerQueryResult = Apollo.QueryResult<
  CategoryModalContainerQuery,
  CategoryModalContainerQueryVariables
>;
export const AllProgramsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'allPrograms' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'digitalClinicalPrograms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ProgramListFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'programsWalkthrough' },
            name: { kind: 'Name', value: 'getWalkthrough' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'walkthroughType' },
                      value: { kind: 'EnumValue', value: 'CareNow' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'WalkthroughFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'digitalClinicalProgramCategories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'DigitalClinicalProgramCategories',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DigitalClinicalProgramCategories' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalProgramCategory' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'iconBackground' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WalkthroughFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Walkthrough' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'wasCompleted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'steps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProgramListFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalProgramListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          { kind: 'Field', name: { kind: 'Name', value: 'programId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'progress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'percentageComplete' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextModule' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'moduleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAllProgramsQuery__
 *
 * To run a query within a React component, call `useAllProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProgramsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllProgramsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AllProgramsQuery,
    AllProgramsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AllProgramsQuery, AllProgramsQueryVariables>(
    AllProgramsDocument,
    options,
  );
}
export function useAllProgramsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AllProgramsQuery,
    AllProgramsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AllProgramsQuery, AllProgramsQueryVariables>(
    AllProgramsDocument,
    options,
  );
}
// @ts-ignore
export function useAllProgramsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AllProgramsQuery,
    AllProgramsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AllProgramsQuery, AllProgramsQueryVariables>;
export function useAllProgramsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AllProgramsQuery,
        AllProgramsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AllProgramsQuery | undefined,
  AllProgramsQueryVariables
>;
export function useAllProgramsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AllProgramsQuery,
        AllProgramsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AllProgramsQuery, AllProgramsQueryVariables>(
    AllProgramsDocument,
    options,
  );
}
export type AllProgramsQueryHookResult = ReturnType<typeof useAllProgramsQuery>;
export type AllProgramsLazyQueryHookResult = ReturnType<
  typeof useAllProgramsLazyQuery
>;
export type AllProgramsSuspenseQueryHookResult = ReturnType<
  typeof useAllProgramsSuspenseQuery
>;
export type AllProgramsQueryResult = Apollo.QueryResult<
  AllProgramsQuery,
  AllProgramsQueryVariables
>;
export const WalkthroughCacheDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WalkthroughCache' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'programsWalkthrough' },
            name: { kind: 'Name', value: 'getWalkthrough' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'walkthroughType' },
                      value: { kind: 'EnumValue', value: 'CareNow' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'WalkthroughFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WalkthroughFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Walkthrough' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'wasCompleted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'steps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useWalkthroughCacheQuery__
 *
 * To run a query within a React component, call `useWalkthroughCacheQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalkthroughCacheQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalkthroughCacheQuery({
 *   variables: {
 *   },
 * });
 */
export function useWalkthroughCacheQuery(
  baseOptions?: Apollo.QueryHookOptions<
    WalkthroughCacheQuery,
    WalkthroughCacheQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WalkthroughCacheQuery, WalkthroughCacheQueryVariables>(
    WalkthroughCacheDocument,
    options,
  );
}
export function useWalkthroughCacheLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WalkthroughCacheQuery,
    WalkthroughCacheQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WalkthroughCacheQuery,
    WalkthroughCacheQueryVariables
  >(WalkthroughCacheDocument, options);
}
// @ts-ignore
export function useWalkthroughCacheSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WalkthroughCacheQuery,
    WalkthroughCacheQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  WalkthroughCacheQuery,
  WalkthroughCacheQueryVariables
>;
export function useWalkthroughCacheSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WalkthroughCacheQuery,
        WalkthroughCacheQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  WalkthroughCacheQuery | undefined,
  WalkthroughCacheQueryVariables
>;
export function useWalkthroughCacheSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WalkthroughCacheQuery,
        WalkthroughCacheQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WalkthroughCacheQuery,
    WalkthroughCacheQueryVariables
  >(WalkthroughCacheDocument, options);
}
export type WalkthroughCacheQueryHookResult = ReturnType<
  typeof useWalkthroughCacheQuery
>;
export type WalkthroughCacheLazyQueryHookResult = ReturnType<
  typeof useWalkthroughCacheLazyQuery
>;
export type WalkthroughCacheSuspenseQueryHookResult = ReturnType<
  typeof useWalkthroughCacheSuspenseQuery
>;
export type WalkthroughCacheQueryResult = Apollo.QueryResult<
  WalkthroughCacheQuery,
  WalkthroughCacheQueryVariables
>;
export const CompleteWalkthroughDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CompleteWalkthrough' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'walkthroughType' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'WalkthroughTypeInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completeWalkthrough' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'request' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'walkthroughType' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CompleteWalkthroughMutationFn = Apollo.MutationFunction<
  CompleteWalkthroughMutation,
  CompleteWalkthroughMutationVariables
>;

/**
 * __useCompleteWalkthroughMutation__
 *
 * To run a mutation, you first call `useCompleteWalkthroughMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteWalkthroughMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeWalkthroughMutation, { data, loading, error }] = useCompleteWalkthroughMutation({
 *   variables: {
 *      walkthroughType: // value for 'walkthroughType'
 *   },
 * });
 */
export function useCompleteWalkthroughMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompleteWalkthroughMutation,
    CompleteWalkthroughMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompleteWalkthroughMutation,
    CompleteWalkthroughMutationVariables
  >(CompleteWalkthroughDocument, options);
}
export type CompleteWalkthroughMutationHookResult = ReturnType<
  typeof useCompleteWalkthroughMutation
>;
export type CompleteWalkthroughMutationResult =
  Apollo.MutationResult<CompleteWalkthroughMutation>;
export type CompleteWalkthroughMutationOptions = Apollo.BaseMutationOptions<
  CompleteWalkthroughMutation,
  CompleteWalkthroughMutationVariables
>;
export const DigitalClinicalModuleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DigitalClinicalModule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'where' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FindDigitalClinicalModuleInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'digitalClinicalModule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'where' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'DigitalClinicalModuleDetailsFields',
                  },
                },
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'DigitalClinicalModuleSectionsFields',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModuleStatusFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalModule' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'moduleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'progress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalContentItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedContentItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'remainingContentItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'percentageComplete' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DigitalClinicalModuleArticleFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Article' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentItemId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'author' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heroImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audios' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hlsUrl' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userInteraction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'seenByUser' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'DigitalClinicalModuleChoiceQuestionFields',
      },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ChoiceQuestion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentItemId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optionId' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'responseType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userInteraction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'seenByUser' } },
                { kind: 'Field', name: { kind: 'Name', value: 'choices' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'DigitalClinicalModuleFreeTextQuestionFields',
      },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FreeTextQuestion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentItemId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hint' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userInteraction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'seenByUser' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DigitalClinicalModuleScaleQuestionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ScaleQuestion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentItemId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scale' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scalePointId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userInteraction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'seenByUser' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scalePointId' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'DigitalClinicalModuleStarRatingQuestionFields',
      },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StarRatingQuestion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'contentItemId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'starRatings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'starRatingId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userInteraction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'seenByUser' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'starRatingId' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DigitalClinicalModuleDetailsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalModule' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'ModuleStatusFields' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moduleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introduction' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heroImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'timeEstimate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'minutes' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DigitalClinicalModuleSectionsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalModule' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'DigitalClinicalModuleArticleFields',
                        },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'DigitalClinicalModuleChoiceQuestionFields',
                        },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'DigitalClinicalModuleFreeTextQuestionFields',
                        },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'DigitalClinicalModuleScaleQuestionFields',
                        },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value:
                            'DigitalClinicalModuleStarRatingQuestionFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useDigitalClinicalModuleQuery__
 *
 * To run a query within a React component, call `useDigitalClinicalModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useDigitalClinicalModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDigitalClinicalModuleQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDigitalClinicalModuleQuery(
  baseOptions: Apollo.QueryHookOptions<
    DigitalClinicalModuleQuery,
    DigitalClinicalModuleQueryVariables
  > &
    (
      | { variables: DigitalClinicalModuleQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DigitalClinicalModuleQuery,
    DigitalClinicalModuleQueryVariables
  >(DigitalClinicalModuleDocument, options);
}
export function useDigitalClinicalModuleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DigitalClinicalModuleQuery,
    DigitalClinicalModuleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DigitalClinicalModuleQuery,
    DigitalClinicalModuleQueryVariables
  >(DigitalClinicalModuleDocument, options);
}
// @ts-ignore
export function useDigitalClinicalModuleSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DigitalClinicalModuleQuery,
    DigitalClinicalModuleQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  DigitalClinicalModuleQuery,
  DigitalClinicalModuleQueryVariables
>;
export function useDigitalClinicalModuleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DigitalClinicalModuleQuery,
        DigitalClinicalModuleQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DigitalClinicalModuleQuery | undefined,
  DigitalClinicalModuleQueryVariables
>;
export function useDigitalClinicalModuleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DigitalClinicalModuleQuery,
        DigitalClinicalModuleQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    DigitalClinicalModuleQuery,
    DigitalClinicalModuleQueryVariables
  >(DigitalClinicalModuleDocument, options);
}
export type DigitalClinicalModuleQueryHookResult = ReturnType<
  typeof useDigitalClinicalModuleQuery
>;
export type DigitalClinicalModuleLazyQueryHookResult = ReturnType<
  typeof useDigitalClinicalModuleLazyQuery
>;
export type DigitalClinicalModuleSuspenseQueryHookResult = ReturnType<
  typeof useDigitalClinicalModuleSuspenseQuery
>;
export type DigitalClinicalModuleQueryResult = Apollo.QueryResult<
  DigitalClinicalModuleQuery,
  DigitalClinicalModuleQueryVariables
>;
export const ModuleOverviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ModuleOverview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'where' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FindDigitalClinicalModuleInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'digitalClinicalModule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'where' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ModuleOverviewFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModuleOverviewFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalModule' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'moduleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introduction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'progress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalContentItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedContentItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'remainingContentItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'percentageComplete' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'timeEstimate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'minutes' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heroImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'font' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'color' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hexCode' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useModuleOverviewQuery__
 *
 * To run a query within a React component, call `useModuleOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useModuleOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModuleOverviewQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useModuleOverviewQuery(
  baseOptions: Apollo.QueryHookOptions<
    ModuleOverviewQuery,
    ModuleOverviewQueryVariables
  > &
    (
      | { variables: ModuleOverviewQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ModuleOverviewQuery, ModuleOverviewQueryVariables>(
    ModuleOverviewDocument,
    options,
  );
}
export function useModuleOverviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ModuleOverviewQuery,
    ModuleOverviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ModuleOverviewQuery, ModuleOverviewQueryVariables>(
    ModuleOverviewDocument,
    options,
  );
}
// @ts-ignore
export function useModuleOverviewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ModuleOverviewQuery,
    ModuleOverviewQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ModuleOverviewQuery,
  ModuleOverviewQueryVariables
>;
export function useModuleOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ModuleOverviewQuery,
        ModuleOverviewQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ModuleOverviewQuery | undefined,
  ModuleOverviewQueryVariables
>;
export function useModuleOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ModuleOverviewQuery,
        ModuleOverviewQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ModuleOverviewQuery,
    ModuleOverviewQueryVariables
  >(ModuleOverviewDocument, options);
}
export type ModuleOverviewQueryHookResult = ReturnType<
  typeof useModuleOverviewQuery
>;
export type ModuleOverviewLazyQueryHookResult = ReturnType<
  typeof useModuleOverviewLazyQuery
>;
export type ModuleOverviewSuspenseQueryHookResult = ReturnType<
  typeof useModuleOverviewSuspenseQuery
>;
export type ModuleOverviewQueryResult = Apollo.QueryResult<
  ModuleOverviewQuery,
  ModuleOverviewQueryVariables
>;
export const SingleProgramDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SingleProgram' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'where' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FindDigitalClinicalProgramInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'digitalClinicalProgram' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'where' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SingleProgramFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProgramStatusFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalProgram' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'programId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'progress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalModules' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedModules' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'percentageComplete' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModuleListItemStatusFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalModuleListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'moduleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'progress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalContentItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedContentItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'remainingContentItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'percentageComplete' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SingleProgramFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalProgram' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'ProgramStatusFields' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'programId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'modules' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ModuleListItemStatusFields' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'heroImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'backgroundImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'font' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'color' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hexCode' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'moduleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'introduction' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'timeEstimate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutes' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSingleProgramQuery__
 *
 * To run a query within a React component, call `useSingleProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleProgramQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSingleProgramQuery(
  baseOptions: Apollo.QueryHookOptions<
    SingleProgramQuery,
    SingleProgramQueryVariables
  > &
    (
      | { variables: SingleProgramQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SingleProgramQuery, SingleProgramQueryVariables>(
    SingleProgramDocument,
    options,
  );
}
export function useSingleProgramLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SingleProgramQuery,
    SingleProgramQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SingleProgramQuery, SingleProgramQueryVariables>(
    SingleProgramDocument,
    options,
  );
}
// @ts-ignore
export function useSingleProgramSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SingleProgramQuery,
    SingleProgramQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SingleProgramQuery,
  SingleProgramQueryVariables
>;
export function useSingleProgramSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SingleProgramQuery,
        SingleProgramQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SingleProgramQuery | undefined,
  SingleProgramQueryVariables
>;
export function useSingleProgramSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SingleProgramQuery,
        SingleProgramQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SingleProgramQuery,
    SingleProgramQueryVariables
  >(SingleProgramDocument, options);
}
export type SingleProgramQueryHookResult = ReturnType<
  typeof useSingleProgramQuery
>;
export type SingleProgramLazyQueryHookResult = ReturnType<
  typeof useSingleProgramLazyQuery
>;
export type SingleProgramSuspenseQueryHookResult = ReturnType<
  typeof useSingleProgramSuspenseQuery
>;
export type SingleProgramQueryResult = Apollo.QueryResult<
  SingleProgramQuery,
  SingleProgramQueryVariables
>;
export const ProgramMenuDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ProgramMenu' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'where' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FindDigitalClinicalProgramInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'digitalClinicalProgram' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'where' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'programId' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ProgramInfoFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProgramInfoFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalProgram' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useProgramMenuQuery__
 *
 * To run a query within a React component, call `useProgramMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramMenuQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProgramMenuQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProgramMenuQuery,
    ProgramMenuQueryVariables
  > &
    (
      | { variables: ProgramMenuQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProgramMenuQuery, ProgramMenuQueryVariables>(
    ProgramMenuDocument,
    options,
  );
}
export function useProgramMenuLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProgramMenuQuery,
    ProgramMenuQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ProgramMenuQuery, ProgramMenuQueryVariables>(
    ProgramMenuDocument,
    options,
  );
}
// @ts-ignore
export function useProgramMenuSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProgramMenuQuery,
    ProgramMenuQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ProgramMenuQuery, ProgramMenuQueryVariables>;
export function useProgramMenuSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProgramMenuQuery,
        ProgramMenuQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ProgramMenuQuery | undefined,
  ProgramMenuQueryVariables
>;
export function useProgramMenuSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProgramMenuQuery,
        ProgramMenuQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ProgramMenuQuery, ProgramMenuQueryVariables>(
    ProgramMenuDocument,
    options,
  );
}
export type ProgramMenuQueryHookResult = ReturnType<typeof useProgramMenuQuery>;
export type ProgramMenuLazyQueryHookResult = ReturnType<
  typeof useProgramMenuLazyQuery
>;
export type ProgramMenuSuspenseQueryHookResult = ReturnType<
  typeof useProgramMenuSuspenseQuery
>;
export type ProgramMenuQueryResult = Apollo.QueryResult<
  ProgramMenuQuery,
  ProgramMenuQueryVariables
>;
export const LeaveProgramMenuDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'LeaveProgramMenu' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'request' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LeaveDigitalClinicalProgramInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaveDigitalClinicalProgram' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'request' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'request' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type LeaveProgramMenuMutationFn = Apollo.MutationFunction<
  LeaveProgramMenuMutation,
  LeaveProgramMenuMutationVariables
>;

/**
 * __useLeaveProgramMenuMutation__
 *
 * To run a mutation, you first call `useLeaveProgramMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveProgramMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveProgramMenuMutation, { data, loading, error }] = useLeaveProgramMenuMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useLeaveProgramMenuMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LeaveProgramMenuMutation,
    LeaveProgramMenuMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    LeaveProgramMenuMutation,
    LeaveProgramMenuMutationVariables
  >(LeaveProgramMenuDocument, options);
}
export type LeaveProgramMenuMutationHookResult = ReturnType<
  typeof useLeaveProgramMenuMutation
>;
export type LeaveProgramMenuMutationResult =
  Apollo.MutationResult<LeaveProgramMenuMutation>;
export type LeaveProgramMenuMutationOptions = Apollo.BaseMutationOptions<
  LeaveProgramMenuMutation,
  LeaveProgramMenuMutationVariables
>;
export const TrackProgramProgressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TrackProgramProgress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'trackProgramInput' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'DigitalClinicalProgramInteractionInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'trackDigitalClinicalProgramProgress',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'request' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'trackProgramInput' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ProgramStatusFields' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modules' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'ModuleListItemStatusFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProgramStatusFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalProgram' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'programId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'progress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalModules' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedModules' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'percentageComplete' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModuleListItemStatusFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalModuleListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'moduleId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'progress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalContentItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedContentItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'remainingContentItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'percentageComplete' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type TrackProgramProgressMutationFn = Apollo.MutationFunction<
  TrackProgramProgressMutation,
  TrackProgramProgressMutationVariables
>;

/**
 * __useTrackProgramProgressMutation__
 *
 * To run a mutation, you first call `useTrackProgramProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackProgramProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackProgramProgressMutation, { data, loading, error }] = useTrackProgramProgressMutation({
 *   variables: {
 *      trackProgramInput: // value for 'trackProgramInput'
 *   },
 * });
 */
export function useTrackProgramProgressMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TrackProgramProgressMutation,
    TrackProgramProgressMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TrackProgramProgressMutation,
    TrackProgramProgressMutationVariables
  >(TrackProgramProgressDocument, options);
}
export type TrackProgramProgressMutationHookResult = ReturnType<
  typeof useTrackProgramProgressMutation
>;
export type TrackProgramProgressMutationResult =
  Apollo.MutationResult<TrackProgramProgressMutation>;
export type TrackProgramProgressMutationOptions = Apollo.BaseMutationOptions<
  TrackProgramProgressMutation,
  TrackProgramProgressMutationVariables
>;
export const AssessmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Assessment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'requestGlobalContent' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'requestGlobalContent' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'requestGlobalContent' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Assessment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentType' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentType' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionOption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemQuestionnaireOptionsList' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jumpTo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurementRanges' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MeasurementRanges' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'jumpTo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'range' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurementRange' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'AssessmentItemQuestionnaireMeasurementRanges',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ranges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentQuestionMeasurementRanges',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurement' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'AssessmentItemQuestionnaireMeasurements',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unitOfMeasurement' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calculationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurementRanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentQuestionMeasurementRange',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestion' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemQuestionnaire' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reference' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'multipleChoice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introduction' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentQuestionOption' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentQuestionMeasurement',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Image' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentAnswerMeasurement' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemAnswersMeasurements' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'measurementUuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'measurementType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calculationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentAnswer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemAnswers' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'optionUuids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionUuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentAnswerMeasurement' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentRemaining' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RemainingAssessmentsCompletionPoints' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bonusPoints' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resetDate' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentStatusFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'percentageComplete' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextQuestionReference' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeRetaken' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cooldownPeriodExpirationDate' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Assessment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'localisedUuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introduction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfQuestions' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'AssessmentStatusFields' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'type' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'questionnaire' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentQuestion' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentAnswer' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'remainingAssessmentsCompletionPoints',
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentRemaining' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAssessmentQuery__
 *
 * To run a query within a React component, call `useAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      requestGlobalContent: // value for 'requestGlobalContent'
 *   },
 * });
 */
export function useAssessmentQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssessmentQuery,
    AssessmentQueryVariables
  > &
    (
      | { variables: AssessmentQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AssessmentQuery, AssessmentQueryVariables>(
    AssessmentDocument,
    options,
  );
}
export function useAssessmentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssessmentQuery,
    AssessmentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AssessmentQuery, AssessmentQueryVariables>(
    AssessmentDocument,
    options,
  );
}
// @ts-ignore
export function useAssessmentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AssessmentQuery,
    AssessmentQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AssessmentQuery, AssessmentQueryVariables>;
export function useAssessmentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssessmentQuery,
        AssessmentQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AssessmentQuery | undefined,
  AssessmentQueryVariables
>;
export function useAssessmentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssessmentQuery,
        AssessmentQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AssessmentQuery, AssessmentQueryVariables>(
    AssessmentDocument,
    options,
  );
}
export type AssessmentQueryHookResult = ReturnType<typeof useAssessmentQuery>;
export type AssessmentLazyQueryHookResult = ReturnType<
  typeof useAssessmentLazyQuery
>;
export type AssessmentSuspenseQueryHookResult = ReturnType<
  typeof useAssessmentSuspenseQuery
>;
export type AssessmentQueryResult = Apollo.QueryResult<
  AssessmentQuery,
  AssessmentQueryVariables
>;
export const AnswerAssessmentQuestionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AnswerAssessmentQuestions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'assesmentId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'answers' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'AssessmentAnswersInput' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'requestGlobalContent' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answerAssessmentQuestions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'request' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'assesmentId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'answers' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'answers' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'requestGlobalContent' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'requestGlobalContent' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assessment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AnswerMutationResponse' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentAnswerMeasurement' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemAnswersMeasurements' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'measurementUuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'measurementType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calculationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentAnswer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemAnswers' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'optionUuids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionUuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentAnswerMeasurement' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentStatusFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'percentageComplete' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextQuestionReference' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeRetaken' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cooldownPeriodExpirationDate' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnswerMutationResponse' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'AssessmentStatusFields' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentAnswer' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AnswerAssessmentQuestionsMutationFn = Apollo.MutationFunction<
  AnswerAssessmentQuestionsMutation,
  AnswerAssessmentQuestionsMutationVariables
>;

/**
 * __useAnswerAssessmentQuestionsMutation__
 *
 * To run a mutation, you first call `useAnswerAssessmentQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerAssessmentQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerAssessmentQuestionsMutation, { data, loading, error }] = useAnswerAssessmentQuestionsMutation({
 *   variables: {
 *      assesmentId: // value for 'assesmentId'
 *      answers: // value for 'answers'
 *      requestGlobalContent: // value for 'requestGlobalContent'
 *   },
 * });
 */
export function useAnswerAssessmentQuestionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AnswerAssessmentQuestionsMutation,
    AnswerAssessmentQuestionsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AnswerAssessmentQuestionsMutation,
    AnswerAssessmentQuestionsMutationVariables
  >(AnswerAssessmentQuestionsDocument, options);
}
export type AnswerAssessmentQuestionsMutationHookResult = ReturnType<
  typeof useAnswerAssessmentQuestionsMutation
>;
export type AnswerAssessmentQuestionsMutationResult =
  Apollo.MutationResult<AnswerAssessmentQuestionsMutation>;
export type AnswerAssessmentQuestionsMutationOptions =
  Apollo.BaseMutationOptions<
    AnswerAssessmentQuestionsMutation,
    AnswerAssessmentQuestionsMutationVariables
  >;
export const FinishAnsweringAssessmentQuestionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'FinishAnsweringAssessmentQuestions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'assesmentId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'answers' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'AssessmentAnswersInput' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'requestGlobalContent' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answerAssessmentQuestions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'request' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'assesmentId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'answers' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'answers' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'requestGlobalContent' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'requestGlobalContent' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assessment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'FinalAnswerMutationResponse',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalTierState' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AssessmentTierState' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Image' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentAnswerMeasurement' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemAnswersMeasurements' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'measurementUuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'measurementType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calculationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentAnswer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemAnswers' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'optionUuids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionUuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentAnswerMeasurement' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentStatusFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'percentageComplete' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextQuestionReference' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeRetaken' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cooldownPeriodExpirationDate' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultFeedback' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResultFeedback' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentCategory' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentContentCategory' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentType' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentContentType' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'typeGroup' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemContentImages' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'articlethumbnail' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentAuthor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemContentAuthor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItemResultContentList' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sanitizedBody' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastModificationDate' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourcePath' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'author' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentResultContentAuthor',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'category' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentResultContentCategory',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'type' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultContentType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'images' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'thumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MeasurementResultFeedback' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MeasurementResultFeedback' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MeasurementResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentContentMeasurementResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'feedback' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MeasurementResultFeedback' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItemResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'digestTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'digest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minScore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxScore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percentageScore' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shouldDisplayPercentage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'minScaleLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxScaleLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'feedback' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultFeedback' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurementResult' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MeasurementResult' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NextAssessment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentTierState' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemCurrentTierProgress' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pointsForCompletingAssessment' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'bonusPointsForCompletingAllAssessments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tierSummary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextTier' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TieringHubNextTier' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentTier' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TieringHubCurrentTier' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'points' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TieringHubTierPoints' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FinalAnswerMutationResponse' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'AssessmentStatusFields' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tierPoints' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentAnswer' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'result' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResult' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextAssessment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NextAssessment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tierProgress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentTierState' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubTierPoints' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TierPoints' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'earned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thisMonth' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'since' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'remainingToReachNextTier' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requiredToNotRegress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remaining' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thisMonth' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'remaining' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'daysRemaining' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubNextTier' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NextTier' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'meetsRequirementsForTier' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubCurrentTier' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CurrentTier' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'motivationalMessage' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type FinishAnsweringAssessmentQuestionsMutationFn =
  Apollo.MutationFunction<
    FinishAnsweringAssessmentQuestionsMutation,
    FinishAnsweringAssessmentQuestionsMutationVariables
  >;

/**
 * __useFinishAnsweringAssessmentQuestionsMutation__
 *
 * To run a mutation, you first call `useFinishAnsweringAssessmentQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishAnsweringAssessmentQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishAnsweringAssessmentQuestionsMutation, { data, loading, error }] = useFinishAnsweringAssessmentQuestionsMutation({
 *   variables: {
 *      assesmentId: // value for 'assesmentId'
 *      answers: // value for 'answers'
 *      requestGlobalContent: // value for 'requestGlobalContent'
 *   },
 * });
 */
export function useFinishAnsweringAssessmentQuestionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FinishAnsweringAssessmentQuestionsMutation,
    FinishAnsweringAssessmentQuestionsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    FinishAnsweringAssessmentQuestionsMutation,
    FinishAnsweringAssessmentQuestionsMutationVariables
  >(FinishAnsweringAssessmentQuestionsDocument, options);
}
export type FinishAnsweringAssessmentQuestionsMutationHookResult = ReturnType<
  typeof useFinishAnsweringAssessmentQuestionsMutation
>;
export type FinishAnsweringAssessmentQuestionsMutationResult =
  Apollo.MutationResult<FinishAnsweringAssessmentQuestionsMutation>;
export type FinishAnsweringAssessmentQuestionsMutationOptions =
  Apollo.BaseMutationOptions<
    FinishAnsweringAssessmentQuestionsMutation,
    FinishAnsweringAssessmentQuestionsMutationVariables
  >;
export const AllTiersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AllTiers' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allTiers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TieringHubAllTiers' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubAllTiers' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TierDefinition' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          { kind: 'Field', name: { kind: 'Name', value: 'points' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAllTiersQuery__
 *
 * To run a query within a React component, call `useAllTiersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTiersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTiersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllTiersQuery(
  baseOptions?: Apollo.QueryHookOptions<AllTiersQuery, AllTiersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AllTiersQuery, AllTiersQueryVariables>(
    AllTiersDocument,
    options,
  );
}
export function useAllTiersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AllTiersQuery,
    AllTiersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AllTiersQuery, AllTiersQueryVariables>(
    AllTiersDocument,
    options,
  );
}
// @ts-ignore
export function useAllTiersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AllTiersQuery,
    AllTiersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AllTiersQuery, AllTiersQueryVariables>;
export function useAllTiersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AllTiersQuery, AllTiersQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  AllTiersQuery | undefined,
  AllTiersQueryVariables
>;
export function useAllTiersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AllTiersQuery, AllTiersQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AllTiersQuery, AllTiersQueryVariables>(
    AllTiersDocument,
    options,
  );
}
export type AllTiersQueryHookResult = ReturnType<typeof useAllTiersQuery>;
export type AllTiersLazyQueryHookResult = ReturnType<
  typeof useAllTiersLazyQuery
>;
export type AllTiersSuspenseQueryHookResult = ReturnType<
  typeof useAllTiersSuspenseQuery
>;
export type AllTiersQueryResult = Apollo.QueryResult<
  AllTiersQuery,
  AllTiersQueryVariables
>;
export const AssessmentHistoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AssessmentHistory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'archiveId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'requestGlobalContent' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'resultData' },
            name: { kind: 'Name', value: 'historicalAssessment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'archiveId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'archiveId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'HistoricalAssessment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'commonAssessmentProperties' },
            name: { kind: 'Name', value: 'assessment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'requestGlobalContent' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'requestGlobalContent' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultCommonFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Image' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultFeedback' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResultFeedback' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentCategory' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentContentCategory' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentType' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentContentType' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'typeGroup' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemContentImages' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'articlethumbnail' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentAuthor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemContentAuthor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItemResultContentList' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sanitizedBody' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastModificationDate' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourcePath' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'author' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentResultContentAuthor',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'category' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentResultContentCategory',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'type' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultContentType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'images' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'thumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MeasurementResultFeedback' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MeasurementResultFeedback' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MeasurementResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentContentMeasurementResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'feedback' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MeasurementResultFeedback' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItemResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'digestTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'digest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minScore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxScore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percentageScore' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shouldDisplayPercentage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'minScaleLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxScaleLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'feedback' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultFeedback' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurementResult' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MeasurementResult' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HistoricalAssessment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HistoricalAssessment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'assessmentUuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archiveId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'result' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResult' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultCommonFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canBeRetaken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentImage' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAssessmentHistoryQuery__
 *
 * To run a query within a React component, call `useAssessmentHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentHistoryQuery({
 *   variables: {
 *      archiveId: // value for 'archiveId'
 *      id: // value for 'id'
 *      requestGlobalContent: // value for 'requestGlobalContent'
 *   },
 * });
 */
export function useAssessmentHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssessmentHistoryQuery,
    AssessmentHistoryQueryVariables
  > &
    (
      | { variables: AssessmentHistoryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssessmentHistoryQuery,
    AssessmentHistoryQueryVariables
  >(AssessmentHistoryDocument, options);
}
export function useAssessmentHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssessmentHistoryQuery,
    AssessmentHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssessmentHistoryQuery,
    AssessmentHistoryQueryVariables
  >(AssessmentHistoryDocument, options);
}
// @ts-ignore
export function useAssessmentHistorySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AssessmentHistoryQuery,
    AssessmentHistoryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AssessmentHistoryQuery,
  AssessmentHistoryQueryVariables
>;
export function useAssessmentHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssessmentHistoryQuery,
        AssessmentHistoryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AssessmentHistoryQuery | undefined,
  AssessmentHistoryQueryVariables
>;
export function useAssessmentHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssessmentHistoryQuery,
        AssessmentHistoryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssessmentHistoryQuery,
    AssessmentHistoryQueryVariables
  >(AssessmentHistoryDocument, options);
}
export type AssessmentHistoryQueryHookResult = ReturnType<
  typeof useAssessmentHistoryQuery
>;
export type AssessmentHistoryLazyQueryHookResult = ReturnType<
  typeof useAssessmentHistoryLazyQuery
>;
export type AssessmentHistorySuspenseQueryHookResult = ReturnType<
  typeof useAssessmentHistorySuspenseQuery
>;
export type AssessmentHistoryQueryResult = Apollo.QueryResult<
  AssessmentHistoryQuery,
  AssessmentHistoryQueryVariables
>;
export const AssessmentFullHistoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AssessmentFullHistory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessmentHistory' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentHistory' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentHistoryResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemHistoryResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'digestTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'digest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percentageScore' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentHistory' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemHistory' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'archiveId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assessmentUuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introduction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfQuestions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cooldownPeriodExpirationDate' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'result' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentHistoryResult' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAssessmentFullHistoryQuery__
 *
 * To run a query within a React component, call `useAssessmentFullHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentFullHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentFullHistoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAssessmentFullHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssessmentFullHistoryQuery,
    AssessmentFullHistoryQueryVariables
  > &
    (
      | { variables: AssessmentFullHistoryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssessmentFullHistoryQuery,
    AssessmentFullHistoryQueryVariables
  >(AssessmentFullHistoryDocument, options);
}
export function useAssessmentFullHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssessmentFullHistoryQuery,
    AssessmentFullHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssessmentFullHistoryQuery,
    AssessmentFullHistoryQueryVariables
  >(AssessmentFullHistoryDocument, options);
}
// @ts-ignore
export function useAssessmentFullHistorySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AssessmentFullHistoryQuery,
    AssessmentFullHistoryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AssessmentFullHistoryQuery,
  AssessmentFullHistoryQueryVariables
>;
export function useAssessmentFullHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssessmentFullHistoryQuery,
        AssessmentFullHistoryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AssessmentFullHistoryQuery | undefined,
  AssessmentFullHistoryQueryVariables
>;
export function useAssessmentFullHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssessmentFullHistoryQuery,
        AssessmentFullHistoryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssessmentFullHistoryQuery,
    AssessmentFullHistoryQueryVariables
  >(AssessmentFullHistoryDocument, options);
}
export type AssessmentFullHistoryQueryHookResult = ReturnType<
  typeof useAssessmentFullHistoryQuery
>;
export type AssessmentFullHistoryLazyQueryHookResult = ReturnType<
  typeof useAssessmentFullHistoryLazyQuery
>;
export type AssessmentFullHistorySuspenseQueryHookResult = ReturnType<
  typeof useAssessmentFullHistorySuspenseQuery
>;
export type AssessmentFullHistoryQueryResult = Apollo.QueryResult<
  AssessmentFullHistoryQuery,
  AssessmentFullHistoryQueryVariables
>;
export const AssessmentResultDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AssessmentResult' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'requestGlobalContent' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'resultData' },
            name: { kind: 'Name', value: 'assessment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'requestGlobalContent' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'requestGlobalContent' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'FinalAnswerMutationResponse' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'commonAssessmentProperties' },
            name: { kind: 'Name', value: 'assessment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'requestGlobalContent' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'requestGlobalContent' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultCommonFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Image' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentAnswerMeasurement' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemAnswersMeasurements' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'measurementUuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'measurementType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calculationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentAnswer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemAnswers' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'optionUuids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionUuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentAnswerMeasurement' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentStatusFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'percentageComplete' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextQuestionReference' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeRetaken' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cooldownPeriodExpirationDate' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultFeedback' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResultFeedback' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentCategory' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentContentCategory' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentType' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentContentType' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'typeGroup' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemContentImages' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'articlethumbnail' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentAuthor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemContentAuthor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItemResultContentList' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sanitizedBody' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastModificationDate' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourcePath' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'author' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentResultContentAuthor',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'category' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentResultContentCategory',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'type' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultContentType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'images' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'thumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MeasurementResultFeedback' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MeasurementResultFeedback' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MeasurementResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentContentMeasurementResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'feedback' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MeasurementResultFeedback' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItemResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'digestTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'digest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minScore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxScore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percentageScore' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shouldDisplayPercentage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'minScaleLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxScaleLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'feedback' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultFeedback' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurementResult' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MeasurementResult' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NextAssessment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentTierState' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemCurrentTierProgress' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pointsForCompletingAssessment' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'bonusPointsForCompletingAllAssessments',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tierSummary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextTier' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TieringHubNextTier' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentTier' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TieringHubCurrentTier' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'points' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TieringHubTierPoints' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FinalAnswerMutationResponse' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'AssessmentStatusFields' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tierPoints' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentAnswer' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'result' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResult' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextAssessment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NextAssessment' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tierProgress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentTierState' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultCommonFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canBeRetaken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubTierPoints' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TierPoints' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'earned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thisMonth' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'since' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'remainingToReachNextTier' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requiredToNotRegress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remaining' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thisMonth' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'remaining' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'daysRemaining' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubNextTier' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NextTier' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'meetsRequirementsForTier' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubCurrentTier' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CurrentTier' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'motivationalMessage' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAssessmentResultQuery__
 *
 * To run a query within a React component, call `useAssessmentResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentResultQuery({
 *   variables: {
 *      id: // value for 'id'
 *      requestGlobalContent: // value for 'requestGlobalContent'
 *   },
 * });
 */
export function useAssessmentResultQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssessmentResultQuery,
    AssessmentResultQueryVariables
  > &
    (
      | { variables: AssessmentResultQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AssessmentResultQuery, AssessmentResultQueryVariables>(
    AssessmentResultDocument,
    options,
  );
}
export function useAssessmentResultLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssessmentResultQuery,
    AssessmentResultQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssessmentResultQuery,
    AssessmentResultQueryVariables
  >(AssessmentResultDocument, options);
}
// @ts-ignore
export function useAssessmentResultSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AssessmentResultQuery,
    AssessmentResultQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AssessmentResultQuery,
  AssessmentResultQueryVariables
>;
export function useAssessmentResultSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssessmentResultQuery,
        AssessmentResultQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AssessmentResultQuery | undefined,
  AssessmentResultQueryVariables
>;
export function useAssessmentResultSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssessmentResultQuery,
        AssessmentResultQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssessmentResultQuery,
    AssessmentResultQueryVariables
  >(AssessmentResultDocument, options);
}
export type AssessmentResultQueryHookResult = ReturnType<
  typeof useAssessmentResultQuery
>;
export type AssessmentResultLazyQueryHookResult = ReturnType<
  typeof useAssessmentResultLazyQuery
>;
export type AssessmentResultSuspenseQueryHookResult = ReturnType<
  typeof useAssessmentResultSuspenseQuery
>;
export type AssessmentResultQueryResult = Apollo.QueryResult<
  AssessmentResultQuery,
  AssessmentResultQueryVariables
>;
export const RetakeAssessmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RetakeAssessment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'requestGlobalContent' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retakeAssessment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'request' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'uuid' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'requestGlobalContent' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'requestGlobalContent' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assessment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Assessment' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentType' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentType' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionOption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemQuestionnaireOptionsList' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jumpTo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurementRanges' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MeasurementRanges' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'jumpTo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'range' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurementRange' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'AssessmentItemQuestionnaireMeasurementRanges',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ranges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentQuestionMeasurementRanges',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurement' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'AssessmentItemQuestionnaireMeasurements',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unitOfMeasurement' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calculationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurementRanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentQuestionMeasurementRange',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestion' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemQuestionnaire' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reference' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'multipleChoice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introduction' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentQuestionOption' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentQuestionMeasurement',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Image' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentAnswerMeasurement' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemAnswersMeasurements' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'measurementUuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'measurementType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calculationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentAnswer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemAnswers' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'optionUuids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionUuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentAnswerMeasurement' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentRemaining' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RemainingAssessmentsCompletionPoints' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bonusPoints' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resetDate' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentStatusFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'percentageComplete' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextQuestionReference' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeRetaken' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cooldownPeriodExpirationDate' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Assessment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'localisedUuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introduction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfQuestions' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'AssessmentStatusFields' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'type' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'questionnaire' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentQuestion' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentAnswer' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'remainingAssessmentsCompletionPoints',
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentRemaining' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RetakeAssessmentMutationFn = Apollo.MutationFunction<
  RetakeAssessmentMutation,
  RetakeAssessmentMutationVariables
>;

/**
 * __useRetakeAssessmentMutation__
 *
 * To run a mutation, you first call `useRetakeAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetakeAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retakeAssessmentMutation, { data, loading, error }] = useRetakeAssessmentMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      requestGlobalContent: // value for 'requestGlobalContent'
 *   },
 * });
 */
export function useRetakeAssessmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetakeAssessmentMutation,
    RetakeAssessmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RetakeAssessmentMutation,
    RetakeAssessmentMutationVariables
  >(RetakeAssessmentDocument, options);
}
export type RetakeAssessmentMutationHookResult = ReturnType<
  typeof useRetakeAssessmentMutation
>;
export type RetakeAssessmentMutationResult =
  Apollo.MutationResult<RetakeAssessmentMutation>;
export type RetakeAssessmentMutationOptions = Apollo.BaseMutationOptions<
  RetakeAssessmentMutation,
  RetakeAssessmentMutationVariables
>;
export const ChangeGenderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ChangeGender' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'gender' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'answers' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'AssessmentAnswersInput' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'requestGlobalContent' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changeGender' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'request' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'gender' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'gender' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'answers' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'answers' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'requestGlobalContent' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'requestGlobalContent' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assessment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'result' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'AssessmentResult' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Image' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultFeedback' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResultFeedback' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentCategory' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentContentCategory' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentType' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentContentType' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'typeGroup' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemContentImages' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'articlethumbnail' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContentAuthor' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemContentAuthor' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResultContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItemResultContentList' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sanitizedBody' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastModificationDate' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resourcePath' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'author' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentResultContentAuthor',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'category' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentResultContentCategory',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'type' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultContentType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'images' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'thumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MeasurementResultFeedback' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MeasurementResultFeedback' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MeasurementResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentContentMeasurementResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'feedback' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MeasurementResultFeedback' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItemResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'digestTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'digest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minScore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxScore' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percentageScore' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shouldDisplayPercentage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'minScaleLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxScaleLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'feedback' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultFeedback' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentResultContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurementResult' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MeasurementResult' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ChangeGenderMutationFn = Apollo.MutationFunction<
  ChangeGenderMutation,
  ChangeGenderMutationVariables
>;

/**
 * __useChangeGenderMutation__
 *
 * To run a mutation, you first call `useChangeGenderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeGenderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeGenderMutation, { data, loading, error }] = useChangeGenderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      gender: // value for 'gender'
 *      answers: // value for 'answers'
 *      requestGlobalContent: // value for 'requestGlobalContent'
 *   },
 * });
 */
export function useChangeGenderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeGenderMutation,
    ChangeGenderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChangeGenderMutation,
    ChangeGenderMutationVariables
  >(ChangeGenderDocument, options);
}
export type ChangeGenderMutationHookResult = ReturnType<
  typeof useChangeGenderMutation
>;
export type ChangeGenderMutationResult =
  Apollo.MutationResult<ChangeGenderMutation>;
export type ChangeGenderMutationOptions = Apollo.BaseMutationOptions<
  ChangeGenderMutation,
  ChangeGenderMutationVariables
>;
export const RegressionInfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RegressionInfo' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tierRegressionInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RegressionInformation' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentTier' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TieringHubCurrentTier' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegressionInformation' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TierRegressionInfo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'font' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'color' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hexCode' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'timePeriods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isCurrent' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'timePeriod' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pointsEarned' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'pointGoal' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentTierDefinition' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubCurrentTier' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CurrentTier' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'motivationalMessage' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useRegressionInfoQuery__
 *
 * To run a query within a React component, call `useRegressionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegressionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegressionInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegressionInfoQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RegressionInfoQuery,
    RegressionInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RegressionInfoQuery, RegressionInfoQueryVariables>(
    RegressionInfoDocument,
    options,
  );
}
export function useRegressionInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RegressionInfoQuery,
    RegressionInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RegressionInfoQuery, RegressionInfoQueryVariables>(
    RegressionInfoDocument,
    options,
  );
}
// @ts-ignore
export function useRegressionInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RegressionInfoQuery,
    RegressionInfoQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RegressionInfoQuery,
  RegressionInfoQueryVariables
>;
export function useRegressionInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RegressionInfoQuery,
        RegressionInfoQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RegressionInfoQuery | undefined,
  RegressionInfoQueryVariables
>;
export function useRegressionInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RegressionInfoQuery,
        RegressionInfoQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    RegressionInfoQuery,
    RegressionInfoQueryVariables
  >(RegressionInfoDocument, options);
}
export type RegressionInfoQueryHookResult = ReturnType<
  typeof useRegressionInfoQuery
>;
export type RegressionInfoLazyQueryHookResult = ReturnType<
  typeof useRegressionInfoLazyQuery
>;
export type RegressionInfoSuspenseQueryHookResult = ReturnType<
  typeof useRegressionInfoSuspenseQuery
>;
export type RegressionInfoQueryResult = Apollo.QueryResult<
  RegressionInfoQuery,
  RegressionInfoQueryVariables
>;
export const AssessmentHeroCardsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AssessmentHeroCards' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessmentHeroCards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SingleAssessmentHeroCard' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'THICardFields' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'HealthRiskAssessmentHeroCard' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SingleAssessmentHeroCard' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SingleAssessmentCard' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tierPoints' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'numberOfQuestions' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'percentageComplete' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'percentageScore' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'type' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'filter' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HealthRiskAssessmentHeroCard' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HealthRiskAssessmentCard' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tierPoints' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numberOfAssessments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessmentsRemaining' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextAssessment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'numberOfQuestions' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'percentageComplete' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'percentageScore' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'type' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'filter' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'THICardFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TotalHealthIndexCard' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextPillar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'score' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bracket' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bracketId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'color' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hexCode' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tierPoints' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAssessmentHeroCardsQuery__
 *
 * To run a query within a React component, call `useAssessmentHeroCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentHeroCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentHeroCardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAssessmentHeroCardsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AssessmentHeroCardsQuery,
    AssessmentHeroCardsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssessmentHeroCardsQuery,
    AssessmentHeroCardsQueryVariables
  >(AssessmentHeroCardsDocument, options);
}
export function useAssessmentHeroCardsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssessmentHeroCardsQuery,
    AssessmentHeroCardsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssessmentHeroCardsQuery,
    AssessmentHeroCardsQueryVariables
  >(AssessmentHeroCardsDocument, options);
}
// @ts-ignore
export function useAssessmentHeroCardsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AssessmentHeroCardsQuery,
    AssessmentHeroCardsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AssessmentHeroCardsQuery,
  AssessmentHeroCardsQueryVariables
>;
export function useAssessmentHeroCardsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssessmentHeroCardsQuery,
        AssessmentHeroCardsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AssessmentHeroCardsQuery | undefined,
  AssessmentHeroCardsQueryVariables
>;
export function useAssessmentHeroCardsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssessmentHeroCardsQuery,
        AssessmentHeroCardsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssessmentHeroCardsQuery,
    AssessmentHeroCardsQueryVariables
  >(AssessmentHeroCardsDocument, options);
}
export type AssessmentHeroCardsQueryHookResult = ReturnType<
  typeof useAssessmentHeroCardsQuery
>;
export type AssessmentHeroCardsLazyQueryHookResult = ReturnType<
  typeof useAssessmentHeroCardsLazyQuery
>;
export type AssessmentHeroCardsSuspenseQueryHookResult = ReturnType<
  typeof useAssessmentHeroCardsSuspenseQuery
>;
export type AssessmentHeroCardsQueryResult = Apollo.QueryResult<
  AssessmentHeroCardsQuery,
  AssessmentHeroCardsQueryVariables
>;
export const AssessmentContentLanguageMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AssessmentContentLanguageMessage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'assessmentContentLanguageMessage' },
            name: { kind: 'Name', value: 'wellbeingContentLanguageMessage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'section' },
                value: { kind: 'EnumValue', value: 'ASSESSMENTS' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'WellbeingContentLanguageMessage',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WellbeingContentLanguageMessage' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'WellbeingContentLanguageMessageResponse',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'banner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'WellbeingContentLanguageMessageNoContent',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'section' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bannerText' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'WellbeingContentLanguageMessageNoChoice',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'section' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bannerText' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bannerTextPopUp' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'WellbeingContentLanguageMessageChangeLanguage',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'section' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bannerText' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bannerTextPopUp' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAssessmentContentLanguageMessageQuery__
 *
 * To run a query within a React component, call `useAssessmentContentLanguageMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentContentLanguageMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentContentLanguageMessageQuery({
 *   variables: {
 *   },
 * });
 */
export function useAssessmentContentLanguageMessageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AssessmentContentLanguageMessageQuery,
    AssessmentContentLanguageMessageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssessmentContentLanguageMessageQuery,
    AssessmentContentLanguageMessageQueryVariables
  >(AssessmentContentLanguageMessageDocument, options);
}
export function useAssessmentContentLanguageMessageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssessmentContentLanguageMessageQuery,
    AssessmentContentLanguageMessageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssessmentContentLanguageMessageQuery,
    AssessmentContentLanguageMessageQueryVariables
  >(AssessmentContentLanguageMessageDocument, options);
}
// @ts-ignore
export function useAssessmentContentLanguageMessageSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AssessmentContentLanguageMessageQuery,
    AssessmentContentLanguageMessageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AssessmentContentLanguageMessageQuery,
  AssessmentContentLanguageMessageQueryVariables
>;
export function useAssessmentContentLanguageMessageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssessmentContentLanguageMessageQuery,
        AssessmentContentLanguageMessageQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AssessmentContentLanguageMessageQuery | undefined,
  AssessmentContentLanguageMessageQueryVariables
>;
export function useAssessmentContentLanguageMessageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssessmentContentLanguageMessageQuery,
        AssessmentContentLanguageMessageQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssessmentContentLanguageMessageQuery,
    AssessmentContentLanguageMessageQueryVariables
  >(AssessmentContentLanguageMessageDocument, options);
}
export type AssessmentContentLanguageMessageQueryHookResult = ReturnType<
  typeof useAssessmentContentLanguageMessageQuery
>;
export type AssessmentContentLanguageMessageLazyQueryHookResult = ReturnType<
  typeof useAssessmentContentLanguageMessageLazyQuery
>;
export type AssessmentContentLanguageMessageSuspenseQueryHookResult =
  ReturnType<typeof useAssessmentContentLanguageMessageSuspenseQuery>;
export type AssessmentContentLanguageMessageQueryResult = Apollo.QueryResult<
  AssessmentContentLanguageMessageQuery,
  AssessmentContentLanguageMessageQueryVariables
>;
export const AssessmentsHubDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AssessmentsHub' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'requestGlobalContent' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'allAssessments' },
            name: { kind: 'Name', value: 'fetchAssessments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'requestGlobalContent' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'requestGlobalContent' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assessments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AssessmentHubListItem' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentLanguage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'translatedGlobalContentExists',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessmentTypeFilters' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentTypeFilters' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentType' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentType' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionOption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemQuestionnaireOptionsList' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jumpTo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurementRanges' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MeasurementRanges' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'jumpTo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'range' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurementRange' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'AssessmentItemQuestionnaireMeasurementRanges',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ranges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentQuestionMeasurementRanges',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestionMeasurement' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'AssessmentItemQuestionnaireMeasurements',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unitOfMeasurement' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calculationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurementRanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentQuestionMeasurementRange',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentQuestion' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemQuestionnaire' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reference' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'multipleChoice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introduction' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentQuestionOption' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentQuestionMeasurement',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Image' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentAnswerMeasurement' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemAnswersMeasurements' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'measurementUuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'measurementType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calculationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentAnswer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentItemAnswers' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'optionUuids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'questionUuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'measurements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentAnswerMeasurement' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentRemaining' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RemainingAssessmentsCompletionPoints' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bonusPoints' } },
          { kind: 'Field', name: { kind: 'Name', value: 'resetDate' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentStatusFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'percentageComplete' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextQuestionReference' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeRetaken' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cooldownPeriodExpirationDate' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Assessment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'localisedUuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introduction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfQuestions' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'AssessmentStatusFields' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'type' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentType' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'questionnaire' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentQuestion' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentAnswer' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'remainingAssessmentsCompletionPoints',
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AssessmentRemaining' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentsHubAssessmentResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItemResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'digestTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'digest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minScaleLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxScaleLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percentageScore' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shouldDisplayPercentage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'Assessment' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tierPoints' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentTypeFilters' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentTypeFilter' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'typeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssessmentHubListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'AssessmentListItem' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'result' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AssessmentsHubAssessmentResult',
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAssessmentsHubQuery__
 *
 * To run a query within a React component, call `useAssessmentsHubQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentsHubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentsHubQuery({
 *   variables: {
 *      requestGlobalContent: // value for 'requestGlobalContent'
 *   },
 * });
 */
export function useAssessmentsHubQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AssessmentsHubQuery,
    AssessmentsHubQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AssessmentsHubQuery, AssessmentsHubQueryVariables>(
    AssessmentsHubDocument,
    options,
  );
}
export function useAssessmentsHubLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssessmentsHubQuery,
    AssessmentsHubQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AssessmentsHubQuery, AssessmentsHubQueryVariables>(
    AssessmentsHubDocument,
    options,
  );
}
// @ts-ignore
export function useAssessmentsHubSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AssessmentsHubQuery,
    AssessmentsHubQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AssessmentsHubQuery,
  AssessmentsHubQueryVariables
>;
export function useAssessmentsHubSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssessmentsHubQuery,
        AssessmentsHubQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AssessmentsHubQuery | undefined,
  AssessmentsHubQueryVariables
>;
export function useAssessmentsHubSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssessmentsHubQuery,
        AssessmentsHubQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AssessmentsHubQuery,
    AssessmentsHubQueryVariables
  >(AssessmentsHubDocument, options);
}
export type AssessmentsHubQueryHookResult = ReturnType<
  typeof useAssessmentsHubQuery
>;
export type AssessmentsHubLazyQueryHookResult = ReturnType<
  typeof useAssessmentsHubLazyQuery
>;
export type AssessmentsHubSuspenseQueryHookResult = ReturnType<
  typeof useAssessmentsHubSuspenseQuery
>;
export type AssessmentsHubQueryResult = Apollo.QueryResult<
  AssessmentsHubQuery,
  AssessmentsHubQueryVariables
>;
export const PointsModalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PointsModal' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessmentTierPoints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assessmentCooldownFrequency' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pointsForAnAssessment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pointsForHRA' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pointsForTHI' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePointsModalQuery__
 *
 * To run a query within a React component, call `usePointsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointsModalQuery({
 *   variables: {
 *   },
 * });
 */
export function usePointsModalQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PointsModalQuery,
    PointsModalQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PointsModalQuery, PointsModalQueryVariables>(
    PointsModalDocument,
    options,
  );
}
export function usePointsModalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PointsModalQuery,
    PointsModalQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PointsModalQuery, PointsModalQueryVariables>(
    PointsModalDocument,
    options,
  );
}
// @ts-ignore
export function usePointsModalSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PointsModalQuery,
    PointsModalQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<PointsModalQuery, PointsModalQueryVariables>;
export function usePointsModalSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PointsModalQuery,
        PointsModalQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PointsModalQuery | undefined,
  PointsModalQueryVariables
>;
export function usePointsModalSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PointsModalQuery,
        PointsModalQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PointsModalQuery, PointsModalQueryVariables>(
    PointsModalDocument,
    options,
  );
}
export type PointsModalQueryHookResult = ReturnType<typeof usePointsModalQuery>;
export type PointsModalLazyQueryHookResult = ReturnType<
  typeof usePointsModalLazyQuery
>;
export type PointsModalSuspenseQueryHookResult = ReturnType<
  typeof usePointsModalSuspenseQuery
>;
export type PointsModalQueryResult = Apollo.QueryResult<
  PointsModalQuery,
  PointsModalQueryVariables
>;
export const GetPermissionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPermissions' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'howDoesPersonalisationWork' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'PersonalisationPermission',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PersonalisationPermission' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HowPersonalisationWorksPermission' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allowPersonalisation' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'footer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetPermissionsQuery__
 *
 * To run a query within a React component, call `useGetPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPermissionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPermissionsQuery,
    GetPermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(
    GetPermissionsDocument,
    options,
  );
}
export function useGetPermissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPermissionsQuery,
    GetPermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(
    GetPermissionsDocument,
    options,
  );
}
// @ts-ignore
export function useGetPermissionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPermissionsQuery,
    GetPermissionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetPermissionsQuery,
  GetPermissionsQueryVariables
>;
export function useGetPermissionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPermissionsQuery,
        GetPermissionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetPermissionsQuery | undefined,
  GetPermissionsQueryVariables
>;
export function useGetPermissionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPermissionsQuery,
        GetPermissionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPermissionsQuery,
    GetPermissionsQueryVariables
  >(GetPermissionsDocument, options);
}
export type GetPermissionsQueryHookResult = ReturnType<
  typeof useGetPermissionsQuery
>;
export type GetPermissionsLazyQueryHookResult = ReturnType<
  typeof useGetPermissionsLazyQuery
>;
export type GetPermissionsSuspenseQueryHookResult = ReturnType<
  typeof useGetPermissionsSuspenseQuery
>;
export type GetPermissionsQueryResult = Apollo.QueryResult<
  GetPermissionsQuery,
  GetPermissionsQueryVariables
>;
export const CompleteCustomTierActivityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CompleteCustomTierActivity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'request' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'FindCustomTierActivityInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completeCustomTierActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'request' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'request' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customTierActivity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'CustomTieringActivityListItem',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentTier' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TieringHubCurrentTier' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextTier' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TieringHubNextTier' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tierPoints' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TieringHubTierPoints' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomTieringActivityListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CustomTierActivity' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'activityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tierPointAward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubTierPoints' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TierPoints' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'earned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thisMonth' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'since' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'remainingToReachNextTier' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requiredToNotRegress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remaining' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thisMonth' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'remaining' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'daysRemaining' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubNextTier' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NextTier' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'meetsRequirementsForTier' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubCurrentTier' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CurrentTier' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'motivationalMessage' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CompleteCustomTierActivityMutationFn = Apollo.MutationFunction<
  CompleteCustomTierActivityMutation,
  CompleteCustomTierActivityMutationVariables
>;

/**
 * __useCompleteCustomTierActivityMutation__
 *
 * To run a mutation, you first call `useCompleteCustomTierActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteCustomTierActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeCustomTierActivityMutation, { data, loading, error }] = useCompleteCustomTierActivityMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useCompleteCustomTierActivityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompleteCustomTierActivityMutation,
    CompleteCustomTierActivityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompleteCustomTierActivityMutation,
    CompleteCustomTierActivityMutationVariables
  >(CompleteCustomTierActivityDocument, options);
}
export type CompleteCustomTierActivityMutationHookResult = ReturnType<
  typeof useCompleteCustomTierActivityMutation
>;
export type CompleteCustomTierActivityMutationResult =
  Apollo.MutationResult<CompleteCustomTierActivityMutation>;
export type CompleteCustomTierActivityMutationOptions =
  Apollo.BaseMutationOptions<
    CompleteCustomTierActivityMutation,
    CompleteCustomTierActivityMutationVariables
  >;
export const ActivityModalRegressionInfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActivityModalRegressionInfo' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tierRegressionInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TierRegressionInfo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TierRegressionInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TierRegressionInfo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'font' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'color' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hexCode' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'timePeriods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isCurrent' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'timePeriod' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pointsEarned' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'pointGoal' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useActivityModalRegressionInfoQuery__
 *
 * To run a query within a React component, call `useActivityModalRegressionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityModalRegressionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityModalRegressionInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useActivityModalRegressionInfoQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ActivityModalRegressionInfoQuery,
    ActivityModalRegressionInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ActivityModalRegressionInfoQuery,
    ActivityModalRegressionInfoQueryVariables
  >(ActivityModalRegressionInfoDocument, options);
}
export function useActivityModalRegressionInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActivityModalRegressionInfoQuery,
    ActivityModalRegressionInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ActivityModalRegressionInfoQuery,
    ActivityModalRegressionInfoQueryVariables
  >(ActivityModalRegressionInfoDocument, options);
}
// @ts-ignore
export function useActivityModalRegressionInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ActivityModalRegressionInfoQuery,
    ActivityModalRegressionInfoQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ActivityModalRegressionInfoQuery,
  ActivityModalRegressionInfoQueryVariables
>;
export function useActivityModalRegressionInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ActivityModalRegressionInfoQuery,
        ActivityModalRegressionInfoQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ActivityModalRegressionInfoQuery | undefined,
  ActivityModalRegressionInfoQueryVariables
>;
export function useActivityModalRegressionInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ActivityModalRegressionInfoQuery,
        ActivityModalRegressionInfoQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ActivityModalRegressionInfoQuery,
    ActivityModalRegressionInfoQueryVariables
  >(ActivityModalRegressionInfoDocument, options);
}
export type ActivityModalRegressionInfoQueryHookResult = ReturnType<
  typeof useActivityModalRegressionInfoQuery
>;
export type ActivityModalRegressionInfoLazyQueryHookResult = ReturnType<
  typeof useActivityModalRegressionInfoLazyQuery
>;
export type ActivityModalRegressionInfoSuspenseQueryHookResult = ReturnType<
  typeof useActivityModalRegressionInfoSuspenseQuery
>;
export type ActivityModalRegressionInfoQueryResult = Apollo.QueryResult<
  ActivityModalRegressionInfoQuery,
  ActivityModalRegressionInfoQueryVariables
>;
export const CustomActivityModalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CustomActivityModal' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentTier' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TieringHubCurrentTier' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextTier' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TieringHubNextTier' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allTiers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TieringHubAllTiers' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tierPoints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TieringHubTierPoints' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubTierPoints' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TierPoints' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'earned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thisMonth' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'since' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'remainingToReachNextTier' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requiredToNotRegress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remaining' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thisMonth' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'remaining' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'daysRemaining' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubNextTier' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NextTier' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'meetsRequirementsForTier' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubCurrentTier' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CurrentTier' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'motivationalMessage' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubAllTiers' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TierDefinition' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          { kind: 'Field', name: { kind: 'Name', value: 'points' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCustomActivityModalQuery__
 *
 * To run a query within a React component, call `useCustomActivityModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomActivityModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomActivityModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomActivityModalQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CustomActivityModalQuery,
    CustomActivityModalQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CustomActivityModalQuery,
    CustomActivityModalQueryVariables
  >(CustomActivityModalDocument, options);
}
export function useCustomActivityModalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomActivityModalQuery,
    CustomActivityModalQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CustomActivityModalQuery,
    CustomActivityModalQueryVariables
  >(CustomActivityModalDocument, options);
}
// @ts-ignore
export function useCustomActivityModalSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CustomActivityModalQuery,
    CustomActivityModalQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CustomActivityModalQuery,
  CustomActivityModalQueryVariables
>;
export function useCustomActivityModalSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CustomActivityModalQuery,
        CustomActivityModalQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CustomActivityModalQuery | undefined,
  CustomActivityModalQueryVariables
>;
export function useCustomActivityModalSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CustomActivityModalQuery,
        CustomActivityModalQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CustomActivityModalQuery,
    CustomActivityModalQueryVariables
  >(CustomActivityModalDocument, options);
}
export type CustomActivityModalQueryHookResult = ReturnType<
  typeof useCustomActivityModalQuery
>;
export type CustomActivityModalLazyQueryHookResult = ReturnType<
  typeof useCustomActivityModalLazyQuery
>;
export type CustomActivityModalSuspenseQueryHookResult = ReturnType<
  typeof useCustomActivityModalSuspenseQuery
>;
export type CustomActivityModalQueryResult = Apollo.QueryResult<
  CustomActivityModalQuery,
  CustomActivityModalQueryVariables
>;
export const FeedbackScreenDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FeedbackScreen' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customTierActivities' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CustomTieringActivityListItem',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tierPoints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TieringHubTierPoints' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextTier' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TieringHubNextTier' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentTier' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TieringHubCurrentTier' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allTiers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TieringHubAllTiers' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomTieringActivityListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CustomTierActivity' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'activityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tierPointAward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubTierPoints' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TierPoints' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'earned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thisMonth' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'since' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'remainingToReachNextTier' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requiredToNotRegress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remaining' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thisMonth' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'remaining' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'daysRemaining' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubNextTier' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NextTier' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'meetsRequirementsForTier' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubCurrentTier' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CurrentTier' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'motivationalMessage' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubAllTiers' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TierDefinition' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          { kind: 'Field', name: { kind: 'Name', value: 'points' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFeedbackScreenQuery__
 *
 * To run a query within a React component, call `useFeedbackScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackScreenQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeedbackScreenQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FeedbackScreenQuery,
    FeedbackScreenQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FeedbackScreenQuery, FeedbackScreenQueryVariables>(
    FeedbackScreenDocument,
    options,
  );
}
export function useFeedbackScreenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FeedbackScreenQuery,
    FeedbackScreenQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FeedbackScreenQuery, FeedbackScreenQueryVariables>(
    FeedbackScreenDocument,
    options,
  );
}
// @ts-ignore
export function useFeedbackScreenSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FeedbackScreenQuery,
    FeedbackScreenQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FeedbackScreenQuery,
  FeedbackScreenQueryVariables
>;
export function useFeedbackScreenSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FeedbackScreenQuery,
        FeedbackScreenQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FeedbackScreenQuery | undefined,
  FeedbackScreenQueryVariables
>;
export function useFeedbackScreenSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FeedbackScreenQuery,
        FeedbackScreenQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FeedbackScreenQuery,
    FeedbackScreenQueryVariables
  >(FeedbackScreenDocument, options);
}
export type FeedbackScreenQueryHookResult = ReturnType<
  typeof useFeedbackScreenQuery
>;
export type FeedbackScreenLazyQueryHookResult = ReturnType<
  typeof useFeedbackScreenLazyQuery
>;
export type FeedbackScreenSuspenseQueryHookResult = ReturnType<
  typeof useFeedbackScreenSuspenseQuery
>;
export type FeedbackScreenQueryResult = Apollo.QueryResult<
  FeedbackScreenQuery,
  FeedbackScreenQueryVariables
>;
export const TierRewardsPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TierRewardsPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allTiers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TieringHubAllTiers' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubAllTiers' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TierDefinition' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          { kind: 'Field', name: { kind: 'Name', value: 'points' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTierRewardsPageQuery__
 *
 * To run a query within a React component, call `useTierRewardsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTierRewardsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTierRewardsPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useTierRewardsPageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TierRewardsPageQuery,
    TierRewardsPageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TierRewardsPageQuery, TierRewardsPageQueryVariables>(
    TierRewardsPageDocument,
    options,
  );
}
export function useTierRewardsPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TierRewardsPageQuery,
    TierRewardsPageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TierRewardsPageQuery,
    TierRewardsPageQueryVariables
  >(TierRewardsPageDocument, options);
}
// @ts-ignore
export function useTierRewardsPageSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TierRewardsPageQuery,
    TierRewardsPageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TierRewardsPageQuery,
  TierRewardsPageQueryVariables
>;
export function useTierRewardsPageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TierRewardsPageQuery,
        TierRewardsPageQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TierRewardsPageQuery | undefined,
  TierRewardsPageQueryVariables
>;
export function useTierRewardsPageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TierRewardsPageQuery,
        TierRewardsPageQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TierRewardsPageQuery,
    TierRewardsPageQueryVariables
  >(TierRewardsPageDocument, options);
}
export type TierRewardsPageQueryHookResult = ReturnType<
  typeof useTierRewardsPageQuery
>;
export type TierRewardsPageLazyQueryHookResult = ReturnType<
  typeof useTierRewardsPageLazyQuery
>;
export type TierRewardsPageSuspenseQueryHookResult = ReturnType<
  typeof useTierRewardsPageSuspenseQuery
>;
export type TierRewardsPageQueryResult = Apollo.QueryResult<
  TierRewardsPageQuery,
  TierRewardsPageQueryVariables
>;
export const PaginatedTieringActivitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PaginatedTieringActivities' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cursor' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allTierActivities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'select' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'first' },
                      value: { kind: 'IntValue', value: '10' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'after' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cursor' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pointsEarned' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'additionalInformation' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paging' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isLastPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cursors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'after' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePaginatedTieringActivitiesQuery__
 *
 * To run a query within a React component, call `usePaginatedTieringActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedTieringActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedTieringActivitiesQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function usePaginatedTieringActivitiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PaginatedTieringActivitiesQuery,
    PaginatedTieringActivitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PaginatedTieringActivitiesQuery,
    PaginatedTieringActivitiesQueryVariables
  >(PaginatedTieringActivitiesDocument, options);
}
export function usePaginatedTieringActivitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaginatedTieringActivitiesQuery,
    PaginatedTieringActivitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PaginatedTieringActivitiesQuery,
    PaginatedTieringActivitiesQueryVariables
  >(PaginatedTieringActivitiesDocument, options);
}
// @ts-ignore
export function usePaginatedTieringActivitiesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PaginatedTieringActivitiesQuery,
    PaginatedTieringActivitiesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  PaginatedTieringActivitiesQuery,
  PaginatedTieringActivitiesQueryVariables
>;
export function usePaginatedTieringActivitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PaginatedTieringActivitiesQuery,
        PaginatedTieringActivitiesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PaginatedTieringActivitiesQuery | undefined,
  PaginatedTieringActivitiesQueryVariables
>;
export function usePaginatedTieringActivitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PaginatedTieringActivitiesQuery,
        PaginatedTieringActivitiesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PaginatedTieringActivitiesQuery,
    PaginatedTieringActivitiesQueryVariables
  >(PaginatedTieringActivitiesDocument, options);
}
export type PaginatedTieringActivitiesQueryHookResult = ReturnType<
  typeof usePaginatedTieringActivitiesQuery
>;
export type PaginatedTieringActivitiesLazyQueryHookResult = ReturnType<
  typeof usePaginatedTieringActivitiesLazyQuery
>;
export type PaginatedTieringActivitiesSuspenseQueryHookResult = ReturnType<
  typeof usePaginatedTieringActivitiesSuspenseQuery
>;
export type PaginatedTieringActivitiesQueryResult = Apollo.QueryResult<
  PaginatedTieringActivitiesQuery,
  PaginatedTieringActivitiesQueryVariables
>;
export const TieringHubDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TieringHub' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tierPoints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TieringHubTierPoints' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextTier' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TieringHubNextTier' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentTier' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TieringHubCurrentTier' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allTiers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TieringHubAllTiers' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tierRegressionInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TierRegressionInfo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubTierPoints' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TierPoints' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'earned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thisMonth' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'since' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'remainingToReachNextTier' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requiredToNotRegress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remaining' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thisMonth' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'remaining' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'daysRemaining' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubNextTier' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NextTier' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'meetsRequirementsForTier' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubCurrentTier' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CurrentTier' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'motivationalMessage' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubAllTiers' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TierDefinition' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          { kind: 'Field', name: { kind: 'Name', value: 'points' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TierRegressionInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TierRegressionInfo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'font' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'color' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hexCode' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'timePeriods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isCurrent' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'timePeriod' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pointsEarned' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'pointGoal' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTieringHubQuery__
 *
 * To run a query within a React component, call `useTieringHubQuery` and pass it any options that fit your needs.
 * When your component renders, `useTieringHubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTieringHubQuery({
 *   variables: {
 *   },
 * });
 */
export function useTieringHubQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TieringHubQuery,
    TieringHubQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TieringHubQuery, TieringHubQueryVariables>(
    TieringHubDocument,
    options,
  );
}
export function useTieringHubLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TieringHubQuery,
    TieringHubQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TieringHubQuery, TieringHubQueryVariables>(
    TieringHubDocument,
    options,
  );
}
// @ts-ignore
export function useTieringHubSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TieringHubQuery,
    TieringHubQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<TieringHubQuery, TieringHubQueryVariables>;
export function useTieringHubSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TieringHubQuery,
        TieringHubQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TieringHubQuery | undefined,
  TieringHubQueryVariables
>;
export function useTieringHubSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TieringHubQuery,
        TieringHubQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TieringHubQuery, TieringHubQueryVariables>(
    TieringHubDocument,
    options,
  );
}
export type TieringHubQueryHookResult = ReturnType<typeof useTieringHubQuery>;
export type TieringHubLazyQueryHookResult = ReturnType<
  typeof useTieringHubLazyQuery
>;
export type TieringHubSuspenseQueryHookResult = ReturnType<
  typeof useTieringHubSuspenseQuery
>;
export type TieringHubQueryResult = Apollo.QueryResult<
  TieringHubQuery,
  TieringHubQueryVariables
>;
export const GetGroupChallengeConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetGroupChallengeConfig' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groupChallengeConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activityTypes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'emoji' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'limits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'titleMaxLength' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetGroupChallengeConfigQuery__
 *
 * To run a query within a React component, call `useGetGroupChallengeConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupChallengeConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupChallengeConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGroupChallengeConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetGroupChallengeConfigQuery,
    GetGroupChallengeConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetGroupChallengeConfigQuery,
    GetGroupChallengeConfigQueryVariables
  >(GetGroupChallengeConfigDocument, options);
}
export function useGetGroupChallengeConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGroupChallengeConfigQuery,
    GetGroupChallengeConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetGroupChallengeConfigQuery,
    GetGroupChallengeConfigQueryVariables
  >(GetGroupChallengeConfigDocument, options);
}
// @ts-ignore
export function useGetGroupChallengeConfigSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetGroupChallengeConfigQuery,
    GetGroupChallengeConfigQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetGroupChallengeConfigQuery,
  GetGroupChallengeConfigQueryVariables
>;
export function useGetGroupChallengeConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetGroupChallengeConfigQuery,
        GetGroupChallengeConfigQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetGroupChallengeConfigQuery | undefined,
  GetGroupChallengeConfigQueryVariables
>;
export function useGetGroupChallengeConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetGroupChallengeConfigQuery,
        GetGroupChallengeConfigQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetGroupChallengeConfigQuery,
    GetGroupChallengeConfigQueryVariables
  >(GetGroupChallengeConfigDocument, options);
}
export type GetGroupChallengeConfigQueryHookResult = ReturnType<
  typeof useGetGroupChallengeConfigQuery
>;
export type GetGroupChallengeConfigLazyQueryHookResult = ReturnType<
  typeof useGetGroupChallengeConfigLazyQuery
>;
export type GetGroupChallengeConfigSuspenseQueryHookResult = ReturnType<
  typeof useGetGroupChallengeConfigSuspenseQuery
>;
export type GetGroupChallengeConfigQueryResult = Apollo.QueryResult<
  GetGroupChallengeConfigQuery,
  GetGroupChallengeConfigQueryVariables
>;
export const CreateGroupChallengeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateGroupChallenge' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateGroupChallengeInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createGroupChallenge' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'challenge' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'GroupStepChallenge' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'challengeId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'startDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'endDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateGroupChallengeMutationFn = Apollo.MutationFunction<
  CreateGroupChallengeMutation,
  CreateGroupChallengeMutationVariables
>;

/**
 * __useCreateGroupChallengeMutation__
 *
 * To run a mutation, you first call `useCreateGroupChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupChallengeMutation, { data, loading, error }] = useCreateGroupChallengeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGroupChallengeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateGroupChallengeMutation,
    CreateGroupChallengeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateGroupChallengeMutation,
    CreateGroupChallengeMutationVariables
  >(CreateGroupChallengeDocument, options);
}
export type CreateGroupChallengeMutationHookResult = ReturnType<
  typeof useCreateGroupChallengeMutation
>;
export type CreateGroupChallengeMutationResult =
  Apollo.MutationResult<CreateGroupChallengeMutation>;
export type CreateGroupChallengeMutationOptions = Apollo.BaseMutationOptions<
  CreateGroupChallengeMutation,
  CreateGroupChallengeMutationVariables
>;
export const UpdatePersonalisationPermissionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePersonalisationPermission' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'allowPersonalisation' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePersonalisationPermission' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'request' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'allowPersonalisation' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'allowPersonalisation' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'PersonalisationPermission',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PersonalisationPermission' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HowPersonalisationWorksPermission' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allowPersonalisation' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'footer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdatePersonalisationPermissionMutationFn = Apollo.MutationFunction<
  UpdatePersonalisationPermissionMutation,
  UpdatePersonalisationPermissionMutationVariables
>;

/**
 * __useUpdatePersonalisationPermissionMutation__
 *
 * To run a mutation, you first call `useUpdatePersonalisationPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonalisationPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonalisationPermissionMutation, { data, loading, error }] = useUpdatePersonalisationPermissionMutation({
 *   variables: {
 *      allowPersonalisation: // value for 'allowPersonalisation'
 *   },
 * });
 */
export function useUpdatePersonalisationPermissionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePersonalisationPermissionMutation,
    UpdatePersonalisationPermissionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePersonalisationPermissionMutation,
    UpdatePersonalisationPermissionMutationVariables
  >(UpdatePersonalisationPermissionDocument, options);
}
export type UpdatePersonalisationPermissionMutationHookResult = ReturnType<
  typeof useUpdatePersonalisationPermissionMutation
>;
export type UpdatePersonalisationPermissionMutationResult =
  Apollo.MutationResult<UpdatePersonalisationPermissionMutation>;
export type UpdatePersonalisationPermissionMutationOptions =
  Apollo.BaseMutationOptions<
    UpdatePersonalisationPermissionMutation,
    UpdatePersonalisationPermissionMutationVariables
  >;
export const JoinDigitalClinicalProgramDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'JoinDigitalClinicalProgram' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'joinProgramInput' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'JoinDigitalClinicalProgramInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'joinDigitalClinicalProgram' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'request' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'joinProgramInput' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type JoinDigitalClinicalProgramMutationFn = Apollo.MutationFunction<
  JoinDigitalClinicalProgramMutation,
  JoinDigitalClinicalProgramMutationVariables
>;

/**
 * __useJoinDigitalClinicalProgramMutation__
 *
 * To run a mutation, you first call `useJoinDigitalClinicalProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinDigitalClinicalProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinDigitalClinicalProgramMutation, { data, loading, error }] = useJoinDigitalClinicalProgramMutation({
 *   variables: {
 *      joinProgramInput: // value for 'joinProgramInput'
 *   },
 * });
 */
export function useJoinDigitalClinicalProgramMutation(
  baseOptions?: Apollo.MutationHookOptions<
    JoinDigitalClinicalProgramMutation,
    JoinDigitalClinicalProgramMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    JoinDigitalClinicalProgramMutation,
    JoinDigitalClinicalProgramMutationVariables
  >(JoinDigitalClinicalProgramDocument, options);
}
export type JoinDigitalClinicalProgramMutationHookResult = ReturnType<
  typeof useJoinDigitalClinicalProgramMutation
>;
export type JoinDigitalClinicalProgramMutationResult =
  Apollo.MutationResult<JoinDigitalClinicalProgramMutation>;
export type JoinDigitalClinicalProgramMutationOptions =
  Apollo.BaseMutationOptions<
    JoinDigitalClinicalProgramMutation,
    JoinDigitalClinicalProgramMutationVariables
  >;
export const RecommendedArticlesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RecommendedArticles' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendedArticles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'select' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'first' },
                      value: { kind: 'IntValue', value: '12' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recommendations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'RecommendationFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'howDoesPersonalisationWork' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'HowDoesPersonalisationWork' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RecommendationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Article' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'author' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'categoryTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contentItemId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heroImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastModificationDate' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PersonalisationPermission' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HowPersonalisationWorksPermission' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allowPersonalisation' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'footer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HowDoesPersonalisationWork' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HowDoesPersonalisationWorkResponse' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'button' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permission' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PersonalisationPermission' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useRecommendedArticlesQuery__
 *
 * To run a query within a React component, call `useRecommendedArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendedArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendedArticlesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecommendedArticlesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RecommendedArticlesQuery,
    RecommendedArticlesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RecommendedArticlesQuery,
    RecommendedArticlesQueryVariables
  >(RecommendedArticlesDocument, options);
}
export function useRecommendedArticlesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RecommendedArticlesQuery,
    RecommendedArticlesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RecommendedArticlesQuery,
    RecommendedArticlesQueryVariables
  >(RecommendedArticlesDocument, options);
}
// @ts-ignore
export function useRecommendedArticlesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RecommendedArticlesQuery,
    RecommendedArticlesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RecommendedArticlesQuery,
  RecommendedArticlesQueryVariables
>;
export function useRecommendedArticlesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RecommendedArticlesQuery,
        RecommendedArticlesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RecommendedArticlesQuery | undefined,
  RecommendedArticlesQueryVariables
>;
export function useRecommendedArticlesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RecommendedArticlesQuery,
        RecommendedArticlesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    RecommendedArticlesQuery,
    RecommendedArticlesQueryVariables
  >(RecommendedArticlesDocument, options);
}
export type RecommendedArticlesQueryHookResult = ReturnType<
  typeof useRecommendedArticlesQuery
>;
export type RecommendedArticlesLazyQueryHookResult = ReturnType<
  typeof useRecommendedArticlesLazyQuery
>;
export type RecommendedArticlesSuspenseQueryHookResult = ReturnType<
  typeof useRecommendedArticlesSuspenseQuery
>;
export type RecommendedArticlesQueryResult = Apollo.QueryResult<
  RecommendedArticlesQuery,
  RecommendedArticlesQueryVariables
>;
export const FetchFeaturedChallengesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FetchFeaturedChallenges' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'from' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'GraphQLDate' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'featuredChallenges' },
            name: { kind: 'Name', value: 'fetchFeaturedChallenges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'FeaturedChallengeFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FeaturedStepChallengeField' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'participationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stepActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FeaturedHabitChallengeField' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'participationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'from' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'from' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FeaturedChallengeFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'fetchFeaturedChallengesResponse' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'challenges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'FeaturedStepChallengeField' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'FeaturedHabitChallengeField' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFetchFeaturedChallengesQuery__
 *
 * To run a query within a React component, call `useFetchFeaturedChallengesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFeaturedChallengesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFeaturedChallengesQuery({
 *   variables: {
 *      from: // value for 'from'
 *   },
 * });
 */
export function useFetchFeaturedChallengesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchFeaturedChallengesQuery,
    FetchFeaturedChallengesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchFeaturedChallengesQuery,
    FetchFeaturedChallengesQueryVariables
  >(FetchFeaturedChallengesDocument, options);
}
export function useFetchFeaturedChallengesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchFeaturedChallengesQuery,
    FetchFeaturedChallengesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchFeaturedChallengesQuery,
    FetchFeaturedChallengesQueryVariables
  >(FetchFeaturedChallengesDocument, options);
}
// @ts-ignore
export function useFetchFeaturedChallengesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchFeaturedChallengesQuery,
    FetchFeaturedChallengesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchFeaturedChallengesQuery,
  FetchFeaturedChallengesQueryVariables
>;
export function useFetchFeaturedChallengesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchFeaturedChallengesQuery,
        FetchFeaturedChallengesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchFeaturedChallengesQuery | undefined,
  FetchFeaturedChallengesQueryVariables
>;
export function useFetchFeaturedChallengesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchFeaturedChallengesQuery,
        FetchFeaturedChallengesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchFeaturedChallengesQuery,
    FetchFeaturedChallengesQueryVariables
  >(FetchFeaturedChallengesDocument, options);
}
export type FetchFeaturedChallengesQueryHookResult = ReturnType<
  typeof useFetchFeaturedChallengesQuery
>;
export type FetchFeaturedChallengesLazyQueryHookResult = ReturnType<
  typeof useFetchFeaturedChallengesLazyQuery
>;
export type FetchFeaturedChallengesSuspenseQueryHookResult = ReturnType<
  typeof useFetchFeaturedChallengesSuspenseQuery
>;
export type FetchFeaturedChallengesQueryResult = Apollo.QueryResult<
  FetchFeaturedChallengesQuery,
  FetchFeaturedChallengesQueryVariables
>;
export const FetchAssessmentHeroCardsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FetchAssessmentHeroCards' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'requestGlobalContent' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'assessmentHeroCards' },
            name: { kind: 'Name', value: 'assessmentHeroCards' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'requestGlobalContent' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'requestGlobalContent' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SingleAssessmentsCardFields' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'THICardFields' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'HRACardFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SingleAssessmentsCardFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SingleAssessmentCard' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tierPoints' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'numberOfQuestions' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'percentageComplete' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'percentageScore' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'icon' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'tierPoints' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'THICardFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TotalHealthIndexCard' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextPillar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'score' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bracket' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bracketId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'color' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hexCode' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tierPoints' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HRACardFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HealthRiskAssessmentCard' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tierPoints' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numberOfAssessments' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessmentsRemaining' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextAssessment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'numberOfQuestions' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'percentageComplete' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'percentageScore' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFetchAssessmentHeroCardsQuery__
 *
 * To run a query within a React component, call `useFetchAssessmentHeroCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAssessmentHeroCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAssessmentHeroCardsQuery({
 *   variables: {
 *      requestGlobalContent: // value for 'requestGlobalContent'
 *   },
 * });
 */
export function useFetchAssessmentHeroCardsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchAssessmentHeroCardsQuery,
    FetchAssessmentHeroCardsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchAssessmentHeroCardsQuery,
    FetchAssessmentHeroCardsQueryVariables
  >(FetchAssessmentHeroCardsDocument, options);
}
export function useFetchAssessmentHeroCardsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchAssessmentHeroCardsQuery,
    FetchAssessmentHeroCardsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchAssessmentHeroCardsQuery,
    FetchAssessmentHeroCardsQueryVariables
  >(FetchAssessmentHeroCardsDocument, options);
}
// @ts-ignore
export function useFetchAssessmentHeroCardsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchAssessmentHeroCardsQuery,
    FetchAssessmentHeroCardsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchAssessmentHeroCardsQuery,
  FetchAssessmentHeroCardsQueryVariables
>;
export function useFetchAssessmentHeroCardsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchAssessmentHeroCardsQuery,
        FetchAssessmentHeroCardsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchAssessmentHeroCardsQuery | undefined,
  FetchAssessmentHeroCardsQueryVariables
>;
export function useFetchAssessmentHeroCardsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchAssessmentHeroCardsQuery,
        FetchAssessmentHeroCardsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchAssessmentHeroCardsQuery,
    FetchAssessmentHeroCardsQueryVariables
  >(FetchAssessmentHeroCardsDocument, options);
}
export type FetchAssessmentHeroCardsQueryHookResult = ReturnType<
  typeof useFetchAssessmentHeroCardsQuery
>;
export type FetchAssessmentHeroCardsLazyQueryHookResult = ReturnType<
  typeof useFetchAssessmentHeroCardsLazyQuery
>;
export type FetchAssessmentHeroCardsSuspenseQueryHookResult = ReturnType<
  typeof useFetchAssessmentHeroCardsSuspenseQuery
>;
export type FetchAssessmentHeroCardsQueryResult = Apollo.QueryResult<
  FetchAssessmentHeroCardsQuery,
  FetchAssessmentHeroCardsQueryVariables
>;
export const FetchWellbeingPromotionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FetchWellbeingPromotions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'from' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'GraphQLDate' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'wellbeingPromotions' },
            name: { kind: 'Name', value: 'wellbeingPromotions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ChallengePromotion' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FeaturedStepChallengeField' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'participationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stepActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FeaturedHabitChallengeField' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'participationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'from' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'from' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengePromotion' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ChallengePromotion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'challengeUnion' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'FeaturedHabitChallengeField' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'FeaturedStepChallengeField' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFetchWellbeingPromotionsQuery__
 *
 * To run a query within a React component, call `useFetchWellbeingPromotionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchWellbeingPromotionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchWellbeingPromotionsQuery({
 *   variables: {
 *      from: // value for 'from'
 *   },
 * });
 */
export function useFetchWellbeingPromotionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchWellbeingPromotionsQuery,
    FetchWellbeingPromotionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchWellbeingPromotionsQuery,
    FetchWellbeingPromotionsQueryVariables
  >(FetchWellbeingPromotionsDocument, options);
}
export function useFetchWellbeingPromotionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchWellbeingPromotionsQuery,
    FetchWellbeingPromotionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchWellbeingPromotionsQuery,
    FetchWellbeingPromotionsQueryVariables
  >(FetchWellbeingPromotionsDocument, options);
}
// @ts-ignore
export function useFetchWellbeingPromotionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchWellbeingPromotionsQuery,
    FetchWellbeingPromotionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchWellbeingPromotionsQuery,
  FetchWellbeingPromotionsQueryVariables
>;
export function useFetchWellbeingPromotionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchWellbeingPromotionsQuery,
        FetchWellbeingPromotionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchWellbeingPromotionsQuery | undefined,
  FetchWellbeingPromotionsQueryVariables
>;
export function useFetchWellbeingPromotionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchWellbeingPromotionsQuery,
        FetchWellbeingPromotionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchWellbeingPromotionsQuery,
    FetchWellbeingPromotionsQueryVariables
  >(FetchWellbeingPromotionsDocument, options);
}
export type FetchWellbeingPromotionsQueryHookResult = ReturnType<
  typeof useFetchWellbeingPromotionsQuery
>;
export type FetchWellbeingPromotionsLazyQueryHookResult = ReturnType<
  typeof useFetchWellbeingPromotionsLazyQuery
>;
export type FetchWellbeingPromotionsSuspenseQueryHookResult = ReturnType<
  typeof useFetchWellbeingPromotionsSuspenseQuery
>;
export type FetchWellbeingPromotionsQueryResult = Apollo.QueryResult<
  FetchWellbeingPromotionsQuery,
  FetchWellbeingPromotionsQueryVariables
>;
export const FetchWellbeingContentLanguageMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FetchWellbeingContentLanguageMessage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'assessmentContentLanguageMessage' },
            name: { kind: 'Name', value: 'wellbeingContentLanguageMessage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'section' },
                value: { kind: 'EnumValue', value: 'ASSESSMENTS' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'WellbeingContentLanguageMessage',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WellbeingContentLanguageMessage' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'WellbeingContentLanguageMessageResponse',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'banner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'WellbeingContentLanguageMessageNoContent',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'section' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bannerText' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'WellbeingContentLanguageMessageNoChoice',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'section' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bannerText' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bannerTextPopUp' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'WellbeingContentLanguageMessageChangeLanguage',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'section' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bannerText' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bannerTextPopUp' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFetchWellbeingContentLanguageMessageQuery__
 *
 * To run a query within a React component, call `useFetchWellbeingContentLanguageMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchWellbeingContentLanguageMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchWellbeingContentLanguageMessageQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchWellbeingContentLanguageMessageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchWellbeingContentLanguageMessageQuery,
    FetchWellbeingContentLanguageMessageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchWellbeingContentLanguageMessageQuery,
    FetchWellbeingContentLanguageMessageQueryVariables
  >(FetchWellbeingContentLanguageMessageDocument, options);
}
export function useFetchWellbeingContentLanguageMessageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchWellbeingContentLanguageMessageQuery,
    FetchWellbeingContentLanguageMessageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchWellbeingContentLanguageMessageQuery,
    FetchWellbeingContentLanguageMessageQueryVariables
  >(FetchWellbeingContentLanguageMessageDocument, options);
}
// @ts-ignore
export function useFetchWellbeingContentLanguageMessageSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchWellbeingContentLanguageMessageQuery,
    FetchWellbeingContentLanguageMessageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchWellbeingContentLanguageMessageQuery,
  FetchWellbeingContentLanguageMessageQueryVariables
>;
export function useFetchWellbeingContentLanguageMessageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchWellbeingContentLanguageMessageQuery,
        FetchWellbeingContentLanguageMessageQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchWellbeingContentLanguageMessageQuery | undefined,
  FetchWellbeingContentLanguageMessageQueryVariables
>;
export function useFetchWellbeingContentLanguageMessageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchWellbeingContentLanguageMessageQuery,
        FetchWellbeingContentLanguageMessageQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchWellbeingContentLanguageMessageQuery,
    FetchWellbeingContentLanguageMessageQueryVariables
  >(FetchWellbeingContentLanguageMessageDocument, options);
}
export type FetchWellbeingContentLanguageMessageQueryHookResult = ReturnType<
  typeof useFetchWellbeingContentLanguageMessageQuery
>;
export type FetchWellbeingContentLanguageMessageLazyQueryHookResult =
  ReturnType<typeof useFetchWellbeingContentLanguageMessageLazyQuery>;
export type FetchWellbeingContentLanguageMessageSuspenseQueryHookResult =
  ReturnType<typeof useFetchWellbeingContentLanguageMessageSuspenseQuery>;
export type FetchWellbeingContentLanguageMessageQueryResult =
  Apollo.QueryResult<
    FetchWellbeingContentLanguageMessageQuery,
    FetchWellbeingContentLanguageMessageQueryVariables
  >;
export const TieringDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Tiering' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentTier' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tierPoints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'earned' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allTiers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTieringQuery__
 *
 * To run a query within a React component, call `useTieringQuery` and pass it any options that fit your needs.
 * When your component renders, `useTieringQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTieringQuery({
 *   variables: {
 *   },
 * });
 */
export function useTieringQuery(
  baseOptions?: Apollo.QueryHookOptions<TieringQuery, TieringQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TieringQuery, TieringQueryVariables>(
    TieringDocument,
    options,
  );
}
export function useTieringLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TieringQuery,
    TieringQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TieringQuery, TieringQueryVariables>(
    TieringDocument,
    options,
  );
}
// @ts-ignore
export function useTieringSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TieringQuery,
    TieringQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<TieringQuery, TieringQueryVariables>;
export function useTieringSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TieringQuery, TieringQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  TieringQuery | undefined,
  TieringQueryVariables
>;
export function useTieringSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TieringQuery, TieringQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TieringQuery, TieringQueryVariables>(
    TieringDocument,
    options,
  );
}
export type TieringQueryHookResult = ReturnType<typeof useTieringQuery>;
export type TieringLazyQueryHookResult = ReturnType<typeof useTieringLazyQuery>;
export type TieringSuspenseQueryHookResult = ReturnType<
  typeof useTieringSuspenseQuery
>;
export type TieringQueryResult = Apollo.QueryResult<
  TieringQuery,
  TieringQueryVariables
>;
export const RecommendedResourcesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RecommendedResources' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendedArticles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'select' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'first' },
                      value: { kind: 'IntValue', value: '3' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recommendations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastModificationDate' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categoryTitle' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'author' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'surname' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'heroImage' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'audios' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'videos' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'howDoesPersonalisationWork' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'HowDoesPersonalisationWork' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PersonalisationPermission' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HowPersonalisationWorksPermission' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allowPersonalisation' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'footer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HowDoesPersonalisationWork' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HowDoesPersonalisationWorkResponse' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'body' } },
          { kind: 'Field', name: { kind: 'Name', value: 'button' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permission' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PersonalisationPermission' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useRecommendedResourcesQuery__
 *
 * To run a query within a React component, call `useRecommendedResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendedResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendedResourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecommendedResourcesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RecommendedResourcesQuery,
    RecommendedResourcesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RecommendedResourcesQuery,
    RecommendedResourcesQueryVariables
  >(RecommendedResourcesDocument, options);
}
export function useRecommendedResourcesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RecommendedResourcesQuery,
    RecommendedResourcesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RecommendedResourcesQuery,
    RecommendedResourcesQueryVariables
  >(RecommendedResourcesDocument, options);
}
// @ts-ignore
export function useRecommendedResourcesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RecommendedResourcesQuery,
    RecommendedResourcesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RecommendedResourcesQuery,
  RecommendedResourcesQueryVariables
>;
export function useRecommendedResourcesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RecommendedResourcesQuery,
        RecommendedResourcesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RecommendedResourcesQuery | undefined,
  RecommendedResourcesQueryVariables
>;
export function useRecommendedResourcesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RecommendedResourcesQuery,
        RecommendedResourcesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    RecommendedResourcesQuery,
    RecommendedResourcesQueryVariables
  >(RecommendedResourcesDocument, options);
}
export type RecommendedResourcesQueryHookResult = ReturnType<
  typeof useRecommendedResourcesQuery
>;
export type RecommendedResourcesLazyQueryHookResult = ReturnType<
  typeof useRecommendedResourcesLazyQuery
>;
export type RecommendedResourcesSuspenseQueryHookResult = ReturnType<
  typeof useRecommendedResourcesSuspenseQuery
>;
export type RecommendedResourcesQueryResult = Apollo.QueryResult<
  RecommendedResourcesQuery,
  RecommendedResourcesQueryVariables
>;
export const ChallengesOverviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ChallengesOverview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'from' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'GraphQLDate' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'joinedChallenges' },
            name: { kind: 'Name', value: 'fetchChallenges' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'wasJoined' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'HubList' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'notJoinedChallenges' },
            name: { kind: 'Name', value: 'fetchChallenges' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'wasJoined' },
                      value: { kind: 'BooleanValue', value: false },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'participationType' },
                      value: { kind: 'EnumValue', value: 'Individual' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'HubList' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'completedChallenges' },
            name: { kind: 'Name', value: 'fetchChallenges' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'participationType' },
                      value: { kind: 'EnumValue', value: 'Individual' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: {
                        kind: 'ListValue',
                        values: [{ kind: 'EnumValue', value: 'Completed' }],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'HubList' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengeIntroduction' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ChallengeIntroduction' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'info' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StepChallengeDateInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUploaded' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StepChallengeListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categoryDisplayText' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'participationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stepActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaderboardIndividuals' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leaderboard' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'position' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitChallengeDateInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengePage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Challenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'HabitChallenge' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participationType' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'introduction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ChallengeIntroduction' },
                      },
                    ],
                  },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'HabitChallengeDateInfo' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'StepChallenge' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participationType' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastUploaded' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'introduction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ChallengeIntroduction' },
                      },
                    ],
                  },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'StepChallengeDateInfo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HabitChallengeListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categoryDisplayText' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'participationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'from' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'from' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaderboardIndividuals' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leaderboard' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'position' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HubList' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'fetchChallengesResponse' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'challenges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ChallengePage' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'StepChallengeListItem' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'HabitChallengeListItem' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useChallengesOverviewQuery__
 *
 * To run a query within a React component, call `useChallengesOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useChallengesOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChallengesOverviewQuery({
 *   variables: {
 *      from: // value for 'from'
 *   },
 * });
 */
export function useChallengesOverviewQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ChallengesOverviewQuery,
    ChallengesOverviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ChallengesOverviewQuery,
    ChallengesOverviewQueryVariables
  >(ChallengesOverviewDocument, options);
}
export function useChallengesOverviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChallengesOverviewQuery,
    ChallengesOverviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ChallengesOverviewQuery,
    ChallengesOverviewQueryVariables
  >(ChallengesOverviewDocument, options);
}
// @ts-ignore
export function useChallengesOverviewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ChallengesOverviewQuery,
    ChallengesOverviewQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ChallengesOverviewQuery,
  ChallengesOverviewQueryVariables
>;
export function useChallengesOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChallengesOverviewQuery,
        ChallengesOverviewQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ChallengesOverviewQuery | undefined,
  ChallengesOverviewQueryVariables
>;
export function useChallengesOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ChallengesOverviewQuery,
        ChallengesOverviewQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ChallengesOverviewQuery,
    ChallengesOverviewQueryVariables
  >(ChallengesOverviewDocument, options);
}
export type ChallengesOverviewQueryHookResult = ReturnType<
  typeof useChallengesOverviewQuery
>;
export type ChallengesOverviewLazyQueryHookResult = ReturnType<
  typeof useChallengesOverviewLazyQuery
>;
export type ChallengesOverviewSuspenseQueryHookResult = ReturnType<
  typeof useChallengesOverviewSuspenseQuery
>;
export type ChallengesOverviewQueryResult = Apollo.QueryResult<
  ChallengesOverviewQuery,
  ChallengesOverviewQueryVariables
>;
export const WellbeingPromotionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WellbeingPromotions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'from' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'GraphQLDate' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'wellbeingPromotions' },
            name: { kind: 'Name', value: 'wellbeingPromotions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ChallengePromotion' },
                },
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'WellbeingHubAssessmentPromotion',
                  },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'WellbeingHubHraPromotion' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WellbeingHubAssessmentListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfQuestions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'percentageComplete' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tierPoints' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WellbeingHubAssessmentPromotion' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AssessmentPromotion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'WellbeingHubAssessmentListItem',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WellbeingHubHraPromotion' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HraPromotion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'HRAPromotionFields' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FeaturedStepChallengeField' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StepChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'participationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stepActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FeaturedHabitChallengeField' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HabitChallenge' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'participationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'challengeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completionReward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'goal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'from' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'from' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracked' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endDateTimeISO' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startDateTimeISO' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChallengePromotion' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ChallengePromotion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'challengeUnion' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'FeaturedHabitChallengeField' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'FeaturedStepChallengeField' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HRAPromotionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HraPromotion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assessment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'icon' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tierPoints' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'numberOfAssessments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assessmentsRemaining' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assessment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfQuestions' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'percentageComplete' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'result' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'percentageScore' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useWellbeingPromotionsQuery__
 *
 * To run a query within a React component, call `useWellbeingPromotionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWellbeingPromotionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWellbeingPromotionsQuery({
 *   variables: {
 *      from: // value for 'from'
 *   },
 * });
 */
export function useWellbeingPromotionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    WellbeingPromotionsQuery,
    WellbeingPromotionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    WellbeingPromotionsQuery,
    WellbeingPromotionsQueryVariables
  >(WellbeingPromotionsDocument, options);
}
export function useWellbeingPromotionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WellbeingPromotionsQuery,
    WellbeingPromotionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WellbeingPromotionsQuery,
    WellbeingPromotionsQueryVariables
  >(WellbeingPromotionsDocument, options);
}
// @ts-ignore
export function useWellbeingPromotionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WellbeingPromotionsQuery,
    WellbeingPromotionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  WellbeingPromotionsQuery,
  WellbeingPromotionsQueryVariables
>;
export function useWellbeingPromotionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WellbeingPromotionsQuery,
        WellbeingPromotionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  WellbeingPromotionsQuery | undefined,
  WellbeingPromotionsQueryVariables
>;
export function useWellbeingPromotionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WellbeingPromotionsQuery,
        WellbeingPromotionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WellbeingPromotionsQuery,
    WellbeingPromotionsQueryVariables
  >(WellbeingPromotionsDocument, options);
}
export type WellbeingPromotionsQueryHookResult = ReturnType<
  typeof useWellbeingPromotionsQuery
>;
export type WellbeingPromotionsLazyQueryHookResult = ReturnType<
  typeof useWellbeingPromotionsLazyQuery
>;
export type WellbeingPromotionsSuspenseQueryHookResult = ReturnType<
  typeof useWellbeingPromotionsSuspenseQuery
>;
export type WellbeingPromotionsQueryResult = Apollo.QueryResult<
  WellbeingPromotionsQuery,
  WellbeingPromotionsQueryVariables
>;
export const CareNowProgramsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CareNowPrograms' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'notJoinedPrograms' },
            name: { kind: 'Name', value: 'digitalClinicalPrograms' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'select' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'first' },
                      value: { kind: 'IntValue', value: '3' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'wasJoined' },
                      value: { kind: 'BooleanValue', value: false },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'WellbeingHubProgramFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'joinedPrograms' },
            name: { kind: 'Name', value: 'digitalClinicalPrograms' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'select' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'first' },
                      value: { kind: 'IntValue', value: '4' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'wasJoined' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          { kind: 'EnumValue', value: 'NotStarted' },
                          { kind: 'EnumValue', value: 'InProgress' },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'WellbeingHubProgramFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'completedPrograms' },
            name: { kind: 'Name', value: 'digitalClinicalPrograms' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'select' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'first' },
                      value: { kind: 'IntValue', value: '3' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: {
                        kind: 'ListValue',
                        values: [{ kind: 'EnumValue', value: 'Completed' }],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'WellbeingHubProgramFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WellbeingHubProgramFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DigitalClinicalProgramListItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'programId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wasJoined' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'progress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalModules' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedModules' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'percentageComplete' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCareNowProgramsQuery__
 *
 * To run a query within a React component, call `useCareNowProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCareNowProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCareNowProgramsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCareNowProgramsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CareNowProgramsQuery,
    CareNowProgramsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CareNowProgramsQuery, CareNowProgramsQueryVariables>(
    CareNowProgramsDocument,
    options,
  );
}
export function useCareNowProgramsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CareNowProgramsQuery,
    CareNowProgramsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CareNowProgramsQuery,
    CareNowProgramsQueryVariables
  >(CareNowProgramsDocument, options);
}
// @ts-ignore
export function useCareNowProgramsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CareNowProgramsQuery,
    CareNowProgramsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CareNowProgramsQuery,
  CareNowProgramsQueryVariables
>;
export function useCareNowProgramsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CareNowProgramsQuery,
        CareNowProgramsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CareNowProgramsQuery | undefined,
  CareNowProgramsQueryVariables
>;
export function useCareNowProgramsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CareNowProgramsQuery,
        CareNowProgramsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CareNowProgramsQuery,
    CareNowProgramsQueryVariables
  >(CareNowProgramsDocument, options);
}
export type CareNowProgramsQueryHookResult = ReturnType<
  typeof useCareNowProgramsQuery
>;
export type CareNowProgramsLazyQueryHookResult = ReturnType<
  typeof useCareNowProgramsLazyQuery
>;
export type CareNowProgramsSuspenseQueryHookResult = ReturnType<
  typeof useCareNowProgramsSuspenseQuery
>;
export type CareNowProgramsQueryResult = Apollo.QueryResult<
  CareNowProgramsQuery,
  CareNowProgramsQueryVariables
>;
export const PromotedActivitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PromotedActivities' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customTierActivities' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CustomTieringActivityListItem',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tierRegressionInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TierRegressionInfo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentTier' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TieringHubCurrentTier' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomTieringActivityListItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CustomTierActivity' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'activityId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tierPointAward' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'points' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TieringHubCurrentTier' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CurrentTier' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'motivationalMessage' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TierRegressionInfo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TierRegressionInfo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'font' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'color' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hexCode' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'timePeriods' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isCurrent' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'timePeriod' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pointsEarned' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'pointGoal' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePromotedActivitiesQuery__
 *
 * To run a query within a React component, call `usePromotedActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromotedActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromotedActivitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePromotedActivitiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PromotedActivitiesQuery,
    PromotedActivitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PromotedActivitiesQuery,
    PromotedActivitiesQueryVariables
  >(PromotedActivitiesDocument, options);
}
export function usePromotedActivitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PromotedActivitiesQuery,
    PromotedActivitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PromotedActivitiesQuery,
    PromotedActivitiesQueryVariables
  >(PromotedActivitiesDocument, options);
}
// @ts-ignore
export function usePromotedActivitiesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PromotedActivitiesQuery,
    PromotedActivitiesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  PromotedActivitiesQuery,
  PromotedActivitiesQueryVariables
>;
export function usePromotedActivitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PromotedActivitiesQuery,
        PromotedActivitiesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PromotedActivitiesQuery | undefined,
  PromotedActivitiesQueryVariables
>;
export function usePromotedActivitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PromotedActivitiesQuery,
        PromotedActivitiesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PromotedActivitiesQuery,
    PromotedActivitiesQueryVariables
  >(PromotedActivitiesDocument, options);
}
export type PromotedActivitiesQueryHookResult = ReturnType<
  typeof usePromotedActivitiesQuery
>;
export type PromotedActivitiesLazyQueryHookResult = ReturnType<
  typeof usePromotedActivitiesLazyQuery
>;
export type PromotedActivitiesSuspenseQueryHookResult = ReturnType<
  typeof usePromotedActivitiesSuspenseQuery
>;
export type PromotedActivitiesQueryResult = Apollo.QueryResult<
  PromotedActivitiesQuery,
  PromotedActivitiesQueryVariables
>;
export const WpoCreateAppointmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'wpoCreateAppointment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'WpoCreateAppointmentInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wpoCreateAppointment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'WpoCreateAppointment' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WpoCreateAppointment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'WpoCreateAppointmentResponse' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'success' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentStartDateTime' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentEndDateTime' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'counsellorId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'counsellorFirstName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'counsellorLastName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'userFirstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userLastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentMode' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type WpoCreateAppointmentMutationFn = Apollo.MutationFunction<
  WpoCreateAppointmentMutation,
  WpoCreateAppointmentMutationVariables
>;

/**
 * __useWpoCreateAppointmentMutation__
 *
 * To run a mutation, you first call `useWpoCreateAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWpoCreateAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wpoCreateAppointmentMutation, { data, loading, error }] = useWpoCreateAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWpoCreateAppointmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WpoCreateAppointmentMutation,
    WpoCreateAppointmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    WpoCreateAppointmentMutation,
    WpoCreateAppointmentMutationVariables
  >(WpoCreateAppointmentDocument, options);
}
export type WpoCreateAppointmentMutationHookResult = ReturnType<
  typeof useWpoCreateAppointmentMutation
>;
export type WpoCreateAppointmentMutationResult =
  Apollo.MutationResult<WpoCreateAppointmentMutation>;
export type WpoCreateAppointmentMutationOptions = Apollo.BaseMutationOptions<
  WpoCreateAppointmentMutation,
  WpoCreateAppointmentMutationVariables
>;
export const GetWpoAppointmentHistoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getWpoAppointmentHistory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'WpoGetAppointmentHistoryInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wpoGetAppointmentHistory' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appointmentId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateFrom' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateTo' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appointmentMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'counsellorName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetWpoAppointmentHistoryQuery__
 *
 * To run a query within a React component, call `useGetWpoAppointmentHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWpoAppointmentHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWpoAppointmentHistoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWpoAppointmentHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWpoAppointmentHistoryQuery,
    GetWpoAppointmentHistoryQueryVariables
  > &
    (
      | { variables: GetWpoAppointmentHistoryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWpoAppointmentHistoryQuery,
    GetWpoAppointmentHistoryQueryVariables
  >(GetWpoAppointmentHistoryDocument, options);
}
export function useGetWpoAppointmentHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWpoAppointmentHistoryQuery,
    GetWpoAppointmentHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWpoAppointmentHistoryQuery,
    GetWpoAppointmentHistoryQueryVariables
  >(GetWpoAppointmentHistoryDocument, options);
}
// @ts-ignore
export function useGetWpoAppointmentHistorySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWpoAppointmentHistoryQuery,
    GetWpoAppointmentHistoryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetWpoAppointmentHistoryQuery,
  GetWpoAppointmentHistoryQueryVariables
>;
export function useGetWpoAppointmentHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWpoAppointmentHistoryQuery,
        GetWpoAppointmentHistoryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetWpoAppointmentHistoryQuery | undefined,
  GetWpoAppointmentHistoryQueryVariables
>;
export function useGetWpoAppointmentHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWpoAppointmentHistoryQuery,
        GetWpoAppointmentHistoryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWpoAppointmentHistoryQuery,
    GetWpoAppointmentHistoryQueryVariables
  >(GetWpoAppointmentHistoryDocument, options);
}
export type GetWpoAppointmentHistoryQueryHookResult = ReturnType<
  typeof useGetWpoAppointmentHistoryQuery
>;
export type GetWpoAppointmentHistoryLazyQueryHookResult = ReturnType<
  typeof useGetWpoAppointmentHistoryLazyQuery
>;
export type GetWpoAppointmentHistorySuspenseQueryHookResult = ReturnType<
  typeof useGetWpoAppointmentHistorySuspenseQuery
>;
export type GetWpoAppointmentHistoryQueryResult = Apollo.QueryResult<
  GetWpoAppointmentHistoryQuery,
  GetWpoAppointmentHistoryQueryVariables
>;
export const GetWpoAppointmentsAreasOfConcernDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getWpoAppointmentsAreasOfConcern' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'WpoGetFiltersInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wpoGetFilters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'areaOfConcerns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetWpoAppointmentsAreasOfConcernQuery__
 *
 * To run a query within a React component, call `useGetWpoAppointmentsAreasOfConcernQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWpoAppointmentsAreasOfConcernQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWpoAppointmentsAreasOfConcernQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWpoAppointmentsAreasOfConcernQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetWpoAppointmentsAreasOfConcernQuery,
    GetWpoAppointmentsAreasOfConcernQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWpoAppointmentsAreasOfConcernQuery,
    GetWpoAppointmentsAreasOfConcernQueryVariables
  >(GetWpoAppointmentsAreasOfConcernDocument, options);
}
export function useGetWpoAppointmentsAreasOfConcernLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWpoAppointmentsAreasOfConcernQuery,
    GetWpoAppointmentsAreasOfConcernQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWpoAppointmentsAreasOfConcernQuery,
    GetWpoAppointmentsAreasOfConcernQueryVariables
  >(GetWpoAppointmentsAreasOfConcernDocument, options);
}
// @ts-ignore
export function useGetWpoAppointmentsAreasOfConcernSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWpoAppointmentsAreasOfConcernQuery,
    GetWpoAppointmentsAreasOfConcernQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetWpoAppointmentsAreasOfConcernQuery,
  GetWpoAppointmentsAreasOfConcernQueryVariables
>;
export function useGetWpoAppointmentsAreasOfConcernSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWpoAppointmentsAreasOfConcernQuery,
        GetWpoAppointmentsAreasOfConcernQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetWpoAppointmentsAreasOfConcernQuery | undefined,
  GetWpoAppointmentsAreasOfConcernQueryVariables
>;
export function useGetWpoAppointmentsAreasOfConcernSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWpoAppointmentsAreasOfConcernQuery,
        GetWpoAppointmentsAreasOfConcernQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWpoAppointmentsAreasOfConcernQuery,
    GetWpoAppointmentsAreasOfConcernQueryVariables
  >(GetWpoAppointmentsAreasOfConcernDocument, options);
}
export type GetWpoAppointmentsAreasOfConcernQueryHookResult = ReturnType<
  typeof useGetWpoAppointmentsAreasOfConcernQuery
>;
export type GetWpoAppointmentsAreasOfConcernLazyQueryHookResult = ReturnType<
  typeof useGetWpoAppointmentsAreasOfConcernLazyQuery
>;
export type GetWpoAppointmentsAreasOfConcernSuspenseQueryHookResult =
  ReturnType<typeof useGetWpoAppointmentsAreasOfConcernSuspenseQuery>;
export type GetWpoAppointmentsAreasOfConcernQueryResult = Apollo.QueryResult<
  GetWpoAppointmentsAreasOfConcernQuery,
  GetWpoAppointmentsAreasOfConcernQueryVariables
>;
export const WpoCancelAppointmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'WpoCancelAppointment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'WpoCancelAppointmentInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wpoCancelAppointment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type WpoCancelAppointmentMutationFn = Apollo.MutationFunction<
  WpoCancelAppointmentMutation,
  WpoCancelAppointmentMutationVariables
>;

/**
 * __useWpoCancelAppointmentMutation__
 *
 * To run a mutation, you first call `useWpoCancelAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWpoCancelAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wpoCancelAppointmentMutation, { data, loading, error }] = useWpoCancelAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWpoCancelAppointmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WpoCancelAppointmentMutation,
    WpoCancelAppointmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    WpoCancelAppointmentMutation,
    WpoCancelAppointmentMutationVariables
  >(WpoCancelAppointmentDocument, options);
}
export type WpoCancelAppointmentMutationHookResult = ReturnType<
  typeof useWpoCancelAppointmentMutation
>;
export type WpoCancelAppointmentMutationResult =
  Apollo.MutationResult<WpoCancelAppointmentMutation>;
export type WpoCancelAppointmentMutationOptions = Apollo.BaseMutationOptions<
  WpoCancelAppointmentMutation,
  WpoCancelAppointmentMutationVariables
>;
export const GetAvailableWpoCounsellorsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAvailableWpoCounsellors' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'WpoGetAvailableCounsellorsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wpoGetAvailableCounsellors' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'counsellorList' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'counsellorId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gender' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAvailableWpoCounsellorsQuery__
 *
 * To run a query within a React component, call `useGetAvailableWpoCounsellorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableWpoCounsellorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableWpoCounsellorsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAvailableWpoCounsellorsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAvailableWpoCounsellorsQuery,
    GetAvailableWpoCounsellorsQueryVariables
  > &
    (
      | { variables: GetAvailableWpoCounsellorsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAvailableWpoCounsellorsQuery,
    GetAvailableWpoCounsellorsQueryVariables
  >(GetAvailableWpoCounsellorsDocument, options);
}
export function useGetAvailableWpoCounsellorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAvailableWpoCounsellorsQuery,
    GetAvailableWpoCounsellorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAvailableWpoCounsellorsQuery,
    GetAvailableWpoCounsellorsQueryVariables
  >(GetAvailableWpoCounsellorsDocument, options);
}
// @ts-ignore
export function useGetAvailableWpoCounsellorsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAvailableWpoCounsellorsQuery,
    GetAvailableWpoCounsellorsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAvailableWpoCounsellorsQuery,
  GetAvailableWpoCounsellorsQueryVariables
>;
export function useGetAvailableWpoCounsellorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAvailableWpoCounsellorsQuery,
        GetAvailableWpoCounsellorsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAvailableWpoCounsellorsQuery | undefined,
  GetAvailableWpoCounsellorsQueryVariables
>;
export function useGetAvailableWpoCounsellorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAvailableWpoCounsellorsQuery,
        GetAvailableWpoCounsellorsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAvailableWpoCounsellorsQuery,
    GetAvailableWpoCounsellorsQueryVariables
  >(GetAvailableWpoCounsellorsDocument, options);
}
export type GetAvailableWpoCounsellorsQueryHookResult = ReturnType<
  typeof useGetAvailableWpoCounsellorsQuery
>;
export type GetAvailableWpoCounsellorsLazyQueryHookResult = ReturnType<
  typeof useGetAvailableWpoCounsellorsLazyQuery
>;
export type GetAvailableWpoCounsellorsSuspenseQueryHookResult = ReturnType<
  typeof useGetAvailableWpoCounsellorsSuspenseQuery
>;
export type GetAvailableWpoCounsellorsQueryResult = Apollo.QueryResult<
  GetAvailableWpoCounsellorsQuery,
  GetAvailableWpoCounsellorsQueryVariables
>;
export const GetHowItWorksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getHowItWorks' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'GetHowItWorksInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getHowItWorks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'headerImageUrl' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetHowItWorksQuery__
 *
 * To run a query within a React component, call `useGetHowItWorksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHowItWorksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHowItWorksQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetHowItWorksQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetHowItWorksQuery,
    GetHowItWorksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetHowItWorksQuery, GetHowItWorksQueryVariables>(
    GetHowItWorksDocument,
    options,
  );
}
export function useGetHowItWorksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetHowItWorksQuery,
    GetHowItWorksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetHowItWorksQuery, GetHowItWorksQueryVariables>(
    GetHowItWorksDocument,
    options,
  );
}
// @ts-ignore
export function useGetHowItWorksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetHowItWorksQuery,
    GetHowItWorksQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetHowItWorksQuery,
  GetHowItWorksQueryVariables
>;
export function useGetHowItWorksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetHowItWorksQuery,
        GetHowItWorksQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetHowItWorksQuery | undefined,
  GetHowItWorksQueryVariables
>;
export function useGetHowItWorksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetHowItWorksQuery,
        GetHowItWorksQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetHowItWorksQuery,
    GetHowItWorksQueryVariables
  >(GetHowItWorksDocument, options);
}
export type GetHowItWorksQueryHookResult = ReturnType<
  typeof useGetHowItWorksQuery
>;
export type GetHowItWorksLazyQueryHookResult = ReturnType<
  typeof useGetHowItWorksLazyQuery
>;
export type GetHowItWorksSuspenseQueryHookResult = ReturnType<
  typeof useGetHowItWorksSuspenseQuery
>;
export type GetHowItWorksQueryResult = Apollo.QueryResult<
  GetHowItWorksQuery,
  GetHowItWorksQueryVariables
>;
export const GetHasUpcomingWpoAppointmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getHasUpcomingWpoAppointment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'WpoUserHasUpcomingAppointmentInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wpoUserHasUpcomingAppointment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'appointment' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'wpoServiceConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'serviceId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appointmentTypeId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetHasUpcomingWpoAppointmentQuery__
 *
 * To run a query within a React component, call `useGetHasUpcomingWpoAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHasUpcomingWpoAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHasUpcomingWpoAppointmentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetHasUpcomingWpoAppointmentQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetHasUpcomingWpoAppointmentQuery,
    GetHasUpcomingWpoAppointmentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetHasUpcomingWpoAppointmentQuery,
    GetHasUpcomingWpoAppointmentQueryVariables
  >(GetHasUpcomingWpoAppointmentDocument, options);
}
export function useGetHasUpcomingWpoAppointmentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetHasUpcomingWpoAppointmentQuery,
    GetHasUpcomingWpoAppointmentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetHasUpcomingWpoAppointmentQuery,
    GetHasUpcomingWpoAppointmentQueryVariables
  >(GetHasUpcomingWpoAppointmentDocument, options);
}
// @ts-ignore
export function useGetHasUpcomingWpoAppointmentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetHasUpcomingWpoAppointmentQuery,
    GetHasUpcomingWpoAppointmentQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetHasUpcomingWpoAppointmentQuery,
  GetHasUpcomingWpoAppointmentQueryVariables
>;
export function useGetHasUpcomingWpoAppointmentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetHasUpcomingWpoAppointmentQuery,
        GetHasUpcomingWpoAppointmentQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetHasUpcomingWpoAppointmentQuery | undefined,
  GetHasUpcomingWpoAppointmentQueryVariables
>;
export function useGetHasUpcomingWpoAppointmentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetHasUpcomingWpoAppointmentQuery,
        GetHasUpcomingWpoAppointmentQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetHasUpcomingWpoAppointmentQuery,
    GetHasUpcomingWpoAppointmentQueryVariables
  >(GetHasUpcomingWpoAppointmentDocument, options);
}
export type GetHasUpcomingWpoAppointmentQueryHookResult = ReturnType<
  typeof useGetHasUpcomingWpoAppointmentQuery
>;
export type GetHasUpcomingWpoAppointmentLazyQueryHookResult = ReturnType<
  typeof useGetHasUpcomingWpoAppointmentLazyQuery
>;
export type GetHasUpcomingWpoAppointmentSuspenseQueryHookResult = ReturnType<
  typeof useGetHasUpcomingWpoAppointmentSuspenseQuery
>;
export type GetHasUpcomingWpoAppointmentQueryResult = Apollo.QueryResult<
  GetHasUpcomingWpoAppointmentQuery,
  GetHasUpcomingWpoAppointmentQueryVariables
>;
export const GetWpoAppointmentsLanguagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getWpoAppointmentsLanguages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'WpoGetFiltersInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wpoGetFilters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'counsellorLanguages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetWpoAppointmentsLanguagesQuery__
 *
 * To run a query within a React component, call `useGetWpoAppointmentsLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWpoAppointmentsLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWpoAppointmentsLanguagesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWpoAppointmentsLanguagesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetWpoAppointmentsLanguagesQuery,
    GetWpoAppointmentsLanguagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWpoAppointmentsLanguagesQuery,
    GetWpoAppointmentsLanguagesQueryVariables
  >(GetWpoAppointmentsLanguagesDocument, options);
}
export function useGetWpoAppointmentsLanguagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWpoAppointmentsLanguagesQuery,
    GetWpoAppointmentsLanguagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWpoAppointmentsLanguagesQuery,
    GetWpoAppointmentsLanguagesQueryVariables
  >(GetWpoAppointmentsLanguagesDocument, options);
}
// @ts-ignore
export function useGetWpoAppointmentsLanguagesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWpoAppointmentsLanguagesQuery,
    GetWpoAppointmentsLanguagesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetWpoAppointmentsLanguagesQuery,
  GetWpoAppointmentsLanguagesQueryVariables
>;
export function useGetWpoAppointmentsLanguagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWpoAppointmentsLanguagesQuery,
        GetWpoAppointmentsLanguagesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetWpoAppointmentsLanguagesQuery | undefined,
  GetWpoAppointmentsLanguagesQueryVariables
>;
export function useGetWpoAppointmentsLanguagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWpoAppointmentsLanguagesQuery,
        GetWpoAppointmentsLanguagesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWpoAppointmentsLanguagesQuery,
    GetWpoAppointmentsLanguagesQueryVariables
  >(GetWpoAppointmentsLanguagesDocument, options);
}
export type GetWpoAppointmentsLanguagesQueryHookResult = ReturnType<
  typeof useGetWpoAppointmentsLanguagesQuery
>;
export type GetWpoAppointmentsLanguagesLazyQueryHookResult = ReturnType<
  typeof useGetWpoAppointmentsLanguagesLazyQuery
>;
export type GetWpoAppointmentsLanguagesSuspenseQueryHookResult = ReturnType<
  typeof useGetWpoAppointmentsLanguagesSuspenseQuery
>;
export type GetWpoAppointmentsLanguagesQueryResult = Apollo.QueryResult<
  GetWpoAppointmentsLanguagesQuery,
  GetWpoAppointmentsLanguagesQueryVariables
>;
export const GetAvailableWpoTimeslotsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAvailableWpoTimeslots' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'WpoGetAvailableTimeSlotsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wpoGetAvailableTimeSlots' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availableTimeSlots' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startDateTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endDateTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timeslotId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAvailableWpoTimeslotsQuery__
 *
 * To run a query within a React component, call `useGetAvailableWpoTimeslotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableWpoTimeslotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableWpoTimeslotsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAvailableWpoTimeslotsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAvailableWpoTimeslotsQuery,
    GetAvailableWpoTimeslotsQueryVariables
  > &
    (
      | { variables: GetAvailableWpoTimeslotsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAvailableWpoTimeslotsQuery,
    GetAvailableWpoTimeslotsQueryVariables
  >(GetAvailableWpoTimeslotsDocument, options);
}
export function useGetAvailableWpoTimeslotsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAvailableWpoTimeslotsQuery,
    GetAvailableWpoTimeslotsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAvailableWpoTimeslotsQuery,
    GetAvailableWpoTimeslotsQueryVariables
  >(GetAvailableWpoTimeslotsDocument, options);
}
// @ts-ignore
export function useGetAvailableWpoTimeslotsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAvailableWpoTimeslotsQuery,
    GetAvailableWpoTimeslotsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAvailableWpoTimeslotsQuery,
  GetAvailableWpoTimeslotsQueryVariables
>;
export function useGetAvailableWpoTimeslotsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAvailableWpoTimeslotsQuery,
        GetAvailableWpoTimeslotsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAvailableWpoTimeslotsQuery | undefined,
  GetAvailableWpoTimeslotsQueryVariables
>;
export function useGetAvailableWpoTimeslotsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAvailableWpoTimeslotsQuery,
        GetAvailableWpoTimeslotsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAvailableWpoTimeslotsQuery,
    GetAvailableWpoTimeslotsQueryVariables
  >(GetAvailableWpoTimeslotsDocument, options);
}
export type GetAvailableWpoTimeslotsQueryHookResult = ReturnType<
  typeof useGetAvailableWpoTimeslotsQuery
>;
export type GetAvailableWpoTimeslotsLazyQueryHookResult = ReturnType<
  typeof useGetAvailableWpoTimeslotsLazyQuery
>;
export type GetAvailableWpoTimeslotsSuspenseQueryHookResult = ReturnType<
  typeof useGetAvailableWpoTimeslotsSuspenseQuery
>;
export type GetAvailableWpoTimeslotsQueryResult = Apollo.QueryResult<
  GetAvailableWpoTimeslotsQuery,
  GetAvailableWpoTimeslotsQueryVariables
>;
export const FetchBannerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FetchBanner' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'bannerId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BannerId' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'banner' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'bannerId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Banner' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Banner' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BannerResponse' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'banner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'dismissed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFetchBannerQuery__
 *
 * To run a query within a React component, call `useFetchBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchBannerQuery({
 *   variables: {
 *      bannerId: // value for 'bannerId'
 *   },
 * });
 */
export function useFetchBannerQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchBannerQuery,
    FetchBannerQueryVariables
  > &
    (
      | { variables: FetchBannerQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FetchBannerQuery, FetchBannerQueryVariables>(
    FetchBannerDocument,
    options,
  );
}
export function useFetchBannerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchBannerQuery,
    FetchBannerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FetchBannerQuery, FetchBannerQueryVariables>(
    FetchBannerDocument,
    options,
  );
}
// @ts-ignore
export function useFetchBannerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchBannerQuery,
    FetchBannerQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<FetchBannerQuery, FetchBannerQueryVariables>;
export function useFetchBannerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchBannerQuery,
        FetchBannerQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchBannerQuery | undefined,
  FetchBannerQueryVariables
>;
export function useFetchBannerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchBannerQuery,
        FetchBannerQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FetchBannerQuery, FetchBannerQueryVariables>(
    FetchBannerDocument,
    options,
  );
}
export type FetchBannerQueryHookResult = ReturnType<typeof useFetchBannerQuery>;
export type FetchBannerLazyQueryHookResult = ReturnType<
  typeof useFetchBannerLazyQuery
>;
export type FetchBannerSuspenseQueryHookResult = ReturnType<
  typeof useFetchBannerSuspenseQuery
>;
export type FetchBannerQueryResult = Apollo.QueryResult<
  FetchBannerQuery,
  FetchBannerQueryVariables
>;
export const DismissBannerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DismissBanner' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'bannerId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BannerId' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'markAsDismissed' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'bannerId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Banner' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Banner' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BannerResponse' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'banner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'dismissed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DismissBannerMutationFn = Apollo.MutationFunction<
  DismissBannerMutation,
  DismissBannerMutationVariables
>;

/**
 * __useDismissBannerMutation__
 *
 * To run a mutation, you first call `useDismissBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissBannerMutation, { data, loading, error }] = useDismissBannerMutation({
 *   variables: {
 *      bannerId: // value for 'bannerId'
 *   },
 * });
 */
export function useDismissBannerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DismissBannerMutation,
    DismissBannerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DismissBannerMutation,
    DismissBannerMutationVariables
  >(DismissBannerDocument, options);
}
export type DismissBannerMutationHookResult = ReturnType<
  typeof useDismissBannerMutation
>;
export type DismissBannerMutationResult =
  Apollo.MutationResult<DismissBannerMutation>;
export type DismissBannerMutationOptions = Apollo.BaseMutationOptions<
  DismissBannerMutation,
  DismissBannerMutationVariables
>;
export const TooltipDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Tooltip' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'findTooltip' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FindTooltipInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tooltip' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'findTooltip' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TooltipFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TooltipFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Tooltip' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'tooltipId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTooltipQuery__
 *
 * To run a query within a React component, call `useTooltipQuery` and pass it any options that fit your needs.
 * When your component renders, `useTooltipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTooltipQuery({
 *   variables: {
 *      findTooltip: // value for 'findTooltip'
 *   },
 * });
 */
export function useTooltipQuery(
  baseOptions: Apollo.QueryHookOptions<TooltipQuery, TooltipQueryVariables> &
    ({ variables: TooltipQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TooltipQuery, TooltipQueryVariables>(
    TooltipDocument,
    options,
  );
}
export function useTooltipLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TooltipQuery,
    TooltipQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TooltipQuery, TooltipQueryVariables>(
    TooltipDocument,
    options,
  );
}
// @ts-ignore
export function useTooltipSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TooltipQuery,
    TooltipQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<TooltipQuery, TooltipQueryVariables>;
export function useTooltipSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TooltipQuery, TooltipQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  TooltipQuery | undefined,
  TooltipQueryVariables
>;
export function useTooltipSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TooltipQuery, TooltipQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TooltipQuery, TooltipQueryVariables>(
    TooltipDocument,
    options,
  );
}
export type TooltipQueryHookResult = ReturnType<typeof useTooltipQuery>;
export type TooltipLazyQueryHookResult = ReturnType<typeof useTooltipLazyQuery>;
export type TooltipSuspenseQueryHookResult = ReturnType<
  typeof useTooltipSuspenseQuery
>;
export type TooltipQueryResult = Apollo.QueryResult<
  TooltipQuery,
  TooltipQueryVariables
>;
export const DismissTooltipDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DismissTooltip' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'findTooltip' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FindTooltipInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dismissTooltip' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'request' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'findTooltip' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tooltipId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DismissTooltipMutationFn = Apollo.MutationFunction<
  DismissTooltipMutation,
  DismissTooltipMutationVariables
>;

/**
 * __useDismissTooltipMutation__
 *
 * To run a mutation, you first call `useDismissTooltipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissTooltipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissTooltipMutation, { data, loading, error }] = useDismissTooltipMutation({
 *   variables: {
 *      findTooltip: // value for 'findTooltip'
 *   },
 * });
 */
export function useDismissTooltipMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DismissTooltipMutation,
    DismissTooltipMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DismissTooltipMutation,
    DismissTooltipMutationVariables
  >(DismissTooltipDocument, options);
}
export type DismissTooltipMutationHookResult = ReturnType<
  typeof useDismissTooltipMutation
>;
export type DismissTooltipMutationResult =
  Apollo.MutationResult<DismissTooltipMutation>;
export type DismissTooltipMutationOptions = Apollo.BaseMutationOptions<
  DismissTooltipMutation,
  DismissTooltipMutationVariables
>;
export const FeedbackRequestDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FeedbackRequest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FeedbackRequestInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'feedbackRequest' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'feedbackRequest' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'negativeFreeTextInputPrompt',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'positiveFreeTextInputPrompt',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'question' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textInputMaxLength' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useFeedbackRequestQuery__
 *
 * To run a query within a React component, call `useFeedbackRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackRequestQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFeedbackRequestQuery(
  baseOptions: Apollo.QueryHookOptions<
    FeedbackRequestQuery,
    FeedbackRequestQueryVariables
  > &
    (
      | { variables: FeedbackRequestQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FeedbackRequestQuery, FeedbackRequestQueryVariables>(
    FeedbackRequestDocument,
    options,
  );
}
export function useFeedbackRequestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FeedbackRequestQuery,
    FeedbackRequestQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FeedbackRequestQuery,
    FeedbackRequestQueryVariables
  >(FeedbackRequestDocument, options);
}
// @ts-ignore
export function useFeedbackRequestSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FeedbackRequestQuery,
    FeedbackRequestQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FeedbackRequestQuery,
  FeedbackRequestQueryVariables
>;
export function useFeedbackRequestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FeedbackRequestQuery,
        FeedbackRequestQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FeedbackRequestQuery | undefined,
  FeedbackRequestQueryVariables
>;
export function useFeedbackRequestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FeedbackRequestQuery,
        FeedbackRequestQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FeedbackRequestQuery,
    FeedbackRequestQueryVariables
  >(FeedbackRequestDocument, options);
}
export type FeedbackRequestQueryHookResult = ReturnType<
  typeof useFeedbackRequestQuery
>;
export type FeedbackRequestLazyQueryHookResult = ReturnType<
  typeof useFeedbackRequestLazyQuery
>;
export type FeedbackRequestSuspenseQueryHookResult = ReturnType<
  typeof useFeedbackRequestSuspenseQuery
>;
export type FeedbackRequestQueryResult = Apollo.QueryResult<
  FeedbackRequestQuery,
  FeedbackRequestQueryVariables
>;
export const SubmitFeedbackDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SubmitFeedback' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'submitFeedbackInput' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SubmitFeedbackInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submitFeedback' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'submitFeedbackInput' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SubmitFeedbackMutationFn = Apollo.MutationFunction<
  SubmitFeedbackMutation,
  SubmitFeedbackMutationVariables
>;

/**
 * __useSubmitFeedbackMutation__
 *
 * To run a mutation, you first call `useSubmitFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFeedbackMutation, { data, loading, error }] = useSubmitFeedbackMutation({
 *   variables: {
 *      submitFeedbackInput: // value for 'submitFeedbackInput'
 *   },
 * });
 */
export function useSubmitFeedbackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitFeedbackMutation,
    SubmitFeedbackMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitFeedbackMutation,
    SubmitFeedbackMutationVariables
  >(SubmitFeedbackDocument, options);
}
export type SubmitFeedbackMutationHookResult = ReturnType<
  typeof useSubmitFeedbackMutation
>;
export type SubmitFeedbackMutationResult =
  Apollo.MutationResult<SubmitFeedbackMutation>;
export type SubmitFeedbackMutationOptions = Apollo.BaseMutationOptions<
  SubmitFeedbackMutation,
  SubmitFeedbackMutationVariables
>;
export const WellBeingButtonDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WellBeingButton' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'walkthroughType' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'WalkthroughType' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'walkthrough' },
            name: { kind: 'Name', value: 'getWalkthrough' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'walkthroughType' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'walkthroughType' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'WalkthroughFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WalkthroughFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Walkthrough' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'wasCompleted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'steps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useWellBeingButtonQuery__
 *
 * To run a query within a React component, call `useWellBeingButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useWellBeingButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWellBeingButtonQuery({
 *   variables: {
 *      walkthroughType: // value for 'walkthroughType'
 *   },
 * });
 */
export function useWellBeingButtonQuery(
  baseOptions?: Apollo.QueryHookOptions<
    WellBeingButtonQuery,
    WellBeingButtonQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WellBeingButtonQuery, WellBeingButtonQueryVariables>(
    WellBeingButtonDocument,
    options,
  );
}
export function useWellBeingButtonLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WellBeingButtonQuery,
    WellBeingButtonQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WellBeingButtonQuery,
    WellBeingButtonQueryVariables
  >(WellBeingButtonDocument, options);
}
// @ts-ignore
export function useWellBeingButtonSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WellBeingButtonQuery,
    WellBeingButtonQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  WellBeingButtonQuery,
  WellBeingButtonQueryVariables
>;
export function useWellBeingButtonSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WellBeingButtonQuery,
        WellBeingButtonQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  WellBeingButtonQuery | undefined,
  WellBeingButtonQueryVariables
>;
export function useWellBeingButtonSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WellBeingButtonQuery,
        WellBeingButtonQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WellBeingButtonQuery,
    WellBeingButtonQueryVariables
  >(WellBeingButtonDocument, options);
}
export type WellBeingButtonQueryHookResult = ReturnType<
  typeof useWellBeingButtonQuery
>;
export type WellBeingButtonLazyQueryHookResult = ReturnType<
  typeof useWellBeingButtonLazyQuery
>;
export type WellBeingButtonSuspenseQueryHookResult = ReturnType<
  typeof useWellBeingButtonSuspenseQuery
>;
export type WellBeingButtonQueryResult = Apollo.QueryResult<
  WellBeingButtonQuery,
  WellBeingButtonQueryVariables
>;
export const ConnectChatInitializationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ConnectChatInitialization' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConnectChatInitializationInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'connectChatInitialization' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'chatDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'awsRegion' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contactId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'participantId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'participantToken' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'langCode' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useConnectChatInitializationQuery__
 *
 * To run a query within a React component, call `useConnectChatInitializationQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectChatInitializationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectChatInitializationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConnectChatInitializationQuery(
  baseOptions: Apollo.QueryHookOptions<
    ConnectChatInitializationQuery,
    ConnectChatInitializationQueryVariables
  > &
    (
      | { variables: ConnectChatInitializationQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConnectChatInitializationQuery,
    ConnectChatInitializationQueryVariables
  >(ConnectChatInitializationDocument, options);
}
export function useConnectChatInitializationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConnectChatInitializationQuery,
    ConnectChatInitializationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConnectChatInitializationQuery,
    ConnectChatInitializationQueryVariables
  >(ConnectChatInitializationDocument, options);
}
// @ts-ignore
export function useConnectChatInitializationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ConnectChatInitializationQuery,
    ConnectChatInitializationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ConnectChatInitializationQuery,
  ConnectChatInitializationQueryVariables
>;
export function useConnectChatInitializationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ConnectChatInitializationQuery,
        ConnectChatInitializationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ConnectChatInitializationQuery | undefined,
  ConnectChatInitializationQueryVariables
>;
export function useConnectChatInitializationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ConnectChatInitializationQuery,
        ConnectChatInitializationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ConnectChatInitializationQuery,
    ConnectChatInitializationQueryVariables
  >(ConnectChatInitializationDocument, options);
}
export type ConnectChatInitializationQueryHookResult = ReturnType<
  typeof useConnectChatInitializationQuery
>;
export type ConnectChatInitializationLazyQueryHookResult = ReturnType<
  typeof useConnectChatInitializationLazyQuery
>;
export type ConnectChatInitializationSuspenseQueryHookResult = ReturnType<
  typeof useConnectChatInitializationSuspenseQuery
>;
export type ConnectChatInitializationQueryResult = Apollo.QueryResult<
  ConnectChatInitializationQuery,
  ConnectChatInitializationQueryVariables
>;
export const MemberAssistGreetingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MemberAssistGreeting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locale' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'memberAssistGreeting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'greeting' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'introduction' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'capabilityStatement' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMemberAssistGreetingQuery__
 *
 * To run a query within a React component, call `useMemberAssistGreetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberAssistGreetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberAssistGreetingQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useMemberAssistGreetingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MemberAssistGreetingQuery,
    MemberAssistGreetingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MemberAssistGreetingQuery,
    MemberAssistGreetingQueryVariables
  >(MemberAssistGreetingDocument, options);
}
export function useMemberAssistGreetingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MemberAssistGreetingQuery,
    MemberAssistGreetingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MemberAssistGreetingQuery,
    MemberAssistGreetingQueryVariables
  >(MemberAssistGreetingDocument, options);
}
// @ts-ignore
export function useMemberAssistGreetingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MemberAssistGreetingQuery,
    MemberAssistGreetingQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  MemberAssistGreetingQuery,
  MemberAssistGreetingQueryVariables
>;
export function useMemberAssistGreetingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MemberAssistGreetingQuery,
        MemberAssistGreetingQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MemberAssistGreetingQuery | undefined,
  MemberAssistGreetingQueryVariables
>;
export function useMemberAssistGreetingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MemberAssistGreetingQuery,
        MemberAssistGreetingQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MemberAssistGreetingQuery,
    MemberAssistGreetingQueryVariables
  >(MemberAssistGreetingDocument, options);
}
export type MemberAssistGreetingQueryHookResult = ReturnType<
  typeof useMemberAssistGreetingQuery
>;
export type MemberAssistGreetingLazyQueryHookResult = ReturnType<
  typeof useMemberAssistGreetingLazyQuery
>;
export type MemberAssistGreetingSuspenseQueryHookResult = ReturnType<
  typeof useMemberAssistGreetingSuspenseQuery
>;
export type MemberAssistGreetingQueryResult = Apollo.QueryResult<
  MemberAssistGreetingQuery,
  MemberAssistGreetingQueryVariables
>;
export const GetSuggestedPromptsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSuggestedPrompts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SuggestedPromptsInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSuggestedPrompts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'suggestedPrompts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'prompt' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetSuggestedPromptsQuery__
 *
 * To run a query within a React component, call `useGetSuggestedPromptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestedPromptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestedPromptsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSuggestedPromptsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSuggestedPromptsQuery,
    GetSuggestedPromptsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSuggestedPromptsQuery,
    GetSuggestedPromptsQueryVariables
  >(GetSuggestedPromptsDocument, options);
}
export function useGetSuggestedPromptsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSuggestedPromptsQuery,
    GetSuggestedPromptsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSuggestedPromptsQuery,
    GetSuggestedPromptsQueryVariables
  >(GetSuggestedPromptsDocument, options);
}
// @ts-ignore
export function useGetSuggestedPromptsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSuggestedPromptsQuery,
    GetSuggestedPromptsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetSuggestedPromptsQuery,
  GetSuggestedPromptsQueryVariables
>;
export function useGetSuggestedPromptsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSuggestedPromptsQuery,
        GetSuggestedPromptsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetSuggestedPromptsQuery | undefined,
  GetSuggestedPromptsQueryVariables
>;
export function useGetSuggestedPromptsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSuggestedPromptsQuery,
        GetSuggestedPromptsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSuggestedPromptsQuery,
    GetSuggestedPromptsQueryVariables
  >(GetSuggestedPromptsDocument, options);
}
export type GetSuggestedPromptsQueryHookResult = ReturnType<
  typeof useGetSuggestedPromptsQuery
>;
export type GetSuggestedPromptsLazyQueryHookResult = ReturnType<
  typeof useGetSuggestedPromptsLazyQuery
>;
export type GetSuggestedPromptsSuspenseQueryHookResult = ReturnType<
  typeof useGetSuggestedPromptsSuspenseQuery
>;
export type GetSuggestedPromptsQueryResult = Apollo.QueryResult<
  GetSuggestedPromptsQuery,
  GetSuggestedPromptsQueryVariables
>;
export const GetFeedbackReasonsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetFeedbackReasons' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'FeedbackReasonsInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getFeedbackReasons' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reasons' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetFeedbackReasonsQuery__
 *
 * To run a query within a React component, call `useGetFeedbackReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbackReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbackReasonsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetFeedbackReasonsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetFeedbackReasonsQuery,
    GetFeedbackReasonsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetFeedbackReasonsQuery,
    GetFeedbackReasonsQueryVariables
  >(GetFeedbackReasonsDocument, options);
}
export function useGetFeedbackReasonsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFeedbackReasonsQuery,
    GetFeedbackReasonsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFeedbackReasonsQuery,
    GetFeedbackReasonsQueryVariables
  >(GetFeedbackReasonsDocument, options);
}
// @ts-ignore
export function useGetFeedbackReasonsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFeedbackReasonsQuery,
    GetFeedbackReasonsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetFeedbackReasonsQuery,
  GetFeedbackReasonsQueryVariables
>;
export function useGetFeedbackReasonsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFeedbackReasonsQuery,
        GetFeedbackReasonsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetFeedbackReasonsQuery | undefined,
  GetFeedbackReasonsQueryVariables
>;
export function useGetFeedbackReasonsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFeedbackReasonsQuery,
        GetFeedbackReasonsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetFeedbackReasonsQuery,
    GetFeedbackReasonsQueryVariables
  >(GetFeedbackReasonsDocument, options);
}
export type GetFeedbackReasonsQueryHookResult = ReturnType<
  typeof useGetFeedbackReasonsQuery
>;
export type GetFeedbackReasonsLazyQueryHookResult = ReturnType<
  typeof useGetFeedbackReasonsLazyQuery
>;
export type GetFeedbackReasonsSuspenseQueryHookResult = ReturnType<
  typeof useGetFeedbackReasonsSuspenseQuery
>;
export type GetFeedbackReasonsQueryResult = Apollo.QueryResult<
  GetFeedbackReasonsQuery,
  GetFeedbackReasonsQueryVariables
>;
export const GetConversationsListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConversationsList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ConversationsInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ConversationItem' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paging' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AiNavigatorPaging' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AiNavigatorPaging' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Pagination' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isLastPage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cursors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetConversationsListQuery__
 *
 * To run a query within a React component, call `useGetConversationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationsListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetConversationsListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConversationsListQuery,
    GetConversationsListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConversationsListQuery,
    GetConversationsListQueryVariables
  >(GetConversationsListDocument, options);
}
export function useGetConversationsListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConversationsListQuery,
    GetConversationsListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConversationsListQuery,
    GetConversationsListQueryVariables
  >(GetConversationsListDocument, options);
}
// @ts-ignore
export function useGetConversationsListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetConversationsListQuery,
    GetConversationsListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetConversationsListQuery,
  GetConversationsListQueryVariables
>;
export function useGetConversationsListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetConversationsListQuery,
        GetConversationsListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetConversationsListQuery | undefined,
  GetConversationsListQueryVariables
>;
export function useGetConversationsListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetConversationsListQuery,
        GetConversationsListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetConversationsListQuery,
    GetConversationsListQueryVariables
  >(GetConversationsListDocument, options);
}
export type GetConversationsListQueryHookResult = ReturnType<
  typeof useGetConversationsListQuery
>;
export type GetConversationsListLazyQueryHookResult = ReturnType<
  typeof useGetConversationsListLazyQuery
>;
export type GetConversationsListSuspenseQueryHookResult = ReturnType<
  typeof useGetConversationsListSuspenseQuery
>;
export type GetConversationsListQueryResult = Apollo.QueryResult<
  GetConversationsListQuery,
  GetConversationsListQueryVariables
>;
export const GetConversationMessagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConversationMessages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sessionId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ConversationMessagesInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversationMessages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sessionId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'traceId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'content' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedback' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'citations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'content' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'title' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'media' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'ChatMedia' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hlsUrl' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'title' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'ChatMediaCard' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'title' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'category' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'author' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'thumbnail' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paging' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AiNavigatorPaging' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AiNavigatorPaging' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Pagination' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isLastPage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cursors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetConversationMessagesQuery__
 *
 * To run a query within a React component, call `useGetConversationMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationMessagesQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetConversationMessagesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetConversationMessagesQuery,
    GetConversationMessagesQueryVariables
  > &
    (
      | { variables: GetConversationMessagesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConversationMessagesQuery,
    GetConversationMessagesQueryVariables
  >(GetConversationMessagesDocument, options);
}
export function useGetConversationMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConversationMessagesQuery,
    GetConversationMessagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConversationMessagesQuery,
    GetConversationMessagesQueryVariables
  >(GetConversationMessagesDocument, options);
}
// @ts-ignore
export function useGetConversationMessagesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetConversationMessagesQuery,
    GetConversationMessagesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetConversationMessagesQuery,
  GetConversationMessagesQueryVariables
>;
export function useGetConversationMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetConversationMessagesQuery,
        GetConversationMessagesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetConversationMessagesQuery | undefined,
  GetConversationMessagesQueryVariables
>;
export function useGetConversationMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetConversationMessagesQuery,
        GetConversationMessagesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetConversationMessagesQuery,
    GetConversationMessagesQueryVariables
  >(GetConversationMessagesDocument, options);
}
export type GetConversationMessagesQueryHookResult = ReturnType<
  typeof useGetConversationMessagesQuery
>;
export type GetConversationMessagesLazyQueryHookResult = ReturnType<
  typeof useGetConversationMessagesLazyQuery
>;
export type GetConversationMessagesSuspenseQueryHookResult = ReturnType<
  typeof useGetConversationMessagesSuspenseQuery
>;
export type GetConversationMessagesQueryResult = Apollo.QueryResult<
  GetConversationMessagesQuery,
  GetConversationMessagesQueryVariables
>;
export const SearchConversationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SearchConversations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SearchConversationsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchConversations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ConversationItem' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paging' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AiNavigatorPaging' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AiNavigatorPaging' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Pagination' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isLastPage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cursors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSearchConversationsQuery__
 *
 * To run a query within a React component, call `useSearchConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchConversationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchConversationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchConversationsQuery,
    SearchConversationsQueryVariables
  > &
    (
      | { variables: SearchConversationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SearchConversationsQuery,
    SearchConversationsQueryVariables
  >(SearchConversationsDocument, options);
}
export function useSearchConversationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchConversationsQuery,
    SearchConversationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SearchConversationsQuery,
    SearchConversationsQueryVariables
  >(SearchConversationsDocument, options);
}
// @ts-ignore
export function useSearchConversationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchConversationsQuery,
    SearchConversationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SearchConversationsQuery,
  SearchConversationsQueryVariables
>;
export function useSearchConversationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchConversationsQuery,
        SearchConversationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SearchConversationsQuery | undefined,
  SearchConversationsQueryVariables
>;
export function useSearchConversationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchConversationsQuery,
        SearchConversationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SearchConversationsQuery,
    SearchConversationsQueryVariables
  >(SearchConversationsDocument, options);
}
export type SearchConversationsQueryHookResult = ReturnType<
  typeof useSearchConversationsQuery
>;
export type SearchConversationsLazyQueryHookResult = ReturnType<
  typeof useSearchConversationsLazyQuery
>;
export type SearchConversationsSuspenseQueryHookResult = ReturnType<
  typeof useSearchConversationsSuspenseQuery
>;
export type SearchConversationsQueryResult = Apollo.QueryResult<
  SearchConversationsQuery,
  SearchConversationsQueryVariables
>;
export const SubmitChatFeedbackDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SubmitChatFeedback' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ChatFeedbackInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submitChatFeedback' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SubmitChatFeedbackMutationFn = Apollo.MutationFunction<
  SubmitChatFeedbackMutation,
  SubmitChatFeedbackMutationVariables
>;

/**
 * __useSubmitChatFeedbackMutation__
 *
 * To run a mutation, you first call `useSubmitChatFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitChatFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitChatFeedbackMutation, { data, loading, error }] = useSubmitChatFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitChatFeedbackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitChatFeedbackMutation,
    SubmitChatFeedbackMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitChatFeedbackMutation,
    SubmitChatFeedbackMutationVariables
  >(SubmitChatFeedbackDocument, options);
}
export type SubmitChatFeedbackMutationHookResult = ReturnType<
  typeof useSubmitChatFeedbackMutation
>;
export type SubmitChatFeedbackMutationResult =
  Apollo.MutationResult<SubmitChatFeedbackMutation>;
export type SubmitChatFeedbackMutationOptions = Apollo.BaseMutationOptions<
  SubmitChatFeedbackMutation,
  SubmitChatFeedbackMutationVariables
>;
export const DeleteConversationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteConversation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sessionId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteConversation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sessionId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'deletedSessionId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeleteConversationMutationFn = Apollo.MutationFunction<
  DeleteConversationMutation,
  DeleteConversationMutationVariables
>;

/**
 * __useDeleteConversationMutation__
 *
 * To run a mutation, you first call `useDeleteConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConversationMutation, { data, loading, error }] = useDeleteConversationMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useDeleteConversationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteConversationMutation,
    DeleteConversationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteConversationMutation,
    DeleteConversationMutationVariables
  >(DeleteConversationDocument, options);
}
export type DeleteConversationMutationHookResult = ReturnType<
  typeof useDeleteConversationMutation
>;
export type DeleteConversationMutationResult =
  Apollo.MutationResult<DeleteConversationMutation>;
export type DeleteConversationMutationOptions = Apollo.BaseMutationOptions<
  DeleteConversationMutation,
  DeleteConversationMutationVariables
>;
export const DeleteAllConversationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteAllConversations' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAllConversations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'deletedSessionIds' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeleteAllConversationsMutationFn = Apollo.MutationFunction<
  DeleteAllConversationsMutation,
  DeleteAllConversationsMutationVariables
>;

/**
 * __useDeleteAllConversationsMutation__
 *
 * To run a mutation, you first call `useDeleteAllConversationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllConversationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllConversationsMutation, { data, loading, error }] = useDeleteAllConversationsMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteAllConversationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAllConversationsMutation,
    DeleteAllConversationsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteAllConversationsMutation,
    DeleteAllConversationsMutationVariables
  >(DeleteAllConversationsDocument, options);
}
export type DeleteAllConversationsMutationHookResult = ReturnType<
  typeof useDeleteAllConversationsMutation
>;
export type DeleteAllConversationsMutationResult =
  Apollo.MutationResult<DeleteAllConversationsMutation>;
export type DeleteAllConversationsMutationOptions = Apollo.BaseMutationOptions<
  DeleteAllConversationsMutation,
  DeleteAllConversationsMutationVariables
>;
export const UpdateConversationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateConversation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateConversationInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateConversation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateConversationMutationFn = Apollo.MutationFunction<
  UpdateConversationMutation,
  UpdateConversationMutationVariables
>;

/**
 * __useUpdateConversationMutation__
 *
 * To run a mutation, you first call `useUpdateConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConversationMutation, { data, loading, error }] = useUpdateConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateConversationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateConversationMutation,
    UpdateConversationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateConversationMutation,
    UpdateConversationMutationVariables
  >(UpdateConversationDocument, options);
}
export type UpdateConversationMutationHookResult = ReturnType<
  typeof useUpdateConversationMutation
>;
export type UpdateConversationMutationResult =
  Apollo.MutationResult<UpdateConversationMutation>;
export type UpdateConversationMutationOptions = Apollo.BaseMutationOptions<
  UpdateConversationMutation,
  UpdateConversationMutationVariables
>;
export const DeleteAllMemoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteAllMemories' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAllMemories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'deletedCount' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeleteAllMemoriesMutationFn = Apollo.MutationFunction<
  DeleteAllMemoriesMutation,
  DeleteAllMemoriesMutationVariables
>;

/**
 * __useDeleteAllMemoriesMutation__
 *
 * To run a mutation, you first call `useDeleteAllMemoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllMemoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllMemoriesMutation, { data, loading, error }] = useDeleteAllMemoriesMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteAllMemoriesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAllMemoriesMutation,
    DeleteAllMemoriesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteAllMemoriesMutation,
    DeleteAllMemoriesMutationVariables
  >(DeleteAllMemoriesDocument, options);
}
export type DeleteAllMemoriesMutationHookResult = ReturnType<
  typeof useDeleteAllMemoriesMutation
>;
export type DeleteAllMemoriesMutationResult =
  Apollo.MutationResult<DeleteAllMemoriesMutation>;
export type DeleteAllMemoriesMutationOptions = Apollo.BaseMutationOptions<
  DeleteAllMemoriesMutation,
  DeleteAllMemoriesMutationVariables
>;
export const GetUpcomingWpoAppointmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUpcomingWpoAppointment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'WpoGetUpcomingAppointmentInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wpoGetUpcomingAppointment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appointmentId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateFrom' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateTo' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayDateFrom' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayDateTo' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timeZoneCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appointmentMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'counsellorName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isCancelAllowed' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'serviceTypeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'serviceName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetUpcomingWpoAppointmentQuery__
 *
 * To run a query within a React component, call `useGetUpcomingWpoAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpcomingWpoAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpcomingWpoAppointmentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUpcomingWpoAppointmentQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUpcomingWpoAppointmentQuery,
    GetUpcomingWpoAppointmentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUpcomingWpoAppointmentQuery,
    GetUpcomingWpoAppointmentQueryVariables
  >(GetUpcomingWpoAppointmentDocument, options);
}
export function useGetUpcomingWpoAppointmentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUpcomingWpoAppointmentQuery,
    GetUpcomingWpoAppointmentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUpcomingWpoAppointmentQuery,
    GetUpcomingWpoAppointmentQueryVariables
  >(GetUpcomingWpoAppointmentDocument, options);
}
// @ts-ignore
export function useGetUpcomingWpoAppointmentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetUpcomingWpoAppointmentQuery,
    GetUpcomingWpoAppointmentQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetUpcomingWpoAppointmentQuery,
  GetUpcomingWpoAppointmentQueryVariables
>;
export function useGetUpcomingWpoAppointmentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetUpcomingWpoAppointmentQuery,
        GetUpcomingWpoAppointmentQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetUpcomingWpoAppointmentQuery | undefined,
  GetUpcomingWpoAppointmentQueryVariables
>;
export function useGetUpcomingWpoAppointmentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetUpcomingWpoAppointmentQuery,
        GetUpcomingWpoAppointmentQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetUpcomingWpoAppointmentQuery,
    GetUpcomingWpoAppointmentQueryVariables
  >(GetUpcomingWpoAppointmentDocument, options);
}
export type GetUpcomingWpoAppointmentQueryHookResult = ReturnType<
  typeof useGetUpcomingWpoAppointmentQuery
>;
export type GetUpcomingWpoAppointmentLazyQueryHookResult = ReturnType<
  typeof useGetUpcomingWpoAppointmentLazyQuery
>;
export type GetUpcomingWpoAppointmentSuspenseQueryHookResult = ReturnType<
  typeof useGetUpcomingWpoAppointmentSuspenseQuery
>;
export type GetUpcomingWpoAppointmentQueryResult = Apollo.QueryResult<
  GetUpcomingWpoAppointmentQuery,
  GetUpcomingWpoAppointmentQueryVariables
>;
export const ThiResultDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'THIResult' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalHealthIndexResult' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'THIResultModalFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'THIResultModalFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TotalHealthIndexResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'score' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bracket' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'color' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hexCode' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'articles' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'body' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useThiResultQuery__
 *
 * To run a query within a React component, call `useThiResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useThiResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThiResultQuery({
 *   variables: {
 *   },
 * });
 */
export function useThiResultQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ThiResultQuery,
    ThiResultQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ThiResultQuery, ThiResultQueryVariables>(
    ThiResultDocument,
    options,
  );
}
export function useThiResultLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ThiResultQuery,
    ThiResultQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ThiResultQuery, ThiResultQueryVariables>(
    ThiResultDocument,
    options,
  );
}
// @ts-ignore
export function useThiResultSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ThiResultQuery,
    ThiResultQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ThiResultQuery, ThiResultQueryVariables>;
export function useThiResultSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ThiResultQuery, ThiResultQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ThiResultQuery | undefined,
  ThiResultQueryVariables
>;
export function useThiResultSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ThiResultQuery, ThiResultQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ThiResultQuery, ThiResultQueryVariables>(
    ThiResultDocument,
    options,
  );
}
export type ThiResultQueryHookResult = ReturnType<typeof useThiResultQuery>;
export type ThiResultLazyQueryHookResult = ReturnType<
  typeof useThiResultLazyQuery
>;
export type ThiResultSuspenseQueryHookResult = ReturnType<
  typeof useThiResultSuspenseQuery
>;
export type ThiResultQueryResult = Apollo.QueryResult<
  ThiResultQuery,
  ThiResultQueryVariables
>;
